{
  "schemaVersion": 1,
  "id": "vilnius-wide-judu-public-transport-stops",
  "description": "Separable JUDU GTFS bus and trolleybus platform positions inside the Vilnius-wide projected envelope.",
  "source": {
    "name": "Vilnius public transport static GTFS",
    "publisher": "SĮ Susisiekimo paslaugos (JUDU)",
    "catalogUrl": "https://judu.lt/atviri-duomenys/",
    "url": "https://www.stops.lt/vilnius/vilnius/gtfs.zip",
    "termsUrl": "https://judu.lt/wp-content/uploads/2022/03/Duomenu-naudojimo-salygos-lt.pdf",
    "fetchedAt": "2026-08-11",
    "archiveFileName": "vilnius-gtfs.zip",
    "archiveSha256": "6707aff0990da48d6e670b7f79ca6666b9a52a9e14a205292134bc91ed5063cb",
    "notes": "Only stops referenced by route_type 3 buses or route_type 800 trolleybuses are retained. Ferry-only stops are excluded. Coordinates were transformed from WGS84 to EPSG:3346 with GDAL and clipped to data/regions/vilnius-wide.json."
  },
  "boundsLks94": {
    "minEasting": 556032,
    "minNorthing": 6051072,
    "maxEasting": 594176,
    "maxNorthing": 6077184
  },
  "stopCount": 1503,
  "stops": [
    {
      "id": "judu:stop:329",
      "stopId": "329",
      "name": "Akacijų st.",
      "description": "link Laisvės pr.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1612",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "21",
        "55",
        "68"
      ],
      "wgs84": {
        "latitude": 54.67818,
        "longitude": 25.20273
      },
      "lks94": {
        "easting": 577565.069,
        "northing": 6060857.134
      }
    },
    {
      "id": "judu:stop:342",
      "stopId": "342",
      "name": "Arimų st.",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2375",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "27"
      ],
      "wgs84": {
        "latitude": 54.70248,
        "longitude": 25.43145
      },
      "lks94": {
        "easting": 592259.336,
        "northing": 6063838.024
      }
    },
    {
      "id": "judu:stop:348",
      "stopId": "348",
      "name": "Ateities st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2017",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "10",
        "34",
        "49",
        "50",
        "87",
        "N3",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.736,
        "longitude": 25.26599
      },
      "lks94": {
        "easting": 581528.48,
        "northing": 6067363.459
      }
    },
    {
      "id": "judu:stop:351",
      "stopId": "351",
      "name": "Atminties st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1712",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "9",
        "116"
      ],
      "wgs84": {
        "latitude": 54.68715,
        "longitude": 25.20713
      },
      "lks94": {
        "easting": 577831.651,
        "northing": 6061860.25
      }
    },
    {
      "id": "judu:stop:356",
      "stopId": "356",
      "name": "Drujos st.",
      "description": "link N.Vilnios",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1207",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "7",
        "9",
        "12",
        "14",
        "15",
        "16",
        "19",
        "26",
        "31",
        "33",
        "34",
        "38",
        "42",
        "58",
        "65",
        "74",
        "78",
        "82",
        "89",
        "114",
        "119"
      ],
      "wgs84": {
        "latitude": 54.67878,
        "longitude": 25.31164
      },
      "lks94": {
        "easting": 584587.13,
        "northing": 6061049.663
      }
    },
    {
      "id": "judu:stop:357",
      "stopId": "357",
      "name": "Aukštieji Paneriai",
      "description": "link Savanorių pr.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2906",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "20",
        "51",
        "62"
      ],
      "wgs84": {
        "latitude": 54.63135,
        "longitude": 25.17403
      },
      "lks94": {
        "easting": 575801.386,
        "northing": 6055614.229
      }
    },
    {
      "id": "judu:stop:364",
      "stopId": "364",
      "name": "Juliaus Juzeliūno st.",
      "description": "link Laisvės pr.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3320",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5",
        "24",
        "57",
        "125"
      ],
      "wgs84": {
        "latitude": 54.73041,
        "longitude": 25.23684
      },
      "lks94": {
        "easting": 579662.314,
        "northing": 6066707.879
      }
    },
    {
      "id": "judu:stop:370",
      "stopId": "370",
      "name": "Bajorų sodai",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2105",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "49",
        "50",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.75762,
        "longitude": 25.25671
      },
      "lks94": {
        "easting": 580887.787,
        "northing": 6069758.755
      }
    },
    {
      "id": "judu:stop:387",
      "stopId": "387",
      "name": "Belmontas",
      "description": "link N.Vilnios",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1217",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "18",
        "27",
        "31",
        "37",
        "58",
        "67",
        "74",
        "115",
        "119"
      ],
      "wgs84": {
        "latitude": 54.68403,
        "longitude": 25.32038
      },
      "lks94": {
        "easting": 585139.748,
        "northing": 6061644.476
      }
    },
    {
      "id": "judu:stop:393",
      "stopId": "393",
      "name": "Buivydiškių st.",
      "description": "link Pašilaičių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1910",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5G",
        "25",
        "43",
        "46",
        "48",
        "73",
        "75",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.71394,
        "longitude": 25.23743
      },
      "lks94": {
        "easting": 579732.634,
        "northing": 6064875.644
      }
    },
    {
      "id": "judu:stop:394",
      "stopId": "394",
      "name": "Buivydiškių st.",
      "description": "link Šeškinės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1909",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5G",
        "25",
        "43",
        "46",
        "48",
        "73",
        "75",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.71322,
        "longitude": 25.23789
      },
      "lks94": {
        "easting": 579763.686,
        "northing": 6064796.04
      }
    },
    {
      "id": "judu:stop:410",
      "stopId": "410",
      "name": "Dariaus ir Girėno st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2608",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G",
        "4",
        "7",
        "11",
        "13",
        "14",
        "15",
        "20",
        "26",
        "28",
        "38",
        "41",
        "43",
        "51",
        "55",
        "57",
        "61",
        "62",
        "65",
        "114",
        "116",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.64755,
        "longitude": 25.27318
      },
      "lks94": {
        "easting": 582170.008,
        "northing": 6057528.548
      }
    },
    {
      "id": "judu:stop:429",
      "stopId": "429",
      "name": "Dvarčionys",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1011",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18",
        "38"
      ],
      "wgs84": {
        "latitude": 54.72972,
        "longitude": 25.37052
      },
      "lks94": {
        "easting": 588273.348,
        "northing": 6066791.059
      }
    },
    {
      "id": "judu:stop:437",
      "stopId": "437",
      "name": "Erfurto st.",
      "description": "link Laisvės pr.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1617",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "7",
        "20",
        "22",
        "49",
        "54",
        "59",
        "62",
        "69",
        "116",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.67363,
        "longitude": 25.20114
      },
      "lks94": {
        "easting": 577471.196,
        "northing": 6060349.022
      }
    },
    {
      "id": "judu:stop:446",
      "stopId": "446",
      "name": "Fabijoniškės",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3802",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "52",
        "87"
      ],
      "wgs84": {
        "latitude": 54.73145,
        "longitude": 25.23739
      },
      "lks94": {
        "easting": 579695.696,
        "northing": 6066824.243
      }
    },
    {
      "id": "judu:stop:449",
      "stopId": "449",
      "name": "Filaretų st.",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1210",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "4G",
        "6G",
        "7",
        "9",
        "12",
        "15",
        "16",
        "18",
        "19",
        "26",
        "27",
        "31",
        "33",
        "34",
        "37",
        "38",
        "42",
        "58",
        "65",
        "67",
        "74",
        "78",
        "82",
        "89",
        "114",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.68532,
        "longitude": 25.30853
      },
      "lks94": {
        "easting": 584373.014,
        "northing": 6061773.73
      }
    },
    {
      "id": "judu:stop:456",
      "stopId": "456",
      "name": "Galgiai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4602",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18"
      ],
      "wgs84": {
        "latitude": 54.72031,
        "longitude": 25.41133
      },
      "lks94": {
        "easting": 590922.753,
        "northing": 6065795.971
      }
    },
    {
      "id": "judu:stop:474",
      "stopId": "474",
      "name": "Gedimino prospektas",
      "description": "link Pedagoginio žiedo",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0219",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "24",
        "25",
        "29",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.68909,
        "longitude": 25.26261
      },
      "lks94": {
        "easting": 581404.743,
        "northing": 6062139.064
      }
    },
    {
      "id": "judu:stop:481",
      "stopId": "481",
      "name": "Gedvydžių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3805",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G",
        "52",
        "87"
      ],
      "wgs84": {
        "latitude": 54.73463,
        "longitude": 25.23419
      },
      "lks94": {
        "easting": 579483.381,
        "northing": 6067174.508
      }
    },
    {
      "id": "judu:stop:491",
      "stopId": "491",
      "name": "Geologų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2616",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "117",
        "118",
        "119",
        "122",
        "123",
        "125"
      ],
      "wgs84": {
        "latitude": 54.63986,
        "longitude": 25.26679
      },
      "lks94": {
        "easting": 581773.059,
        "northing": 6056665.305
      }
    },
    {
      "id": "judu:stop:493",
      "stopId": "493",
      "name": "Tiekimo st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2620",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1",
        "4",
        "7",
        "11",
        "13",
        "14",
        "15",
        "20",
        "26",
        "28",
        "38",
        "41",
        "43",
        "51",
        "55",
        "57",
        "61",
        "62",
        "65",
        "88",
        "114",
        "116",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.63206,
        "longitude": 25.27312
      },
      "lks94": {
        "easting": 582197.379,
        "northing": 6055804.665
      }
    },
    {
      "id": "judu:stop:542",
      "stopId": "542",
      "name": "Pumpėnų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3201",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "7",
        "18",
        "32",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.72239,
        "longitude": 25.22192
      },
      "lks94": {
        "easting": 578716.939,
        "northing": 6065798.515
      }
    },
    {
      "id": "judu:stop:548",
      "stopId": "548",
      "name": "Kalno st.",
      "description": "link N.Vilnios",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2330",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "115"
      ],
      "wgs84": {
        "latitude": 54.70476,
        "longitude": 25.39286
      },
      "lks94": {
        "easting": 589767.276,
        "northing": 6064041.715
      }
    },
    {
      "id": "judu:stop:588",
      "stopId": "588",
      "name": "Kirtimai",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2618",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1",
        "4",
        "7",
        "11",
        "13",
        "14",
        "15",
        "20",
        "26",
        "28",
        "38",
        "41",
        "43",
        "51",
        "55",
        "57",
        "61",
        "62",
        "65",
        "88",
        "114",
        "116",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.63684,
        "longitude": 25.27461
      },
      "lks94": {
        "easting": 582283.922,
        "northing": 6056338.353
      }
    },
    {
      "id": "judu:stop:596",
      "stopId": "596",
      "name": "Karoliniškių poliklinika",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1705",
      "modes": [
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "9"
      ],
      "wgs84": {
        "latitude": 54.69344,
        "longitude": 25.21524
      },
      "lks94": {
        "easting": 578342.413,
        "northing": 6062569.267
      }
    },
    {
      "id": "judu:stop:603",
      "stopId": "603",
      "name": "Krivių st.",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1101",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "7",
        "9",
        "12",
        "15",
        "16",
        "18",
        "19",
        "26",
        "27",
        "31",
        "33",
        "34",
        "37",
        "38",
        "42",
        "58",
        "65",
        "67",
        "74",
        "78",
        "82",
        "89",
        "114",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.68802,
        "longitude": 25.30531
      },
      "lks94": {
        "easting": 584159.816,
        "northing": 6062070.337
      }
    },
    {
      "id": "judu:stop:616",
      "stopId": "616",
      "name": "Kinologijos centras",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4002",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12",
        "14",
        "16",
        "58",
        "61",
        "122"
      ],
      "wgs84": {
        "latitude": 54.64878,
        "longitude": 25.32131
      },
      "lks94": {
        "easting": 585273.526,
        "northing": 6057722.797
      }
    },
    {
      "id": "judu:stop:617",
      "stopId": "617",
      "name": "Kinologijos centras",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1417",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "16",
        "58",
        "61",
        "122"
      ],
      "wgs84": {
        "latitude": 54.64925,
        "longitude": 25.32053
      },
      "lks94": {
        "easting": 585222.207,
        "northing": 6057774.154
      }
    },
    {
      "id": "judu:stop:632",
      "stopId": "632",
      "name": "Džocharo Dudajevo skv.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0309",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "11"
      ],
      "wgs84": {
        "latitude": 54.69583,
        "longitude": 25.25609
      },
      "lks94": {
        "easting": 580970.978,
        "northing": 6062881.596
      }
    },
    {
      "id": "judu:stop:639",
      "stopId": "639",
      "name": "Bukčiai",
      "description": "į miestą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1634",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "49"
      ],
      "wgs84": {
        "latitude": 54.65501,
        "longitude": 25.19563
      },
      "lks94": {
        "easting": 577151.109,
        "northing": 6058270.791
      }
    },
    {
      "id": "judu:stop:640",
      "stopId": "640",
      "name": "Amatų st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0531",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "13"
      ],
      "wgs84": {
        "latitude": 54.66967,
        "longitude": 25.26711
      },
      "lks94": {
        "easting": 581733.862,
        "northing": 6059983.11
      }
    },
    {
      "id": "judu:stop:646",
      "stopId": "646",
      "name": "Lydos st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4015",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "12",
        "14",
        "19",
        "82"
      ],
      "wgs84": {
        "latitude": 54.62535,
        "longitude": 25.30561
      },
      "lks94": {
        "easting": 584308.814,
        "northing": 6055096.441
      }
    },
    {
      "id": "judu:stop:677",
      "stopId": "677",
      "name": "Lvivo st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0110",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4G",
        "9",
        "19",
        "27",
        "37",
        "89"
      ],
      "wgs84": {
        "latitude": 54.69457,
        "longitude": 25.28387
      },
      "lks94": {
        "easting": 582764.219,
        "northing": 6062773.772
      }
    },
    {
      "id": "judu:stop:683",
      "stopId": "683",
      "name": "Mikalojaus Konstantino Čiurlionio st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0505",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "22"
      ],
      "wgs84": {
        "latitude": 54.6816,
        "longitude": 25.26471
      },
      "lks94": {
        "easting": 581555.146,
        "northing": 6061307.965
      }
    },
    {
      "id": "judu:stop:684",
      "stopId": "684",
      "name": "Markučiai",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1218",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "13"
      ],
      "wgs84": {
        "latitude": 54.6743,
        "longitude": 25.32268
      },
      "lks94": {
        "easting": 585308.446,
        "northing": 6060564.46
      }
    },
    {
      "id": "judu:stop:687",
      "stopId": "687",
      "name": "Medeinos st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3303",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "5G",
        "7",
        "18",
        "32",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.72871,
        "longitude": 25.21815
      },
      "lks94": {
        "easting": 578461.875,
        "northing": 6066497.632
      }
    },
    {
      "id": "judu:stop:690",
      "stopId": "690",
      "name": "Kirtimų geležinkelio stotis",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2622",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "4"
      ],
      "wgs84": {
        "latitude": 54.62953,
        "longitude": 25.2722
      },
      "lks94": {
        "easting": 582143.082,
        "northing": 6055522.036
      }
    },
    {
      "id": "judu:stop:720",
      "stopId": "720",
      "name": "Miškiniai",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1601",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "16",
        "18",
        "21",
        "25",
        "117",
        "118"
      ],
      "wgs84": {
        "latitude": 54.67119,
        "longitude": 25.22725
      },
      "lks94": {
        "easting": 579159.902,
        "northing": 6060106.601
      }
    },
    {
      "id": "judu:stop:721",
      "stopId": "721",
      "name": "Miškiniai",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1602",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "16",
        "18",
        "21",
        "25",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.67093,
        "longitude": 25.22641
      },
      "lks94": {
        "easting": 579106.228,
        "northing": 6060076.72
      }
    },
    {
      "id": "judu:stop:733",
      "stopId": "733",
      "name": "Musninkų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1920",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "25",
        "75"
      ],
      "wgs84": {
        "latitude": 54.71665,
        "longitude": 25.24386
      },
      "lks94": {
        "easting": 580141.578,
        "northing": 6065184.556
      }
    },
    {
      "id": "judu:stop:738",
      "stopId": "738",
      "name": "Naujieji Verkiai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2202",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "35",
        "65"
      ],
      "wgs84": {
        "latitude": 54.75984,
        "longitude": 25.33217
      },
      "lks94": {
        "easting": 585739.773,
        "northing": 6070095.44
      }
    },
    {
      "id": "judu:stop:741",
      "stopId": "741",
      "name": "Nemenčinės plentas",
      "description": "link Saulėtekio",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1119",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "4G",
        "5G",
        "10",
        "15",
        "17",
        "18",
        "19",
        "38",
        "39",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.72278,
        "longitude": 25.32004
      },
      "lks94": {
        "easting": 585036.723,
        "northing": 6065956.397
      }
    },
    {
      "id": "judu:stop:753",
      "stopId": "753",
      "name": "Europos aikštė",
      "description": "link Pilaitės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0104",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3G",
        "3G-A",
        "4G",
        "9",
        "19",
        "30",
        "43",
        "46",
        "56",
        "63",
        "88",
        "89",
        "N6",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.69564,
        "longitude": 25.27743
      },
      "lks94": {
        "easting": 582346.922,
        "northing": 6062885.275
      }
    },
    {
      "id": "judu:stop:756",
      "stopId": "756",
      "name": "Oslo st.",
      "description": "link Laisvės pr.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1622",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "21",
        "49",
        "55",
        "69",
        "116"
      ],
      "wgs84": {
        "latitude": 54.67016,
        "longitude": 25.19759
      },
      "lks94": {
        "easting": 577248.825,
        "northing": 6059958.944
      }
    },
    {
      "id": "judu:stop:783",
      "stopId": "783",
      "name": "Lazdynų seniūnija",
      "description": "link Laisvės pr.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1615",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "22",
        "49",
        "54",
        "59",
        "116",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.6752,
        "longitude": 25.20412
      },
      "lks94": {
        "easting": 577660.394,
        "northing": 6060527.034
      }
    },
    {
      "id": "judu:stop:790",
      "stopId": "790",
      "name": "LITEXPO",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1603",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "16",
        "18",
        "20",
        "21",
        "25",
        "62",
        "117",
        "118"
      ],
      "wgs84": {
        "latitude": 54.67561,
        "longitude": 25.2225
      },
      "lks94": {
        "easting": 578844.969,
        "northing": 6060593.145
      }
    },
    {
      "id": "judu:stop:795",
      "stopId": "795",
      "name": "Deivių st.",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3310",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "52",
        "125",
        "N4",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.73562,
        "longitude": 25.22905
      },
      "lks94": {
        "easting": 579150.446,
        "northing": 6067278.873
      }
    },
    {
      "id": "judu:stop:814",
      "stopId": "814",
      "name": "Panorama",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0317",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "9",
        "19",
        "21",
        "22",
        "30",
        "49",
        "69"
      ],
      "wgs84": {
        "latitude": 54.69915,
        "longitude": 25.25704
      },
      "lks94": {
        "easting": 581025.598,
        "northing": 6063252.164
      }
    },
    {
      "id": "judu:stop:823",
      "stopId": "823",
      "name": "Stasio Lozoraičio st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3801",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G-A",
        "5",
        "24",
        "57",
        "87",
        "125"
      ],
      "wgs84": {
        "latitude": 54.7244,
        "longitude": 25.24251
      },
      "lks94": {
        "easting": 580039.332,
        "northing": 6066045.493
      }
    },
    {
      "id": "judu:stop:848",
      "stopId": "848",
      "name": "Karaliaus Mindaugo tiltas",
      "description": "link Žaliojo tilto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0201",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "6",
        "6G",
        "10",
        "15",
        "17",
        "20",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.68858,
        "longitude": 25.28741
      },
      "lks94": {
        "easting": 583004.636,
        "northing": 6062111.346
      }
    },
    {
      "id": "judu:stop:855",
      "stopId": "855",
      "name": "Rygos st.",
      "description": "link Šeškinės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1911",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5G",
        "25",
        "43",
        "46",
        "48",
        "73",
        "75",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.71575,
        "longitude": 25.23211
      },
      "lks94": {
        "easting": 579386.326,
        "northing": 6065071.043
      }
    },
    {
      "id": "judu:stop:857",
      "stopId": "857",
      "name": "Riovonys",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2406",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "6",
        "8",
        "12",
        "15",
        "18",
        "20",
        "24",
        "25",
        "28",
        "51",
        "62",
        "123",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.65967,
        "longitude": 25.23359
      },
      "lks94": {
        "easting": 579591.344,
        "northing": 6058831.746
      }
    },
    {
      "id": "judu:stop:863",
      "stopId": "863",
      "name": "Skaistės st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4315",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "16"
      ],
      "wgs84": {
        "latitude": 54.60573,
        "longitude": 25.39316
      },
      "lks94": {
        "easting": 590005.228,
        "northing": 6053021.64
      }
    },
    {
      "id": "judu:stop:900",
      "stopId": "900",
      "name": "Senoji plytinė",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1005",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "4G",
        "5G",
        "10",
        "18",
        "19",
        "38",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.72416,
        "longitude": 25.34075
      },
      "lks94": {
        "easting": 586367.843,
        "northing": 6066135.264
      }
    },
    {
      "id": "judu:stop:928",
      "stopId": "928",
      "name": "Spaudos rūmai",
      "description": "link Lazdynų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1811",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "2G",
        "3",
        "4",
        "7",
        "9",
        "16",
        "18",
        "19",
        "21",
        "22",
        "25",
        "30",
        "32",
        "54",
        "55",
        "59",
        "68",
        "73",
        "75",
        "N2",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.70263,
        "longitude": 25.22377
      },
      "lks94": {
        "easting": 578874.456,
        "northing": 6063601.55
      }
    },
    {
      "id": "judu:stop:931",
      "stopId": "931",
      "name": "Srovės st.",
      "description": "link N.Vilnios",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1208",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "18",
        "27",
        "31",
        "37",
        "58",
        "67",
        "74",
        "115",
        "119"
      ],
      "wgs84": {
        "latitude": 54.68188,
        "longitude": 25.31555
      },
      "lks94": {
        "easting": 584832.805,
        "northing": 6061399.366
      }
    },
    {
      "id": "judu:stop:939",
      "stopId": "939",
      "name": "Stotis",
      "description": "\"B\" stotelė",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0530b",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12",
        "16",
        "61"
      ],
      "wgs84": {
        "latitude": 54.6711,
        "longitude": 25.28443
      },
      "lks94": {
        "easting": 582848.101,
        "northing": 6060162.546
      }
    },
    {
      "id": "judu:stop:946",
      "stopId": "946",
      "name": "Subačiaus st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0423",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "6G",
        "10",
        "11",
        "13",
        "31",
        "34",
        "74",
        "89"
      ],
      "wgs84": {
        "latitude": 54.67723,
        "longitude": 25.30249
      },
      "lks94": {
        "easting": 584000.284,
        "northing": 6060866.185
      }
    },
    {
      "id": "judu:stop:949",
      "stopId": "949",
      "name": "Sūduvių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3301",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "7",
        "18",
        "32",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.72563,
        "longitude": 25.21922
      },
      "lks94": {
        "easting": 578536.747,
        "northing": 6066156.062
      }
    },
    {
      "id": "judu:stop:950",
      "stopId": "950",
      "name": "Kiškių st.",
      "description": "link Nemenčinės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3520",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "39",
        "121"
      ],
      "wgs84": {
        "latitude": 54.73457,
        "longitude": 25.33814
      },
      "lks94": {
        "easting": 586177.629,
        "northing": 6067290.544
      }
    },
    {
      "id": "judu:stop:976",
      "stopId": "976",
      "name": "Aukštoji Veržuva",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3533",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "38"
      ],
      "wgs84": {
        "latitude": 54.74999,
        "longitude": 25.42812
      },
      "lks94": {
        "easting": 591937.116,
        "northing": 6069120.79
      }
    },
    {
      "id": "judu:stop:986",
      "stopId": "986",
      "name": "Šeškinės poliklinika",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1921",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G",
        "3G-A",
        "5",
        "24",
        "57",
        "87",
        "125"
      ],
      "wgs84": {
        "latitude": 54.71606,
        "longitude": 25.24745
      },
      "lks94": {
        "easting": 580374.036,
        "northing": 6065123.002
      }
    },
    {
      "id": "judu:stop:988",
      "stopId": "988",
      "name": "Lietuvos sąjūdžio kelias",
      "description": "link Pilaitės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0106",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3G",
        "3G-A",
        "4G",
        "9",
        "19",
        "30",
        "43",
        "46",
        "56",
        "63",
        "69",
        "89"
      ],
      "wgs84": {
        "latitude": 54.69853,
        "longitude": 25.2665
      },
      "lks94": {
        "easting": 581636.577,
        "northing": 6063194.127
      }
    },
    {
      "id": "judu:stop:1004",
      "stopId": "1004",
      "name": "Televizijos bokštas",
      "description": "link Viršuliškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1708",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "7",
        "16",
        "18",
        "21",
        "22",
        "25",
        "49",
        "54",
        "55",
        "59",
        "68",
        "69",
        "116",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.69092,
        "longitude": 25.21486
      },
      "lks94": {
        "easting": 578322.771,
        "northing": 6062288.399
      }
    },
    {
      "id": "judu:stop:1008",
      "stopId": "1008",
      "name": "Titnago st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2421",
      "modes": [
        "trolleybus"
      ],
      "routeShortNames": [
        "15",
        "18"
      ],
      "wgs84": {
        "latitude": 54.6497,
        "longitude": 25.18613
      },
      "lks94": {
        "easting": 576548.106,
        "northing": 6057669.464
      }
    },
    {
      "id": "judu:stop:1017",
      "stopId": "1017",
      "name": "Antakalnio žiedas",
      "description": "visos kryptys, troleibusai",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1118",
      "modes": [
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "21"
      ],
      "wgs84": {
        "latitude": 54.72291,
        "longitude": 25.31872
      },
      "lks94": {
        "easting": 584951.422,
        "northing": 6065969.265
      }
    },
    {
      "id": "judu:stop:1028",
      "stopId": "1028",
      "name": "Turniškės",
      "description": "į miestą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3510",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "15"
      ],
      "wgs84": {
        "latitude": 54.74512,
        "longitude": 25.32753
      },
      "lks94": {
        "easting": 585472.159,
        "northing": 6068451.637
      }
    },
    {
      "id": "judu:stop:1032",
      "stopId": "1032",
      "name": "Mikalojaus Katkaus st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0912",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5",
        "26",
        "34",
        "65"
      ],
      "wgs84": {
        "latitude": 54.70078,
        "longitude": 25.29246
      },
      "lks94": {
        "easting": 583305.214,
        "northing": 6063475.021
      }
    },
    {
      "id": "judu:stop:1035",
      "stopId": "1035",
      "name": "Tverečiaus st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1113",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "4",
        "10",
        "15",
        "19",
        "21",
        "38",
        "50",
        "114",
        "115",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.71619,
        "longitude": 25.31646
      },
      "lks94": {
        "easting": 584819.872,
        "northing": 6065218.687
      }
    },
    {
      "id": "judu:stop:1039",
      "stopId": "1039",
      "name": "Ukmergės st.",
      "description": "link Perkūnkiemio",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1916",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5",
        "24",
        "57",
        "87",
        "125"
      ],
      "wgs84": {
        "latitude": 54.71245,
        "longitude": 25.24974
      },
      "lks94": {
        "easting": 580528.729,
        "northing": 6064723.88
      }
    },
    {
      "id": "judu:stop:1042",
      "stopId": "1042",
      "name": "Ukmergės st.",
      "description": "link Paberžės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1922",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "40",
        "56"
      ],
      "wgs84": {
        "latitude": 54.71328,
        "longitude": 25.25166
      },
      "lks94": {
        "easting": 580650.792,
        "northing": 6064818.453
      }
    },
    {
      "id": "judu:stop:1064",
      "stopId": "1064",
      "name": "Vaikų darželis",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2205",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "35",
        "65"
      ],
      "wgs84": {
        "latitude": 54.76256,
        "longitude": 25.33563
      },
      "lks94": {
        "easting": 585956.685,
        "northing": 6070402.375
      }
    },
    {
      "id": "judu:stop:1069",
      "stopId": "1069",
      "name": "Vaikų kaimas",
      "description": "link Ukmergės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1907",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5G",
        "7",
        "46",
        "48",
        "73"
      ],
      "wgs84": {
        "latitude": 54.70877,
        "longitude": 25.24118
      },
      "lks94": {
        "easting": 579984.424,
        "northing": 6064304.555
      }
    },
    {
      "id": "judu:stop:1071",
      "stopId": "1071",
      "name": "Vaivorykštės st.",
      "description": "link Viršuliškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1714",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "4G",
        "7",
        "16",
        "18",
        "21",
        "22",
        "25",
        "49",
        "54",
        "55",
        "59",
        "68",
        "69",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.68519,
        "longitude": 25.20766
      },
      "lks94": {
        "easting": 577869.574,
        "northing": 6061642.714
      }
    },
    {
      "id": "judu:stop:1076",
      "stopId": "1076",
      "name": "Valkininkų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2418",
      "modes": [
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "6",
        "12"
      ],
      "wgs84": {
        "latitude": 54.64372,
        "longitude": 25.20184
      },
      "lks94": {
        "easting": 577573.305,
        "northing": 6057021.204
      }
    },
    {
      "id": "judu:stop:1115",
      "stopId": "1115",
      "name": "Visoriai",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2111",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "34",
        "120",
        "121",
        "125"
      ],
      "wgs84": {
        "latitude": 54.75781,
        "longitude": 25.26474
      },
      "lks94": {
        "easting": 581404.227,
        "northing": 6069789.189
      }
    },
    {
      "id": "judu:stop:1116",
      "stopId": "1116",
      "name": "Vytauto st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0305",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "11"
      ],
      "wgs84": {
        "latitude": 54.69117,
        "longitude": 25.25643
      },
      "lks94": {
        "easting": 581002.176,
        "northing": 6062363.392
      }
    },
    {
      "id": "judu:stop:1123",
      "stopId": "1123",
      "name": "Zarasų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1203",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "34",
        "74",
        "89"
      ],
      "wgs84": {
        "latitude": 54.67669,
        "longitude": 25.31012
      },
      "lks94": {
        "easting": 584493.452,
        "northing": 6060815.246
      }
    },
    {
      "id": "judu:stop:1129",
      "stopId": "1129",
      "name": "Naujoji Vilnia",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2372",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "67"
      ],
      "wgs84": {
        "latitude": 54.69523,
        "longitude": 25.44039
      },
      "lks94": {
        "easting": 592852.051,
        "northing": 6063043.002
      }
    },
    {
      "id": "judu:stop:1144",
      "stopId": "1144",
      "name": "Ožkinių žiedas",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2218",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "35",
        "65"
      ],
      "wgs84": {
        "latitude": 54.76844,
        "longitude": 25.36646
      },
      "lks94": {
        "easting": 587927.927,
        "northing": 6071094.957
      }
    },
    {
      "id": "judu:stop:1158",
      "stopId": "1158",
      "name": "Fabijoniškių žiedas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3810",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G-A",
        "5",
        "24",
        "53",
        "56",
        "57"
      ],
      "wgs84": {
        "latitude": 54.73906,
        "longitude": 25.24147
      },
      "lks94": {
        "easting": 579943.474,
        "northing": 6067675.784
      }
    },
    {
      "id": "judu:stop:1167",
      "stopId": "1167",
      "name": "Žolyno st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1125",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "15"
      ],
      "wgs84": {
        "latitude": 54.70782,
        "longitude": 25.33847
      },
      "lks94": {
        "easting": 586255.662,
        "northing": 6064314.048
      }
    },
    {
      "id": "judu:stop:3512",
      "stopId": "3512",
      "name": "Šeškinės kalvos",
      "description": "link Fabijoniškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1930",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "25",
        "48",
        "53",
        "56",
        "87",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.71157,
        "longitude": 25.257
      },
      "lks94": {
        "easting": 580998.266,
        "northing": 6064634.302
      }
    },
    {
      "id": "judu:stop:3551",
      "stopId": "3551",
      "name": "Alberto Goštauto st.",
      "description": "Nuo Žaliojo tilto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0222",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "25",
        "56"
      ],
      "wgs84": {
        "latitude": 54.69288,
        "longitude": 25.27088
      },
      "lks94": {
        "easting": 581930.274,
        "northing": 6062570.46
      }
    },
    {
      "id": "judu:stop:3560",
      "stopId": "3560",
      "name": "Žaros st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1638",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "21",
        "69"
      ],
      "wgs84": {
        "latitude": 54.66649,
        "longitude": 25.19576
      },
      "lks94": {
        "easting": 577137.744,
        "northing": 6059548.509
      }
    },
    {
      "id": "judu:stop:3566",
      "stopId": "3566",
      "name": "Saulėtekis",
      "description": "link Nemenčinės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1021",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "15",
        "17",
        "39"
      ],
      "wgs84": {
        "latitude": 54.72719,
        "longitude": 25.32671
      },
      "lks94": {
        "easting": 585457.099,
        "northing": 6066455.272
      }
    },
    {
      "id": "judu:stop:3572",
      "stopId": "3572",
      "name": "Daniliškės",
      "description": "į miestą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3104",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.60105,
        "longitude": 25.13817
      },
      "lks94": {
        "easting": 573540.802,
        "northing": 6052204.135
      }
    },
    {
      "id": "judu:stop:3575",
      "stopId": "3575",
      "name": "Vaidotai",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2501",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "8",
        "9",
        "25"
      ],
      "wgs84": {
        "latitude": 54.59876,
        "longitude": 25.17635
      },
      "lks94": {
        "easting": 576011.887,
        "northing": 6051989.909
      }
    },
    {
      "id": "judu:stop:3589",
      "stopId": "3589",
      "name": "Žėručio st.",
      "description": "link Laisvės pr.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1641",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "22",
        "49",
        "54",
        "59",
        "116",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.67661,
        "longitude": 25.2084
      },
      "lks94": {
        "easting": 577933.721,
        "northing": 6060688.691
      }
    },
    {
      "id": "judu:stop:3590",
      "stopId": "3590",
      "name": "Stotis",
      "description": "\"D\" stotelė",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0530d",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "13",
        "54"
      ],
      "wgs84": {
        "latitude": 54.67106,
        "longitude": 25.28399
      },
      "lks94": {
        "easting": 582819.803,
        "northing": 6060157.576
      }
    },
    {
      "id": "judu:stop:3610",
      "stopId": "3610",
      "name": "Jono Biliūno st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3550",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "121"
      ],
      "wgs84": {
        "latitude": 54.79495,
        "longitude": 25.39235
      },
      "lks94": {
        "easting": 589535.186,
        "northing": 6074077.921
      }
    },
    {
      "id": "judu:stop:3616",
      "stopId": "3616",
      "name": "Stotis",
      "description": "\"F\" stotelė",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0530f",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "15",
        "16"
      ],
      "wgs84": {
        "latitude": 54.67115,
        "longitude": 25.28328
      },
      "lks94": {
        "easting": 582773.827,
        "northing": 6060166.754
      }
    },
    {
      "id": "judu:stop:3617",
      "stopId": "3617",
      "name": "Stotis",
      "description": "\"G\" stotelė",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0530g",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "58"
      ],
      "wgs84": {
        "latitude": 54.67085,
        "longitude": 25.28336
      },
      "lks94": {
        "easting": 582779.597,
        "northing": 6060133.463
      }
    },
    {
      "id": "judu:stop:4266",
      "stopId": "4266",
      "name": "Stotis",
      "description": "\"C\" stotelė",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0530c",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "19",
        "82"
      ],
      "wgs84": {
        "latitude": 54.67108,
        "longitude": 25.2842
      },
      "lks94": {
        "easting": 582833.307,
        "northing": 6060160.049
      }
    },
    {
      "id": "judu:stop:4267",
      "stopId": "4267",
      "name": "Stotis",
      "description": "\"E\" stotelė",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0530e",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "13",
        "31",
        "34",
        "58",
        "74",
        "89"
      ],
      "wgs84": {
        "latitude": 54.67147,
        "longitude": 25.28327
      },
      "lks94": {
        "easting": 582772.531,
        "northing": 6060202.354
      }
    },
    {
      "id": "judu:stop:4290",
      "stopId": "4290",
      "name": "Paštas",
      "description": "išlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2641",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1"
      ],
      "wgs84": {
        "latitude": 54.63581,
        "longitude": 25.27655
      },
      "lks94": {
        "easting": 582411.237,
        "northing": 6056226.003
      }
    },
    {
      "id": "judu:stop:4388",
      "stopId": "4388",
      "name": "Igno Šeiniaus st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3832",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G",
        "3G-A",
        "5",
        "24",
        "57",
        "87",
        "125"
      ],
      "wgs84": {
        "latitude": 54.72146,
        "longitude": 25.24426
      },
      "lks94": {
        "easting": 580157.858,
        "northing": 6065720.305
      }
    },
    {
      "id": "judu:stop:4395",
      "stopId": "4395",
      "name": "Paukščių takas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1646",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "21",
        "55",
        "68"
      ],
      "wgs84": {
        "latitude": 54.6798,
        "longitude": 25.20734
      },
      "lks94": {
        "easting": 577859.257,
        "northing": 6061042.521
      }
    },
    {
      "id": "judu:stop:4410",
      "stopId": "4410",
      "name": "Vilijos st.",
      "description": "link Savanorių pr.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2937",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "20",
        "25",
        "51",
        "62"
      ],
      "wgs84": {
        "latitude": 54.63595,
        "longitude": 25.17316
      },
      "lks94": {
        "easting": 575736.669,
        "northing": 6056125.21
      }
    },
    {
      "id": "judu:stop:4426",
      "stopId": "4426",
      "name": "Svajonių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3554",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "15"
      ],
      "wgs84": {
        "latitude": 54.74065,
        "longitude": 25.31469
      },
      "lks94": {
        "easting": 584654.834,
        "northing": 6067938.618
      }
    },
    {
      "id": "judu:stop:4454",
      "stopId": "4454",
      "name": "Salos",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4120",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "28",
        "29",
        "59",
        "68",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.66862,
        "longitude": 25.10393
      },
      "lks94": {
        "easting": 571210.373,
        "northing": 6059688.559
      }
    },
    {
      "id": "judu:stop:4455",
      "stopId": "4455",
      "name": "Prekybos bazė",
      "description": "visos kryptys",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2939",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "28"
      ],
      "wgs84": {
        "latitude": 54.65806,
        "longitude": 25.13807
      },
      "lks94": {
        "easting": 573431.567,
        "northing": 6058548.514
      }
    },
    {
      "id": "judu:stop:4456",
      "stopId": "4456",
      "name": "Gunkliškių st.",
      "description": "link E.Andrė st.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3105",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.6273,
        "longitude": 25.10127
      },
      "lks94": {
        "easting": 571110.89,
        "northing": 6055087.445
      }
    },
    {
      "id": "judu:stop:4479",
      "stopId": "4479",
      "name": "Naujosios Gineitiškės",
      "description": "link Antežerių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4407",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32",
        "118"
      ],
      "wgs84": {
        "latitude": 54.73597,
        "longitude": 25.20137
      },
      "lks94": {
        "easting": 577367.283,
        "northing": 6067286.951
      }
    },
    {
      "id": "judu:stop:4506",
      "stopId": "4506",
      "name": "Juozo Tiškevičiaus st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3107",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.62135,
        "longitude": 25.11329
      },
      "lks94": {
        "easting": 571897.502,
        "northing": 6054437.516
      }
    },
    {
      "id": "judu:stop:4507",
      "stopId": "4507",
      "name": "Juozo Tiškevičiaus st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3108",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.62198,
        "longitude": 25.11288
      },
      "lks94": {
        "easting": 571869.915,
        "northing": 6054507.208
      }
    },
    {
      "id": "judu:stop:4516",
      "stopId": "4516",
      "name": "Trakų Vokė",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3109",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.624,
        "longitude": 25.11253
      },
      "lks94": {
        "easting": 571843.753,
        "northing": 6054731.651
      }
    },
    {
      "id": "judu:stop:4520",
      "stopId": "4520",
      "name": "Bistryčios st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1130",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "15",
        "114",
        "115"
      ],
      "wgs84": {
        "latitude": 54.7084,
        "longitude": 25.33044
      },
      "lks94": {
        "easting": 585736.988,
        "northing": 6064368.755
      }
    },
    {
      "id": "judu:stop:4521",
      "stopId": "4521",
      "name": "Bistryčios st.",
      "description": "link Antakalnio",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1131",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "15",
        "114",
        "115"
      ],
      "wgs84": {
        "latitude": 54.70839,
        "longitude": 25.32956
      },
      "lks94": {
        "easting": 585680.303,
        "northing": 6064366.568
      }
    },
    {
      "id": "judu:stop:4526",
      "stopId": "4526",
      "name": "Gilužio st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3609",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "4G",
        "30",
        "54",
        "75",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.704,
        "longitude": 25.17438
      },
      "lks94": {
        "easting": 575688.77,
        "northing": 6063699.637
      }
    },
    {
      "id": "judu:stop:4531",
      "stopId": "4531",
      "name": "Vytauto Andriaus Graičiūno st.",
      "description": "į miestą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2821",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "25"
      ],
      "wgs84": {
        "latitude": 54.60814,
        "longitude": 25.16
      },
      "lks94": {
        "easting": 574938.222,
        "northing": 6053016.217
      }
    },
    {
      "id": "judu:stop:4590",
      "stopId": "4590",
      "name": "Alyvų st.",
      "description": "link Kalino",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5121",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26"
      ],
      "wgs84": {
        "latitude": 54.8049,
        "longitude": 25.26845
      },
      "lks94": {
        "easting": 581548.208,
        "northing": 6075034.058
      }
    },
    {
      "id": "judu:stop:4591",
      "stopId": "4591",
      "name": "Alyvų st.",
      "description": "link Riešės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5122",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26"
      ],
      "wgs84": {
        "latitude": 54.80492,
        "longitude": 25.27128
      },
      "lks94": {
        "easting": 581730.097,
        "northing": 6075039.58
      }
    },
    {
      "id": "judu:stop:4686",
      "stopId": "4686",
      "name": "Karveliškių kapinės",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5144",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "63"
      ],
      "wgs84": {
        "latitude": 54.70931,
        "longitude": 25.10116
      },
      "lks94": {
        "easting": 570960.671,
        "northing": 6064214.091
      }
    },
    {
      "id": "judu:stop:4705",
      "stopId": "4705",
      "name": "Raistelių miškas",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5145",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "9",
        "82"
      ],
      "wgs84": {
        "latitude": 54.61127,
        "longitude": 25.23016
      },
      "lks94": {
        "easting": 579464.372,
        "northing": 6053441.617
      }
    },
    {
      "id": "judu:stop:4706",
      "stopId": "4706",
      "name": "Raistelių miškas",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5146",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "9",
        "82"
      ],
      "wgs84": {
        "latitude": 54.61112,
        "longitude": 25.23105
      },
      "lks94": {
        "easting": 579522.153,
        "northing": 6053425.931
      }
    },
    {
      "id": "judu:stop:4777",
      "stopId": "4777",
      "name": "Bireliai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2243",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "76"
      ],
      "wgs84": {
        "latitude": 54.82118,
        "longitude": 25.32066
      },
      "lks94": {
        "easting": 584870.439,
        "northing": 6076907.807
      }
    },
    {
      "id": "judu:stop:4898",
      "stopId": "4898",
      "name": "Žvėryno žiedas",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5151",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "11",
        "32",
        "59",
        "63",
        "116"
      ],
      "wgs84": {
        "latitude": 54.69846,
        "longitude": 25.2462
      },
      "lks94": {
        "easting": 580328.279,
        "northing": 6063162.918
      }
    },
    {
      "id": "judu:stop:4965",
      "stopId": "4965",
      "name": "Grigaičių žiedas",
      "description": "visos kryptys",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5163",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "58"
      ],
      "wgs84": {
        "latitude": 54.6643,
        "longitude": 25.41555
      },
      "lks94": {
        "easting": 591320.296,
        "northing": 6059568.412
      }
    },
    {
      "id": "judu:stop:4988",
      "stopId": "4988",
      "name": "Piliakalnio st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5164",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "4G",
        "30",
        "32",
        "54",
        "63",
        "75",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.69991,
        "longitude": 25.21175
      },
      "lks94": {
        "easting": 578105.007,
        "northing": 6063285.408
      }
    },
    {
      "id": "judu:stop:4989",
      "stopId": "4989",
      "name": "Piliakalnio st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5165",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "4G",
        "30",
        "32",
        "54",
        "63",
        "75",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.69943,
        "longitude": 25.21248
      },
      "lks94": {
        "easting": 578152.98,
        "northing": 6063232.802
      }
    },
    {
      "id": "judu:stop:4990",
      "stopId": "4990",
      "name": "Sietyno st.",
      "description": "link Justiniškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5166",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "2G",
        "3",
        "7",
        "9",
        "16",
        "18",
        "19",
        "21",
        "22",
        "25",
        "30",
        "32",
        "54",
        "55",
        "59",
        "68",
        "75",
        "N2",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.70037,
        "longitude": 25.22343
      },
      "lks94": {
        "easting": 578856.927,
        "northing": 6063349.659
      }
    },
    {
      "id": "judu:stop:4991",
      "stopId": "4991",
      "name": "Sietyno st.",
      "description": "link Pilaitės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5167",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "4G",
        "30",
        "32",
        "54",
        "63",
        "75",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.69967,
        "longitude": 25.22116
      },
      "lks94": {
        "easting": 578711.975,
        "northing": 6063269.21
      }
    },
    {
      "id": "judu:stop:5013",
      "stopId": "5013",
      "name": "Šiaurės miestelis",
      "description": "link žiedo",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0922",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3",
        "5",
        "7",
        "30",
        "33",
        "69",
        "114",
        "119"
      ],
      "wgs84": {
        "latitude": 54.71139,
        "longitude": 25.30392
      },
      "lks94": {
        "easting": 584021.888,
        "northing": 6064669.429
      }
    },
    {
      "id": "judu:stop:5022",
      "stopId": "5022",
      "name": "Autobusų parkas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5177",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "7",
        "8",
        "9",
        "10",
        "24",
        "25",
        "27",
        "29",
        "33",
        "34",
        "35",
        "36",
        "37",
        "46",
        "48",
        "49",
        "53",
        "56",
        "63",
        "66",
        "87",
        "89",
        "N4",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.72092,
        "longitude": 25.29589
      },
      "lks94": {
        "easting": 583484.896,
        "northing": 6065720.407
      }
    },
    {
      "id": "judu:stop:5060",
      "stopId": "5060",
      "name": "Taikos st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3204",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "5G",
        "7",
        "18",
        "32",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.7206,
        "longitude": 25.22263
      },
      "lks94": {
        "easting": 578766.146,
        "northing": 6065600.107
      }
    },
    {
      "id": "judu:stop:5063",
      "stopId": "5063",
      "name": "Justiniškės",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3209",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "5G",
        "7",
        "18",
        "32",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.71754,
        "longitude": 25.22209
      },
      "lks94": {
        "easting": 578737.289,
        "northing": 6065258.96
      }
    },
    {
      "id": "judu:stop:5067",
      "stopId": "5067",
      "name": "Rygos st.",
      "description": "link Pašilaičių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1912",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "16",
        "19",
        "46",
        "48",
        "52",
        "55",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.71687,
        "longitude": 25.23153
      },
      "lks94": {
        "easting": 579346.771,
        "northing": 6065195.03
      }
    },
    {
      "id": "judu:stop:5074",
      "stopId": "5074",
      "name": "Vaikų kaimas",
      "description": "link Justiniškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1908",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5G",
        "46",
        "48",
        "73"
      ],
      "wgs84": {
        "latitude": 54.70949,
        "longitude": 25.24035
      },
      "lks94": {
        "easting": 579929.524,
        "northing": 6064383.737
      }
    },
    {
      "id": "judu:stop:5080",
      "stopId": "5080",
      "name": "Licėjus",
      "description": "link Kalvarijų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0710",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5G",
        "7",
        "8",
        "25",
        "26",
        "29",
        "46",
        "48",
        "53",
        "56",
        "87",
        "89",
        "N4",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.71305,
        "longitude": 25.27899
      },
      "lks94": {
        "easting": 582412.173,
        "northing": 6064824.606
      }
    },
    {
      "id": "judu:stop:5086",
      "stopId": "5086",
      "name": "Kareivių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0810",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "5",
        "6",
        "6G",
        "7",
        "9",
        "12",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "27",
        "30",
        "31",
        "33",
        "42",
        "58",
        "67",
        "69",
        "74",
        "78",
        "82",
        "89",
        "114",
        "115",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.71859,
        "longitude": 25.30393
      },
      "lks94": {
        "easting": 584007.644,
        "northing": 6065470.704
      }
    },
    {
      "id": "judu:stop:5087",
      "stopId": "5087",
      "name": "Žirmūnai",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0822",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "9",
        "12",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "27",
        "30",
        "31",
        "33",
        "42",
        "58",
        "67",
        "69",
        "74",
        "78",
        "82",
        "89",
        "114",
        "115",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.71595,
        "longitude": 25.30509
      },
      "lks94": {
        "easting": 584087.839,
        "northing": 6065178.296
      }
    },
    {
      "id": "judu:stop:5088",
      "stopId": "5088",
      "name": "Šiaurės miestelis",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0902",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "9",
        "12",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "27",
        "31",
        "42",
        "58",
        "67",
        "74",
        "78",
        "82",
        "89",
        "114",
        "115",
        "119",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.71083,
        "longitude": 25.30465
      },
      "lks94": {
        "easting": 584070.083,
        "northing": 6064607.983
      }
    },
    {
      "id": "judu:stop:5091",
      "stopId": "5091",
      "name": "Šilo tiltas",
      "description": "link Šilo tilto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1129",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4G",
        "6",
        "12",
        "17",
        "20",
        "21",
        "50",
        "119"
      ],
      "wgs84": {
        "latitude": 54.70519,
        "longitude": 25.31007
      },
      "lks94": {
        "easting": 584431.037,
        "northing": 6063986.834
      }
    },
    {
      "id": "judu:stop:5092",
      "stopId": "5092",
      "name": "Šilo tiltas",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1108",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "4",
        "4G",
        "6",
        "10",
        "12",
        "15",
        "17",
        "19",
        "20",
        "21",
        "38",
        "50",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.70545,
        "longitude": 25.31096
      },
      "lks94": {
        "easting": 584487.852,
        "northing": 6064016.84
      }
    },
    {
      "id": "judu:stop:5095",
      "stopId": "5095",
      "name": "Klinikų st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1110",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "4",
        "4G",
        "15",
        "19",
        "21",
        "38",
        "50",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.71125,
        "longitude": 25.31486
      },
      "lks94": {
        "easting": 584727.089,
        "northing": 6064667.001
      }
    },
    {
      "id": "judu:stop:5096",
      "stopId": "5096",
      "name": "Klinikų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1109",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "4",
        "4G",
        "6",
        "10",
        "12",
        "15",
        "17",
        "19",
        "20",
        "21",
        "38",
        "50",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.71058,
        "longitude": 25.31437
      },
      "lks94": {
        "easting": 584696.913,
        "northing": 6064591.848
      }
    },
    {
      "id": "judu:stop:5103",
      "stopId": "5103",
      "name": "Saulėtekis",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1122",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "4G",
        "5G",
        "10",
        "15",
        "17",
        "18",
        "19",
        "38",
        "39",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.72622,
        "longitude": 25.32482
      },
      "lks94": {
        "easting": 585337.404,
        "northing": 6066345.024
      }
    },
    {
      "id": "judu:stop:5104",
      "stopId": "5104",
      "name": "Saulėtekis",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1001",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "4G",
        "5G",
        "10",
        "18",
        "19",
        "38",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.72624,
        "longitude": 25.32752
      },
      "lks94": {
        "easting": 585511.27,
        "northing": 6066350.537
      }
    },
    {
      "id": "judu:stop:5105",
      "stopId": "5105",
      "name": "Vilniaus universitetas",
      "description": "link Saulėtekio",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1023",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "4G",
        "5G",
        "10",
        "18",
        "19",
        "38"
      ],
      "wgs84": {
        "latitude": 54.72454,
        "longitude": 25.33199
      },
      "lks94": {
        "easting": 585802.776,
        "northing": 6066166.807
      }
    },
    {
      "id": "judu:stop:5107",
      "stopId": "5107",
      "name": "Gedimino technikos universitetas",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1003",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "4G",
        "5G",
        "10",
        "18",
        "19",
        "38"
      ],
      "wgs84": {
        "latitude": 54.72385,
        "longitude": 25.33566
      },
      "lks94": {
        "easting": 586040.634,
        "northing": 6066094.513
      }
    },
    {
      "id": "judu:stop:5116",
      "stopId": "5116",
      "name": "Gedimino technikos universitetas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1002",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "4G",
        "5G",
        "10",
        "18",
        "19",
        "38",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.72412,
        "longitude": 25.33451
      },
      "lks94": {
        "easting": 585965.986,
        "northing": 6066123.151
      }
    },
    {
      "id": "judu:stop:5117",
      "stopId": "5117",
      "name": "Nemenčinės plentas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1117",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "10",
        "15",
        "17",
        "18",
        "19",
        "38",
        "39",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.72385,
        "longitude": 25.32007
      },
      "lks94": {
        "easting": 585036.416,
        "northing": 6066075.509
      }
    },
    {
      "id": "judu:stop:5118",
      "stopId": "5118",
      "name": "Antakalnis",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1115",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "4",
        "4G",
        "6",
        "10",
        "15",
        "19",
        "21",
        "38",
        "50",
        "114",
        "115",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.7196,
        "longitude": 25.31724
      },
      "lks94": {
        "easting": 584863.001,
        "northing": 6065599.117
      }
    },
    {
      "id": "judu:stop:5119",
      "stopId": "5119",
      "name": "Tverečiaus st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1114",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "4",
        "6",
        "10",
        "15",
        "19",
        "21",
        "38",
        "50",
        "114",
        "115",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.7175,
        "longitude": 25.31659
      },
      "lks94": {
        "easting": 584825.512,
        "northing": 6065364.63
      }
    },
    {
      "id": "judu:stop:5125",
      "stopId": "5125",
      "name": "Kareivių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0808",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "5G",
        "6",
        "10"
      ],
      "wgs84": {
        "latitude": 54.71989,
        "longitude": 25.30161
      },
      "lks94": {
        "easting": 583855.5,
        "northing": 6065612.601
      }
    },
    {
      "id": "judu:stop:5127",
      "stopId": "5127",
      "name": "Verkių st.",
      "description": "link Kalvarijų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0807",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "6",
        "7",
        "8",
        "9",
        "10",
        "24",
        "25",
        "27",
        "29",
        "34",
        "35",
        "36",
        "37",
        "46",
        "48",
        "49",
        "53",
        "56",
        "63",
        "66",
        "87",
        "89",
        "N4",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.71687,
        "longitude": 25.2936
      },
      "lks94": {
        "easting": 583345.685,
        "northing": 6065266.974
      }
    },
    {
      "id": "judu:stop:5128",
      "stopId": "5128",
      "name": "Pramogų arena",
      "description": "link centro (troleibusai)",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0805",
      "modes": [
        "trolleybus"
      ],
      "routeShortNames": [
        "6",
        "10"
      ],
      "wgs84": {
        "latitude": 54.71556,
        "longitude": 25.28943
      },
      "lks94": {
        "easting": 583079.709,
        "northing": 6065116.244
      }
    },
    {
      "id": "judu:stop:5131",
      "stopId": "5131",
      "name": "Pramogų arena",
      "description": "link Šeškinės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2015",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5G",
        "7",
        "8",
        "24",
        "25",
        "26",
        "29",
        "46",
        "48",
        "53",
        "56",
        "87",
        "N4",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.71508,
        "longitude": 25.28573
      },
      "lks94": {
        "easting": 582842.304,
        "northing": 6065058.453
      }
    },
    {
      "id": "judu:stop:5137",
      "stopId": "5137",
      "name": "Rygos st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3218",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5G",
        "43",
        "73",
        "75"
      ],
      "wgs84": {
        "latitude": 54.71647,
        "longitude": 25.22962
      },
      "lks94": {
        "easting": 579224.497,
        "northing": 6065148.357
      }
    },
    {
      "id": "judu:stop:5140",
      "stopId": "5140",
      "name": "Taikos st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3202",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "5G",
        "7",
        "18",
        "32",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.72159,
        "longitude": 25.22279
      },
      "lks94": {
        "easting": 578774.533,
        "northing": 6065710.461
      }
    },
    {
      "id": "judu:stop:5141",
      "stopId": "5141",
      "name": "Sūduvių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3302",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "7",
        "18",
        "32",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.72646,
        "longitude": 25.21906
      },
      "lks94": {
        "easting": 578524.836,
        "northing": 6066248.252
      }
    },
    {
      "id": "judu:stop:5147",
      "stopId": "5147",
      "name": "Autobusų parkas",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0813",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "9",
        "12",
        "16",
        "17",
        "18",
        "19",
        "27",
        "30",
        "31",
        "33",
        "39",
        "42",
        "50",
        "58",
        "67",
        "69",
        "74",
        "78",
        "82",
        "89",
        "115",
        "121",
        "N1",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.72216,
        "longitude": 25.29669
      },
      "lks94": {
        "easting": 583533.882,
        "northing": 6065859.354
      }
    },
    {
      "id": "judu:stop:5149",
      "stopId": "5149",
      "name": "Žirmūnų seniūnija",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0814",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "9",
        "12",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "27",
        "30",
        "31",
        "33",
        "39",
        "42",
        "50",
        "58",
        "67",
        "69",
        "74",
        "78",
        "82",
        "89",
        "115",
        "121",
        "N1",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.7219,
        "longitude": 25.30071
      },
      "lks94": {
        "easting": 583793.375,
        "northing": 6065835.212
      }
    },
    {
      "id": "judu:stop:5154",
      "stopId": "5154",
      "name": "Žirmūnų seniūnija",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0815",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "5",
        "5G",
        "6",
        "6G",
        "7",
        "9",
        "12",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "27",
        "30",
        "31",
        "33",
        "39",
        "42",
        "50",
        "58",
        "67",
        "69",
        "74",
        "78",
        "82",
        "89",
        "115",
        "121",
        "N1",
        "N3",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.72236,
        "longitude": 25.29994
      },
      "lks94": {
        "easting": 583742.825,
        "northing": 6065885.485
      }
    },
    {
      "id": "judu:stop:5156",
      "stopId": "5156",
      "name": "Stotis",
      "description": "\"J\" stotelė",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0530j",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1G",
        "53"
      ],
      "wgs84": {
        "latitude": 54.67025,
        "longitude": 25.28349
      },
      "lks94": {
        "easting": 582789.202,
        "northing": 6060066.844
      }
    },
    {
      "id": "judu:stop:5160",
      "stopId": "5160",
      "name": "Aguonų st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0415",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "4",
        "13",
        "15",
        "16",
        "41",
        "42",
        "54",
        "61",
        "78"
      ],
      "wgs84": {
        "latitude": 54.67263,
        "longitude": 25.27852
      },
      "lks94": {
        "easting": 582463.816,
        "northing": 6060325.857
      }
    },
    {
      "id": "judu:stop:5166",
      "stopId": "5166",
      "name": "Vienaragių st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0521",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "2G",
        "3",
        "4",
        "13",
        "15",
        "16",
        "41",
        "42",
        "54",
        "61",
        "78"
      ],
      "wgs84": {
        "latitude": 54.67191,
        "longitude": 25.27022
      },
      "lks94": {
        "easting": 581929.949,
        "northing": 6060236.015
      }
    },
    {
      "id": "judu:stop:5167",
      "stopId": "5167",
      "name": "Vienaragių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0519",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "4G",
        "7",
        "13",
        "15",
        "16",
        "55",
        "73",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.6718,
        "longitude": 25.26847
      },
      "lks94": {
        "easting": 581817.3,
        "northing": 6060221.733
      }
    },
    {
      "id": "judu:stop:5168",
      "stopId": "5168",
      "name": "Vienaragių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0520",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3G",
        "9",
        "10",
        "11",
        "17",
        "21",
        "43",
        "54",
        "55",
        "57",
        "73",
        "116",
        "125",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.67262,
        "longitude": 25.26932
      },
      "lks94": {
        "easting": 581870.474,
        "northing": 6060313.979
      }
    },
    {
      "id": "judu:stop:5173",
      "stopId": "5173",
      "name": "Prūsų st.",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1503",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "4",
        "7",
        "9",
        "10",
        "11",
        "13",
        "14",
        "15",
        "17",
        "26",
        "38",
        "41",
        "42",
        "43",
        "55",
        "57",
        "61",
        "65",
        "78",
        "114",
        "116",
        "125",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.66522,
        "longitude": 25.2728
      },
      "lks94": {
        "easting": 582109.847,
        "northing": 6059494.525
      }
    },
    {
      "id": "judu:stop:5175",
      "stopId": "5175",
      "name": "Naujininkai",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1501",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "3G",
        "4",
        "4G",
        "7",
        "9",
        "11",
        "13",
        "14",
        "15",
        "26",
        "38",
        "41",
        "42",
        "43",
        "55",
        "57",
        "61",
        "65",
        "78",
        "114",
        "116",
        "122",
        "125",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.66084,
        "longitude": 25.2732
      },
      "lks94": {
        "easting": 582144.487,
        "northing": 6059007.56
      }
    },
    {
      "id": "judu:stop:5180",
      "stopId": "5180",
      "name": "Eišiškių plentas",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2603",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G",
        "4",
        "7",
        "43",
        "51",
        "55",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.65129,
        "longitude": 25.27177
      },
      "lks94": {
        "easting": 582071.477,
        "northing": 6057943.108
      }
    },
    {
      "id": "judu:stop:5181",
      "stopId": "5181",
      "name": "Eišiškių plentas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2604",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G",
        "4",
        "7",
        "11",
        "13",
        "14",
        "15",
        "20",
        "26",
        "28",
        "38",
        "41",
        "43",
        "51",
        "55",
        "57",
        "61",
        "62",
        "65",
        "114",
        "116",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.65148,
        "longitude": 25.27186
      },
      "lks94": {
        "easting": 582076.902,
        "northing": 6057964.358
      }
    },
    {
      "id": "judu:stop:5182",
      "stopId": "5182",
      "name": "Dariaus ir Girėno st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2607",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G",
        "4",
        "7",
        "43",
        "51",
        "55",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.64719,
        "longitude": 25.27313
      },
      "lks94": {
        "easting": 582167.508,
        "northing": 6057488.427
      }
    },
    {
      "id": "judu:stop:5184",
      "stopId": "5184",
      "name": "Felikso Vaitkaus st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2612",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "4",
        "7",
        "11",
        "13",
        "14",
        "15",
        "20",
        "26",
        "28",
        "38",
        "41",
        "43",
        "51",
        "55",
        "57",
        "61",
        "62",
        "65",
        "114",
        "116",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.64352,
        "longitude": 25.27401
      },
      "lks94": {
        "easting": 582231.708,
        "northing": 6057081.038
      }
    },
    {
      "id": "judu:stop:5193",
      "stopId": "5193",
      "name": "Kirtimai",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2619",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "4",
        "7",
        "43",
        "51",
        "55"
      ],
      "wgs84": {
        "latitude": 54.63748,
        "longitude": 25.27466
      },
      "lks94": {
        "easting": 582285.857,
        "northing": 6056409.635
      }
    },
    {
      "id": "judu:stop:5194",
      "stopId": "5194",
      "name": "Tiekimo st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2621",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "4",
        "4G",
        "7",
        "43",
        "51",
        "55"
      ],
      "wgs84": {
        "latitude": 54.63323,
        "longitude": 25.27323
      },
      "lks94": {
        "easting": 582202.121,
        "northing": 6055934.997
      }
    },
    {
      "id": "judu:stop:5200",
      "stopId": "5200",
      "name": "Naujininkai",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1502",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "9",
        "10",
        "17",
        "122"
      ],
      "wgs84": {
        "latitude": 54.66275,
        "longitude": 25.27418
      },
      "lks94": {
        "easting": 582203.855,
        "northing": 6059221.263
      }
    },
    {
      "id": "judu:stop:5206",
      "stopId": "5206",
      "name": "Musninkų st.",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1933",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "48",
        "87"
      ],
      "wgs84": {
        "latitude": 54.7169,
        "longitude": 25.24484
      },
      "lks94": {
        "easting": 580204.222,
        "northing": 6065213.498
      }
    },
    {
      "id": "judu:stop:5208",
      "stopId": "5208",
      "name": "Musninkų st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1919",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "25",
        "75",
        "87"
      ],
      "wgs84": {
        "latitude": 54.71662,
        "longitude": 25.24452
      },
      "lks94": {
        "easting": 580184.159,
        "northing": 6065181.972
      }
    },
    {
      "id": "judu:stop:5209",
      "stopId": "5209",
      "name": "Dūkštų st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1918",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "43",
        "87",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.715,
        "longitude": 25.24638
      },
      "lks94": {
        "easting": 580307.194,
        "northing": 6065003.813
      }
    },
    {
      "id": "judu:stop:5212",
      "stopId": "5212",
      "name": "Ukmergės st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1915",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "57"
      ],
      "wgs84": {
        "latitude": 54.71194,
        "longitude": 25.24942
      },
      "lks94": {
        "easting": 580509.12,
        "northing": 6064666.757
      }
    },
    {
      "id": "judu:stop:5214",
      "stopId": "5214",
      "name": "Šeškinė",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1903",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G",
        "3G-A",
        "5",
        "24",
        "40",
        "43",
        "56",
        "57",
        "125",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.70963,
        "longitude": 25.25157
      },
      "lks94": {
        "easting": 580652.237,
        "northing": 6064412.152
      }
    },
    {
      "id": "judu:stop:5220",
      "stopId": "5220",
      "name": "Saltoniškės",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0321",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G-A",
        "5",
        "8",
        "24",
        "29",
        "40",
        "43",
        "46",
        "49",
        "56",
        "57",
        "73",
        "125",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.70123,
        "longitude": 25.26289
      },
      "lks94": {
        "easting": 581398.489,
        "northing": 6063490.409
      }
    },
    {
      "id": "judu:stop:5244",
      "stopId": "5244",
      "name": "Žaliasis tiltas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0102",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1G",
        "2G",
        "3G",
        "3G-A",
        "6",
        "9",
        "10",
        "12",
        "25",
        "43",
        "53",
        "55",
        "56",
        "88",
        "N3",
        "N4",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.69234,
        "longitude": 25.28003
      },
      "lks94": {
        "easting": 582521.213,
        "northing": 6062521.083
      }
    },
    {
      "id": "judu:stop:5245",
      "stopId": "5245",
      "name": "Žaliasis tiltas",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0101",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1G",
        "2G",
        "3G",
        "3G-A",
        "6",
        "6G",
        "9",
        "10",
        "12",
        "43",
        "46",
        "53",
        "55",
        "56",
        "88",
        "N3",
        "N4",
        "N6",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.69236,
        "longitude": 25.28048
      },
      "lks94": {
        "easting": 582550.182,
        "northing": 6062523.837
      }
    },
    {
      "id": "judu:stop:5248",
      "stopId": "5248",
      "name": "Operos ir baleto teatras",
      "description": "link Žaliojo tilto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0233",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "9",
        "10",
        "17",
        "43",
        "46",
        "55",
        "56",
        "N3",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.69081,
        "longitude": 25.27732
      },
      "lks94": {
        "easting": 582349.612,
        "northing": 6062347.632
      }
    },
    {
      "id": "judu:stop:5249",
      "stopId": "5249",
      "name": "Operos ir baleto teatras",
      "description": "link Baltojo tilto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0232",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "9",
        "10",
        "17",
        "25",
        "43",
        "55",
        "56",
        "N1",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.69123,
        "longitude": 25.27574
      },
      "lks94": {
        "easting": 582246.905,
        "northing": 6062392.52
      }
    },
    {
      "id": "judu:stop:5257",
      "stopId": "5257",
      "name": "Kražių st.",
      "description": "link Gedimino pr.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0224",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "9",
        "10",
        "17",
        "40",
        "55",
        "57",
        "73",
        "125",
        "N1",
        "N4",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.69179,
        "longitude": 25.27091
      },
      "lks94": {
        "easting": 581934.404,
        "northing": 6062449.193
      }
    },
    {
      "id": "judu:stop:5258",
      "stopId": "5258",
      "name": "Kražių st.",
      "description": "link Žaliojo tilto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0225",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "9",
        "10",
        "17",
        "21",
        "22",
        "43",
        "55",
        "N3",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.69172,
        "longitude": 25.27116
      },
      "lks94": {
        "easting": 581950.661,
        "northing": 6062441.695
      }
    },
    {
      "id": "judu:stop:5259",
      "stopId": "5259",
      "name": "Vašingtono aikštė",
      "description": "šalia skvero",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0223",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "21",
        "22",
        "40",
        "57",
        "73",
        "125"
      ],
      "wgs84": {
        "latitude": 54.6916,
        "longitude": 25.26987
      },
      "lks94": {
        "easting": 581867.742,
        "northing": 6062426.835
      }
    },
    {
      "id": "judu:stop:5264",
      "stopId": "5264",
      "name": "Juozo Tumo-Vaižganto st.",
      "description": "link Tauro kalno",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0214",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3G",
        "4",
        "9",
        "10",
        "17",
        "21",
        "22",
        "43",
        "55",
        "57",
        "73",
        "123",
        "125"
      ],
      "wgs84": {
        "latitude": 54.68835,
        "longitude": 25.26799
      },
      "lks94": {
        "easting": 581753.079,
        "northing": 6062062.963
      }
    },
    {
      "id": "judu:stop:5266",
      "stopId": "5266",
      "name": "Mikalojaus Konstantino Čiurlionio st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0504",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3G",
        "9",
        "10",
        "11",
        "17",
        "43",
        "54",
        "55",
        "57",
        "73",
        "116",
        "125"
      ],
      "wgs84": {
        "latitude": 54.68082,
        "longitude": 25.26548
      },
      "lks94": {
        "easting": 581606.362,
        "northing": 6061222.056
      }
    },
    {
      "id": "judu:stop:5267",
      "stopId": "5267",
      "name": "Mikalojaus Konstantino Čiurlionio st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0503",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3G",
        "4",
        "6",
        "9",
        "10",
        "11",
        "12",
        "17",
        "21",
        "22",
        "43",
        "55",
        "57",
        "73",
        "116",
        "125",
        "N2",
        "N8",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.68203,
        "longitude": 25.26526
      },
      "lks94": {
        "easting": 581589.749,
        "northing": 6061356.457
      }
    },
    {
      "id": "judu:stop:5272",
      "stopId": "5272",
      "name": "Taraso Ševčenkos st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0511",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3G",
        "9",
        "10",
        "11",
        "17",
        "43",
        "54",
        "55",
        "57",
        "73",
        "116",
        "125"
      ],
      "wgs84": {
        "latitude": 54.67694,
        "longitude": 25.26749
      },
      "lks94": {
        "easting": 581743.767,
        "northing": 6060792.603
      }
    },
    {
      "id": "judu:stop:5289",
      "stopId": "5289",
      "name": "Saltoniškės",
      "description": "link Šeškinės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1901",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5",
        "40",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.70231,
        "longitude": 25.26185
      },
      "lks94": {
        "easting": 581329.3,
        "northing": 6063609.393
      }
    },
    {
      "id": "judu:stop:5290",
      "stopId": "5290",
      "name": "Šeškinė",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1902",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G",
        "3G-A",
        "5",
        "24",
        "40",
        "43",
        "46",
        "56",
        "57",
        "73",
        "125",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.70976,
        "longitude": 25.25213
      },
      "lks94": {
        "easting": 580688.064,
        "northing": 6064427.263
      }
    },
    {
      "id": "judu:stop:5294",
      "stopId": "5294",
      "name": "Ukmergės st.",
      "description": "link Laisvės pr.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1914",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "40",
        "43",
        "56",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.71201,
        "longitude": 25.2488
      },
      "lks94": {
        "easting": 580469.033,
        "northing": 6064673.836
      }
    },
    {
      "id": "judu:stop:5300",
      "stopId": "5300",
      "name": "Stotis",
      "description": "\"A\" stotelė",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0530a",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "2",
        "7",
        "15",
        "20",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.67071,
        "longitude": 25.2849
      },
      "lks94": {
        "easting": 582879.21,
        "northing": 6060119.699
      }
    },
    {
      "id": "judu:stop:5304",
      "stopId": "5304",
      "name": "Eišiškių plentas",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2601",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "7",
        "9",
        "41",
        "42",
        "43",
        "55",
        "78",
        "117",
        "118",
        "119",
        "122",
        "123",
        "125"
      ],
      "wgs84": {
        "latitude": 54.64925,
        "longitude": 25.26784
      },
      "lks94": {
        "easting": 581821.973,
        "northing": 6057711.5
      }
    },
    {
      "id": "judu:stop:5305",
      "stopId": "5305",
      "name": "Eišiškių plentas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2602",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "7",
        "9",
        "41",
        "42",
        "43",
        "55",
        "78",
        "117",
        "118",
        "119",
        "122",
        "123",
        "125"
      ],
      "wgs84": {
        "latitude": 54.65041,
        "longitude": 25.26936
      },
      "lks94": {
        "easting": 581917.73,
        "northing": 6057842.363
      }
    },
    {
      "id": "judu:stop:5307",
      "stopId": "5307",
      "name": "Metalo st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2606",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "7",
        "9",
        "41",
        "42",
        "43",
        "55",
        "78",
        "117",
        "118",
        "119",
        "122",
        "123",
        "125"
      ],
      "wgs84": {
        "latitude": 54.64632,
        "longitude": 25.26573
      },
      "lks94": {
        "easting": 581691.684,
        "northing": 6057382.977
      }
    },
    {
      "id": "judu:stop:5310",
      "stopId": "5310",
      "name": "Metalo st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2609",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "117",
        "118",
        "119",
        "122",
        "123",
        "125"
      ],
      "wgs84": {
        "latitude": 54.64556,
        "longitude": 25.26567
      },
      "lks94": {
        "easting": 581689.336,
        "northing": 6057298.33
      }
    },
    {
      "id": "judu:stop:5313",
      "stopId": "5313",
      "name": "Geologų st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2617",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "117",
        "118",
        "119",
        "122",
        "123",
        "125"
      ],
      "wgs84": {
        "latitude": 54.63868,
        "longitude": 25.26684
      },
      "lks94": {
        "easting": 581778.655,
        "northing": 6056534.046
      }
    },
    {
      "id": "judu:stop:5315",
      "stopId": "5315",
      "name": "Katilinė",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2623",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "117",
        "118",
        "119",
        "122",
        "123",
        "125"
      ],
      "wgs84": {
        "latitude": 54.63486,
        "longitude": 25.26604
      },
      "lks94": {
        "easting": 581734.677,
        "northing": 6056108.004
      }
    },
    {
      "id": "judu:stop:5316",
      "stopId": "5316",
      "name": "Meistrų st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2639",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3"
      ],
      "wgs84": {
        "latitude": 54.63085,
        "longitude": 25.25945
      },
      "lks94": {
        "easting": 581317.254,
        "northing": 6055654.101
      }
    },
    {
      "id": "judu:stop:5317",
      "stopId": "5317",
      "name": "Pameistrių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2640",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3"
      ],
      "wgs84": {
        "latitude": 54.63078,
        "longitude": 25.26474
      },
      "lks94": {
        "easting": 581658.928,
        "northing": 6055652.447
      }
    },
    {
      "id": "judu:stop:5319",
      "stopId": "5319",
      "name": "Elektros st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2627",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3"
      ],
      "wgs84": {
        "latitude": 54.63399,
        "longitude": 25.25666
      },
      "lks94": {
        "easting": 581130.874,
        "northing": 6056000.312
      }
    },
    {
      "id": "judu:stop:5320",
      "stopId": "5320",
      "name": "Verslo st.",
      "description": "nuo Eišiškių pl.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2626",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.63701,
        "longitude": 25.25814
      },
      "lks94": {
        "easting": 581220.4,
        "northing": 6056338.105
      }
    },
    {
      "id": "judu:stop:5332",
      "stopId": "5332",
      "name": "Pamėnkalnio st.",
      "description": "link Senamiesčio",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0215",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "6",
        "7",
        "11",
        "12",
        "21",
        "N1",
        "N2",
        "N4",
        "N6",
        "N8",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.68736,
        "longitude": 25.26934
      },
      "lks94": {
        "easting": 581842.107,
        "northing": 6061954.363
      }
    },
    {
      "id": "judu:stop:5334",
      "stopId": "5334",
      "name": "Islandijos st.",
      "description": "link Žvėryno",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0212c",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "6",
        "7",
        "11",
        "12",
        "N3",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.685,
        "longitude": 25.27641
      },
      "lks94": {
        "easting": 582302.703,
        "northing": 6061699.991
      }
    },
    {
      "id": "judu:stop:5338",
      "stopId": "5338",
      "name": "Islandijos st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0235d",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "1G",
        "2",
        "2G",
        "7",
        "10",
        "11",
        "15",
        "20",
        "21",
        "53",
        "88",
        "N2",
        "N8",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.68371,
        "longitude": 25.27701
      },
      "lks94": {
        "easting": 582344,
        "northing": 6061557.136
      }
    },
    {
      "id": "judu:stop:5339",
      "stopId": "5339",
      "name": "Reformatų st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0407",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "N2",
        "N8",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.68117,
        "longitude": 25.27731
      },
      "lks94": {
        "easting": 582368.486,
        "northing": 6061274.821
      }
    },
    {
      "id": "judu:stop:5345",
      "stopId": "5345",
      "name": "MO muziejus",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0409",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "1G",
        "2",
        "2G",
        "7",
        "10",
        "11",
        "15",
        "20",
        "21",
        "53",
        "88",
        "N2",
        "N8",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.67934,
        "longitude": 25.27802
      },
      "lks94": {
        "easting": 582417.976,
        "northing": 6061072
      }
    },
    {
      "id": "judu:stop:5346",
      "stopId": "5346",
      "name": "MO muziejus",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0410",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "1G",
        "2",
        "2G",
        "7",
        "10",
        "11",
        "15",
        "20",
        "53",
        "88",
        "N5",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.67902,
        "longitude": 25.27855
      },
      "lks94": {
        "easting": 582452.802,
        "northing": 6061037.011
      }
    },
    {
      "id": "judu:stop:5347",
      "stopId": "5347",
      "name": "Tauragnų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0708",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "6",
        "9",
        "10",
        "25",
        "26",
        "27",
        "34",
        "35",
        "36",
        "37",
        "49",
        "50",
        "53",
        "55",
        "56",
        "63",
        "65",
        "66",
        "89",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.71169,
        "longitude": 25.28625
      },
      "lks94": {
        "easting": 582882.722,
        "northing": 6064681.805
      }
    },
    {
      "id": "judu:stop:5349",
      "stopId": "5349",
      "name": "Vingriai",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0411",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "2",
        "7",
        "10",
        "11",
        "15",
        "20",
        "21",
        "53",
        "88",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.67665,
        "longitude": 25.28086
      },
      "lks94": {
        "easting": 582606.575,
        "northing": 6060775.978
      }
    },
    {
      "id": "judu:stop:5351",
      "stopId": "5351",
      "name": "Giedraičių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0707",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "6",
        "9",
        "10",
        "25",
        "26",
        "27",
        "30",
        "34",
        "35",
        "36",
        "37",
        "49",
        "50",
        "53",
        "55",
        "56",
        "63",
        "65",
        "66",
        "89",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.70734,
        "longitude": 25.28494
      },
      "lks94": {
        "easting": 582807.176,
        "northing": 6064196.162
      }
    },
    {
      "id": "judu:stop:5355",
      "stopId": "5355",
      "name": "Bazilijonų st.",
      "description": "link Aušros vartų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5153",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "10",
        "11",
        "13",
        "31",
        "34",
        "74",
        "88",
        "89"
      ],
      "wgs84": {
        "latitude": 54.67408,
        "longitude": 25.28657
      },
      "lks94": {
        "easting": 582980.051,
        "northing": 6060496.705
      }
    },
    {
      "id": "judu:stop:5358",
      "stopId": "5358",
      "name": "Aušros vartai",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0417",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "10",
        "11",
        "13",
        "31",
        "34",
        "74",
        "89"
      ],
      "wgs84": {
        "latitude": 54.67473,
        "longitude": 25.29278
      },
      "lks94": {
        "easting": 583379.224,
        "northing": 6060576.397
      }
    },
    {
      "id": "judu:stop:5360",
      "stopId": "5360",
      "name": "Misionierių st.",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0420",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "10",
        "11",
        "13",
        "31",
        "34",
        "74",
        "89"
      ],
      "wgs84": {
        "latitude": 54.6766,
        "longitude": 25.29735
      },
      "lks94": {
        "easting": 583670.109,
        "northing": 6060789.938
      }
    },
    {
      "id": "judu:stop:5362",
      "stopId": "5362",
      "name": "Subačiaus st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0422",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "10",
        "13",
        "31",
        "34",
        "74",
        "89"
      ],
      "wgs84": {
        "latitude": 54.67701,
        "longitude": 25.30362
      },
      "lks94": {
        "easting": 584073.61,
        "northing": 6060843.055
      }
    },
    {
      "id": "judu:stop:5372",
      "stopId": "5372",
      "name": "Rudens st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1213",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "6G",
        "14",
        "18",
        "27",
        "31",
        "37",
        "58",
        "67",
        "74",
        "115",
        "119"
      ],
      "wgs84": {
        "latitude": 54.6864,
        "longitude": 25.32505
      },
      "lks94": {
        "easting": 585435.88,
        "northing": 6061913.896
      }
    },
    {
      "id": "judu:stop:5373",
      "stopId": "5373",
      "name": "Šaudykla",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1215",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "18",
        "27",
        "31",
        "37",
        "58",
        "67",
        "74",
        "115",
        "119"
      ],
      "wgs84": {
        "latitude": 54.68902,
        "longitude": 25.33243
      },
      "lks94": {
        "easting": 585906.161,
        "northing": 6062214.47
      }
    },
    {
      "id": "judu:stop:5378",
      "stopId": "5378",
      "name": "Kalvarijų turgus",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0703",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1G",
        "2G",
        "3G",
        "6",
        "9",
        "10",
        "25",
        "30",
        "53",
        "55",
        "56",
        "63",
        "89",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.69931,
        "longitude": 25.28249
      },
      "lks94": {
        "easting": 582665.625,
        "northing": 6063299.643
      }
    },
    {
      "id": "judu:stop:5381",
      "stopId": "5381",
      "name": "Viadukas",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2307",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "27"
      ],
      "wgs84": {
        "latitude": 54.69301,
        "longitude": 25.34898
      },
      "lks94": {
        "easting": 586964.597,
        "northing": 6062678.876
      }
    },
    {
      "id": "judu:stop:5382",
      "stopId": "5382",
      "name": "Viadukas",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2306",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "27"
      ],
      "wgs84": {
        "latitude": 54.69397,
        "longitude": 25.3492
      },
      "lks94": {
        "easting": 586976.725,
        "northing": 6062785.983
      }
    },
    {
      "id": "judu:stop:5383",
      "stopId": "5383",
      "name": "Girininkija",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2308",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "27"
      ],
      "wgs84": {
        "latitude": 54.69439,
        "longitude": 25.36363
      },
      "lks94": {
        "easting": 587905.995,
        "northing": 6062850.697
      }
    },
    {
      "id": "judu:stop:5384",
      "stopId": "5384",
      "name": "Girininkija",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2309",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "27"
      ],
      "wgs84": {
        "latitude": 54.69459,
        "longitude": 25.36486
      },
      "lks94": {
        "easting": 587984.849,
        "northing": 6062874.495
      }
    },
    {
      "id": "judu:stop:5385",
      "stopId": "5385",
      "name": "Kučkuriškės",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2311",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "27"
      ],
      "wgs84": {
        "latitude": 54.69551,
        "longitude": 25.36901
      },
      "lks94": {
        "easting": 588250.363,
        "northing": 6062982.086
      }
    },
    {
      "id": "judu:stop:5387",
      "stopId": "5387",
      "name": "Kučkuriškės",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2310",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "27"
      ],
      "wgs84": {
        "latitude": 54.69581,
        "longitude": 25.36955
      },
      "lks94": {
        "easting": 588284.519,
        "northing": 6063016.151
      }
    },
    {
      "id": "judu:stop:5388",
      "stopId": "5388",
      "name": "Užtvankos st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2318",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "27"
      ],
      "wgs84": {
        "latitude": 54.6967,
        "longitude": 25.38105
      },
      "lks94": {
        "easting": 589023.841,
        "northing": 6063129.718
      }
    },
    {
      "id": "judu:stop:5389",
      "stopId": "5389",
      "name": "Užtvankos st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2319",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "27"
      ],
      "wgs84": {
        "latitude": 54.6965,
        "longitude": 25.38113
      },
      "lks94": {
        "easting": 589029.435,
        "northing": 6063107.563
      }
    },
    {
      "id": "judu:stop:5390",
      "stopId": "5390",
      "name": "Širšių st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2320",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "27"
      ],
      "wgs84": {
        "latitude": 54.69566,
        "longitude": 25.38774
      },
      "lks94": {
        "easting": 589457.345,
        "northing": 6063022.487
      }
    },
    {
      "id": "judu:stop:5391",
      "stopId": "5391",
      "name": "Širšių st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2321",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "27"
      ],
      "wgs84": {
        "latitude": 54.69561,
        "longitude": 25.3893
      },
      "lks94": {
        "easting": 589558.01,
        "northing": 6063018.912
      }
    },
    {
      "id": "judu:stop:5394",
      "stopId": "5394",
      "name": "Alberto Kojelavičiaus st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2323",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "18",
        "115"
      ],
      "wgs84": {
        "latitude": 54.69465,
        "longitude": 25.39674
      },
      "lks94": {
        "easting": 590039.707,
        "northing": 6062921.596
      }
    },
    {
      "id": "judu:stop:5396",
      "stopId": "5396",
      "name": "Dūmų st.",
      "description": "link S. Batoro g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2340",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "18",
        "115"
      ],
      "wgs84": {
        "latitude": 54.69318,
        "longitude": 25.40137
      },
      "lks94": {
        "easting": 590341.422,
        "northing": 6062763.956
      }
    },
    {
      "id": "judu:stop:5399",
      "stopId": "5399",
      "name": "Tremtinių st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2347",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "67"
      ],
      "wgs84": {
        "latitude": 54.6931,
        "longitude": 25.41141
      },
      "lks94": {
        "easting": 590988.802,
        "northing": 6062768.02
      }
    },
    {
      "id": "judu:stop:5400",
      "stopId": "5400",
      "name": "Tremtinių st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2345",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "6G",
        "14",
        "18",
        "31",
        "67",
        "74",
        "115",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.6929,
        "longitude": 25.40981
      },
      "lks94": {
        "easting": 590886.109,
        "northing": 6062743.69
      }
    },
    {
      "id": "judu:stop:5403",
      "stopId": "5403",
      "name": "Pramonės st.",
      "description": "link Linksmosios g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2363",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "67"
      ],
      "wgs84": {
        "latitude": 54.69435,
        "longitude": 25.41807
      },
      "lks94": {
        "easting": 591415.31,
        "northing": 6062915.778
      }
    },
    {
      "id": "judu:stop:5406",
      "stopId": "5406",
      "name": "Neries st.",
      "description": "link Linksmosios g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2369",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "67"
      ],
      "wgs84": {
        "latitude": 54.69563,
        "longitude": 25.42869
      },
      "lks94": {
        "easting": 592096.978,
        "northing": 6063072.103
      }
    },
    {
      "id": "judu:stop:5408",
      "stopId": "5408",
      "name": "Neries st.",
      "description": "link Pergalės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2368",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "67"
      ],
      "wgs84": {
        "latitude": 54.69572,
        "longitude": 25.42939
      },
      "lks94": {
        "easting": 592141.895,
        "northing": 6063083.037
      }
    },
    {
      "id": "judu:stop:5409",
      "stopId": "5409",
      "name": "Vinco Kudirkos aikštė",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0211",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1G",
        "2",
        "2G",
        "3",
        "6",
        "10",
        "12",
        "15",
        "20",
        "53",
        "88",
        "N3",
        "N7",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.68871,
        "longitude": 25.27982
      },
      "lks94": {
        "easting": 582515.041,
        "northing": 6062116.866
      }
    },
    {
      "id": "judu:stop:5411",
      "stopId": "5411",
      "name": "Pramonės st.",
      "description": "link Pergalės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2362",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "67"
      ],
      "wgs84": {
        "latitude": 54.69448,
        "longitude": 25.41865
      },
      "lks94": {
        "easting": 591452.405,
        "northing": 6062931
      }
    },
    {
      "id": "judu:stop:5415",
      "stopId": "5415",
      "name": "Dūmų st.",
      "description": "link Šiaurės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2339",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "18",
        "115"
      ],
      "wgs84": {
        "latitude": 54.69318,
        "longitude": 25.40036
      },
      "lks94": {
        "easting": 590276.316,
        "northing": 6062762.656
      }
    },
    {
      "id": "judu:stop:5417",
      "stopId": "5417",
      "name": "Alberto Kojelavičiaus st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2322",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "27"
      ],
      "wgs84": {
        "latitude": 54.69516,
        "longitude": 25.3957
      },
      "lks94": {
        "easting": 589971.54,
        "northing": 6062977.017
      }
    },
    {
      "id": "judu:stop:5421",
      "stopId": "5421",
      "name": "Mildos st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1216",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "18",
        "27",
        "31",
        "67",
        "74",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.69162,
        "longitude": 25.34337
      },
      "lks94": {
        "easting": 586605.92,
        "northing": 6062517.254
      }
    },
    {
      "id": "judu:stop:5423",
      "stopId": "5423",
      "name": "Šaudykla",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1214",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "18",
        "27",
        "31",
        "37",
        "67",
        "74",
        "119",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.68899,
        "longitude": 25.33066
      },
      "lks94": {
        "easting": 585792.114,
        "northing": 6062208.967
      }
    },
    {
      "id": "judu:stop:5424",
      "stopId": "5424",
      "name": "Rudens st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1212",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "6G",
        "14",
        "18",
        "27",
        "31",
        "37",
        "67",
        "74",
        "119",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.68599,
        "longitude": 25.32358
      },
      "lks94": {
        "easting": 585341.964,
        "northing": 6061866.482
      }
    },
    {
      "id": "judu:stop:5425",
      "stopId": "5425",
      "name": "Belmontas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1211",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "18",
        "27",
        "31",
        "37",
        "67",
        "74",
        "119",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.68379,
        "longitude": 25.3194
      },
      "lks94": {
        "easting": 585077.062,
        "northing": 6061616.58
      }
    },
    {
      "id": "judu:stop:5428",
      "stopId": "5428",
      "name": "Misionierių st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0421",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "10",
        "11",
        "13",
        "31",
        "34",
        "74",
        "89"
      ],
      "wgs84": {
        "latitude": 54.67662,
        "longitude": 25.29652
      },
      "lks94": {
        "easting": 583616.542,
        "northing": 6060791.175
      }
    },
    {
      "id": "judu:stop:5430",
      "stopId": "5430",
      "name": "Gėlių st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0412",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "2",
        "7",
        "15",
        "20",
        "21",
        "53",
        "89",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.67424,
        "longitude": 25.28366
      },
      "lks94": {
        "easting": 582792.049,
        "northing": 6060511.076
      }
    },
    {
      "id": "judu:stop:5432",
      "stopId": "5432",
      "name": "Reformatų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0406",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "2",
        "7",
        "10",
        "11",
        "15",
        "20",
        "53",
        "88",
        "N5",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.68149,
        "longitude": 25.2774
      },
      "lks94": {
        "easting": 582373.642,
        "northing": 6061310.538
      }
    },
    {
      "id": "judu:stop:5443",
      "stopId": "5443",
      "name": "Gedvydžių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3322",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G",
        "87"
      ],
      "wgs84": {
        "latitude": 54.73413,
        "longitude": 25.2342
      },
      "lks94": {
        "easting": 579485.004,
        "northing": 6067118.876
      }
    },
    {
      "id": "judu:stop:5450",
      "stopId": "5450",
      "name": "Stasio Lozoraičio st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3323",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G-A",
        "5",
        "24",
        "57",
        "87",
        "125"
      ],
      "wgs84": {
        "latitude": 54.72401,
        "longitude": 25.24241
      },
      "lks94": {
        "easting": 580033.659,
        "northing": 6066001.977
      }
    },
    {
      "id": "judu:stop:5451",
      "stopId": "5451",
      "name": "Igno Šeiniaus st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3325",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G",
        "3G-A",
        "5",
        "24",
        "57",
        "87",
        "125"
      ],
      "wgs84": {
        "latitude": 54.72179,
        "longitude": 25.24353
      },
      "lks94": {
        "easting": 580110.181,
        "northing": 6065756.197
      }
    },
    {
      "id": "judu:stop:5452",
      "stopId": "5452",
      "name": "Šeškinės poliklinika",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1932",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G",
        "3G-A",
        "5",
        "24",
        "57",
        "87",
        "125"
      ],
      "wgs84": {
        "latitude": 54.71545,
        "longitude": 25.24715
      },
      "lks94": {
        "easting": 580355.914,
        "northing": 6065054.773
      }
    },
    {
      "id": "judu:stop:5459",
      "stopId": "5459",
      "name": "Islandijos st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0207a",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "6",
        "6G",
        "10",
        "12",
        "15",
        "20",
        "53",
        "88",
        "N1",
        "N5",
        "N8",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.68526,
        "longitude": 25.27821
      },
      "lks94": {
        "easting": 582418.234,
        "northing": 6061731.037
      }
    },
    {
      "id": "judu:stop:5462",
      "stopId": "5462",
      "name": "Linkmenų st.",
      "description": "link Žirmūnų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0702",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5",
        "49"
      ],
      "wgs84": {
        "latitude": 54.70453,
        "longitude": 25.27236
      },
      "lks94": {
        "easting": 582002.179,
        "northing": 6063868.678
      }
    },
    {
      "id": "judu:stop:5467",
      "stopId": "5467",
      "name": "Žalgirio st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0705",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1G",
        "2G",
        "3G",
        "6",
        "9",
        "10",
        "25",
        "30",
        "53",
        "55",
        "56",
        "63",
        "89",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.70308,
        "longitude": 25.28353
      },
      "lks94": {
        "easting": 582724.984,
        "northing": 6063720.419
      }
    },
    {
      "id": "judu:stop:5469",
      "stopId": "5469",
      "name": "Tauragnų st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0803",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "6",
        "9",
        "10",
        "26",
        "34",
        "35",
        "36",
        "37",
        "49",
        "50",
        "53",
        "55",
        "56",
        "63",
        "65",
        "66",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.71144,
        "longitude": 25.28659
      },
      "lks94": {
        "easting": 582905.139,
        "northing": 6064654.385
      }
    },
    {
      "id": "judu:stop:5476",
      "stopId": "5476",
      "name": "Lizdeikos st.",
      "description": "link Antakalnio",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1121",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "5G",
        "6",
        "10",
        "17",
        "18",
        "39",
        "50",
        "114",
        "115",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.72728,
        "longitude": 25.31552
      },
      "lks94": {
        "easting": 584736.174,
        "northing": 6066451.718
      }
    },
    {
      "id": "judu:stop:5481",
      "stopId": "5481",
      "name": "Pramogų arena",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0709",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1G",
        "2G",
        "3G",
        "9",
        "10",
        "25",
        "26",
        "27",
        "34",
        "35",
        "36",
        "37",
        "49",
        "50",
        "53",
        "55",
        "56",
        "63",
        "65",
        "66",
        "89",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.71448,
        "longitude": 25.28664
      },
      "lks94": {
        "easting": 582902.159,
        "northing": 6064992.756
      }
    },
    {
      "id": "judu:stop:5483",
      "stopId": "5483",
      "name": "Antakalnio žiedas",
      "description": "visos kryptys, autobusai",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1118a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "15",
        "17",
        "18",
        "38",
        "39",
        "50",
        "115"
      ],
      "wgs84": {
        "latitude": 54.72232,
        "longitude": 25.31887
      },
      "lks94": {
        "easting": 584962.319,
        "northing": 6065903.788
      }
    },
    {
      "id": "judu:stop:5485",
      "stopId": "5485",
      "name": "Antakalnio žiedas",
      "description": "visos kryptys",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1118c",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "5G",
        "10",
        "114",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.72274,
        "longitude": 25.31912
      },
      "lks94": {
        "easting": 584977.544,
        "northing": 6065950.831
      }
    },
    {
      "id": "judu:stop:5490",
      "stopId": "5490",
      "name": "Lizdeikos st.",
      "description": "link Žirmūnų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1132",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "5G",
        "10",
        "17",
        "18",
        "39",
        "50",
        "114",
        "115",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.7272,
        "longitude": 25.31625
      },
      "lks94": {
        "easting": 584783.36,
        "northing": 6066443.697
      }
    },
    {
      "id": "judu:stop:5491",
      "stopId": "5491",
      "name": "Oskaro Milašiaus st.",
      "description": "link Žirmūnų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3501",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "10",
        "17",
        "18",
        "39",
        "50",
        "114",
        "115",
        "121",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.72783,
        "longitude": 25.31438
      },
      "lks94": {
        "easting": 584661.601,
        "northing": 6066511.549
      }
    },
    {
      "id": "judu:stop:5492",
      "stopId": "5492",
      "name": "Vinco Kudirkos aikštė",
      "description": "link Žaliojo tilto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0210",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1G",
        "2",
        "2G",
        "3",
        "6",
        "10",
        "12",
        "15",
        "20",
        "53",
        "88",
        "N1",
        "N4",
        "N5",
        "N6",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.68753,
        "longitude": 25.2798
      },
      "lks94": {
        "easting": 582516.145,
        "northing": 6061985.525
      }
    },
    {
      "id": "judu:stop:5494",
      "stopId": "5494",
      "name": "Valakampių tiltas",
      "description": "link Žirmūnų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0819",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3",
        "10",
        "17",
        "18",
        "39",
        "50",
        "114",
        "115",
        "121",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.72356,
        "longitude": 25.30725
      },
      "lks94": {
        "easting": 584211.224,
        "northing": 6066027.777
      }
    },
    {
      "id": "judu:stop:5498",
      "stopId": "5498",
      "name": "Žalgirio st.",
      "description": "link Geležinio Vilko g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0706",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5",
        "49",
        "69"
      ],
      "wgs84": {
        "latitude": 54.7039,
        "longitude": 25.28302
      },
      "lks94": {
        "easting": 582690.448,
        "northing": 6063811.073
      }
    },
    {
      "id": "judu:stop:5499",
      "stopId": "5499",
      "name": "Linkmenų st.",
      "description": "link Geležinio Vilko g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0701",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5",
        "49",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.70487,
        "longitude": 25.26979
      },
      "lks94": {
        "easting": 581835.87,
        "northing": 6063903.516
      }
    },
    {
      "id": "judu:stop:5505",
      "stopId": "5505",
      "name": "Žirmūnų žiedas",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0818",
      "modes": [
        "trolleybus"
      ],
      "routeShortNames": [
        "6",
        "9",
        "12",
        "17",
        "20",
        "21"
      ],
      "wgs84": {
        "latitude": 54.72666,
        "longitude": 25.2971
      },
      "lks94": {
        "easting": 583551.036,
        "northing": 6066360.633
      }
    },
    {
      "id": "judu:stop:5508",
      "stopId": "5508",
      "name": "Šaltinėlio st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0817",
      "modes": [
        "trolleybus"
      ],
      "routeShortNames": [
        "6",
        "9",
        "12",
        "17",
        "20",
        "21"
      ],
      "wgs84": {
        "latitude": 54.72657,
        "longitude": 25.29674
      },
      "lks94": {
        "easting": 583528.033,
        "northing": 6066350.188
      }
    },
    {
      "id": "judu:stop:5512",
      "stopId": "5512",
      "name": "Fabijoniškių žiedas",
      "description": "išlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3811",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G-A",
        "5",
        "24",
        "53",
        "56",
        "57"
      ],
      "wgs84": {
        "latitude": 54.74009,
        "longitude": 25.24062
      },
      "lks94": {
        "easting": 579886.715,
        "northing": 6067789.442
      }
    },
    {
      "id": "judu:stop:5518",
      "stopId": "5518",
      "name": "Takas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3803",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "40",
        "52",
        "125",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.73296,
        "longitude": 25.23689
      },
      "lks94": {
        "easting": 579660.532,
        "northing": 6066991.72
      }
    },
    {
      "id": "judu:stop:5519",
      "stopId": "5519",
      "name": "Takas",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3804",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "40",
        "52",
        "125",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.73416,
        "longitude": 25.23594
      },
      "lks94": {
        "easting": 579596.999,
        "northing": 6067124.187
      }
    },
    {
      "id": "judu:stop:5524",
      "stopId": "5524",
      "name": "Algirdo st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0501",
      "modes": [
        "trolleybus"
      ],
      "routeShortNames": [
        "6",
        "12"
      ],
      "wgs84": {
        "latitude": 54.68197,
        "longitude": 25.2682
      },
      "lks94": {
        "easting": 581779.444,
        "northing": 6061353.2
      }
    },
    {
      "id": "judu:stop:5532",
      "stopId": "5532",
      "name": "Gerosios Vilties st.",
      "description": "iš centro, autobusų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0606",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "4",
        "4G",
        "6",
        "7",
        "12",
        "15",
        "16",
        "21",
        "22",
        "29",
        "54",
        "55",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.6708,
        "longitude": 25.24196
      },
      "lks94": {
        "easting": 580109.443,
        "northing": 6060079.882
      }
    },
    {
      "id": "judu:stop:5533",
      "stopId": "5533",
      "name": "Studentų st.",
      "description": "link Žirmūnų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0320",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "22",
        "40",
        "46",
        "57",
        "73",
        "89",
        "125"
      ],
      "wgs84": {
        "latitude": 54.69729,
        "longitude": 25.26327
      },
      "lks94": {
        "easting": 581430.871,
        "northing": 6063052.38
      }
    },
    {
      "id": "judu:stop:5534",
      "stopId": "5534",
      "name": "Studentų st.",
      "description": "link Pilaitės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0108",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "21",
        "22",
        "24",
        "57",
        "73",
        "89",
        "125"
      ],
      "wgs84": {
        "latitude": 54.69724,
        "longitude": 25.2643
      },
      "lks94": {
        "easting": 581497.362,
        "northing": 6063048.011
      }
    },
    {
      "id": "judu:stop:5535",
      "stopId": "5535",
      "name": "Gerosios Vilties st.",
      "description": "link centro, troleibusų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0607",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "4",
        "4G",
        "6",
        "7",
        "12",
        "15",
        "16",
        "21",
        "22",
        "29",
        "54",
        "55",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.6704,
        "longitude": 25.24159
      },
      "lks94": {
        "easting": 580086.365,
        "northing": 6060034.945
      }
    },
    {
      "id": "judu:stop:5539",
      "stopId": "5539",
      "name": "Alberto Goštauto st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0221",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "22",
        "40",
        "46",
        "56",
        "57",
        "73",
        "123",
        "125",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.69456,
        "longitude": 25.26747
      },
      "lks94": {
        "easting": 581707.076,
        "northing": 6062753.447
      }
    },
    {
      "id": "judu:stop:5542",
      "stopId": "5542",
      "name": "Vilkpėdės st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2404",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "6",
        "8",
        "12",
        "15",
        "18",
        "24",
        "25",
        "123"
      ],
      "wgs84": {
        "latitude": 54.66478,
        "longitude": 25.23679
      },
      "lks94": {
        "easting": 579787.782,
        "northing": 6059404.051
      }
    },
    {
      "id": "judu:stop:5543",
      "stopId": "5543",
      "name": "Vilkpėdės st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2405",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "6",
        "8",
        "12",
        "15",
        "18",
        "20",
        "24",
        "25",
        "28",
        "51",
        "62",
        "123",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.66331,
        "longitude": 25.23548
      },
      "lks94": {
        "easting": 579706.154,
        "northing": 6059238.972
      }
    },
    {
      "id": "judu:stop:5546",
      "stopId": "5546",
      "name": "Baldai",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2410",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "6",
        "8",
        "12",
        "15",
        "18",
        "20",
        "24",
        "25",
        "28",
        "51",
        "62",
        "123",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.65066,
        "longitude": 25.21825
      },
      "lks94": {
        "easting": 578619.048,
        "northing": 6057811.777
      }
    },
    {
      "id": "judu:stop:5549",
      "stopId": "5549",
      "name": "„Lelija“",
      "description": "link Vilkpedės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0523",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "13"
      ],
      "wgs84": {
        "latitude": 54.66815,
        "longitude": 25.26369
      },
      "lks94": {
        "easting": 581516.313,
        "northing": 6059809.98
      }
    },
    {
      "id": "judu:stop:5550",
      "stopId": "5550",
      "name": "„Lelija“",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0524",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "13"
      ],
      "wgs84": {
        "latitude": 54.66823,
        "longitude": 25.2646
      },
      "lks94": {
        "easting": 581574.851,
        "northing": 6059819.939
      }
    },
    {
      "id": "judu:stop:5552",
      "stopId": "5552",
      "name": "Smolensko st.",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0525",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "13"
      ],
      "wgs84": {
        "latitude": 54.66742,
        "longitude": 25.26005
      },
      "lks94": {
        "easting": 581282.98,
        "northing": 6059724.522
      }
    },
    {
      "id": "judu:stop:5553",
      "stopId": "5553",
      "name": "Smolensko st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0526",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "13"
      ],
      "wgs84": {
        "latitude": 54.66714,
        "longitude": 25.25911
      },
      "lks94": {
        "easting": 581222.905,
        "northing": 6059692.274
      }
    },
    {
      "id": "judu:stop:5554",
      "stopId": "5554",
      "name": "Žemieji Paneriai",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2413",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "6",
        "8",
        "12",
        "15",
        "18",
        "20",
        "24",
        "25",
        "28",
        "51",
        "62",
        "123",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.64608,
        "longitude": 25.20948
      },
      "lks94": {
        "easting": 578061.886,
        "northing": 6057292.304
      }
    },
    {
      "id": "judu:stop:5557",
      "stopId": "5557",
      "name": "Valkininkų st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2417",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "15",
        "18",
        "24",
        "123"
      ],
      "wgs84": {
        "latitude": 54.64406,
        "longitude": 25.20256
      },
      "lks94": {
        "easting": 577619.127,
        "northing": 6057059.836
      }
    },
    {
      "id": "judu:stop:5564",
      "stopId": "5564",
      "name": "Valkininkų st.",
      "description": "link Savanorių pr.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2901",
      "modes": [
        "trolleybus"
      ],
      "routeShortNames": [
        "15",
        "18"
      ],
      "wgs84": {
        "latitude": 54.64395,
        "longitude": 25.19972
      },
      "lks94": {
        "easting": 577436.038,
        "northing": 6057044.46
      }
    },
    {
      "id": "judu:stop:5567",
      "stopId": "5567",
      "name": "Vaduvos st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2414",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "6",
        "8",
        "12",
        "15",
        "18",
        "20",
        "24",
        "25",
        "28",
        "51",
        "62",
        "123",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.64487,
        "longitude": 25.20712
      },
      "lks94": {
        "easting": 577911.889,
        "northing": 6057155.027
      }
    },
    {
      "id": "judu:stop:5570",
      "stopId": "5570",
      "name": "Šaltupio st.",
      "description": "link Savanorių pr.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2419",
      "modes": [
        "trolleybus"
      ],
      "routeShortNames": [
        "15",
        "18"
      ],
      "wgs84": {
        "latitude": 54.64676,
        "longitude": 25.19113
      },
      "lks94": {
        "easting": 576876.319,
        "northing": 6057347.741
      }
    },
    {
      "id": "judu:stop:5571",
      "stopId": "5571",
      "name": "Šaltupio st.",
      "description": "link žiedo",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2420",
      "modes": [
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "15",
        "18"
      ],
      "wgs84": {
        "latitude": 54.64734,
        "longitude": 25.19038
      },
      "lks94": {
        "easting": 576826.822,
        "northing": 6057411.467
      }
    },
    {
      "id": "judu:stop:5573",
      "stopId": "5573",
      "name": "Riovonys",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2407",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "6",
        "8",
        "12",
        "15",
        "18",
        "20",
        "24",
        "25",
        "28",
        "51",
        "62",
        "123",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.65893,
        "longitude": 25.23233
      },
      "lks94": {
        "easting": 579511.498,
        "northing": 6058747.966
      }
    },
    {
      "id": "judu:stop:5579",
      "stopId": "5579",
      "name": "Simono Konarskio st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0507",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "6",
        "12",
        "21",
        "22",
        "54",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.67986,
        "longitude": 25.25964
      },
      "lks94": {
        "easting": 581231.697,
        "northing": 6061108.449
      }
    },
    {
      "id": "judu:stop:5580",
      "stopId": "5580",
      "name": "Simono Konarskio st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0506",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "6",
        "12",
        "21",
        "22",
        "54",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.67947,
        "longitude": 25.25932
      },
      "lks94": {
        "easting": 581211.841,
        "northing": 6061064.677
      }
    },
    {
      "id": "judu:stop:5587",
      "stopId": "5587",
      "name": "Pakalniškių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2409",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "6",
        "8",
        "12",
        "15",
        "18",
        "20",
        "24",
        "25",
        "28",
        "51",
        "62",
        "123",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.65416,
        "longitude": 25.22384
      },
      "lks94": {
        "easting": 578972.99,
        "northing": 6058207.551
      }
    },
    {
      "id": "judu:stop:5588",
      "stopId": "5588",
      "name": "Baldai",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2411",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "6",
        "8",
        "12",
        "15",
        "18",
        "20",
        "24",
        "25",
        "28",
        "51",
        "62",
        "123",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.64983,
        "longitude": 25.21614
      },
      "lks94": {
        "easting": 578484.486,
        "northing": 6057717.05
      }
    },
    {
      "id": "judu:stop:5594",
      "stopId": "5594",
      "name": "Ūmėdžių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2416",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "6",
        "12",
        "15",
        "18",
        "24",
        "123"
      ],
      "wgs84": {
        "latitude": 54.64262,
        "longitude": 25.20425
      },
      "lks94": {
        "easting": 577730.95,
        "northing": 6056901.452
      }
    },
    {
      "id": "judu:stop:5606",
      "stopId": "5606",
      "name": "Šiaurės miestelis",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0901",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "9",
        "12",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "27",
        "30",
        "31",
        "33",
        "42",
        "58",
        "67",
        "69",
        "74",
        "78",
        "82",
        "89",
        "114",
        "N3",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.71182,
        "longitude": 25.30509
      },
      "lks94": {
        "easting": 584096.386,
        "northing": 6064718.684
      }
    },
    {
      "id": "judu:stop:5613",
      "stopId": "5613",
      "name": "Čiunės Sugiharos st.",
      "description": "link Laisvės pr.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1816",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "7"
      ],
      "wgs84": {
        "latitude": 54.7051,
        "longitude": 25.23405
      },
      "lks94": {
        "easting": 579532.156,
        "northing": 6063888.029
      }
    },
    {
      "id": "judu:stop:5614",
      "stopId": "5614",
      "name": "Čiunės Sugiharos st.",
      "description": "link Ozo g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1817",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "7"
      ],
      "wgs84": {
        "latitude": 54.70479,
        "longitude": 25.23527
      },
      "lks94": {
        "easting": 579611.386,
        "northing": 6063854.913
      }
    },
    {
      "id": "judu:stop:5619",
      "stopId": "5619",
      "name": "Viršuliškės",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1819",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "7"
      ],
      "wgs84": {
        "latitude": 54.70649,
        "longitude": 25.22676
      },
      "lks94": {
        "easting": 579059.65,
        "northing": 6064034.483
      }
    },
    {
      "id": "judu:stop:5620",
      "stopId": "5620",
      "name": "Viršuliškės",
      "description": "link Lazdynų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1808",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "7",
        "16",
        "19",
        "25",
        "52",
        "55"
      ],
      "wgs84": {
        "latitude": 54.70683,
        "longitude": 25.22623
      },
      "lks94": {
        "easting": 579024.834,
        "northing": 6064071.724
      }
    },
    {
      "id": "judu:stop:5643",
      "stopId": "5643",
      "name": "Sietyno st.",
      "description": "link Karoliniškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5176",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "2G",
        "3",
        "4",
        "4G",
        "7",
        "9",
        "16",
        "18",
        "21",
        "22",
        "25",
        "49",
        "54",
        "55",
        "59",
        "68",
        "69",
        "116",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.69858,
        "longitude": 25.22124
      },
      "lks94": {
        "easting": 578719.242,
        "northing": 6063147.996
      }
    },
    {
      "id": "judu:stop:5645",
      "stopId": "5645",
      "name": "Švitrigailos st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0512",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "73"
      ],
      "wgs84": {
        "latitude": 54.67424,
        "longitude": 25.26792
      },
      "lks94": {
        "easting": 581776.924,
        "northing": 6060492.631
      }
    },
    {
      "id": "judu:stop:5646",
      "stopId": "5646",
      "name": "Laisvės prospektas",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1703",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "4",
        "7",
        "9",
        "16",
        "18",
        "21",
        "22",
        "25",
        "49",
        "54",
        "55",
        "59",
        "68",
        "69",
        "116",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.69635,
        "longitude": 25.21992
      },
      "lks94": {
        "easting": 578638.474,
        "northing": 6062898.346
      }
    },
    {
      "id": "judu:stop:5649",
      "stopId": "5649",
      "name": "Vytenio st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0514",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "73"
      ],
      "wgs84": {
        "latitude": 54.67185,
        "longitude": 25.26233
      },
      "lks94": {
        "easting": 581421.187,
        "northing": 6060220.161
      }
    },
    {
      "id": "judu:stop:5651",
      "stopId": "5651",
      "name": "Karoliniškės",
      "description": "link Lazdynų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1707",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "4",
        "4G",
        "7",
        "16",
        "18",
        "21",
        "22",
        "25",
        "49",
        "54",
        "55",
        "59",
        "68",
        "69",
        "116",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.69244,
        "longitude": 25.21631
      },
      "lks94": {
        "easting": 578413.317,
        "northing": 6062459.175
      }
    },
    {
      "id": "judu:stop:5655",
      "stopId": "5655",
      "name": "Naugarduko st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0516",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "73"
      ],
      "wgs84": {
        "latitude": 54.67042,
        "longitude": 25.25985
      },
      "lks94": {
        "easting": 581264.089,
        "northing": 6060058.149
      }
    },
    {
      "id": "judu:stop:5656",
      "stopId": "5656",
      "name": "Televizijos bokštas",
      "description": "link Lazdynų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1709",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "7",
        "16",
        "18",
        "21",
        "22",
        "25",
        "49",
        "54",
        "55",
        "59",
        "68",
        "69",
        "116",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.68996,
        "longitude": 25.2126
      },
      "lks94": {
        "easting": 578178.92,
        "northing": 6062179.045
      }
    },
    {
      "id": "judu:stop:5658",
      "stopId": "5658",
      "name": "Minties st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0904",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "4G",
        "5",
        "6",
        "6G",
        "7",
        "9",
        "12",
        "16",
        "17",
        "18",
        "19",
        "20",
        "27",
        "31",
        "42",
        "58",
        "67",
        "74",
        "78",
        "82",
        "89",
        "114",
        "115",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.70362,
        "longitude": 25.30416
      },
      "lks94": {
        "easting": 584053.419,
        "northing": 6063805.022
      }
    },
    {
      "id": "judu:stop:5661",
      "stopId": "5661",
      "name": "Tuskulėnų rimties parkas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0906",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "4G",
        "5",
        "6",
        "6G",
        "7",
        "9",
        "12",
        "16",
        "17",
        "18",
        "19",
        "20",
        "27",
        "31",
        "42",
        "58",
        "67",
        "74",
        "78",
        "82",
        "89",
        "114",
        "115",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.69757,
        "longitude": 25.30032
      },
      "lks94": {
        "easting": 583818.417,
        "northing": 6063127.149
      }
    },
    {
      "id": "judu:stop:5662",
      "stopId": "5662",
      "name": "Šeimyniškių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0908",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "6",
        "9",
        "12",
        "19",
        "27",
        "37",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.69566,
        "longitude": 25.29616
      },
      "lks94": {
        "easting": 583554.205,
        "northing": 6062909.633
      }
    },
    {
      "id": "judu:stop:5664",
      "stopId": "5664",
      "name": "Rinktinės st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0907",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "6",
        "9",
        "12",
        "19",
        "27",
        "37",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.69497,
        "longitude": 25.28955
      },
      "lks94": {
        "easting": 583129.54,
        "northing": 6062824.998
      }
    },
    {
      "id": "judu:stop:5665",
      "stopId": "5665",
      "name": "Rinktinės st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0111",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "9",
        "12",
        "19",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.69477,
        "longitude": 25.28954
      },
      "lks94": {
        "easting": 583129.304,
        "northing": 6062802.729
      }
    },
    {
      "id": "judu:stop:5667",
      "stopId": "5667",
      "name": "Lvivo st.",
      "description": "link Žirmūnų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0109",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4G",
        "6G",
        "9",
        "12",
        "19",
        "89",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.69448,
        "longitude": 25.28276
      },
      "lks94": {
        "easting": 582692.85,
        "northing": 6062762.448
      }
    },
    {
      "id": "judu:stop:5668",
      "stopId": "5668",
      "name": "Vaivorykštės st.",
      "description": "link Lazdynų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1715",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "4",
        "4G",
        "7",
        "16",
        "18",
        "21",
        "22",
        "25",
        "49",
        "54",
        "55",
        "59",
        "68",
        "69",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.6843,
        "longitude": 25.20695
      },
      "lks94": {
        "easting": 577825.499,
        "northing": 6061542.881
      }
    },
    {
      "id": "judu:stop:5672",
      "stopId": "5672",
      "name": "Akacijų st.",
      "description": "link Erfurto g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1613",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "7",
        "21",
        "22",
        "55",
        "68"
      ],
      "wgs84": {
        "latitude": 54.67792,
        "longitude": 25.20181
      },
      "lks94": {
        "easting": 577506.236,
        "northing": 6060827.183
      }
    },
    {
      "id": "judu:stop:5691",
      "stopId": "5691",
      "name": "Šalnos st.",
      "description": "link Laisvės pr.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1618",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "7",
        "20",
        "22",
        "62",
        "69",
        "116"
      ],
      "wgs84": {
        "latitude": 54.67281,
        "longitude": 25.20703
      },
      "lks94": {
        "easting": 577852.639,
        "northing": 6060264.28
      }
    },
    {
      "id": "judu:stop:5692",
      "stopId": "5692",
      "name": "Šalnos st.",
      "description": "link Oslo g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1642",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "69",
        "116"
      ],
      "wgs84": {
        "latitude": 54.67307,
        "longitude": 25.20607
      },
      "lks94": {
        "easting": 577790.226,
        "northing": 6060292.151
      }
    },
    {
      "id": "judu:stop:5693",
      "stopId": "5693",
      "name": "Architektų st.",
      "description": "link Laisvės pr.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1619",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "7",
        "20",
        "22",
        "62",
        "69",
        "116"
      ],
      "wgs84": {
        "latitude": 54.67343,
        "longitude": 25.21451
      },
      "lks94": {
        "easting": 578333.877,
        "northing": 6060341.597
      }
    },
    {
      "id": "judu:stop:5694",
      "stopId": "5694",
      "name": "Architektų st.",
      "description": "link Oslo g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1643",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "69",
        "116"
      ],
      "wgs84": {
        "latitude": 54.67313,
        "longitude": 25.21339
      },
      "lks94": {
        "easting": 578262.22,
        "northing": 6060306.962
      }
    },
    {
      "id": "judu:stop:5697",
      "stopId": "5697",
      "name": "Riešutų st.",
      "description": "link Laisvės pr.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1620",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "7",
        "20",
        "22",
        "62",
        "69",
        "116"
      ],
      "wgs84": {
        "latitude": 54.67653,
        "longitude": 25.21611
      },
      "lks94": {
        "easting": 578431.094,
        "northing": 6060688.373
      }
    },
    {
      "id": "judu:stop:5698",
      "stopId": "5698",
      "name": "Riešutų st.",
      "description": "link Oslo g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1645",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "69",
        "116"
      ],
      "wgs84": {
        "latitude": 54.676,
        "longitude": 25.21556
      },
      "lks94": {
        "easting": 578396.646,
        "northing": 6060628.777
      }
    },
    {
      "id": "judu:stop:5701",
      "stopId": "5701",
      "name": "Ąžuolo st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1606",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "7",
        "21",
        "22",
        "49",
        "54",
        "59",
        "69",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.67994,
        "longitude": 25.21765
      },
      "lks94": {
        "easting": 578523.828,
        "northing": 6061069.583
      }
    },
    {
      "id": "judu:stop:5702",
      "stopId": "5702",
      "name": "Ąžuolo st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1605",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "21",
        "49",
        "54",
        "59",
        "68",
        "69"
      ],
      "wgs84": {
        "latitude": 54.67934,
        "longitude": 25.21701
      },
      "lks94": {
        "easting": 578483.715,
        "northing": 6061002.095
      }
    },
    {
      "id": "judu:stop:5703",
      "stopId": "5703",
      "name": "Ryto st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1607",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "21",
        "49",
        "54",
        "59",
        "68",
        "69"
      ],
      "wgs84": {
        "latitude": 54.68215,
        "longitude": 25.21371
      },
      "lks94": {
        "easting": 578265.506,
        "northing": 6061311.128
      }
    },
    {
      "id": "judu:stop:5704",
      "stopId": "5704",
      "name": "Ryto st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1608",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "7",
        "21",
        "22",
        "49",
        "54",
        "59",
        "69",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.68268,
        "longitude": 25.21309
      },
      "lks94": {
        "easting": 578224.509,
        "northing": 6061369.419
      }
    },
    {
      "id": "judu:stop:5722",
      "stopId": "5722",
      "name": "Spaudos rūmai",
      "description": "link Justiniškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1809",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "7",
        "16",
        "19",
        "25",
        "52",
        "55"
      ],
      "wgs84": {
        "latitude": 54.70417,
        "longitude": 25.22547
      },
      "lks94": {
        "easting": 578981.026,
        "northing": 6063774.844
      }
    },
    {
      "id": "judu:stop:5728",
      "stopId": "5728",
      "name": "Fizikos institutas",
      "description": "visos kryptys",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2903",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "20",
        "25",
        "51",
        "62"
      ],
      "wgs84": {
        "latitude": 54.64212,
        "longitude": 25.18254
      },
      "lks94": {
        "easting": 576330.634,
        "northing": 6056822.002
      }
    },
    {
      "id": "judu:stop:5731",
      "stopId": "5731",
      "name": "Lentvario st.",
      "description": "link Savanorių pr.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2904",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "20",
        "25",
        "51",
        "62"
      ],
      "wgs84": {
        "latitude": 54.63874,
        "longitude": 25.17833
      },
      "lks94": {
        "easting": 576065.209,
        "northing": 6056441.286
      }
    },
    {
      "id": "judu:stop:5732",
      "stopId": "5732",
      "name": "Lentvario st.",
      "description": "link A.Panerių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2905",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "20",
        "25",
        "51",
        "62"
      ],
      "wgs84": {
        "latitude": 54.63836,
        "longitude": 25.17726
      },
      "lks94": {
        "easting": 575996.849,
        "northing": 6056397.839
      }
    },
    {
      "id": "judu:stop:5738",
      "stopId": "5738",
      "name": "Vilijos st.",
      "description": "link Kirtimų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2938",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "20",
        "25",
        "51",
        "62"
      ],
      "wgs84": {
        "latitude": 54.63557,
        "longitude": 25.17174
      },
      "lks94": {
        "easting": 575645.706,
        "northing": 6056081.391
      }
    },
    {
      "id": "judu:stop:5742",
      "stopId": "5742",
      "name": "Galvės st.",
      "description": "link Kirtimų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2910",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "20",
        "25",
        "51",
        "62"
      ],
      "wgs84": {
        "latitude": 54.63274,
        "longitude": 25.1508
      },
      "lks94": {
        "easting": 574299.072,
        "northing": 6055744.103
      }
    },
    {
      "id": "judu:stop:5747",
      "stopId": "5747",
      "name": "Chemijos st.",
      "description": "link Galvės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2811",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8"
      ],
      "wgs84": {
        "latitude": 54.62628,
        "longitude": 25.15099
      },
      "lks94": {
        "easting": 574323.116,
        "northing": 6055025.39
      }
    },
    {
      "id": "judu:stop:5750",
      "stopId": "5750",
      "name": "Prekybos st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2813",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8"
      ],
      "wgs84": {
        "latitude": 54.62063,
        "longitude": 25.15741
      },
      "lks94": {
        "easting": 574748.016,
        "northing": 6054403.429
      }
    },
    {
      "id": "judu:stop:5751",
      "stopId": "5751",
      "name": "Prekybos st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2812",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8"
      ],
      "wgs84": {
        "latitude": 54.62128,
        "longitude": 25.15673
      },
      "lks94": {
        "easting": 574702.911,
        "northing": 6054475.042
      }
    },
    {
      "id": "judu:stop:5756",
      "stopId": "5756",
      "name": "Šaltinio st.",
      "description": "link žiedo",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2816",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "8",
        "9",
        "25"
      ],
      "wgs84": {
        "latitude": 54.60143,
        "longitude": 25.18212
      },
      "lks94": {
        "easting": 576379.711,
        "northing": 6052293.299
      }
    },
    {
      "id": "judu:stop:5757",
      "stopId": "5757",
      "name": "Šaltinio st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2817",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "8",
        "9"
      ],
      "wgs84": {
        "latitude": 54.60171,
        "longitude": 25.18311
      },
      "lks94": {
        "easting": 576443.15,
        "northing": 6052325.535
      }
    },
    {
      "id": "judu:stop:5768",
      "stopId": "5768",
      "name": "Šv. Petro ir Povilo bažnyčia",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0401",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "6",
        "6G",
        "10",
        "15",
        "17",
        "20",
        "33",
        "89",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.69301,
        "longitude": 25.30313
      },
      "lks94": {
        "easting": 584008.96,
        "northing": 6062623.043
      }
    },
    {
      "id": "judu:stop:5770",
      "stopId": "5770",
      "name": "Šv. Petro ir Povilo bažnyčia",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0402",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "6",
        "10",
        "15",
        "17",
        "20",
        "33",
        "89",
        "N1",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.69275,
        "longitude": 25.30315
      },
      "lks94": {
        "easting": 584010.786,
        "northing": 6062594.132
      }
    },
    {
      "id": "judu:stop:5771",
      "stopId": "5771",
      "name": "Kalnų parkas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0403",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "6",
        "10",
        "15",
        "17",
        "20",
        "33",
        "89",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.68938,
        "longitude": 25.2945
      },
      "lks94": {
        "easting": 583460.09,
        "northing": 6062208.781
      }
    },
    {
      "id": "judu:stop:5774",
      "stopId": "5774",
      "name": "Gedimino prospektas",
      "description": "link Savanorių pr.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0220",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "24",
        "29"
      ],
      "wgs84": {
        "latitude": 54.68894,
        "longitude": 25.26208
      },
      "lks94": {
        "easting": 581370.874,
        "northing": 6062121.756
      }
    },
    {
      "id": "judu:stop:5778",
      "stopId": "5778",
      "name": "Vinco Pietario st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0611",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "24",
        "25",
        "123"
      ],
      "wgs84": {
        "latitude": 54.67688,
        "longitude": 25.24579
      },
      "lks94": {
        "easting": 580344.469,
        "northing": 6060760.88
      }
    },
    {
      "id": "judu:stop:5779",
      "stopId": "5779",
      "name": "Vingio parkas",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0609",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "24",
        "25",
        "123"
      ],
      "wgs84": {
        "latitude": 54.6728,
        "longitude": 25.23943
      },
      "lks94": {
        "easting": 579942.331,
        "northing": 6060299.571
      }
    },
    {
      "id": "judu:stop:5780",
      "stopId": "5780",
      "name": "Vingio parkas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0610",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "24",
        "25",
        "29",
        "123",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.67405,
        "longitude": 25.24199
      },
      "lks94": {
        "easting": 580104.98,
        "northing": 6060441.597
      }
    },
    {
      "id": "judu:stop:5803",
      "stopId": "5803",
      "name": "Kaimelio žiedas",
      "description": "link Ateities g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3813",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5",
        "10",
        "24",
        "52",
        "57"
      ],
      "wgs84": {
        "latitude": 54.7316,
        "longitude": 25.24446
      },
      "lks94": {
        "easting": 580150.728,
        "northing": 6066848.989
      }
    },
    {
      "id": "judu:stop:5804",
      "stopId": "5804",
      "name": "Kaimelio st.",
      "description": "link S.Stanevičiaus g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5159",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2G",
        "3G",
        "10",
        "40",
        "55",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.73066,
        "longitude": 25.24621
      },
      "lks94": {
        "easting": 580265.291,
        "northing": 6066746.379
      }
    },
    {
      "id": "judu:stop:5807",
      "stopId": "5807",
      "name": "Antano Jonyno st.",
      "description": "link Kalvarijų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3817",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "10",
        "40",
        "55"
      ],
      "wgs84": {
        "latitude": 54.73137,
        "longitude": 25.24744
      },
      "lks94": {
        "easting": 580343.103,
        "northing": 6066826.801
      }
    },
    {
      "id": "judu:stop:5808",
      "stopId": "5808",
      "name": "Antano Jonyno st.",
      "description": "link Fabijoniškių g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3818",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "10",
        "40",
        "55"
      ],
      "wgs84": {
        "latitude": 54.73156,
        "longitude": 25.24893
      },
      "lks94": {
        "easting": 580438.687,
        "northing": 6066849.653
      }
    },
    {
      "id": "judu:stop:5810",
      "stopId": "5810",
      "name": "Liongino Baliukevičiaus - Dzūko st.",
      "description": "link Geležinio Vilko g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3822",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2G",
        "3G",
        "3G-A",
        "5",
        "10",
        "24",
        "40",
        "48",
        "55",
        "57",
        "125",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.73376,
        "longitude": 25.25421
      },
      "lks94": {
        "easting": 580774.357,
        "northing": 6067100.551
      }
    },
    {
      "id": "judu:stop:5811",
      "stopId": "5811",
      "name": "Liongino Baliukevičiaus - Dzūko st.",
      "description": "link Ukmergės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3820",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G-A",
        "5",
        "24",
        "40",
        "48",
        "53",
        "56",
        "57",
        "75",
        "125",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.734,
        "longitude": 25.25311
      },
      "lks94": {
        "easting": 580703.041,
        "northing": 6067125.994
      }
    },
    {
      "id": "judu:stop:5812",
      "stopId": "5812",
      "name": "Liongino Baliukevičiaus - Dzūko st.",
      "description": "link Ukmergės g",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3819",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2G",
        "3G",
        "10",
        "40",
        "55",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.73329,
        "longitude": 25.2521
      },
      "lks94": {
        "easting": 580639.408,
        "northing": 6067045.819
      }
    },
    {
      "id": "judu:stop:5813",
      "stopId": "5813",
      "name": "Liongino Baliukevičiaus - Dzūko st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3821",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "40",
        "53",
        "56",
        "75",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.73313,
        "longitude": 25.25369
      },
      "lks94": {
        "easting": 580742.122,
        "northing": 6067029.841
      }
    },
    {
      "id": "judu:stop:5814",
      "stopId": "5814",
      "name": "Mykolo Romerio universitetas",
      "description": "link Ukmergės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3823",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2G",
        "3G",
        "3G-A",
        "5",
        "10",
        "24",
        "40",
        "48",
        "55",
        "57",
        "125",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.73517,
        "longitude": 25.25795
      },
      "lks94": {
        "easting": 581012.396,
        "northing": 6067261.778
      }
    },
    {
      "id": "judu:stop:5815",
      "stopId": "5815",
      "name": "Mykolo Romerio universitetas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2001",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2G",
        "3G",
        "3G-A",
        "5",
        "10",
        "24",
        "40",
        "48",
        "55",
        "57",
        "125",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.73531,
        "longitude": 25.25976
      },
      "lks94": {
        "easting": 581128.675,
        "northing": 6067279.449
      }
    },
    {
      "id": "judu:stop:5818",
      "stopId": "5818",
      "name": "Šilo tiltas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1107",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "4",
        "4G",
        "6",
        "10",
        "15",
        "17",
        "19",
        "38",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.70447,
        "longitude": 25.31024
      },
      "lks94": {
        "easting": 584443.488,
        "northing": 6063906.913
      }
    },
    {
      "id": "judu:stop:5819",
      "stopId": "5819",
      "name": "Petro Vileišio st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1105",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "4",
        "6",
        "10",
        "15",
        "17",
        "19",
        "38",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.70165,
        "longitude": 25.30922
      },
      "lks94": {
        "easting": 584383.608,
        "northing": 6063591.859
      }
    },
    {
      "id": "judu:stop:5820",
      "stopId": "5820",
      "name": "Leono Sapiegos st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1103",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "4",
        "6",
        "10",
        "15",
        "17",
        "19",
        "38",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.6963,
        "longitude": 25.30809
      },
      "lks94": {
        "easting": 584321.875,
        "northing": 6062995.121
      }
    },
    {
      "id": "judu:stop:5822",
      "stopId": "5822",
      "name": "Ateities st.",
      "description": "link Pašilaičių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2101",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G-A",
        "5",
        "10",
        "24",
        "40",
        "48",
        "55",
        "57",
        "75",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.73682,
        "longitude": 25.26515
      },
      "lks94": {
        "easting": 581472.743,
        "northing": 6067453.739
      }
    },
    {
      "id": "judu:stop:5826",
      "stopId": "5826",
      "name": "Leono Sapiegos st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1104",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "4",
        "6",
        "10",
        "15",
        "19",
        "38",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.69697,
        "longitude": 25.30873
      },
      "lks94": {
        "easting": 584361.738,
        "northing": 6063070.451
      }
    },
    {
      "id": "judu:stop:5827",
      "stopId": "5827",
      "name": "Ateities st.",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2019",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "76",
        "87"
      ],
      "wgs84": {
        "latitude": 54.7363,
        "longitude": 25.26656
      },
      "lks94": {
        "easting": 581564.583,
        "northing": 6067397.507
      }
    },
    {
      "id": "judu:stop:5828",
      "stopId": "5828",
      "name": "Ateities st.",
      "description": "link Kalvarijų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2002",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G-A",
        "5",
        "24",
        "34",
        "40",
        "49",
        "55",
        "57",
        "75",
        "76",
        "87",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.73707,
        "longitude": 25.26672
      },
      "lks94": {
        "easting": 581573.339,
        "northing": 6067483.385
      }
    },
    {
      "id": "judu:stop:5833",
      "stopId": "5833",
      "name": "Didlaukio st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2008",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "10",
        "34",
        "49",
        "50",
        "76",
        "87",
        "N3",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.72903,
        "longitude": 25.26926
      },
      "lks94": {
        "easting": 581753.085,
        "northing": 6066591.591
      }
    },
    {
      "id": "judu:stop:5834",
      "stopId": "5834",
      "name": "Didlaukio st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2009",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "10",
        "34",
        "49",
        "50",
        "76",
        "87",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.72915,
        "longitude": 25.27162
      },
      "lks94": {
        "easting": 581904.843,
        "northing": 6066607.698
      }
    },
    {
      "id": "judu:stop:5835",
      "stopId": "5835",
      "name": "Baltupiai",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2010",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "10",
        "34",
        "49",
        "50",
        "76",
        "87",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.72758,
        "longitude": 25.27858
      },
      "lks94": {
        "easting": 582356.294,
        "northing": 6066441.123
      }
    },
    {
      "id": "judu:stop:5836",
      "stopId": "5836",
      "name": "Baltupiai",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2011",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1G",
        "2G",
        "3G",
        "3G-A",
        "5",
        "10",
        "24",
        "26",
        "34",
        "35",
        "36",
        "40",
        "49",
        "50",
        "55",
        "65",
        "66",
        "76",
        "87",
        "121",
        "N3",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.72688,
        "longitude": 25.28001
      },
      "lks94": {
        "easting": 582449.82,
        "northing": 6066364.902
      }
    },
    {
      "id": "judu:stop:5839",
      "stopId": "5839",
      "name": "Naujakiemio st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2012",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5",
        "10",
        "24",
        "26",
        "34",
        "35",
        "36",
        "40",
        "49",
        "50",
        "55",
        "65",
        "66",
        "76",
        "87",
        "121",
        "N3",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.72387,
        "longitude": 25.28144
      },
      "lks94": {
        "easting": 582548.043,
        "northing": 6066031.609
      }
    },
    {
      "id": "judu:stop:5840",
      "stopId": "5840",
      "name": "Naujakiemio st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2013",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5",
        "10",
        "24",
        "26",
        "34",
        "35",
        "36",
        "40",
        "48",
        "49",
        "50",
        "55",
        "65",
        "66",
        "76",
        "87",
        "121",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.72467,
        "longitude": 25.28114
      },
      "lks94": {
        "easting": 582527.093,
        "northing": 6066120.286
      }
    },
    {
      "id": "judu:stop:5846",
      "stopId": "5846",
      "name": "Jono Kazlausko st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2014",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1G",
        "10",
        "26",
        "34",
        "35",
        "36",
        "49",
        "50",
        "55",
        "65",
        "66"
      ],
      "wgs84": {
        "latitude": 54.72145,
        "longitude": 25.28502
      },
      "lks94": {
        "easting": 582783.579,
        "northing": 6065766.512
      }
    },
    {
      "id": "judu:stop:5848",
      "stopId": "5848",
      "name": "Jono Kazlausko st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0801",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1G",
        "2G",
        "3G",
        "3G-A",
        "5",
        "10",
        "24",
        "26",
        "34",
        "35",
        "36",
        "40",
        "48",
        "49",
        "50",
        "55",
        "65",
        "66",
        "76",
        "87",
        "121",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.72241,
        "longitude": 25.28381
      },
      "lks94": {
        "easting": 582703.678,
        "northing": 6065871.921
      }
    },
    {
      "id": "judu:stop:5854",
      "stopId": "5854",
      "name": "Zarasų st.",
      "description": "link Markučių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1201",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "10",
        "13",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.67624,
        "longitude": 25.3104
      },
      "lks94": {
        "easting": 584512.443,
        "northing": 6060765.504
      }
    },
    {
      "id": "judu:stop:5855",
      "stopId": "5855",
      "name": "Zarasų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1202",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "10",
        "11",
        "13",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.67658,
        "longitude": 25.3094
      },
      "lks94": {
        "easting": 584447.248,
        "northing": 6060802.138
      }
    },
    {
      "id": "judu:stop:5857",
      "stopId": "5857",
      "name": "Vilnelės st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1204",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "10",
        "13",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.67465,
        "longitude": 25.31948
      },
      "lks94": {
        "easting": 585101.336,
        "northing": 6060599.527
      }
    },
    {
      "id": "judu:stop:5858",
      "stopId": "5858",
      "name": "Vilnelės st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1205",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "10",
        "13",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.6749,
        "longitude": 25.31879
      },
      "lks94": {
        "easting": 585056.314,
        "northing": 6060626.512
      }
    },
    {
      "id": "judu:stop:5861",
      "stopId": "5861",
      "name": "Pramogų arena",
      "description": "link Baltupių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0802",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "55",
        "65",
        "66"
      ],
      "wgs84": {
        "latitude": 54.71626,
        "longitude": 25.28694
      },
      "lks94": {
        "easting": 582917.855,
        "northing": 6065191.2
      }
    },
    {
      "id": "judu:stop:5872",
      "stopId": "5872",
      "name": "Džocharo Dudajevo skv.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0310",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "11"
      ],
      "wgs84": {
        "latitude": 54.69585,
        "longitude": 25.25585
      },
      "lks94": {
        "easting": 580955.468,
        "northing": 6062883.545
      }
    },
    {
      "id": "judu:stop:5875",
      "stopId": "5875",
      "name": "Vytauto st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0306",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "11"
      ],
      "wgs84": {
        "latitude": 54.69173,
        "longitude": 25.25622
      },
      "lks94": {
        "easting": 580987.523,
        "northing": 6062425.47
      }
    },
    {
      "id": "judu:stop:5880",
      "stopId": "5880",
      "name": "Liubarto tiltas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0301",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "11",
        "116",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.68893,
        "longitude": 25.25691
      },
      "lks94": {
        "easting": 581037.583,
        "northing": 6062114.664
      }
    },
    {
      "id": "judu:stop:5881",
      "stopId": "5881",
      "name": "Jokūbo Jasinskio st.",
      "description": "link Senamiesčio",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0218",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "7",
        "11",
        "116",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.68812,
        "longitude": 25.26329
      },
      "lks94": {
        "easting": 581450.525,
        "northing": 6062031.905
      }
    },
    {
      "id": "judu:stop:5900",
      "stopId": "5900",
      "name": "Vilnios st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0428",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "11"
      ],
      "wgs84": {
        "latitude": 54.68024,
        "longitude": 25.29365
      },
      "lks94": {
        "easting": 583424.034,
        "northing": 6061190.616
      }
    },
    {
      "id": "judu:stop:5901",
      "stopId": "5901",
      "name": "Užupis",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0433",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "11"
      ],
      "wgs84": {
        "latitude": 54.68121,
        "longitude": 25.30076
      },
      "lks94": {
        "easting": 583880.513,
        "northing": 6061307.035
      }
    },
    {
      "id": "judu:stop:5902",
      "stopId": "5902",
      "name": "Bernardinų kapinės",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0434",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "11"
      ],
      "wgs84": {
        "latitude": 54.68145,
        "longitude": 25.30538
      },
      "lks94": {
        "easting": 584177.924,
        "northing": 6061339.272
      }
    },
    {
      "id": "judu:stop:5904",
      "stopId": "5904",
      "name": "Bernardinų st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0435",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "11"
      ],
      "wgs84": {
        "latitude": 54.682,
        "longitude": 25.31198
      },
      "lks94": {
        "easting": 584602.359,
        "northing": 6061408.412
      }
    },
    {
      "id": "judu:stop:5906",
      "stopId": "5906",
      "name": "Žvėrynas",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0315",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "9",
        "19",
        "21",
        "22",
        "30",
        "49",
        "69"
      ],
      "wgs84": {
        "latitude": 54.69948,
        "longitude": 25.2432
      },
      "lks94": {
        "easting": 580132.903,
        "northing": 6063273.002
      }
    },
    {
      "id": "judu:stop:5915",
      "stopId": "5915",
      "name": "Karoliniškių poliklinika",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1704",
      "modes": [
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "9"
      ],
      "wgs84": {
        "latitude": 54.69283,
        "longitude": 25.21416
      },
      "lks94": {
        "easting": 578273.967,
        "northing": 6062500.177
      }
    },
    {
      "id": "judu:stop:5919",
      "stopId": "5919",
      "name": "Ugniagesių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1711",
      "modes": [
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "9"
      ],
      "wgs84": {
        "latitude": 54.68951,
        "longitude": 25.20904
      },
      "lks94": {
        "easting": 577950.273,
        "northing": 6062125.007
      }
    },
    {
      "id": "judu:stop:5920",
      "stopId": "5920",
      "name": "Atminties st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1713",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "9",
        "116"
      ],
      "wgs84": {
        "latitude": 54.68674,
        "longitude": 25.2065
      },
      "lks94": {
        "easting": 577791.817,
        "northing": 6061813.924
      }
    },
    {
      "id": "judu:stop:5923",
      "stopId": "5923",
      "name": "Pasakų parkas",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1717",
      "modes": [
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "9"
      ],
      "wgs84": {
        "latitude": 54.68477,
        "longitude": 25.20559
      },
      "lks94": {
        "easting": 577736.911,
        "northing": 6061593.68
      }
    },
    {
      "id": "judu:stop:5924",
      "stopId": "5924",
      "name": "Pasakų parkas",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1716",
      "modes": [
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "9"
      ],
      "wgs84": {
        "latitude": 54.68461,
        "longitude": 25.20607
      },
      "lks94": {
        "easting": 577768.166,
        "northing": 6061576.405
      }
    },
    {
      "id": "judu:stop:5925",
      "stopId": "5925",
      "name": "Drujos st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0424",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "6G",
        "9",
        "11",
        "12",
        "14",
        "16",
        "19",
        "31",
        "33",
        "34",
        "42",
        "58",
        "74",
        "89",
        "119",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.67839,
        "longitude": 25.31053
      },
      "lks94": {
        "easting": 584516.361,
        "northing": 6061004.925
      }
    },
    {
      "id": "judu:stop:5936",
      "stopId": "5936",
      "name": "Pamėnkalnio st.",
      "description": "link Žvėryno",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0216",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "7",
        "11",
        "21",
        "116",
        "123",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.68784,
        "longitude": 25.26659
      },
      "lks94": {
        "easting": 581663.843,
        "northing": 6062004.578
      }
    },
    {
      "id": "judu:stop:5937",
      "stopId": "5937",
      "name": "Jokūbo Jasinskio st.",
      "description": "link Žvėryno",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0217",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "11"
      ],
      "wgs84": {
        "latitude": 54.68828,
        "longitude": 25.26352
      },
      "lks94": {
        "easting": 581465.033,
        "northing": 6062049.977
      }
    },
    {
      "id": "judu:stop:5941",
      "stopId": "5941",
      "name": "Pelesos st.",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1302",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2",
        "12",
        "16",
        "19",
        "61",
        "82",
        "88"
      ],
      "wgs84": {
        "latitude": 54.67108,
        "longitude": 25.29127
      },
      "lks94": {
        "easting": 583289.31,
        "northing": 6060168.412
      }
    },
    {
      "id": "judu:stop:5942",
      "stopId": "5942",
      "name": "Pelesos st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1303",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2",
        "12",
        "16",
        "19",
        "61",
        "82",
        "88"
      ],
      "wgs84": {
        "latitude": 54.67141,
        "longitude": 25.29179
      },
      "lks94": {
        "easting": 583322.174,
        "northing": 6060205.753
      }
    },
    {
      "id": "judu:stop:5944",
      "stopId": "5944",
      "name": "Stadionas",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1305",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2",
        "12",
        "16",
        "19",
        "61",
        "82",
        "88"
      ],
      "wgs84": {
        "latitude": 54.66756,
        "longitude": 25.2971
      },
      "lks94": {
        "easting": 583672.571,
        "northing": 6059783.617
      }
    },
    {
      "id": "judu:stop:5945",
      "stopId": "5945",
      "name": "Stadionas",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1304",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2",
        "12",
        "16",
        "19",
        "61",
        "82",
        "88"
      ],
      "wgs84": {
        "latitude": 54.66848,
        "longitude": 25.29639
      },
      "lks94": {
        "easting": 583624.883,
        "northing": 6059885.154
      }
    },
    {
      "id": "judu:stop:5946",
      "stopId": "5946",
      "name": "Liepkalnis",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1316",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2",
        "12",
        "16",
        "19",
        "61",
        "82",
        "88"
      ],
      "wgs84": {
        "latitude": 54.66287,
        "longitude": 25.29995
      },
      "lks94": {
        "easting": 583866.069,
        "northing": 6059265.087
      }
    },
    {
      "id": "judu:stop:5947",
      "stopId": "5947",
      "name": "Liepkalnis",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1315",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2",
        "12",
        "16",
        "19",
        "61",
        "82",
        "88"
      ],
      "wgs84": {
        "latitude": 54.66298,
        "longitude": 25.30015
      },
      "lks94": {
        "easting": 583878.744,
        "northing": 6059277.567
      }
    },
    {
      "id": "judu:stop:5948",
      "stopId": "5948",
      "name": "Liepkalnis",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1514",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "58"
      ],
      "wgs84": {
        "latitude": 54.66285,
        "longitude": 25.29885
      },
      "lks94": {
        "easting": 583795.147,
        "northing": 6059261.548
      }
    },
    {
      "id": "judu:stop:5953",
      "stopId": "5953",
      "name": "Žirnių st.",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2632",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "12",
        "19",
        "42",
        "82"
      ],
      "wgs84": {
        "latitude": 54.65307,
        "longitude": 25.3027
      },
      "lks94": {
        "easting": 584063.704,
        "northing": 6058177.777
      }
    },
    {
      "id": "judu:stop:5955",
      "stopId": "5955",
      "name": "Kelininkų st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2633",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "12",
        "19",
        "42",
        "82"
      ],
      "wgs84": {
        "latitude": 54.64917,
        "longitude": 25.30266
      },
      "lks94": {
        "easting": 584069.173,
        "northing": 6057743.716
      }
    },
    {
      "id": "judu:stop:5956",
      "stopId": "5956",
      "name": "Šalčininkų kryptis",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2634",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "12",
        "19",
        "42",
        "82"
      ],
      "wgs84": {
        "latitude": 54.64398,
        "longitude": 25.30273
      },
      "lks94": {
        "easting": 584084.403,
        "northing": 6057166.229
      }
    },
    {
      "id": "judu:stop:5957",
      "stopId": "5957",
      "name": "Šalčininkų kryptis",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4004",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "12",
        "14",
        "19",
        "82"
      ],
      "wgs84": {
        "latitude": 54.64484,
        "longitude": 25.30285
      },
      "lks94": {
        "easting": 584090.373,
        "northing": 6057262.078
      }
    },
    {
      "id": "judu:stop:5958",
      "stopId": "5958",
      "name": "Miško parkas",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2635",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "12",
        "19",
        "42",
        "82"
      ],
      "wgs84": {
        "latitude": 54.63671,
        "longitude": 25.30307
      },
      "lks94": {
        "easting": 584121.355,
        "northing": 6056357.593
      }
    },
    {
      "id": "judu:stop:5960",
      "stopId": "5960",
      "name": "Lydos st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2636",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "12",
        "19",
        "42",
        "82"
      ],
      "wgs84": {
        "latitude": 54.62522,
        "longitude": 25.30547
      },
      "lks94": {
        "easting": 584300.043,
        "northing": 6055081.806
      }
    },
    {
      "id": "judu:stop:5964",
      "stopId": "5964",
      "name": "Svirno st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4010",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12"
      ],
      "wgs84": {
        "latitude": 54.61725,
        "longitude": 25.30824
      },
      "lks94": {
        "easting": 584495.419,
        "northing": 6054198.194
      }
    },
    {
      "id": "judu:stop:5965",
      "stopId": "5965",
      "name": "Svirno st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4009",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12",
        "14"
      ],
      "wgs84": {
        "latitude": 54.61865,
        "longitude": 25.30796
      },
      "lks94": {
        "easting": 584474.435,
        "northing": 6054353.656
      }
    },
    {
      "id": "judu:stop:5966",
      "stopId": "5966",
      "name": "Basiukai",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4011",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12",
        "14"
      ],
      "wgs84": {
        "latitude": 54.61206,
        "longitude": 25.31046
      },
      "lks94": {
        "easting": 584649.566,
        "northing": 6053623.298
      }
    },
    {
      "id": "judu:stop:5967",
      "stopId": "5967",
      "name": "Basiukai",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4012",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12"
      ],
      "wgs84": {
        "latitude": 54.61052,
        "longitude": 25.31098
      },
      "lks94": {
        "easting": 584686.351,
        "northing": 6053452.547
      }
    },
    {
      "id": "judu:stop:5969",
      "stopId": "5969",
      "name": "Katiliškės",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4013",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12",
        "14"
      ],
      "wgs84": {
        "latitude": 54.60612,
        "longitude": 25.31308
      },
      "lks94": {
        "easting": 584831.148,
        "northing": 6052965.428
      }
    },
    {
      "id": "judu:stop:5971",
      "stopId": "5971",
      "name": "Kineliai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4326",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12"
      ],
      "wgs84": {
        "latitude": 54.59737,
        "longitude": 25.31626
      },
      "lks94": {
        "easting": 585054.817,
        "northing": 6051995.534
      }
    },
    {
      "id": "judu:stop:5972",
      "stopId": "5972",
      "name": "Kineliai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4325",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12",
        "14"
      ],
      "wgs84": {
        "latitude": 54.5976,
        "longitude": 25.31564
      },
      "lks94": {
        "easting": 585014.276,
        "northing": 6052020.379
      }
    },
    {
      "id": "judu:stop:5973",
      "stopId": "5973",
      "name": "Rudaminos paukštynas",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4324",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12"
      ],
      "wgs84": {
        "latitude": 54.59464,
        "longitude": 25.32951
      },
      "lks94": {
        "easting": 585916.709,
        "northing": 6051707.844
      }
    },
    {
      "id": "judu:stop:5974",
      "stopId": "5974",
      "name": "Rudaminos paukštynas",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4323",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12",
        "14"
      ],
      "wgs84": {
        "latitude": 54.59484,
        "longitude": 25.32915
      },
      "lks94": {
        "easting": 585893.025,
        "northing": 6051729.661
      }
    },
    {
      "id": "judu:stop:5975",
      "stopId": "5975",
      "name": "Čekėnų st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4322",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12"
      ],
      "wgs84": {
        "latitude": 54.59265,
        "longitude": 25.33948
      },
      "lks94": {
        "easting": 586565.181,
        "northing": 6051498.622
      }
    },
    {
      "id": "judu:stop:5976",
      "stopId": "5976",
      "name": "Čekėnų st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4321",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12",
        "14"
      ],
      "wgs84": {
        "latitude": 54.59302,
        "longitude": 25.33798
      },
      "lks94": {
        "easting": 586467.464,
        "northing": 6051537.951
      }
    },
    {
      "id": "judu:stop:5981",
      "stopId": "5981",
      "name": "Draugystės st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4318",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12",
        "14"
      ],
      "wgs84": {
        "latitude": 54.59598,
        "longitude": 25.36412
      },
      "lks94": {
        "easting": 588150.274,
        "northing": 6051899.821
      }
    },
    {
      "id": "judu:stop:5982",
      "stopId": "5982",
      "name": "Draugystės st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4317",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12",
        "14",
        "16"
      ],
      "wgs84": {
        "latitude": 54.59592,
        "longitude": 25.36351
      },
      "lks94": {
        "easting": 588110.988,
        "northing": 6051892.379
      }
    },
    {
      "id": "judu:stop:5985",
      "stopId": "5985",
      "name": "Skaidiškės",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4313",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "16"
      ],
      "wgs84": {
        "latitude": 54.60583,
        "longitude": 25.38387
      },
      "lks94": {
        "easting": 589404.866,
        "northing": 6053020.91
      }
    },
    {
      "id": "judu:stop:5986",
      "stopId": "5986",
      "name": "Skaidiškės",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4314",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12",
        "14",
        "16"
      ],
      "wgs84": {
        "latitude": 54.6064,
        "longitude": 25.38357
      },
      "lks94": {
        "easting": 589384.236,
        "northing": 6053083.96
      }
    },
    {
      "id": "judu:stop:5988",
      "stopId": "5988",
      "name": "Skaidiškių žiedas",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4312",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12",
        "16"
      ],
      "wgs84": {
        "latitude": 54.60943,
        "longitude": 25.38599
      },
      "lks94": {
        "easting": 589533.918,
        "northing": 6053424.229
      }
    },
    {
      "id": "judu:stop:5995",
      "stopId": "5995",
      "name": "Miško parkas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4005",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "12",
        "14",
        "19",
        "82"
      ],
      "wgs84": {
        "latitude": 54.63609,
        "longitude": 25.30331
      },
      "lks94": {
        "easting": 584138.128,
        "northing": 6056288.884
      }
    },
    {
      "id": "judu:stop:5996",
      "stopId": "5996",
      "name": "Kelininkų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4003",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "12",
        "14",
        "19",
        "82"
      ],
      "wgs84": {
        "latitude": 54.65048,
        "longitude": 25.30308
      },
      "lks94": {
        "easting": 584093.572,
        "northing": 6057890.003
      }
    },
    {
      "id": "judu:stop:5998",
      "stopId": "5998",
      "name": "Žirnių st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1314",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2",
        "9",
        "12",
        "16",
        "19",
        "58",
        "61",
        "82",
        "88",
        "119"
      ],
      "wgs84": {
        "latitude": 54.65469,
        "longitude": 25.30307
      },
      "lks94": {
        "easting": 584084.234,
        "northing": 6058358.502
      }
    },
    {
      "id": "judu:stop:6005",
      "stopId": "6005",
      "name": "Pelesos st.",
      "description": "link Dzūkų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0528",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "4G",
        "7",
        "13",
        "14",
        "15",
        "26",
        "38",
        "58",
        "65",
        "114",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.67085,
        "longitude": 25.28921
      },
      "lks94": {
        "easting": 583156.914,
        "northing": 6060140.375
      }
    },
    {
      "id": "judu:stop:6006",
      "stopId": "6006",
      "name": "Pelesos st.",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1301",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "7",
        "11",
        "13",
        "14",
        "15",
        "26",
        "38",
        "58",
        "65",
        "114"
      ],
      "wgs84": {
        "latitude": 54.67091,
        "longitude": 25.28961
      },
      "lks94": {
        "easting": 583182.59,
        "northing": 6060147.526
      }
    },
    {
      "id": "judu:stop:6008",
      "stopId": "6008",
      "name": "Panevėžio st.",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0529",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "4G",
        "7",
        "13",
        "14",
        "15",
        "26",
        "38",
        "58",
        "65",
        "114",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.66793,
        "longitude": 25.28368
      },
      "lks94": {
        "easting": 582806.177,
        "northing": 6059808.885
      }
    },
    {
      "id": "judu:stop:6009",
      "stopId": "6009",
      "name": "Panevėžio st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1509",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "7",
        "11",
        "13",
        "14",
        "15",
        "26",
        "38",
        "58",
        "65",
        "114"
      ],
      "wgs84": {
        "latitude": 54.66814,
        "longitude": 25.28476
      },
      "lks94": {
        "easting": 582875.413,
        "northing": 6059833.529
      }
    },
    {
      "id": "judu:stop:6012",
      "stopId": "6012",
      "name": "Dzūkų st.",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1505",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "58"
      ],
      "wgs84": {
        "latitude": 54.66528,
        "longitude": 25.27651
      },
      "lks94": {
        "easting": 582349.049,
        "northing": 6059505.546
      }
    },
    {
      "id": "judu:stop:6013",
      "stopId": "6013",
      "name": "Dzūkų st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1506",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "58"
      ],
      "wgs84": {
        "latitude": 54.66582,
        "longitude": 25.27595
      },
      "lks94": {
        "easting": 582311.833,
        "northing": 6059564.984
      }
    },
    {
      "id": "judu:stop:6014",
      "stopId": "6014",
      "name": "Rudaminos st.",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1507",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "58"
      ],
      "wgs84": {
        "latitude": 54.66428,
        "longitude": 25.28024
      },
      "lks94": {
        "easting": 582591.691,
        "northing": 6059398.641
      }
    },
    {
      "id": "judu:stop:6015",
      "stopId": "6015",
      "name": "Rudaminos st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1508",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "58"
      ],
      "wgs84": {
        "latitude": 54.66463,
        "longitude": 25.27975
      },
      "lks94": {
        "easting": 582559.372,
        "northing": 6059437.014
      }
    },
    {
      "id": "judu:stop:6017",
      "stopId": "6017",
      "name": "Merkinės st.",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1510",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "58"
      ],
      "wgs84": {
        "latitude": 54.66417,
        "longitude": 25.28719
      },
      "lks94": {
        "easting": 583040.253,
        "northing": 6059394.595
      }
    },
    {
      "id": "judu:stop:6018",
      "stopId": "6018",
      "name": "Merkinės st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1511",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "58"
      ],
      "wgs84": {
        "latitude": 54.66421,
        "longitude": 25.28622
      },
      "lks94": {
        "easting": 582977.598,
        "northing": 6059397.9
      }
    },
    {
      "id": "judu:stop:6019",
      "stopId": "6019",
      "name": "Perlojos st.",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1512",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "58"
      ],
      "wgs84": {
        "latitude": 54.66423,
        "longitude": 25.29368
      },
      "lks94": {
        "easting": 583458.795,
        "northing": 6059408.966
      }
    },
    {
      "id": "judu:stop:6020",
      "stopId": "6020",
      "name": "Perlojos st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1317",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "58"
      ],
      "wgs84": {
        "latitude": 54.66464,
        "longitude": 25.29225
      },
      "lks94": {
        "easting": 583365.707,
        "northing": 6059452.894
      }
    },
    {
      "id": "judu:stop:6024",
      "stopId": "6024",
      "name": "Karaimų kapinės",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2631",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2",
        "119",
        "122"
      ],
      "wgs84": {
        "latitude": 54.65511,
        "longitude": 25.29743
      },
      "lks94": {
        "easting": 583719.455,
        "northing": 6058398.504
      }
    },
    {
      "id": "judu:stop:6029",
      "stopId": "6029",
      "name": "Jaunimo st.",
      "description": "iš N.Vilnios",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5161",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "58"
      ],
      "wgs84": {
        "latitude": 54.66994,
        "longitude": 25.41217
      },
      "lks94": {
        "easting": 591089.636,
        "northing": 6060191.663
      }
    },
    {
      "id": "judu:stop:6030",
      "stopId": "6030",
      "name": "Jaunimo st.",
      "description": "link N.Vilnios",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5162",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "58"
      ],
      "wgs84": {
        "latitude": 54.66979,
        "longitude": 25.41227
      },
      "lks94": {
        "easting": 591096.422,
        "northing": 6060175.1
      }
    },
    {
      "id": "judu:stop:6032",
      "stopId": "6032",
      "name": "Grigaičiai",
      "description": "link Grigaičių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5160",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "58"
      ],
      "wgs84": {
        "latitude": 54.68095,
        "longitude": 25.41305
      },
      "lks94": {
        "easting": 591121.736,
        "northing": 6061418.043
      }
    },
    {
      "id": "judu:stop:6034",
      "stopId": "6034",
      "name": "Grigaičiai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2350",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.68156,
        "longitude": 25.41215
      },
      "lks94": {
        "easting": 591062.337,
        "northing": 6061484.758
      }
    },
    {
      "id": "judu:stop:6035",
      "stopId": "6035",
      "name": "Grigaičiai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2351",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "31",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.68198,
        "longitude": 25.41263
      },
      "lks94": {
        "easting": 591092.348,
        "northing": 6061532.12
      }
    },
    {
      "id": "judu:stop:6040",
      "stopId": "6040",
      "name": "Genių st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2349",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "6G",
        "14",
        "18",
        "31",
        "67",
        "74",
        "115",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.68798,
        "longitude": 25.41324
      },
      "lks94": {
        "easting": 591118.239,
        "northing": 6062200.617
      }
    },
    {
      "id": "judu:stop:6041",
      "stopId": "6041",
      "name": "Genių st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2348",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "6G",
        "14",
        "18",
        "31",
        "67",
        "74",
        "115",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.68827,
        "longitude": 25.41255
      },
      "lks94": {
        "easting": 591073.105,
        "northing": 6062231.995
      }
    },
    {
      "id": "judu:stop:6042",
      "stopId": "6042",
      "name": "Respublikinė psichiatrijos ligoninė",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2353",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "6G",
        "14",
        "18",
        "31",
        "67",
        "74",
        "115",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.68563,
        "longitude": 25.41933
      },
      "lks94": {
        "easting": 591516.151,
        "northing": 6061947.021
      }
    },
    {
      "id": "judu:stop:6043",
      "stopId": "6043",
      "name": "Respublikinė psichiatrijos ligoninė",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2352",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "6G",
        "14",
        "18",
        "31",
        "67",
        "74",
        "115",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.68594,
        "longitude": 25.41868
      },
      "lks94": {
        "easting": 591473.545,
        "northing": 6061980.672
      }
    },
    {
      "id": "judu:stop:6044",
      "stopId": "6044",
      "name": "Parko st.",
      "description": "link Linksmosios g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2355",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "6G",
        "14",
        "18",
        "31",
        "67",
        "74",
        "115",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.6855,
        "longitude": 25.4261
      },
      "lks94": {
        "easting": 591952.934,
        "northing": 6061941.4
      }
    },
    {
      "id": "judu:stop:6045",
      "stopId": "6045",
      "name": "Parko st.",
      "description": "link Pergalės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2354",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "6G",
        "14",
        "18",
        "31",
        "67",
        "74",
        "115",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.68561,
        "longitude": 25.42449
      },
      "lks94": {
        "easting": 591848.882,
        "northing": 6061951.534
      }
    },
    {
      "id": "judu:stop:6047",
      "stopId": "6047",
      "name": "Naujosios Vilnios žiedas",
      "description": "link Pramonės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2357",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "31"
      ],
      "wgs84": {
        "latitude": 54.68593,
        "longitude": 25.42996
      },
      "lks94": {
        "easting": 592200.829,
        "northing": 6061994.314
      }
    },
    {
      "id": "judu:stop:6048",
      "stopId": "6048",
      "name": "Rytų st.",
      "description": "link Pramonės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2359",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31"
      ],
      "wgs84": {
        "latitude": 54.69044,
        "longitude": 25.43374
      },
      "lks94": {
        "easting": 592434.288,
        "northing": 6062501.176
      }
    },
    {
      "id": "judu:stop:6049",
      "stopId": "6049",
      "name": "Rytų st.",
      "description": "link Parko g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2358",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "31"
      ],
      "wgs84": {
        "latitude": 54.68956,
        "longitude": 25.43274
      },
      "lks94": {
        "easting": 592371.821,
        "northing": 6062401.93
      }
    },
    {
      "id": "judu:stop:6051",
      "stopId": "6051",
      "name": "Linksmoji st.",
      "description": "link Pramonės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2371",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31"
      ],
      "wgs84": {
        "latitude": 54.69518,
        "longitude": 25.43604
      },
      "lks94": {
        "easting": 592571.77,
        "northing": 6063031.693
      }
    },
    {
      "id": "judu:stop:6052",
      "stopId": "6052",
      "name": "Linksmoji st.",
      "description": "link Parko g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2370",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31"
      ],
      "wgs84": {
        "latitude": 54.69508,
        "longitude": 25.43593
      },
      "lks94": {
        "easting": 592564.907,
        "northing": 6063020.42
      }
    },
    {
      "id": "judu:stop:6054",
      "stopId": "6054",
      "name": "Jankos Kupalos st.",
      "description": "link Arimų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2338",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "27"
      ],
      "wgs84": {
        "latitude": 54.69432,
        "longitude": 25.40168
      },
      "lks94": {
        "easting": 590358.873,
        "northing": 6062891.219
      }
    },
    {
      "id": "judu:stop:6055",
      "stopId": "6055",
      "name": "Jankos Kupalos st.",
      "description": "link Šiaurės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2337",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "27"
      ],
      "wgs84": {
        "latitude": 54.69445,
        "longitude": 25.4014
      },
      "lks94": {
        "easting": 590340.535,
        "northing": 6062905.326
      }
    },
    {
      "id": "judu:stop:6056",
      "stopId": "6056",
      "name": "Ievų st.",
      "description": "link Arimų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2344",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "27"
      ],
      "wgs84": {
        "latitude": 54.69433,
        "longitude": 25.40838
      },
      "lks94": {
        "easting": 590790.735,
        "northing": 6062900.977
      }
    },
    {
      "id": "judu:stop:6057",
      "stopId": "6057",
      "name": "Ievų st.",
      "description": "link Šiaurės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2343",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "27"
      ],
      "wgs84": {
        "latitude": 54.6943,
        "longitude": 25.40698
      },
      "lks94": {
        "easting": 590700.557,
        "northing": 6062895.828
      }
    },
    {
      "id": "judu:stop:6059",
      "stopId": "6059",
      "name": "Gandrų st.",
      "description": "link Arimų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2361",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "27"
      ],
      "wgs84": {
        "latitude": 54.69516,
        "longitude": 25.41467
      },
      "lks94": {
        "easting": 591194.329,
        "northing": 6063001.496
      }
    },
    {
      "id": "judu:stop:6060",
      "stopId": "6060",
      "name": "Gandrų st.",
      "description": "link Šiaurės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2360",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "27"
      ],
      "wgs84": {
        "latitude": 54.69521,
        "longitude": 25.41434
      },
      "lks94": {
        "easting": 591172.945,
        "northing": 6063006.631
      }
    },
    {
      "id": "judu:stop:6062",
      "stopId": "6062",
      "name": "Rugiagėlių st.",
      "description": "link Arimų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2365",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "27"
      ],
      "wgs84": {
        "latitude": 54.69626,
        "longitude": 25.42181
      },
      "lks94": {
        "easting": 591652.086,
        "northing": 6063133.208
      }
    },
    {
      "id": "judu:stop:6064",
      "stopId": "6064",
      "name": "Rugiagėlių st.",
      "description": "link Šiaurės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2364",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "27"
      ],
      "wgs84": {
        "latitude": 54.69608,
        "longitude": 25.42021
      },
      "lks94": {
        "easting": 591549.36,
        "northing": 6063111.089
      }
    },
    {
      "id": "judu:stop:6065",
      "stopId": "6065",
      "name": "Bičių st.",
      "description": "link Arimų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2367",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "27"
      ],
      "wgs84": {
        "latitude": 54.69735,
        "longitude": 25.42837
      },
      "lks94": {
        "easting": 592072.457,
        "northing": 6063263.092
      }
    },
    {
      "id": "judu:stop:6066",
      "stopId": "6066",
      "name": "Bičių st.",
      "description": "link Šiaurės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2366",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "27"
      ],
      "wgs84": {
        "latitude": 54.69768,
        "longitude": 25.42966
      },
      "lks94": {
        "easting": 592154.856,
        "northing": 6063301.509
      }
    },
    {
      "id": "judu:stop:6068",
      "stopId": "6068",
      "name": "Užkiemio st.",
      "description": "link Šiaurės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2373",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "27"
      ],
      "wgs84": {
        "latitude": 54.69889,
        "longitude": 25.43281
      },
      "lks94": {
        "easting": 592355.14,
        "northing": 6063440.302
      }
    },
    {
      "id": "judu:stop:6069",
      "stopId": "6069",
      "name": "Užkiemio st.",
      "description": "link Arimų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2374",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "27"
      ],
      "wgs84": {
        "latitude": 54.69908,
        "longitude": 25.43283
      },
      "lks94": {
        "easting": 592355.997,
        "northing": 6063461.473
      }
    },
    {
      "id": "judu:stop:6073",
      "stopId": "6073",
      "name": "Naujosios Vilnios žiedas",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2356",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "6G",
        "14",
        "18",
        "31",
        "67",
        "74",
        "115",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.68558,
        "longitude": 25.42811
      },
      "lks94": {
        "easting": 592082.346,
        "northing": 6061952.937
      }
    },
    {
      "id": "judu:stop:6079",
      "stopId": "6079",
      "name": "Lakštingalų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1123",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "15",
        "17",
        "18",
        "39"
      ],
      "wgs84": {
        "latitude": 54.7288,
        "longitude": 25.32883
      },
      "lks94": {
        "easting": 585590.252,
        "northing": 6066637.027
      }
    },
    {
      "id": "judu:stop:6081",
      "stopId": "6081",
      "name": "Lakštingalų st.",
      "description": "link Nemenčinės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3518",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "39"
      ],
      "wgs84": {
        "latitude": 54.72998,
        "longitude": 25.33112
      },
      "lks94": {
        "easting": 585735.252,
        "northing": 6066771.14
      }
    },
    {
      "id": "judu:stop:6082",
      "stopId": "6082",
      "name": "Žuvėdrų st.",
      "description": "link Nemenčinės pl.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3515",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "15"
      ],
      "wgs84": {
        "latitude": 54.7314,
        "longitude": 25.32414
      },
      "lks94": {
        "easting": 585282.726,
        "northing": 6066920.661
      }
    },
    {
      "id": "judu:stop:6083",
      "stopId": "6083",
      "name": "Žuvėdrų st.",
      "description": "link Grybautojų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3516",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "15"
      ],
      "wgs84": {
        "latitude": 54.73133,
        "longitude": 25.32467
      },
      "lks94": {
        "easting": 585317.006,
        "northing": 6066913.515
      }
    },
    {
      "id": "judu:stop:6084",
      "stopId": "6084",
      "name": "Grybautojų st.",
      "description": "link Nemenčinės pl.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3514",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "15"
      ],
      "wgs84": {
        "latitude": 54.73295,
        "longitude": 25.3182
      },
      "lks94": {
        "easting": 584896.935,
        "northing": 6067085.952
      }
    },
    {
      "id": "judu:stop:6095",
      "stopId": "6095",
      "name": "Meškeriotojų st.",
      "description": "link Turniškių g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3509",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "15"
      ],
      "wgs84": {
        "latitude": 54.74585,
        "longitude": 25.31977
      },
      "lks94": {
        "easting": 584971.037,
        "northing": 6068523.45
      }
    },
    {
      "id": "judu:stop:6096",
      "stopId": "6096",
      "name": "Meškeriotojų st.",
      "description": "link Grybautojų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3508",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "15"
      ],
      "wgs84": {
        "latitude": 54.74621,
        "longitude": 25.32017
      },
      "lks94": {
        "easting": 584996.035,
        "northing": 6068563.998
      }
    },
    {
      "id": "judu:stop:6100",
      "stopId": "6100",
      "name": "Bruknių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3507",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "15"
      ],
      "wgs84": {
        "latitude": 54.74355,
        "longitude": 25.30345
      },
      "lks94": {
        "easting": 583925.12,
        "northing": 6068247.846
      }
    },
    {
      "id": "judu:stop:6104",
      "stopId": "6104",
      "name": "2-asis paplūdimys",
      "description": "link Antakalnio",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3506",
      "modes": [
        "trolleybus"
      ],
      "routeShortNames": [
        "3"
      ],
      "wgs84": {
        "latitude": 54.74239,
        "longitude": 25.2946
      },
      "lks94": {
        "easting": 583357.71,
        "northing": 6068108.202
      }
    },
    {
      "id": "judu:stop:6106",
      "stopId": "6106",
      "name": "Vaidilutės st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3505",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3",
        "15"
      ],
      "wgs84": {
        "latitude": 54.73604,
        "longitude": 25.29455
      },
      "lks94": {
        "easting": 583367.53,
        "northing": 6067401.47
      }
    },
    {
      "id": "judu:stop:6107",
      "stopId": "6107",
      "name": "1-asis paplūdimys",
      "description": "link Antakalnio",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3504",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3",
        "15"
      ],
      "wgs84": {
        "latitude": 54.73311,
        "longitude": 25.29605
      },
      "lks94": {
        "easting": 583470.146,
        "northing": 6067077.183
      }
    },
    {
      "id": "judu:stop:6109",
      "stopId": "6109",
      "name": "Rato st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3503",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3",
        "15"
      ],
      "wgs84": {
        "latitude": 54.73082,
        "longitude": 25.30869
      },
      "lks94": {
        "easting": 584288.913,
        "northing": 6066837.446
      }
    },
    {
      "id": "judu:stop:6110",
      "stopId": "6110",
      "name": "Lizdeikos st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3502",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3",
        "15"
      ],
      "wgs84": {
        "latitude": 54.72872,
        "longitude": 25.31366
      },
      "lks94": {
        "easting": 584613.373,
        "northing": 6066609.726
      }
    },
    {
      "id": "judu:stop:6120",
      "stopId": "6120",
      "name": "Minsko plentas",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4301",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12",
        "14",
        "16",
        "61"
      ],
      "wgs84": {
        "latitude": 54.64434,
        "longitude": 25.33872
      },
      "lks94": {
        "easting": 586406.468,
        "northing": 6057249.968
      }
    },
    {
      "id": "judu:stop:6121",
      "stopId": "6121",
      "name": "Minsko plentas",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1418",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "16",
        "58",
        "61",
        "122"
      ],
      "wgs84": {
        "latitude": 54.64501,
        "longitude": 25.33736
      },
      "lks94": {
        "easting": 586317.274,
        "northing": 6057322.857
      }
    },
    {
      "id": "judu:stop:6122",
      "stopId": "6122",
      "name": "Sodai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4302",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12",
        "14",
        "16",
        "61"
      ],
      "wgs84": {
        "latitude": 54.64243,
        "longitude": 25.34666
      },
      "lks94": {
        "easting": 586922.992,
        "northing": 6057047.211
      }
    },
    {
      "id": "judu:stop:6123",
      "stopId": "6123",
      "name": "Sodai",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1419",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "16"
      ],
      "wgs84": {
        "latitude": 54.64299,
        "longitude": 25.34566
      },
      "lks94": {
        "easting": 586857.255,
        "northing": 6057108.293
      }
    },
    {
      "id": "judu:stop:6124",
      "stopId": "6124",
      "name": "Nemėžis",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4303",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12",
        "14",
        "16"
      ],
      "wgs84": {
        "latitude": 54.63997,
        "longitude": 25.35694
      },
      "lks94": {
        "easting": 587591.784,
        "northing": 6056786.22
      }
    },
    {
      "id": "judu:stop:6125",
      "stopId": "6125",
      "name": "Nemėžis",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1420",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "16"
      ],
      "wgs84": {
        "latitude": 54.64047,
        "longitude": 25.35628
      },
      "lks94": {
        "easting": 587548.109,
        "northing": 6056841.04
      }
    },
    {
      "id": "judu:stop:6126",
      "stopId": "6126",
      "name": "Daržininkai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4304",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12",
        "14",
        "16"
      ],
      "wgs84": {
        "latitude": 54.6372,
        "longitude": 25.36844
      },
      "lks94": {
        "easting": 588340.079,
        "northing": 6056492.364
      }
    },
    {
      "id": "judu:stop:6127",
      "stopId": "6127",
      "name": "Daržininkai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4327",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "16"
      ],
      "wgs84": {
        "latitude": 54.63803,
        "longitude": 25.3667
      },
      "lks94": {
        "easting": 588225.963,
        "northing": 6056582.543
      }
    },
    {
      "id": "judu:stop:6128",
      "stopId": "6128",
      "name": "Posūkis",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4306",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12",
        "14",
        "16"
      ],
      "wgs84": {
        "latitude": 54.62644,
        "longitude": 25.39308
      },
      "lks94": {
        "easting": 589954.365,
        "northing": 6055326.216
      }
    },
    {
      "id": "judu:stop:6129",
      "stopId": "6129",
      "name": "Posūkis",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4329",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "16"
      ],
      "wgs84": {
        "latitude": 54.62727,
        "longitude": 25.39227
      },
      "lks94": {
        "easting": 589900.235,
        "northing": 6055417.545
      }
    },
    {
      "id": "judu:stop:6130",
      "stopId": "6130",
      "name": "Stankutiškės",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4307",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12",
        "14",
        "16"
      ],
      "wgs84": {
        "latitude": 54.62039,
        "longitude": 25.38993
      },
      "lks94": {
        "easting": 589764.295,
        "northing": 6054648.922
      }
    },
    {
      "id": "judu:stop:6131",
      "stopId": "6131",
      "name": "Stankutiškės",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4308",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "16"
      ],
      "wgs84": {
        "latitude": 54.62085,
        "longitude": 25.39024
      },
      "lks94": {
        "easting": 589783.302,
        "northing": 6054700.509
      }
    },
    {
      "id": "judu:stop:6133",
      "stopId": "6133",
      "name": "Sodžiaus st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4310",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12",
        "14",
        "16"
      ],
      "wgs84": {
        "latitude": 54.61364,
        "longitude": 25.38872
      },
      "lks94": {
        "easting": 589701.003,
        "northing": 6053896.214
      }
    },
    {
      "id": "judu:stop:6134",
      "stopId": "6134",
      "name": "Sodžiaus st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4309",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "16"
      ],
      "wgs84": {
        "latitude": 54.6139,
        "longitude": 25.38901
      },
      "lks94": {
        "easting": 589719.162,
        "northing": 6053925.518
      }
    },
    {
      "id": "judu:stop:6137",
      "stopId": "6137",
      "name": "Skaidiškės",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4316",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12",
        "14",
        "16"
      ],
      "wgs84": {
        "latitude": 54.60569,
        "longitude": 25.38255
      },
      "lks94": {
        "easting": 589319.899,
        "northing": 6053003.652
      }
    },
    {
      "id": "judu:stop:6140",
      "stopId": "6140",
      "name": "Ežerėlių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3522",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "39",
        "121"
      ],
      "wgs84": {
        "latitude": 54.73855,
        "longitude": 25.34438
      },
      "lks94": {
        "easting": 586570.98,
        "northing": 6067741.145
      }
    },
    {
      "id": "judu:stop:6141",
      "stopId": "6141",
      "name": "Kiškių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3519",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "39",
        "121"
      ],
      "wgs84": {
        "latitude": 54.73383,
        "longitude": 25.33664
      },
      "lks94": {
        "easting": 586082.602,
        "northing": 6067206.351
      }
    },
    {
      "id": "judu:stop:6142",
      "stopId": "6142",
      "name": "Ežerėlių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3521",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "39",
        "121"
      ],
      "wgs84": {
        "latitude": 54.73784,
        "longitude": 25.34252
      },
      "lks94": {
        "easting": 586452.725,
        "northing": 6067659.838
      }
    },
    {
      "id": "judu:stop:6143",
      "stopId": "6143",
      "name": "Nugalėtojų st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3553",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "39",
        "121"
      ],
      "wgs84": {
        "latitude": 54.74176,
        "longitude": 25.34931
      },
      "lks94": {
        "easting": 586881.556,
        "northing": 6068104.468
      }
    },
    {
      "id": "judu:stop:6144",
      "stopId": "6144",
      "name": "Nugalėtojų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3552",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "39",
        "121"
      ],
      "wgs84": {
        "latitude": 54.74172,
        "longitude": 25.34857
      },
      "lks94": {
        "easting": 586833.996,
        "northing": 6068099.1
      }
    },
    {
      "id": "judu:stop:6146",
      "stopId": "6146",
      "name": "Turniškių miškas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3534",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "39",
        "121"
      ],
      "wgs84": {
        "latitude": 54.74815,
        "longitude": 25.35776
      },
      "lks94": {
        "easting": 587411.851,
        "northing": 6068826.083
      }
    },
    {
      "id": "judu:stop:6147",
      "stopId": "6147",
      "name": "Turniškių miškas",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3535",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "39",
        "121"
      ],
      "wgs84": {
        "latitude": 54.74838,
        "longitude": 25.35849
      },
      "lks94": {
        "easting": 587458.349,
        "northing": 6068852.589
      }
    },
    {
      "id": "judu:stop:6148",
      "stopId": "6148",
      "name": "Smėlynė",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3537",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "39",
        "121"
      ],
      "wgs84": {
        "latitude": 54.75471,
        "longitude": 25.3658
      },
      "lks94": {
        "easting": 587915.215,
        "northing": 6069566.168
      }
    },
    {
      "id": "judu:stop:6149",
      "stopId": "6149",
      "name": "Smėlynė",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3536",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "39",
        "121"
      ],
      "wgs84": {
        "latitude": 54.75437,
        "longitude": 25.36489
      },
      "lks94": {
        "easting": 587857.379,
        "northing": 6069527.191
      }
    },
    {
      "id": "judu:stop:6152",
      "stopId": "6152",
      "name": "Veržuvos st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3538",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "39",
        "121"
      ],
      "wgs84": {
        "latitude": 54.76149,
        "longitude": 25.37262
      },
      "lks94": {
        "easting": 588339.418,
        "northing": 6070329.257
      }
    },
    {
      "id": "judu:stop:6153",
      "stopId": "6153",
      "name": "Veržuvos st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3539",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "39",
        "121"
      ],
      "wgs84": {
        "latitude": 54.76224,
        "longitude": 25.37405
      },
      "lks94": {
        "easting": 588429.809,
        "northing": 6070414.524
      }
    },
    {
      "id": "judu:stop:6154",
      "stopId": "6154",
      "name": "Karačiūnai",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3540",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "39",
        "121"
      ],
      "wgs84": {
        "latitude": 54.77234,
        "longitude": 25.38218
      },
      "lks94": {
        "easting": 588930.846,
        "northing": 6071548.794
      }
    },
    {
      "id": "judu:stop:6155",
      "stopId": "6155",
      "name": "Karačiūnai",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3541",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "39",
        "121"
      ],
      "wgs84": {
        "latitude": 54.7713,
        "longitude": 25.38176
      },
      "lks94": {
        "easting": 588906.105,
        "northing": 6071432.524
      }
    },
    {
      "id": "judu:stop:6159",
      "stopId": "6159",
      "name": "Šilas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3542",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "121"
      ],
      "wgs84": {
        "latitude": 54.78466,
        "longitude": 25.38346
      },
      "lks94": {
        "easting": 588986.147,
        "northing": 6072921.466
      }
    },
    {
      "id": "judu:stop:6160",
      "stopId": "6160",
      "name": "Šilas",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3543",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "121"
      ],
      "wgs84": {
        "latitude": 54.78564,
        "longitude": 25.3839
      },
      "lks94": {
        "easting": 589012.294,
        "northing": 6073031.085
      }
    },
    {
      "id": "judu:stop:6162",
      "stopId": "6162",
      "name": "Jono Biliūno st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3551",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "121"
      ],
      "wgs84": {
        "latitude": 54.7945,
        "longitude": 25.39138
      },
      "lks94": {
        "easting": 589473.808,
        "northing": 6074026.604
      }
    },
    {
      "id": "judu:stop:6163",
      "stopId": "6163",
      "name": "Antaviliai",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3547",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "121"
      ],
      "wgs84": {
        "latitude": 54.79863,
        "longitude": 25.39775
      },
      "lks94": {
        "easting": 589874.246,
        "northing": 6074494.364
      }
    },
    {
      "id": "judu:stop:6164",
      "stopId": "6164",
      "name": "Antaviliai",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3548",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "121"
      ],
      "wgs84": {
        "latitude": 54.79841,
        "longitude": 25.39653
      },
      "lks94": {
        "easting": 589796.294,
        "northing": 6074468.318
      }
    },
    {
      "id": "judu:stop:6170",
      "stopId": "6170",
      "name": "Plytinės st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1007",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18",
        "38"
      ],
      "wgs84": {
        "latitude": 54.72791,
        "longitude": 25.34778
      },
      "lks94": {
        "easting": 586812.655,
        "northing": 6066561.261
      }
    },
    {
      "id": "judu:stop:6171",
      "stopId": "6171",
      "name": "Plytinės st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1006",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18",
        "38"
      ],
      "wgs84": {
        "latitude": 54.72762,
        "longitude": 25.34671
      },
      "lks94": {
        "easting": 586744.358,
        "northing": 6066527.665
      }
    },
    {
      "id": "judu:stop:6173",
      "stopId": "6173",
      "name": "Aukštagiris",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3523",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18",
        "38"
      ],
      "wgs84": {
        "latitude": 54.73049,
        "longitude": 25.35577
      },
      "lks94": {
        "easting": 587321.724,
        "northing": 6066858.293
      }
    },
    {
      "id": "judu:stop:6174",
      "stopId": "6174",
      "name": "Aukštagiris",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1008",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18",
        "38"
      ],
      "wgs84": {
        "latitude": 54.73057,
        "longitude": 25.35661
      },
      "lks94": {
        "easting": 587375.65,
        "northing": 6066868.242
      }
    },
    {
      "id": "judu:stop:6176",
      "stopId": "6176",
      "name": "Dvarčionių kryžkelė",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1009",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18",
        "38"
      ],
      "wgs84": {
        "latitude": 54.73347,
        "longitude": 25.37073
      },
      "lks94": {
        "easting": 588278.72,
        "northing": 6067208.645
      }
    },
    {
      "id": "judu:stop:6177",
      "stopId": "6177",
      "name": "Dvarčionių kryžkelė",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3524",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18",
        "38"
      ],
      "wgs84": {
        "latitude": 54.73344,
        "longitude": 25.36972
      },
      "lks94": {
        "easting": 588213.742,
        "northing": 6067204.036
      }
    },
    {
      "id": "judu:stop:6179",
      "stopId": "6179",
      "name": "Lazerių st.",
      "description": "visos kryptys",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1012",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18",
        "38",
        "114"
      ],
      "wgs84": {
        "latitude": 54.72949,
        "longitude": 25.37465
      },
      "lks94": {
        "easting": 588539.84,
        "northing": 6066770.667
      }
    },
    {
      "id": "judu:stop:6180",
      "stopId": "6180",
      "name": "Lazerių st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1013",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18",
        "38"
      ],
      "wgs84": {
        "latitude": 54.72956,
        "longitude": 25.37489
      },
      "lks94": {
        "easting": 588555.144,
        "northing": 6066778.76
      }
    },
    {
      "id": "judu:stop:6181",
      "stopId": "6181",
      "name": "Dvarčionys",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1026",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18",
        "38"
      ],
      "wgs84": {
        "latitude": 54.72986,
        "longitude": 25.37033
      },
      "lks94": {
        "easting": 588260.806,
        "northing": 6066806.4
      }
    },
    {
      "id": "judu:stop:6183",
      "stopId": "6183",
      "name": "Baniškės",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1014",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18",
        "38",
        "114"
      ],
      "wgs84": {
        "latitude": 54.73453,
        "longitude": 25.38833
      },
      "lks94": {
        "easting": 589409.8,
        "northing": 6067348.893
      }
    },
    {
      "id": "judu:stop:6184",
      "stopId": "6184",
      "name": "Baniškės",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3525",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18",
        "38",
        "114"
      ],
      "wgs84": {
        "latitude": 54.73451,
        "longitude": 25.3871
      },
      "lks94": {
        "easting": 589330.636,
        "northing": 6067345.1
      }
    },
    {
      "id": "judu:stop:6188",
      "stopId": "6188",
      "name": "Paliuliškės",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1016",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18"
      ],
      "wgs84": {
        "latitude": 54.73365,
        "longitude": 25.41033
      },
      "lks94": {
        "easting": 590828.495,
        "northing": 6067279.218
      }
    },
    {
      "id": "judu:stop:6189",
      "stopId": "6189",
      "name": "Paliuliškės",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1017",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18"
      ],
      "wgs84": {
        "latitude": 54.73289,
        "longitude": 25.41104
      },
      "lks94": {
        "easting": 590875.919,
        "northing": 6067195.561
      }
    },
    {
      "id": "judu:stop:6190",
      "stopId": "6190",
      "name": "Lubinų st.",
      "description": "link mieto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1018",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18"
      ],
      "wgs84": {
        "latitude": 54.72976,
        "longitude": 25.41224
      },
      "lks94": {
        "easting": 590960.209,
        "northing": 6066848.794
      }
    },
    {
      "id": "judu:stop:6191",
      "stopId": "6191",
      "name": "Lubinų st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1024",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18"
      ],
      "wgs84": {
        "latitude": 54.72872,
        "longitude": 25.41181
      },
      "lks94": {
        "easting": 590934.844,
        "northing": 6066732.5
      }
    },
    {
      "id": "judu:stop:6192",
      "stopId": "6192",
      "name": "Purienų st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1025",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18"
      ],
      "wgs84": {
        "latitude": 54.72488,
        "longitude": 25.412
      },
      "lks94": {
        "easting": 590955.68,
        "northing": 6066305.412
      }
    },
    {
      "id": "judu:stop:6193",
      "stopId": "6193",
      "name": "Purienų st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4601",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18"
      ],
      "wgs84": {
        "latitude": 54.72487,
        "longitude": 25.41211
      },
      "lks94": {
        "easting": 590962.788,
        "northing": 6066304.442
      }
    },
    {
      "id": "judu:stop:6195",
      "stopId": "6195",
      "name": "Galgiai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4603",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18"
      ],
      "wgs84": {
        "latitude": 54.71935,
        "longitude": 25.4115
      },
      "lks94": {
        "easting": 590935.854,
        "northing": 6065689.358
      }
    },
    {
      "id": "judu:stop:6198",
      "stopId": "6198",
      "name": "Vakario st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4604",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18"
      ],
      "wgs84": {
        "latitude": 54.71454,
        "longitude": 25.4126
      },
      "lks94": {
        "easting": 591017.491,
        "northing": 6065155.504
      }
    },
    {
      "id": "judu:stop:6199",
      "stopId": "6199",
      "name": "Vakario st.",
      "description": "link N.Vilnios",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1020",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18"
      ],
      "wgs84": {
        "latitude": 54.71359,
        "longitude": 25.4124
      },
      "lks94": {
        "easting": 591006.733,
        "northing": 6065049.524
      }
    },
    {
      "id": "judu:stop:6203",
      "stopId": "6203",
      "name": "Šiaurės st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2336",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18"
      ],
      "wgs84": {
        "latitude": 54.70929,
        "longitude": 25.41681
      },
      "lks94": {
        "easting": 591300.529,
        "northing": 6064576.728
      }
    },
    {
      "id": "judu:stop:6204",
      "stopId": "6204",
      "name": "Šiaurės st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2335",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18"
      ],
      "wgs84": {
        "latitude": 54.70863,
        "longitude": 25.41716
      },
      "lks94": {
        "easting": 591324.565,
        "northing": 6064503.735
      }
    },
    {
      "id": "judu:stop:6207",
      "stopId": "6207",
      "name": "Pupojų st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2334",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18"
      ],
      "wgs84": {
        "latitude": 54.70272,
        "longitude": 25.41411
      },
      "lks94": {
        "easting": 591141.282,
        "northing": 6063842.079
      }
    },
    {
      "id": "judu:stop:6208",
      "stopId": "6208",
      "name": "Pupojų st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2333",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18"
      ],
      "wgs84": {
        "latitude": 54.70183,
        "longitude": 25.4131
      },
      "lks94": {
        "easting": 591078.185,
        "northing": 6063741.725
      }
    },
    {
      "id": "judu:stop:6211",
      "stopId": "6211",
      "name": "Palydovo st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2331",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18"
      ],
      "wgs84": {
        "latitude": 54.701,
        "longitude": 25.40844
      },
      "lks94": {
        "easting": 590779.708,
        "northing": 6063643.322
      }
    },
    {
      "id": "judu:stop:6212",
      "stopId": "6212",
      "name": "Palydovo st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2332",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18"
      ],
      "wgs84": {
        "latitude": 54.70112,
        "longitude": 25.40998
      },
      "lks94": {
        "easting": 590878.693,
        "northing": 6063658.669
      }
    },
    {
      "id": "judu:stop:6215",
      "stopId": "6215",
      "name": "Uosių st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2326",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18"
      ],
      "wgs84": {
        "latitude": 54.69939,
        "longitude": 25.40195
      },
      "lks94": {
        "easting": 590365.008,
        "northing": 6063455.78
      }
    },
    {
      "id": "judu:stop:6216",
      "stopId": "6216",
      "name": "Uosių st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2327",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "115"
      ],
      "wgs84": {
        "latitude": 54.69943,
        "longitude": 25.40141
      },
      "lks94": {
        "easting": 590330.115,
        "northing": 6063459.536
      }
    },
    {
      "id": "judu:stop:6217",
      "stopId": "6217",
      "name": "Uosių st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2325",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18",
        "115"
      ],
      "wgs84": {
        "latitude": 54.69903,
        "longitude": 25.40122
      },
      "lks94": {
        "easting": 590318.757,
        "northing": 6063414.778
      }
    },
    {
      "id": "judu:stop:6218",
      "stopId": "6218",
      "name": "Paparčių st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2328",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "115"
      ],
      "wgs84": {
        "latitude": 54.70163,
        "longitude": 25.39411
      },
      "lks94": {
        "easting": 589854.75,
        "northing": 6063694.993
      }
    },
    {
      "id": "judu:stop:6219",
      "stopId": "6219",
      "name": "Paparčių st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2329",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "115"
      ],
      "wgs84": {
        "latitude": 54.70157,
        "longitude": 25.39462
      },
      "lks94": {
        "easting": 589887.751,
        "northing": 6063688.969
      }
    },
    {
      "id": "judu:stop:6221",
      "stopId": "6221",
      "name": "Kalno st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2377",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "115"
      ],
      "wgs84": {
        "latitude": 54.70491,
        "longitude": 25.39314
      },
      "lks94": {
        "easting": 589784.989,
        "northing": 6064058.766
      }
    },
    {
      "id": "judu:stop:6225",
      "stopId": "6225",
      "name": "Tremtinių st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2346",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "6G",
        "14",
        "18",
        "58",
        "67",
        "74",
        "115"
      ],
      "wgs84": {
        "latitude": 54.6926,
        "longitude": 25.41063
      },
      "lks94": {
        "easting": 590939.64,
        "northing": 6062711.367
      }
    },
    {
      "id": "judu:stop:6230",
      "stopId": "6230",
      "name": "Alberto Kojelavičiaus st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2324",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18",
        "115"
      ],
      "wgs84": {
        "latitude": 54.69631,
        "longitude": 25.39844
      },
      "lks94": {
        "easting": 590145.609,
        "northing": 6063108.51
      }
    },
    {
      "id": "judu:stop:6239",
      "stopId": "6239",
      "name": "Senoji plytinė",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1004",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "4G",
        "5G",
        "10",
        "18",
        "19",
        "38",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.72403,
        "longitude": 25.33967
      },
      "lks94": {
        "easting": 586298.552,
        "northing": 6066119.468
      }
    },
    {
      "id": "judu:stop:6240",
      "stopId": "6240",
      "name": "Salininkų sodai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2637",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "19",
        "42",
        "82"
      ],
      "wgs84": {
        "latitude": 54.61803,
        "longitude": 25.28348
      },
      "lks94": {
        "easting": 582894.746,
        "northing": 6054255.504
      }
    },
    {
      "id": "judu:stop:6241",
      "stopId": "6241",
      "name": "Salininkų sodai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4006",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "19",
        "82"
      ],
      "wgs84": {
        "latitude": 54.61823,
        "longitude": 25.28465
      },
      "lks94": {
        "easting": 582969.9,
        "northing": 6054279.142
      }
    },
    {
      "id": "judu:stop:6243",
      "stopId": "6243",
      "name": "Sakalaičių st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2638",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "19",
        "42",
        "82"
      ],
      "wgs84": {
        "latitude": 54.61186,
        "longitude": 25.27491
      },
      "lks94": {
        "easting": 582353.733,
        "northing": 6053558.799
      }
    },
    {
      "id": "judu:stop:6244",
      "stopId": "6244",
      "name": "Sakalaičių st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4007",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "19",
        "82"
      ],
      "wgs84": {
        "latitude": 54.61265,
        "longitude": 25.27545
      },
      "lks94": {
        "easting": 582387.017,
        "northing": 6053647.347
      }
    },
    {
      "id": "judu:stop:6246",
      "stopId": "6246",
      "name": "Pervaža",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2715",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "19",
        "42",
        "82"
      ],
      "wgs84": {
        "latitude": 54.60948,
        "longitude": 25.27456
      },
      "lks94": {
        "easting": 582335.929,
        "northing": 6053293.53
      }
    },
    {
      "id": "judu:stop:6247",
      "stopId": "6247",
      "name": "Pervaža",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4008",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "19",
        "82"
      ],
      "wgs84": {
        "latitude": 54.60923,
        "longitude": 25.27467
      },
      "lks94": {
        "easting": 582343.539,
        "northing": 6053265.838
      }
    },
    {
      "id": "judu:stop:6248",
      "stopId": "6248",
      "name": "Vilniaus st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2714",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "19",
        "42",
        "82"
      ],
      "wgs84": {
        "latitude": 54.60566,
        "longitude": 25.26949
      },
      "lks94": {
        "easting": 582016.107,
        "northing": 6052862.493
      }
    },
    {
      "id": "judu:stop:6249",
      "stopId": "6249",
      "name": "Vilniaus st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2815",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "19",
        "82"
      ],
      "wgs84": {
        "latitude": 54.60611,
        "longitude": 25.27069
      },
      "lks94": {
        "easting": 582092.724,
        "northing": 6052913.972
      }
    },
    {
      "id": "judu:stop:6253",
      "stopId": "6253",
      "name": "Jono Stašaičio st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2713",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "19",
        "42",
        "82"
      ],
      "wgs84": {
        "latitude": 54.60512,
        "longitude": 25.26033
      },
      "lks94": {
        "easting": 581425.43,
        "northing": 6052791.748
      }
    },
    {
      "id": "judu:stop:6254",
      "stopId": "6254",
      "name": "Jono Stašaičio st.",
      "description": "link Mechanikų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2712",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "19",
        "42",
        "82"
      ],
      "wgs84": {
        "latitude": 54.60525,
        "longitude": 25.25838
      },
      "lks94": {
        "easting": 581299.195,
        "northing": 6052803.957
      }
    },
    {
      "id": "judu:stop:6256",
      "stopId": "6256",
      "name": "Salininkai",
      "description": "link Eišiškių pl.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2711",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "19",
        "42"
      ],
      "wgs84": {
        "latitude": 54.60566,
        "longitude": 25.25161
      },
      "lks94": {
        "easting": 580861.021,
        "northing": 6052841.774
      }
    },
    {
      "id": "judu:stop:6257",
      "stopId": "6257",
      "name": "Salininkai",
      "description": "link Salininkų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2710",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "19",
        "42",
        "82"
      ],
      "wgs84": {
        "latitude": 54.60565,
        "longitude": 25.25118
      },
      "lks94": {
        "easting": 580833.261,
        "northing": 6052840.166
      }
    },
    {
      "id": "judu:stop:6260",
      "stopId": "6260",
      "name": "Mechanikų st.",
      "description": "link Eišiškių pl.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2708",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "19",
        "42"
      ],
      "wgs84": {
        "latitude": 54.60968,
        "longitude": 25.25171
      },
      "lks94": {
        "easting": 580859.512,
        "northing": 6053289.256
      }
    },
    {
      "id": "judu:stop:6261",
      "stopId": "6261",
      "name": "Mechanikų st.",
      "description": "link Salininkų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2709",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "19",
        "42"
      ],
      "wgs84": {
        "latitude": 54.6097,
        "longitude": 25.25147
      },
      "lks94": {
        "easting": 580843.97,
        "northing": 6053291.205
      }
    },
    {
      "id": "judu:stop:6263",
      "stopId": "6263",
      "name": "Salininkų žiedas",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2706",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "42"
      ],
      "wgs84": {
        "latitude": 54.61419,
        "longitude": 25.25197
      },
      "lks94": {
        "easting": 580867.365,
        "northing": 6053791.452
      }
    },
    {
      "id": "judu:stop:6264",
      "stopId": "6264",
      "name": "Salininkų žiedas",
      "description": "visos kryptys",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2707",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "19",
        "42"
      ],
      "wgs84": {
        "latitude": 54.61403,
        "longitude": 25.25182
      },
      "lks94": {
        "easting": 580857.994,
        "northing": 6053773.473
      }
    },
    {
      "id": "judu:stop:6270",
      "stopId": "6270",
      "name": "Žarijų st.",
      "description": "link Liudvinavo",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2914",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20",
        "62"
      ],
      "wgs84": {
        "latitude": 54.63239,
        "longitude": 25.14007
      },
      "lks94": {
        "easting": 573606.974,
        "northing": 6055693.858
      }
    },
    {
      "id": "judu:stop:6271",
      "stopId": "6271",
      "name": "Žarijų st.",
      "description": "link Galvės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2915",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20",
        "62"
      ],
      "wgs84": {
        "latitude": 54.63223,
        "longitude": 25.14053
      },
      "lks94": {
        "easting": 573636.961,
        "northing": 6055676.534
      }
    },
    {
      "id": "judu:stop:6273",
      "stopId": "6273",
      "name": "Šešėlių st.",
      "description": "link Galvės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2917",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20",
        "62"
      ],
      "wgs84": {
        "latitude": 54.63715,
        "longitude": 25.13563
      },
      "lks94": {
        "easting": 573311.761,
        "northing": 6056218.943
      }
    },
    {
      "id": "judu:stop:6274",
      "stopId": "6274",
      "name": "Šešėlių st.",
      "description": "link Lentvario g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2916",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20",
        "62"
      ],
      "wgs84": {
        "latitude": 54.6376,
        "longitude": 25.13566
      },
      "lks94": {
        "easting": 573312.888,
        "northing": 6056269.053
      }
    },
    {
      "id": "judu:stop:6276",
      "stopId": "6276",
      "name": "Liudvinavo st.",
      "description": "link Galvės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2919",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20",
        "62"
      ],
      "wgs84": {
        "latitude": 54.64015,
        "longitude": 25.13522
      },
      "lks94": {
        "easting": 573279.898,
        "northing": 6056552.377
      }
    },
    {
      "id": "judu:stop:6277",
      "stopId": "6277",
      "name": "Liudvinavo st.",
      "description": "link Lentvario g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2918",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20",
        "62"
      ],
      "wgs84": {
        "latitude": 54.64067,
        "longitude": 25.13522
      },
      "lks94": {
        "easting": 573278.963,
        "northing": 6056610.247
      }
    },
    {
      "id": "judu:stop:6278",
      "stopId": "6278",
      "name": "Asfalto st.",
      "description": "link Lentvario g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2920",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20",
        "62"
      ],
      "wgs84": {
        "latitude": 54.6448,
        "longitude": 25.13449
      },
      "lks94": {
        "easting": 573224.42,
        "northing": 6057069.103
      }
    },
    {
      "id": "judu:stop:6279",
      "stopId": "6279",
      "name": "Asfalto st.",
      "description": "link Galvės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2921",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20",
        "62"
      ],
      "wgs84": {
        "latitude": 54.64519,
        "longitude": 25.13463
      },
      "lks94": {
        "easting": 573232.755,
        "northing": 6057112.651
      }
    },
    {
      "id": "judu:stop:6282",
      "stopId": "6282",
      "name": "Liudvinava",
      "description": "link Mūrinės Vokės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2936",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20",
        "62",
        "68"
      ],
      "wgs84": {
        "latitude": 54.64716,
        "longitude": 25.12816
      },
      "lks94": {
        "easting": 572811.656,
        "northing": 6057325.161
      }
    },
    {
      "id": "judu:stop:6283",
      "stopId": "6283",
      "name": "Liudvinava",
      "description": "link Kirtimų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2935",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20",
        "62",
        "68"
      ],
      "wgs84": {
        "latitude": 54.64705,
        "longitude": 25.12837
      },
      "lks94": {
        "easting": 572825.406,
        "northing": 6057313.137
      }
    },
    {
      "id": "judu:stop:6286",
      "stopId": "6286",
      "name": "Mūrinė Vokė",
      "description": "visos kryptys",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3901",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20",
        "62",
        "68"
      ],
      "wgs84": {
        "latitude": 54.64828,
        "longitude": 25.12176
      },
      "lks94": {
        "easting": 572396.626,
        "northing": 6057443.188
      }
    },
    {
      "id": "judu:stop:6290",
      "stopId": "6290",
      "name": "Kulokiškės",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2922",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20",
        "62",
        "68"
      ],
      "wgs84": {
        "latitude": 54.64564,
        "longitude": 25.14227
      },
      "lks94": {
        "easting": 573725.03,
        "northing": 6057170.722
      }
    },
    {
      "id": "judu:stop:6291",
      "stopId": "6291",
      "name": "Kulokiškės",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2923",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20",
        "62",
        "68"
      ],
      "wgs84": {
        "latitude": 54.64538,
        "longitude": 25.14395
      },
      "lks94": {
        "easting": 573833.928,
        "northing": 6057143.552
      }
    },
    {
      "id": "judu:stop:6294",
      "stopId": "6294",
      "name": "Kauno plentas",
      "description": "link Kirtimų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2925",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20",
        "28",
        "62",
        "68"
      ],
      "wgs84": {
        "latitude": 54.65524,
        "longitude": 25.15088
      },
      "lks94": {
        "easting": 574263.211,
        "northing": 6058248.152
      }
    },
    {
      "id": "judu:stop:6295",
      "stopId": "6295",
      "name": "Kauno plentas",
      "description": "link Gariūnų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2924",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20",
        "28",
        "29",
        "59",
        "62",
        "68",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.65424,
        "longitude": 25.15088
      },
      "lks94": {
        "easting": 574265.035,
        "northing": 6058136.864
      }
    },
    {
      "id": "judu:stop:6296",
      "stopId": "6296",
      "name": "Gariūnai",
      "description": "link TE-3",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2926",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20"
      ],
      "wgs84": {
        "latitude": 54.65999,
        "longitude": 25.16061
      },
      "lks94": {
        "easting": 574882.298,
        "northing": 6058787.098
      }
    },
    {
      "id": "judu:stop:6297",
      "stopId": "6297",
      "name": "Gariūnai",
      "description": "link Savanorių pr.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2927",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20",
        "29",
        "59",
        "62",
        "68"
      ],
      "wgs84": {
        "latitude": 54.65892,
        "longitude": 25.15913
      },
      "lks94": {
        "easting": 574788.778,
        "northing": 6058666.444
      }
    },
    {
      "id": "judu:stop:6300",
      "stopId": "6300",
      "name": "Jočionys",
      "description": "link Gariūnų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2930",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20"
      ],
      "wgs84": {
        "latitude": 54.66413,
        "longitude": 25.16171
      },
      "lks94": {
        "easting": 574945.645,
        "northing": 6059249.002
      }
    },
    {
      "id": "judu:stop:6301",
      "stopId": "6301",
      "name": "Jočionys",
      "description": "link TE-3",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2931",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20"
      ],
      "wgs84": {
        "latitude": 54.66474,
        "longitude": 25.16189
      },
      "lks94": {
        "easting": 574956.134,
        "northing": 6059317.079
      }
    },
    {
      "id": "judu:stop:6309",
      "stopId": "6309",
      "name": "Vandenvala",
      "description": "link Gariūnų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2933",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20",
        "29",
        "59",
        "62",
        "68"
      ],
      "wgs84": {
        "latitude": 54.66539,
        "longitude": 25.17311
      },
      "lks94": {
        "easting": 575678.719,
        "northing": 6059401.449
      }
    },
    {
      "id": "judu:stop:6310",
      "stopId": "6310",
      "name": "Vandenvala",
      "description": "link Lazdynų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2934",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20",
        "29",
        "59",
        "62",
        "68",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.66534,
        "longitude": 25.1738
      },
      "lks94": {
        "easting": 575723.323,
        "northing": 6059396.629
      }
    },
    {
      "id": "judu:stop:6317",
      "stopId": "6317",
      "name": "Lazdynai",
      "description": "link Laisvės pr.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1640",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "22",
        "49",
        "54",
        "59",
        "116",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.67761,
        "longitude": 25.21259
      },
      "lks94": {
        "easting": 578202.013,
        "northing": 6060804.637
      }
    },
    {
      "id": "judu:stop:6318",
      "stopId": "6318",
      "name": "Lazdynai",
      "description": "link baseino",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1611",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20",
        "22",
        "49",
        "54",
        "59",
        "62",
        "68",
        "116"
      ],
      "wgs84": {
        "latitude": 54.67778,
        "longitude": 25.21233
      },
      "lks94": {
        "easting": 578184.919,
        "northing": 6060823.266
      }
    },
    {
      "id": "judu:stop:6319",
      "stopId": "6319",
      "name": "Žėručio st.",
      "description": "link Oslo g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1614",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20",
        "22",
        "49",
        "54",
        "59",
        "62",
        "68",
        "116"
      ],
      "wgs84": {
        "latitude": 54.67642,
        "longitude": 25.20696
      },
      "lks94": {
        "easting": 577841.219,
        "northing": 6060665.949
      }
    },
    {
      "id": "judu:stop:6320",
      "stopId": "6320",
      "name": "Lazdynų seniūnija",
      "description": "link Oslo g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1616",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20",
        "22",
        "49",
        "54",
        "59",
        "62",
        "68",
        "116"
      ],
      "wgs84": {
        "latitude": 54.67473,
        "longitude": 25.20258
      },
      "lks94": {
        "easting": 577561.972,
        "northing": 6060473.027
      }
    },
    {
      "id": "judu:stop:6333",
      "stopId": "6333",
      "name": "LITEXPO",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1604",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "4",
        "4G",
        "16",
        "18",
        "21",
        "25",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.67577,
        "longitude": 25.22186
      },
      "lks94": {
        "easting": 578803.385,
        "northing": 6060610.233
      }
    },
    {
      "id": "judu:stop:6337",
      "stopId": "6337",
      "name": "Eigulių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2401",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "7",
        "16",
        "18",
        "21",
        "22",
        "25",
        "29",
        "54",
        "55",
        "N2",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.669,
        "longitude": 25.23547
      },
      "lks94": {
        "easting": 579694.368,
        "northing": 6059872.181
      }
    },
    {
      "id": "judu:stop:6338",
      "stopId": "6338",
      "name": "Eigulių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0608",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "7",
        "16",
        "18",
        "21",
        "22",
        "25",
        "29",
        "54",
        "55",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.66935,
        "longitude": 25.23571
      },
      "lks94": {
        "easting": 579709.163,
        "northing": 6059911.404
      }
    },
    {
      "id": "judu:stop:6343",
      "stopId": "6343",
      "name": "Vingis",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0509",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "6",
        "12",
        "21",
        "22",
        "54",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.67719,
        "longitude": 25.25438
      },
      "lks94": {
        "easting": 580897.817,
        "northing": 6060805.242
      }
    },
    {
      "id": "judu:stop:6350",
      "stopId": "6350",
      "name": "Lazdynų ligoninė",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1626",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "7",
        "20",
        "22",
        "29",
        "54",
        "55",
        "62",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.67031,
        "longitude": 25.20903
      },
      "lks94": {
        "easting": 577986.422,
        "northing": 6059988.282
      }
    },
    {
      "id": "judu:stop:6351",
      "stopId": "6351",
      "name": "Lazdynų ligoninė",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1624",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "7",
        "22",
        "29",
        "54",
        "55",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.6705,
        "longitude": 25.20809
      },
      "lks94": {
        "easting": 577925.428,
        "northing": 6060008.383
      }
    },
    {
      "id": "judu:stop:6352",
      "stopId": "6352",
      "name": "Šiltnamių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1629",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "7",
        "20",
        "22",
        "29",
        "54",
        "55",
        "62",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.67091,
        "longitude": 25.21492
      },
      "lks94": {
        "easting": 578365.173,
        "northing": 6060061.611
      }
    },
    {
      "id": "judu:stop:6353",
      "stopId": "6353",
      "name": "Šiltnamių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1628",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "7",
        "22",
        "29",
        "54",
        "55",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.67106,
        "longitude": 25.21418
      },
      "lks94": {
        "easting": 578317.155,
        "northing": 6060077.479
      }
    },
    {
      "id": "judu:stop:6356",
      "stopId": "6356",
      "name": "Lukiškės",
      "description": "link Vašingtono a.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0231",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "21",
        "22",
        "43",
        "123"
      ],
      "wgs84": {
        "latitude": 54.6909,
        "longitude": 25.27072
      },
      "lks94": {
        "easting": 581923.948,
        "northing": 6062349.926
      }
    },
    {
      "id": "judu:stop:6362",
      "stopId": "6362",
      "name": "Naujamiestis",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0517",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "4G",
        "7",
        "15",
        "16",
        "55",
        "73",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.67043,
        "longitude": 25.26121
      },
      "lks94": {
        "easting": 581351.788,
        "northing": 6060060.836
      }
    },
    {
      "id": "judu:stop:6363",
      "stopId": "6363",
      "name": "Naujamiestis",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0518",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "4G",
        "7",
        "15",
        "16",
        "55",
        "73",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.67049,
        "longitude": 25.2626
      },
      "lks94": {
        "easting": 581441.323,
        "northing": 6060069.125
      }
    },
    {
      "id": "judu:stop:6365",
      "stopId": "6365",
      "name": "Statybininkų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0515",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "7",
        "15",
        "16",
        "29",
        "55",
        "56",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.67274,
        "longitude": 25.25565
      },
      "lks94": {
        "easting": 580988.574,
        "northing": 6060311.481
      }
    },
    {
      "id": "judu:stop:6366",
      "stopId": "6366",
      "name": "Statybininkų st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0612",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "4G",
        "7",
        "15",
        "16",
        "29",
        "55",
        "56"
      ],
      "wgs84": {
        "latitude": 54.67135,
        "longitude": 25.25735
      },
      "lks94": {
        "easting": 581100.987,
        "northing": 6060158.755
      }
    },
    {
      "id": "judu:stop:6379",
      "stopId": "6379",
      "name": "Jonažolių st.",
      "description": "link Bukčių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1627",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "49",
        "55",
        "116"
      ],
      "wgs84": {
        "latitude": 54.66985,
        "longitude": 25.20846
      },
      "lks94": {
        "easting": 577950.538,
        "northing": 6059936.457
      }
    },
    {
      "id": "judu:stop:6381",
      "stopId": "6381",
      "name": "Jonažolių st.",
      "description": "link Oslo g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1625",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "49",
        "55",
        "116"
      ],
      "wgs84": {
        "latitude": 54.66997,
        "longitude": 25.2074
      },
      "lks94": {
        "easting": 577881.938,
        "northing": 6059948.636
      }
    },
    {
      "id": "judu:stop:6387",
      "stopId": "6387",
      "name": "Pakalnučių st.",
      "description": "link Oslo g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1630",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "49",
        "55",
        "116"
      ],
      "wgs84": {
        "latitude": 54.66911,
        "longitude": 25.21298
      },
      "lks94": {
        "easting": 578243.504,
        "northing": 6059859.132
      }
    },
    {
      "id": "judu:stop:6388",
      "stopId": "6388",
      "name": "Ratilių st.",
      "description": "link Šiltnamių g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1648",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "49",
        "116"
      ],
      "wgs84": {
        "latitude": 54.66456,
        "longitude": 25.21403
      },
      "lks94": {
        "easting": 578319.986,
        "northing": 6059353.947
      }
    },
    {
      "id": "judu:stop:6389",
      "stopId": "6389",
      "name": "Ratilių st.",
      "description": "link Bukčių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1647",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "49",
        "116"
      ],
      "wgs84": {
        "latitude": 54.66525,
        "longitude": 25.21435
      },
      "lks94": {
        "easting": 578339.301,
        "northing": 6059431.092
      }
    },
    {
      "id": "judu:stop:6390",
      "stopId": "6390",
      "name": "Neužmirštuolių st.",
      "description": "link Šiltnamių g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1633",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "49"
      ],
      "wgs84": {
        "latitude": 54.65845,
        "longitude": 25.20379
      },
      "lks94": {
        "easting": 577671.067,
        "northing": 6058662.612
      }
    },
    {
      "id": "judu:stop:6391",
      "stopId": "6391",
      "name": "Neužmirštuolių st.",
      "description": "link Bukčių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1632",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "49"
      ],
      "wgs84": {
        "latitude": 54.65818,
        "longitude": 25.20248
      },
      "lks94": {
        "easting": 577587.061,
        "northing": 6058631.117
      }
    },
    {
      "id": "judu:stop:6396",
      "stopId": "6396",
      "name": "Panorama",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0316",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "9",
        "19",
        "22",
        "30",
        "49",
        "69",
        "73"
      ],
      "wgs84": {
        "latitude": 54.69892,
        "longitude": 25.25607
      },
      "lks94": {
        "easting": 580963.535,
        "northing": 6063225.449
      }
    },
    {
      "id": "judu:stop:6397",
      "stopId": "6397",
      "name": "Vilniaus kolegija",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0318",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4G",
        "9",
        "19",
        "22",
        "30",
        "49",
        "63",
        "69",
        "73"
      ],
      "wgs84": {
        "latitude": 54.6983,
        "longitude": 25.26121
      },
      "lks94": {
        "easting": 581296.071,
        "northing": 6063162.392
      }
    },
    {
      "id": "judu:stop:6398",
      "stopId": "6398",
      "name": "Žvėrynas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0314",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "9",
        "19",
        "22",
        "30",
        "49",
        "69",
        "73"
      ],
      "wgs84": {
        "latitude": 54.69938,
        "longitude": 25.24499
      },
      "lks94": {
        "easting": 580248.472,
        "northing": 6063263.918
      }
    },
    {
      "id": "judu:stop:6400",
      "stopId": "6400",
      "name": "Ugniagesių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1710",
      "modes": [
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "9"
      ],
      "wgs84": {
        "latitude": 54.69021,
        "longitude": 25.21068
      },
      "lks94": {
        "easting": 578054.659,
        "northing": 6062204.73
      }
    },
    {
      "id": "judu:stop:6401",
      "stopId": "6401",
      "name": "Oslo st.",
      "description": "link Bukčių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1653",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "49",
        "55",
        "116"
      ],
      "wgs84": {
        "latitude": 54.67007,
        "longitude": 25.19877
      },
      "lks94": {
        "easting": 577325.106,
        "northing": 6059950.227
      }
    },
    {
      "id": "judu:stop:6404",
      "stopId": "6404",
      "name": "Vilniaus kolegija",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0319",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4G",
        "9",
        "19",
        "21",
        "22",
        "30",
        "49",
        "69"
      ],
      "wgs84": {
        "latitude": 54.6987,
        "longitude": 25.26133
      },
      "lks94": {
        "easting": 581303.005,
        "northing": 6063207.045
      }
    },
    {
      "id": "judu:stop:6410",
      "stopId": "6410",
      "name": "Žemaitės st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0601",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "7",
        "15",
        "16",
        "29",
        "55",
        "56"
      ],
      "wgs84": {
        "latitude": 54.67489,
        "longitude": 25.25194
      },
      "lks94": {
        "easting": 580745.028,
        "northing": 6060546.474
      }
    },
    {
      "id": "judu:stop:6430",
      "stopId": "6430",
      "name": "Žvėrynas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0313",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "7",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.69872,
        "longitude": 25.24565
      },
      "lks94": {
        "easting": 580292.315,
        "northing": 6063191.223
      }
    },
    {
      "id": "judu:stop:6432",
      "stopId": "6432",
      "name": "Sėlių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0312",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "7",
        "11",
        "63",
        "116",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.6984,
        "longitude": 25.24868
      },
      "lks94": {
        "easting": 580488.247,
        "northing": 6063159.081
      }
    },
    {
      "id": "judu:stop:6433",
      "stopId": "6433",
      "name": "Sėlių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0311",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "7",
        "11",
        "116",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.69744,
        "longitude": 25.24977
      },
      "lks94": {
        "easting": 580560.405,
        "northing": 6063053.496
      }
    },
    {
      "id": "judu:stop:6434",
      "stopId": "6434",
      "name": "Latvių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0307",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "7",
        "11",
        "116",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.69385,
        "longitude": 25.25072
      },
      "lks94": {
        "easting": 580628.757,
        "northing": 6062655.067
      }
    },
    {
      "id": "judu:stop:6435",
      "stopId": "6435",
      "name": "Latvių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0308",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "7",
        "11",
        "116",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.69433,
        "longitude": 25.25075
      },
      "lks94": {
        "easting": 580629.739,
        "northing": 6062708.519
      }
    },
    {
      "id": "judu:stop:6436",
      "stopId": "6436",
      "name": "Kęstučio st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0304",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "7",
        "11",
        "116",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.69121,
        "longitude": 25.25158
      },
      "lks94": {
        "easting": 580689.433,
        "northing": 6062362.258
      }
    },
    {
      "id": "judu:stop:6437",
      "stopId": "6437",
      "name": "Kęstučio st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0303",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "7",
        "11",
        "116",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.68948,
        "longitude": 25.2519
      },
      "lks94": {
        "easting": 580713.496,
        "northing": 6062170.1
      }
    },
    {
      "id": "judu:stop:6438",
      "stopId": "6438",
      "name": "Liubarto tiltas",
      "description": "link Žvėryno",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0302",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "7",
        "11",
        "116",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.68908,
        "longitude": 25.25574
      },
      "lks94": {
        "easting": 580961.855,
        "northing": 6062130.007
      }
    },
    {
      "id": "judu:stop:6449",
      "stopId": "6449",
      "name": "Fermentų st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2801",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "25"
      ],
      "wgs84": {
        "latitude": 54.62471,
        "longitude": 25.14078
      },
      "lks94": {
        "easting": 573666.69,
        "northing": 6054839.916
      }
    },
    {
      "id": "judu:stop:6450",
      "stopId": "6450",
      "name": "Fermentų st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2802",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "25"
      ],
      "wgs84": {
        "latitude": 54.62549,
        "longitude": 25.13989
      },
      "lks94": {
        "easting": 573607.811,
        "northing": 6054925.788
      }
    },
    {
      "id": "judu:stop:6454",
      "stopId": "6454",
      "name": "Vokės st.",
      "description": "link Baltosios Vokės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2805",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "25"
      ],
      "wgs84": {
        "latitude": 54.61923,
        "longitude": 25.14521
      },
      "lks94": {
        "easting": 573962.688,
        "northing": 6054234.717
      }
    },
    {
      "id": "judu:stop:6455",
      "stopId": "6455",
      "name": "Kazbėjų st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2807",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "25"
      ],
      "wgs84": {
        "latitude": 54.61584,
        "longitude": 25.14953
      },
      "lks94": {
        "easting": 574247.852,
        "northing": 6053862.011
      }
    },
    {
      "id": "judu:stop:6456",
      "stopId": "6456",
      "name": "Kazbėjų st.",
      "description": "link Galvės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2806",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "25"
      ],
      "wgs84": {
        "latitude": 54.61645,
        "longitude": 25.14909
      },
      "lks94": {
        "easting": 574218.323,
        "northing": 6053929.431
      }
    },
    {
      "id": "judu:stop:6457",
      "stopId": "6457",
      "name": "Slėnis",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2808",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "25"
      ],
      "wgs84": {
        "latitude": 54.61215,
        "longitude": 25.15422
      },
      "lks94": {
        "easting": 574557.509,
        "northing": 6053456.328
      }
    },
    {
      "id": "judu:stop:6458",
      "stopId": "6458",
      "name": "Slėnis",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2809",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "25"
      ],
      "wgs84": {
        "latitude": 54.61227,
        "longitude": 25.1544
      },
      "lks94": {
        "easting": 574568.917,
        "northing": 6053469.874
      }
    },
    {
      "id": "judu:stop:6460",
      "stopId": "6460",
      "name": "Paukščių takas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1636",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "16",
        "18",
        "25",
        "68",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.68065,
        "longitude": 25.20884
      },
      "lks94": {
        "easting": 577954.356,
        "northing": 6061138.78
      }
    },
    {
      "id": "judu:stop:6461",
      "stopId": "6461",
      "name": "Lazdynai",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1609",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "4",
        "4G",
        "16",
        "18",
        "25",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.67891,
        "longitude": 25.21331
      },
      "lks94": {
        "easting": 578245.945,
        "northing": 6060950.112
      }
    },
    {
      "id": "judu:stop:6462",
      "stopId": "6462",
      "name": "Paukščių takas",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1635",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "16",
        "18",
        "25",
        "117",
        "118"
      ],
      "wgs84": {
        "latitude": 54.68085,
        "longitude": 25.20922
      },
      "lks94": {
        "easting": 577978.477,
        "northing": 6061161.459
      }
    },
    {
      "id": "judu:stop:6469",
      "stopId": "6469",
      "name": "Vokės st.",
      "description": "link Galvės g. I",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2804",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "25"
      ],
      "wgs84": {
        "latitude": 54.61976,
        "longitude": 25.14492
      },
      "lks94": {
        "easting": 573942.998,
        "northing": 6054293.394
      }
    },
    {
      "id": "judu:stop:6472",
      "stopId": "6472",
      "name": "Viršuliškės",
      "description": "link Pašilaičių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1807",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "16",
        "19",
        "25",
        "52",
        "55"
      ],
      "wgs84": {
        "latitude": 54.70849,
        "longitude": 25.22674
      },
      "lks94": {
        "easting": 579054.47,
        "northing": 6064257.035
      }
    },
    {
      "id": "judu:stop:6475",
      "stopId": "6475",
      "name": "Šaulių sąjunga",
      "description": "link Lazdynų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1805",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "16",
        "19",
        "25",
        "52",
        "55"
      ],
      "wgs84": {
        "latitude": 54.70909,
        "longitude": 25.22607
      },
      "lks94": {
        "easting": 579010.13,
        "northing": 6064323.053
      }
    },
    {
      "id": "judu:stop:6476",
      "stopId": "6476",
      "name": "Pal. Jurgio Matulaičio bažnyčia",
      "description": "link Lazdynų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1803",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "16",
        "19",
        "25",
        "52",
        "55"
      ],
      "wgs84": {
        "latitude": 54.71178,
        "longitude": 25.22678
      },
      "lks94": {
        "easting": 579050.648,
        "northing": 6064623.216
      }
    },
    {
      "id": "judu:stop:6477",
      "stopId": "6477",
      "name": "Rygos st.",
      "description": "link Lazdynų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1802",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "16",
        "19",
        "25",
        "52",
        "55"
      ],
      "wgs84": {
        "latitude": 54.7156,
        "longitude": 25.23019
      },
      "lks94": {
        "easting": 579262.917,
        "northing": 6065052.18
      }
    },
    {
      "id": "judu:stop:6478",
      "stopId": "6478",
      "name": "Čiobiškio st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3219",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "16",
        "19",
        "46",
        "48",
        "52",
        "55",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.71893,
        "longitude": 25.232
      },
      "lks94": {
        "easting": 579373.026,
        "northing": 6065424.813
      }
    },
    {
      "id": "judu:stop:6479",
      "stopId": "6479",
      "name": "Čiobiškio st.",
      "description": "link Pašilaičių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1913",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "16",
        "19",
        "46",
        "48",
        "52",
        "55",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.71946,
        "longitude": 25.23292
      },
      "lks94": {
        "easting": 579431.259,
        "northing": 6065484.837
      }
    },
    {
      "id": "judu:stop:6481",
      "stopId": "6481",
      "name": "Vilniaus rajono poliklinika",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3313",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "16",
        "19",
        "46",
        "48",
        "52",
        "55",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.72332,
        "longitude": 25.234
      },
      "lks94": {
        "easting": 579493.281,
        "northing": 6065915.629
      }
    },
    {
      "id": "judu:stop:6482",
      "stopId": "6482",
      "name": "Vilniaus rajono poliklinika",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3314",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "16",
        "19",
        "46",
        "48",
        "52",
        "55",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.72281,
        "longitude": 25.23343
      },
      "lks94": {
        "easting": 579457.561,
        "northing": 6065858.227
      }
    },
    {
      "id": "judu:stop:6484",
      "stopId": "6484",
      "name": "Pašilaičių žiedas",
      "description": "visos kryptys",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3324",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "16",
        "19",
        "46",
        "48",
        "52",
        "55",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.72773,
        "longitude": 25.23387
      },
      "lks94": {
        "easting": 579476.277,
        "northing": 6066406.261
      }
    },
    {
      "id": "judu:stop:6487",
      "stopId": "6487",
      "name": "Baltupiai",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2018",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1G",
        "2G",
        "3G",
        "3G-A",
        "5",
        "24",
        "26",
        "35",
        "36",
        "40",
        "48",
        "55",
        "65",
        "66",
        "76",
        "121"
      ],
      "wgs84": {
        "latitude": 54.72828,
        "longitude": 25.28013
      },
      "lks94": {
        "easting": 582454.707,
        "northing": 6066520.844
      }
    },
    {
      "id": "judu:stop:6488",
      "stopId": "6488",
      "name": "Pušynas",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2006",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5",
        "24",
        "26",
        "35",
        "36",
        "40",
        "48",
        "55",
        "65",
        "66",
        "76",
        "121"
      ],
      "wgs84": {
        "latitude": 54.73436,
        "longitude": 25.27891
      },
      "lks94": {
        "easting": 582363.796,
        "northing": 6067196.037
      }
    },
    {
      "id": "judu:stop:6489",
      "stopId": "6489",
      "name": "Pušynas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2007",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5",
        "24",
        "26",
        "35",
        "36",
        "40",
        "55",
        "65",
        "66",
        "121",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.73328,
        "longitude": 25.2788
      },
      "lks94": {
        "easting": 582358.903,
        "northing": 6067075.718
      }
    },
    {
      "id": "judu:stop:6491",
      "stopId": "6491",
      "name": "Seminarija",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2004",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5",
        "24",
        "26",
        "35",
        "36",
        "40",
        "48",
        "55",
        "65",
        "66",
        "76",
        "121"
      ],
      "wgs84": {
        "latitude": 54.73702,
        "longitude": 25.27791
      },
      "lks94": {
        "easting": 582294.007,
        "northing": 6067490.888
      }
    },
    {
      "id": "judu:stop:6492",
      "stopId": "6492",
      "name": "Seminarija",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2005",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5",
        "24",
        "26",
        "35",
        "36",
        "40",
        "55",
        "65",
        "66",
        "121",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.73576,
        "longitude": 25.27801
      },
      "lks94": {
        "easting": 582303,
        "northing": 6067350.783
      }
    },
    {
      "id": "judu:stop:6494",
      "stopId": "6494",
      "name": "Kalvarijos",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2003",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1G",
        "3G-A",
        "5",
        "24",
        "26",
        "35",
        "36",
        "40",
        "55",
        "65",
        "66",
        "121",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.73854,
        "longitude": 25.27686
      },
      "lks94": {
        "easting": 582223.315,
        "northing": 6067658.813
      }
    },
    {
      "id": "judu:stop:6497",
      "stopId": "6497",
      "name": "Kalvarijos",
      "description": "link Santariškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2113",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1G",
        "2G",
        "26",
        "34",
        "35",
        "36",
        "48",
        "49",
        "55",
        "57",
        "65",
        "66",
        "75",
        "76",
        "87",
        "121",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.73997,
        "longitude": 25.27677
      },
      "lks94": {
        "easting": 582214.623,
        "northing": 6067817.848
      }
    },
    {
      "id": "judu:stop:6500",
      "stopId": "6500",
      "name": "Jeruzalė",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2115",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1G",
        "2G",
        "26",
        "34",
        "35",
        "36",
        "48",
        "49",
        "55",
        "57",
        "65",
        "66",
        "75",
        "76",
        "87",
        "121",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.74415,
        "longitude": 25.27788
      },
      "lks94": {
        "easting": 582277.622,
        "northing": 6068284.331
      }
    },
    {
      "id": "judu:stop:6501",
      "stopId": "6501",
      "name": "Jeruzalė",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2114",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1G",
        "2G",
        "26",
        "34",
        "35",
        "36",
        "49",
        "55",
        "57",
        "65",
        "66",
        "75",
        "76",
        "87",
        "121",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.74295,
        "longitude": 25.27691
      },
      "lks94": {
        "easting": 582217.602,
        "northing": 6068149.649
      }
    },
    {
      "id": "judu:stop:6503",
      "stopId": "6503",
      "name": "Žaliųjų Ežerų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2116",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26",
        "34",
        "35",
        "36",
        "49",
        "55",
        "57",
        "65",
        "66",
        "75",
        "76",
        "87",
        "121",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.74855,
        "longitude": 25.27913
      },
      "lks94": {
        "easting": 582349.171,
        "northing": 6068775.462
      }
    },
    {
      "id": "judu:stop:6523",
      "stopId": "6523",
      "name": "Žemynos st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3316",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "16",
        "19",
        "46",
        "48",
        "52",
        "55",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.72576,
        "longitude": 25.23344
      },
      "lks94": {
        "easting": 579452.435,
        "northing": 6066186.537
      }
    },
    {
      "id": "judu:stop:6525",
      "stopId": "6525",
      "name": "Žaliųjų Ežerų st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2120",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26",
        "48",
        "55",
        "75",
        "120",
        "121",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.75062,
        "longitude": 25.27982
      },
      "lks94": {
        "easting": 582389.388,
        "northing": 6069006.637
      }
    },
    {
      "id": "judu:stop:6526",
      "stopId": "6526",
      "name": "Santariškės",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2121",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1G",
        "2G",
        "26",
        "48",
        "55",
        "75",
        "120",
        "121",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.752,
        "longitude": 25.27979
      },
      "lks94": {
        "easting": 582384.655,
        "northing": 6069160.178
      }
    },
    {
      "id": "judu:stop:6532",
      "stopId": "6532",
      "name": "Santariškės",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2122",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1G",
        "2G",
        "26",
        "48",
        "55",
        "75",
        "120",
        "121",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.75286,
        "longitude": 25.28031
      },
      "lks94": {
        "easting": 582416.38,
        "northing": 6069256.496
      }
    },
    {
      "id": "judu:stop:6533",
      "stopId": "6533",
      "name": "Vaikų ligoninė",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2123",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "48",
        "75",
        "121"
      ],
      "wgs84": {
        "latitude": 54.75633,
        "longitude": 25.28131
      },
      "lks94": {
        "easting": 582473.695,
        "northing": 6069643.839
      }
    },
    {
      "id": "judu:stop:6542",
      "stopId": "6542",
      "name": "Žygio st.",
      "description": "link Žirmūnų žiedo",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0913",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5",
        "26",
        "27",
        "34",
        "37",
        "65"
      ],
      "wgs84": {
        "latitude": 54.70295,
        "longitude": 25.28893
      },
      "lks94": {
        "easting": 583073.267,
        "northing": 6063712.329
      }
    },
    {
      "id": "judu:stop:6544",
      "stopId": "6544",
      "name": "Mikalojaus Katkaus st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0911",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5",
        "26",
        "27",
        "34",
        "37",
        "65"
      ],
      "wgs84": {
        "latitude": 54.70009,
        "longitude": 25.2929
      },
      "lks94": {
        "easting": 583334.987,
        "northing": 6063398.756
      }
    },
    {
      "id": "judu:stop:6546",
      "stopId": "6546",
      "name": "Tuskulėnai",
      "description": "link Žirmūnų žiedo",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0909",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5",
        "26",
        "27",
        "34",
        "37",
        "65"
      ],
      "wgs84": {
        "latitude": 54.69702,
        "longitude": 25.29706
      },
      "lks94": {
        "easting": 583609.421,
        "northing": 6063062.054
      }
    },
    {
      "id": "judu:stop:6547",
      "stopId": "6547",
      "name": "Tuskulėnai",
      "description": "nuo Žirmūnų žiedo",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0910",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5",
        "26",
        "34",
        "65"
      ],
      "wgs84": {
        "latitude": 54.6977,
        "longitude": 25.2967
      },
      "lks94": {
        "easting": 583584.819,
        "northing": 6063137.3
      }
    },
    {
      "id": "judu:stop:6565",
      "stopId": "6565",
      "name": "Vasaros st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0439",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "4G",
        "6G",
        "7",
        "9",
        "12",
        "15",
        "16",
        "18",
        "19",
        "26",
        "27",
        "31",
        "33",
        "34",
        "37",
        "38",
        "42",
        "58",
        "65",
        "67",
        "74",
        "78",
        "82",
        "89",
        "114",
        "115",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.6913,
        "longitude": 25.30471
      },
      "lks94": {
        "easting": 584114.349,
        "northing": 6062434.636
      }
    },
    {
      "id": "judu:stop:6566",
      "stopId": "6566",
      "name": "Vasaros st.",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1102",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "6G",
        "7",
        "9",
        "12",
        "15",
        "16",
        "18",
        "19",
        "26",
        "27",
        "31",
        "33",
        "34",
        "37",
        "38",
        "42",
        "58",
        "65",
        "67",
        "74",
        "78",
        "82",
        "89",
        "114",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.69122,
        "longitude": 25.30503
      },
      "lks94": {
        "easting": 584135.144,
        "northing": 6062426.116
      }
    },
    {
      "id": "judu:stop:6568",
      "stopId": "6568",
      "name": "Krivių st.",
      "description": "link Olandų žiedo",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0438",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "7",
        "9",
        "12",
        "15",
        "16",
        "18",
        "19",
        "26",
        "27",
        "31",
        "33",
        "34",
        "37",
        "38",
        "42",
        "58",
        "65",
        "67",
        "74",
        "78",
        "82",
        "89",
        "114",
        "115",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.6873,
        "longitude": 25.30562
      },
      "lks94": {
        "easting": 584181.292,
        "northing": 6061990.583
      }
    },
    {
      "id": "judu:stop:6571",
      "stopId": "6571",
      "name": "Filaretų st.",
      "description": "link Olandų žiedo",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0437",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "4G",
        "6G",
        "7",
        "9",
        "12",
        "15",
        "16",
        "18",
        "19",
        "26",
        "27",
        "31",
        "33",
        "34",
        "37",
        "38",
        "42",
        "58",
        "65",
        "67",
        "74",
        "78",
        "82",
        "89",
        "114",
        "115",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.68473,
        "longitude": 25.30917
      },
      "lks94": {
        "easting": 584415.503,
        "northing": 6061708.84
      }
    },
    {
      "id": "judu:stop:6572",
      "stopId": "6572",
      "name": "Polocko st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1209",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "4G",
        "6G",
        "7",
        "9",
        "12",
        "15",
        "16",
        "18",
        "19",
        "26",
        "27",
        "31",
        "33",
        "34",
        "37",
        "38",
        "42",
        "58",
        "65",
        "67",
        "74",
        "78",
        "82",
        "89",
        "114",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.68331,
        "longitude": 25.31286
      },
      "lks94": {
        "easting": 584656.376,
        "northing": 6061555.257
      }
    },
    {
      "id": "judu:stop:6573",
      "stopId": "6573",
      "name": "Kalnų parkas",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0404",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "6",
        "10",
        "15",
        "17",
        "20",
        "33",
        "89",
        "N1",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.68965,
        "longitude": 25.29581
      },
      "lks94": {
        "easting": 583543.99,
        "northing": 6062240.386
      }
    },
    {
      "id": "judu:stop:6574",
      "stopId": "6574",
      "name": "Polocko st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0436",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "4G",
        "6G",
        "7",
        "9",
        "12",
        "15",
        "16",
        "18",
        "19",
        "26",
        "27",
        "31",
        "33",
        "34",
        "37",
        "38",
        "42",
        "58",
        "65",
        "67",
        "74",
        "78",
        "82",
        "89",
        "114",
        "115",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.6827,
        "longitude": 25.31266
      },
      "lks94": {
        "easting": 584644.749,
        "northing": 6061487.132
      }
    },
    {
      "id": "judu:stop:6580",
      "stopId": "6580",
      "name": "Justiniškės",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3211",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "7",
        "18",
        "32",
        "75",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.71652,
        "longitude": 25.22085
      },
      "lks94": {
        "easting": 578659.377,
        "northing": 6065144.057
      }
    },
    {
      "id": "judu:stop:6581",
      "stopId": "6581",
      "name": "Lūžiai",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3214",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "7",
        "18",
        "32",
        "73",
        "75",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.7108,
        "longitude": 25.21661
      },
      "lks94": {
        "easting": 578397.242,
        "northing": 6064502.747
      }
    },
    {
      "id": "judu:stop:6582",
      "stopId": "6582",
      "name": "Lūžiai",
      "description": "link Pašilaičių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1804",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "7",
        "18",
        "32",
        "75",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.71164,
        "longitude": 25.21772
      },
      "lks94": {
        "easting": 578467.144,
        "northing": 6064597.469
      }
    },
    {
      "id": "judu:stop:6587",
      "stopId": "6587",
      "name": "Kaukaro st.",
      "description": "link Pašilaičių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1815",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "7",
        "18",
        "32",
        "73",
        "75",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.70665,
        "longitude": 25.21577
      },
      "lks94": {
        "easting": 578351.116,
        "northing": 6064039.966
      }
    },
    {
      "id": "judu:stop:6588",
      "stopId": "6588",
      "name": "Kaukaro st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3220",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "7",
        "18",
        "32",
        "73",
        "75",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.70555,
        "longitude": 25.21579
      },
      "lks94": {
        "easting": 578354.525,
        "northing": 6063917.572
      }
    },
    {
      "id": "judu:stop:6591",
      "stopId": "6591",
      "name": "Troleibusų parkas",
      "description": "visos kryptys",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1813",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "4",
        "7",
        "9",
        "16",
        "18",
        "19",
        "21",
        "22",
        "30",
        "32",
        "52",
        "54",
        "59",
        "68",
        "73",
        "75",
        "N2",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.70363,
        "longitude": 25.2194
      },
      "lks94": {
        "easting": 578590.881,
        "northing": 6063707.936
      }
    },
    {
      "id": "judu:stop:6597",
      "stopId": "6597",
      "name": "Spaudos rūmai",
      "description": "link Justiniškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1810",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "7",
        "9",
        "16",
        "18",
        "19",
        "21",
        "22",
        "30",
        "32",
        "52",
        "54",
        "59",
        "68",
        "75",
        "N2",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.70361,
        "longitude": 25.22353
      },
      "lks94": {
        "easting": 578857.087,
        "northing": 6063710.342
      }
    },
    {
      "id": "judu:stop:6603",
      "stopId": "6603",
      "name": "Kunigiškių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4102",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "28",
        "29",
        "59",
        "68",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.67057,
        "longitude": 25.09277
      },
      "lks94": {
        "easting": 570487.135,
        "northing": 6059894.312
      }
    },
    {
      "id": "judu:stop:6604",
      "stopId": "6604",
      "name": "Šviesos st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4119",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "28",
        "29",
        "59",
        "68",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.66959,
        "longitude": 25.09601
      },
      "lks94": {
        "easting": 570697.819,
        "northing": 6059788.506
      }
    },
    {
      "id": "judu:stop:6609",
      "stopId": "6609",
      "name": "Gariūnai",
      "description": "link Lazdynų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2928",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20",
        "29",
        "59",
        "62",
        "68",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.65908,
        "longitude": 25.16073
      },
      "lks94": {
        "easting": 574891.714,
        "northing": 6058685.955
      }
    },
    {
      "id": "judu:stop:6611",
      "stopId": "6611",
      "name": "Karaliaučiaus st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3607",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "4G",
        "75",
        "117",
        "118"
      ],
      "wgs84": {
        "latitude": 54.70725,
        "longitude": 25.17582
      },
      "lks94": {
        "easting": 575775.515,
        "northing": 6064062.877
      }
    },
    {
      "id": "judu:stop:6612",
      "stopId": "6612",
      "name": "Karaliaučiaus st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3608",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "4G",
        "75",
        "117",
        "118"
      ],
      "wgs84": {
        "latitude": 54.7074,
        "longitude": 25.17572
      },
      "lks94": {
        "easting": 575768.791,
        "northing": 6064079.462
      }
    },
    {
      "id": "judu:stop:6614",
      "stopId": "6614",
      "name": "Tolminkiemio st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3606",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "4G",
        "75",
        "117",
        "118"
      ],
      "wgs84": {
        "latitude": 54.70736,
        "longitude": 25.18119
      },
      "lks94": {
        "easting": 576121.361,
        "northing": 6064080.929
      }
    },
    {
      "id": "judu:stop:6615",
      "stopId": "6615",
      "name": "Tolminkiemio st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3605",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "4G",
        "75",
        "117",
        "118"
      ],
      "wgs84": {
        "latitude": 54.70721,
        "longitude": 25.18009
      },
      "lks94": {
        "easting": 576050.756,
        "northing": 6064063.044
      }
    },
    {
      "id": "judu:stop:6618",
      "stopId": "6618",
      "name": "Papilėnų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3603",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "75",
        "117"
      ],
      "wgs84": {
        "latitude": 54.70685,
        "longitude": 25.18741
      },
      "lks94": {
        "easting": 576523.148,
        "northing": 6064030.936
      }
    },
    {
      "id": "judu:stop:6619",
      "stopId": "6619",
      "name": "Papilėnų st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3631",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "4G",
        "75",
        "117"
      ],
      "wgs84": {
        "latitude": 54.70683,
        "longitude": 25.18821
      },
      "lks94": {
        "easting": 576574.74,
        "northing": 6064029.582
      }
    },
    {
      "id": "judu:stop:6621",
      "stopId": "6621",
      "name": "Senoji Pilaitė",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3601",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "75"
      ],
      "wgs84": {
        "latitude": 54.70416,
        "longitude": 25.19664
      },
      "lks94": {
        "easting": 577123.055,
        "northing": 6063741.673
      }
    },
    {
      "id": "judu:stop:6633",
      "stopId": "6633",
      "name": "Rugių st.",
      "description": "link Kalvarijų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5143",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2G",
        "3G",
        "5",
        "24",
        "34",
        "40",
        "49",
        "55",
        "57",
        "75",
        "76",
        "87",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.73819,
        "longitude": 25.27044
      },
      "lks94": {
        "easting": 581810.627,
        "northing": 6067612.358
      }
    },
    {
      "id": "judu:stop:6634",
      "stopId": "6634",
      "name": "Rugių st.",
      "description": "link Geležinio Vilko g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5142",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2G",
        "3G",
        "5",
        "24",
        "34",
        "40",
        "49",
        "55",
        "57",
        "75",
        "76",
        "87",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.73801,
        "longitude": 25.26928
      },
      "lks94": {
        "easting": 581736.295,
        "northing": 6067590.974
      }
    },
    {
      "id": "judu:stop:6635",
      "stopId": "6635",
      "name": "Lietuvos sąjūdžio kelias",
      "description": "link Žirmūnų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0105",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3G",
        "3G-A",
        "4G",
        "9",
        "19",
        "30",
        "43",
        "56",
        "63",
        "89"
      ],
      "wgs84": {
        "latitude": 54.69825,
        "longitude": 25.2663
      },
      "lks94": {
        "easting": 581624.249,
        "northing": 6063162.734
      }
    },
    {
      "id": "judu:stop:6640",
      "stopId": "6640",
      "name": "Kalvarijos",
      "description": "link Baltupio g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2112",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2G",
        "3G-A",
        "5",
        "24",
        "34",
        "40",
        "49",
        "55",
        "57",
        "75",
        "76",
        "87",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.73933,
        "longitude": 25.27535
      },
      "lks94": {
        "easting": 582124.485,
        "northing": 6067744.961
      }
    },
    {
      "id": "judu:stop:6643",
      "stopId": "6643",
      "name": "Laisvės prospektas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1702",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "2G",
        "3",
        "7",
        "9",
        "16",
        "18",
        "21",
        "22",
        "25",
        "49",
        "54",
        "55",
        "59",
        "68",
        "69",
        "116",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.69752,
        "longitude": 25.22123
      },
      "lks94": {
        "easting": 578720.65,
        "northing": 6063030.021
      }
    },
    {
      "id": "judu:stop:6648",
      "stopId": "6648",
      "name": "Lazdynai",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1610",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "4G",
        "16",
        "18",
        "25",
        "117",
        "118"
      ],
      "wgs84": {
        "latitude": 54.67926,
        "longitude": 25.21329
      },
      "lks94": {
        "easting": 578243.982,
        "northing": 6060989.04
      }
    },
    {
      "id": "judu:stop:6649",
      "stopId": "6649",
      "name": "Karoliniškės",
      "description": "link Viršuliškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1706",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "4G",
        "7",
        "16",
        "18",
        "21",
        "22",
        "25",
        "49",
        "54",
        "55",
        "59",
        "68",
        "69",
        "116",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.69279,
        "longitude": 25.21733
      },
      "lks94": {
        "easting": 578478.396,
        "northing": 6062499.265
      }
    },
    {
      "id": "judu:stop:6650",
      "stopId": "6650",
      "name": "Aguonų st.",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0414",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "4",
        "13",
        "15",
        "16",
        "21",
        "41",
        "42",
        "54",
        "61",
        "78"
      ],
      "wgs84": {
        "latitude": 54.67284,
        "longitude": 25.27736
      },
      "lks94": {
        "easting": 582388.576,
        "northing": 6060347.865
      }
    },
    {
      "id": "judu:stop:6651",
      "stopId": "6651",
      "name": "Pal. Jurgio Matulaičio bažnyčia",
      "description": "link Pašilaičių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1818",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "16",
        "19",
        "25",
        "52",
        "55"
      ],
      "wgs84": {
        "latitude": 54.7124,
        "longitude": 25.22824
      },
      "lks94": {
        "easting": 579143.515,
        "northing": 6064693.86
      }
    },
    {
      "id": "judu:stop:6653",
      "stopId": "6653",
      "name": "Žemynos st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3315",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "16",
        "19",
        "46",
        "48",
        "52",
        "55",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.72665,
        "longitude": 25.23398
      },
      "lks94": {
        "easting": 579485.476,
        "northing": 6066286.195
      }
    },
    {
      "id": "judu:stop:6660",
      "stopId": "6660",
      "name": "Šeimyniškių st.",
      "description": "link Šiaurės miestelio",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0112",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "6G",
        "9",
        "12",
        "19",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.69556,
        "longitude": 25.29687
      },
      "lks94": {
        "easting": 583600.176,
        "northing": 6062899.349
      }
    },
    {
      "id": "judu:stop:6665",
      "stopId": "6665",
      "name": "Tuskulėnų rimties parkas",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0905",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "4G",
        "5",
        "6G",
        "7",
        "9",
        "12",
        "16",
        "17",
        "18",
        "19",
        "20",
        "27",
        "31",
        "42",
        "58",
        "67",
        "74",
        "78",
        "82",
        "89",
        "114",
        "N3",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.69823,
        "longitude": 25.3013
      },
      "lks94": {
        "easting": 583880.223,
        "northing": 6063201.768
      }
    },
    {
      "id": "judu:stop:6666",
      "stopId": "6666",
      "name": "Minties st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0903",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "4G",
        "5",
        "6G",
        "7",
        "9",
        "12",
        "16",
        "17",
        "18",
        "19",
        "20",
        "27",
        "31",
        "42",
        "58",
        "67",
        "74",
        "78",
        "82",
        "89",
        "114",
        "N3",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.70418,
        "longitude": 25.30454
      },
      "lks94": {
        "easting": 584076.751,
        "northing": 6063867.797
      }
    },
    {
      "id": "judu:stop:6667",
      "stopId": "6667",
      "name": "Žirmūnai",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0821",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "9",
        "12",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "27",
        "30",
        "31",
        "33",
        "42",
        "58",
        "67",
        "69",
        "74",
        "78",
        "82",
        "89",
        "114",
        "N3",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.71666,
        "longitude": 25.30545
      },
      "lks94": {
        "easting": 584109.563,
        "northing": 6065257.741
      }
    },
    {
      "id": "judu:stop:6668",
      "stopId": "6668",
      "name": "Kareivių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0811",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "5",
        "6",
        "6G",
        "7",
        "9",
        "12",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "27",
        "30",
        "31",
        "33",
        "42",
        "58",
        "67",
        "69",
        "74",
        "78",
        "82",
        "89",
        "N3",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.71934,
        "longitude": 25.30356
      },
      "lks94": {
        "easting": 583982.257,
        "northing": 6065553.726
      }
    },
    {
      "id": "judu:stop:6671",
      "stopId": "6671",
      "name": "Šaltinėlio st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0816",
      "modes": [
        "trolleybus"
      ],
      "routeShortNames": [
        "6",
        "9",
        "12",
        "17",
        "20",
        "21"
      ],
      "wgs84": {
        "latitude": 54.72541,
        "longitude": 25.29826
      },
      "lks94": {
        "easting": 583628.325,
        "northing": 6066222.906
      }
    },
    {
      "id": "judu:stop:6673",
      "stopId": "6673",
      "name": "Gervėčių st.",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0418",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "89"
      ],
      "wgs84": {
        "latitude": 54.67489,
        "longitude": 25.29691
      },
      "lks94": {
        "easting": 583645.249,
        "northing": 6060599.115
      }
    },
    {
      "id": "judu:stop:6674",
      "stopId": "6674",
      "name": "Gervėčių st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0419",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31"
      ],
      "wgs84": {
        "latitude": 54.67336,
        "longitude": 25.29882
      },
      "lks94": {
        "easting": 583771.578,
        "northing": 6060431.125
      }
    },
    {
      "id": "judu:stop:6675",
      "stopId": "6675",
      "name": "Rasų kapinės",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1307",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31"
      ],
      "wgs84": {
        "latitude": 54.67002,
        "longitude": 25.30118
      },
      "lks94": {
        "easting": 583930.673,
        "northing": 6060062.248
      }
    },
    {
      "id": "judu:stop:6676",
      "stopId": "6676",
      "name": "Rasų kapinės",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1306",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31"
      ],
      "wgs84": {
        "latitude": 54.67046,
        "longitude": 25.30109
      },
      "lks94": {
        "easting": 583923.961,
        "northing": 6060111.107
      }
    },
    {
      "id": "judu:stop:6678",
      "stopId": "6678",
      "name": "Dunojaus st.",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1309",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "33"
      ],
      "wgs84": {
        "latitude": 54.66644,
        "longitude": 25.30701
      },
      "lks94": {
        "easting": 584314.123,
        "northing": 6059670.83
      }
    },
    {
      "id": "judu:stop:6679",
      "stopId": "6679",
      "name": "Dunojaus st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1308",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "33"
      ],
      "wgs84": {
        "latitude": 54.66661,
        "longitude": 25.30673
      },
      "lks94": {
        "easting": 584295.709,
        "northing": 6059689.412
      }
    },
    {
      "id": "judu:stop:6680",
      "stopId": "6680",
      "name": "Ribiškės",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1310",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "33"
      ],
      "wgs84": {
        "latitude": 54.66687,
        "longitude": 25.3126
      },
      "lks94": {
        "easting": 584673.814,
        "northing": 6059725.409
      }
    },
    {
      "id": "judu:stop:6681",
      "stopId": "6681",
      "name": "Ribiškės",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1311",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "33"
      ],
      "wgs84": {
        "latitude": 54.66684,
        "longitude": 25.31329
      },
      "lks94": {
        "easting": 584718.384,
        "northing": 6059722.902
      }
    },
    {
      "id": "judu:stop:6682",
      "stopId": "6682",
      "name": "Juodasis kelias",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1312",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "33"
      ],
      "wgs84": {
        "latitude": 54.66648,
        "longitude": 25.3246
      },
      "lks94": {
        "easting": 585448.689,
        "northing": 6059696.543
      }
    },
    {
      "id": "judu:stop:6683",
      "stopId": "6683",
      "name": "Juodasis kelias",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1313",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "33"
      ],
      "wgs84": {
        "latitude": 54.66634,
        "longitude": 25.32542
      },
      "lks94": {
        "easting": 585501.877,
        "northing": 6059681.961
      }
    },
    {
      "id": "judu:stop:6687",
      "stopId": "6687",
      "name": "Guriai",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1402",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.66331,
        "longitude": 25.34187
      },
      "lks94": {
        "easting": 586569.434,
        "northing": 6059364.92
      }
    },
    {
      "id": "judu:stop:6688",
      "stopId": "6688",
      "name": "Guriai",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1401",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "33",
        "58",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.66285,
        "longitude": 25.34007
      },
      "lks94": {
        "easting": 586454.293,
        "northing": 6059311.512
      }
    },
    {
      "id": "judu:stop:6690",
      "stopId": "6690",
      "name": "Pavilnio sodai",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1403",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.66494,
        "longitude": 25.34565
      },
      "lks94": {
        "easting": 586809.806,
        "northing": 6059550.981
      }
    },
    {
      "id": "judu:stop:6691",
      "stopId": "6691",
      "name": "Pavilnio sodai",
      "description": "link N.Vilnios",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1404",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.66501,
        "longitude": 25.34655
      },
      "lks94": {
        "easting": 586867.714,
        "northing": 6059559.884
      }
    },
    {
      "id": "judu:stop:6693",
      "stopId": "6693",
      "name": "Garsioji st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1405",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.66689,
        "longitude": 25.35356
      },
      "lks94": {
        "easting": 587315.878,
        "northing": 6059777.793
      }
    },
    {
      "id": "judu:stop:6694",
      "stopId": "6694",
      "name": "Garsioji st.",
      "description": "link N.Vilnios",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1406",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.66692,
        "longitude": 25.35541
      },
      "lks94": {
        "easting": 587435.146,
        "northing": 6059783.434
      }
    },
    {
      "id": "judu:stop:6695",
      "stopId": "6695",
      "name": "Grūdų st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1407",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.66794,
        "longitude": 25.35941
      },
      "lks94": {
        "easting": 587690.966,
        "northing": 6059901.932
      }
    },
    {
      "id": "judu:stop:6702",
      "stopId": "6702",
      "name": "Petro Vileišio st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1106",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "4",
        "6",
        "10",
        "15",
        "19",
        "38",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.70313,
        "longitude": 25.31002
      },
      "lks94": {
        "easting": 584432.094,
        "northing": 6063757.525
      }
    },
    {
      "id": "judu:stop:6711",
      "stopId": "6711",
      "name": "Antakalnis",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1116",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "4",
        "10",
        "15",
        "19",
        "21",
        "38",
        "50",
        "114",
        "115",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.72106,
        "longitude": 25.31821
      },
      "lks94": {
        "easting": 584922.438,
        "northing": 6065762.768
      }
    },
    {
      "id": "judu:stop:6714",
      "stopId": "6714",
      "name": "Aušros vartai",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0416",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "13",
        "31",
        "34",
        "74",
        "88",
        "89"
      ],
      "wgs84": {
        "latitude": 54.67368,
        "longitude": 25.28949
      },
      "lks94": {
        "easting": 583169.19,
        "northing": 6060455.645
      }
    },
    {
      "id": "judu:stop:6715",
      "stopId": "6715",
      "name": "Vilniaus universitetas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1022",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "4G",
        "5G",
        "10",
        "18",
        "19",
        "38",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.72489,
        "longitude": 25.33134
      },
      "lks94": {
        "easting": 585760.169,
        "northing": 6066204.962
      }
    },
    {
      "id": "judu:stop:6719",
      "stopId": "6719",
      "name": "Pūčkorių atodanga",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2313",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18",
        "31",
        "58",
        "67",
        "74",
        "115"
      ],
      "wgs84": {
        "latitude": 54.69159,
        "longitude": 25.3601
      },
      "lks94": {
        "easting": 587684.486,
        "northing": 6062534.683
      }
    },
    {
      "id": "judu:stop:6720",
      "stopId": "6720",
      "name": "Klinikų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1112",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "4",
        "10",
        "15",
        "19",
        "114",
        "115"
      ],
      "wgs84": {
        "latitude": 54.71161,
        "longitude": 25.31573
      },
      "lks94": {
        "easting": 584782.396,
        "northing": 6064708.114
      }
    },
    {
      "id": "judu:stop:6721",
      "stopId": "6721",
      "name": "Pūčkoriai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2315",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "6G",
        "18",
        "31",
        "58",
        "67",
        "74",
        "115"
      ],
      "wgs84": {
        "latitude": 54.69112,
        "longitude": 25.3673
      },
      "lks94": {
        "easting": 588149.654,
        "northing": 6062491.396
      }
    },
    {
      "id": "judu:stop:6722",
      "stopId": "6722",
      "name": "Pūčkoriai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2314",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "6G",
        "18",
        "31",
        "67",
        "74",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.69145,
        "longitude": 25.36641
      },
      "lks94": {
        "easting": 588091.565,
        "northing": 6062527.003
      }
    },
    {
      "id": "judu:stop:6723",
      "stopId": "6723",
      "name": "Klinikų st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1111",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "4",
        "6",
        "10",
        "12",
        "15",
        "17",
        "19",
        "20",
        "21",
        "114",
        "115"
      ],
      "wgs84": {
        "latitude": 54.71134,
        "longitude": 25.31669
      },
      "lks94": {
        "easting": 584844.816,
        "northing": 6064679.227
      }
    },
    {
      "id": "judu:stop:6724",
      "stopId": "6724",
      "name": "Stepono Batoro st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2317",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18",
        "31",
        "58",
        "67",
        "74",
        "115"
      ],
      "wgs84": {
        "latitude": 54.69312,
        "longitude": 25.37896
      },
      "lks94": {
        "easting": 588896.953,
        "northing": 6062728.669
      }
    },
    {
      "id": "judu:stop:6725",
      "stopId": "6725",
      "name": "Stepono Batoro st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2316",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18",
        "31",
        "67",
        "74",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.69317,
        "longitude": 25.37802
      },
      "lks94": {
        "easting": 588836.249,
        "northing": 6062733.044
      }
    },
    {
      "id": "judu:stop:6727",
      "stopId": "6727",
      "name": "Lelijų st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2342",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "6G",
        "18",
        "31",
        "58",
        "67",
        "74",
        "115"
      ],
      "wgs84": {
        "latitude": 54.68949,
        "longitude": 25.40021
      },
      "lks94": {
        "easting": 590274.837,
        "northing": 6062351.823
      }
    },
    {
      "id": "judu:stop:6729",
      "stopId": "6729",
      "name": "Lelijų st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2341",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "6G",
        "18",
        "31",
        "67",
        "74",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.68973,
        "longitude": 25.40104
      },
      "lks94": {
        "easting": 590327.813,
        "northing": 6062379.599
      }
    },
    {
      "id": "judu:stop:6732",
      "stopId": "6732",
      "name": "Pūčkorių atodanga",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2312",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18",
        "31",
        "67",
        "74",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.69193,
        "longitude": 25.35951
      },
      "lks94": {
        "easting": 587645.719,
        "northing": 6062571.784
      }
    },
    {
      "id": "judu:stop:6736",
      "stopId": "6736",
      "name": "Juozo Tumo-Vaižganto st.",
      "description": "link Žaliojo tilto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0226",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3G",
        "4",
        "9",
        "10",
        "17",
        "21",
        "22",
        "43",
        "55",
        "57",
        "73",
        "125",
        "N3",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.68958,
        "longitude": 25.26922
      },
      "lks94": {
        "easting": 581829.903,
        "northing": 6062201.279
      }
    },
    {
      "id": "judu:stop:6743",
      "stopId": "6743",
      "name": "Tvenkinių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3403",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32"
      ],
      "wgs84": {
        "latitude": 54.71065,
        "longitude": 25.20082
      },
      "lks94": {
        "easting": 577380.084,
        "northing": 6064468.532
      }
    },
    {
      "id": "judu:stop:6746",
      "stopId": "6746",
      "name": "Tvenkinių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4401",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32"
      ],
      "wgs84": {
        "latitude": 54.71104,
        "longitude": 25.20066
      },
      "lks94": {
        "easting": 577369.032,
        "northing": 6064511.757
      }
    },
    {
      "id": "judu:stop:6748",
      "stopId": "6748",
      "name": "Buivydiškės",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4402",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32"
      ],
      "wgs84": {
        "latitude": 54.71687,
        "longitude": 25.19645
      },
      "lks94": {
        "easting": 577086.697,
        "northing": 6065155.933
      }
    },
    {
      "id": "judu:stop:6749",
      "stopId": "6749",
      "name": "Buivydiškės",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4403",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32"
      ],
      "wgs84": {
        "latitude": 54.71735,
        "longitude": 25.19697
      },
      "lks94": {
        "easting": 577119.288,
        "northing": 6065209.923
      }
    },
    {
      "id": "judu:stop:6751",
      "stopId": "6751",
      "name": "Sodų st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4404",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32"
      ],
      "wgs84": {
        "latitude": 54.72409,
        "longitude": 25.18789
      },
      "lks94": {
        "easting": 576521.606,
        "northing": 6065950.065
      }
    },
    {
      "id": "judu:stop:6763",
      "stopId": "6763",
      "name": "Sporto gimnazija",
      "description": "link Ukmergės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3812",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "40",
        "48",
        "52",
        "125",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.73161,
        "longitude": 25.24241
      },
      "lks94": {
        "easting": 580018.683,
        "northing": 6066847.762
      }
    },
    {
      "id": "judu:stop:6766",
      "stopId": "6766",
      "name": "Juliaus Juzeliūno st.",
      "description": "link Ukmergės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3319",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "46",
        "48",
        "52",
        "55",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.72918,
        "longitude": 25.23568
      },
      "lks94": {
        "easting": 579590.015,
        "northing": 6066569.679
      }
    },
    {
      "id": "judu:stop:6773",
      "stopId": "6773",
      "name": "Ateities st.",
      "description": "link Santariškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2102",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "48",
        "50",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.7375,
        "longitude": 25.26584
      },
      "lks94": {
        "easting": 581515.809,
        "northing": 6067530.216
      }
    },
    {
      "id": "judu:stop:6774",
      "stopId": "6774",
      "name": "Maumedžių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2131",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "48",
        "50",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.74065,
        "longitude": 25.26436
      },
      "lks94": {
        "easting": 581414.19,
        "northing": 6067879.053
      }
    },
    {
      "id": "judu:stop:6775",
      "stopId": "6775",
      "name": "Maumedžių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2132",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "48",
        "50",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.74108,
        "longitude": 25.26437
      },
      "lks94": {
        "easting": 581413.971,
        "northing": 6067926.918
      }
    },
    {
      "id": "judu:stop:6776",
      "stopId": "6776",
      "name": "Mokyklos st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2103",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "48",
        "50",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.74535,
        "longitude": 25.26338
      },
      "lks94": {
        "easting": 581341.67,
        "northing": 6068400.967
      }
    },
    {
      "id": "judu:stop:6777",
      "stopId": "6777",
      "name": "Mokyklos st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2104",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "48",
        "50",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.74629,
        "longitude": 25.26375
      },
      "lks94": {
        "easting": 581363.606,
        "northing": 6068506.006
      }
    },
    {
      "id": "judu:stop:6778",
      "stopId": "6778",
      "name": "Akademijos st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2107",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "48",
        "50",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.75262,
        "longitude": 25.27066
      },
      "lks94": {
        "easting": 581795.706,
        "northing": 6069218.492
      }
    },
    {
      "id": "judu:stop:6783",
      "stopId": "6783",
      "name": "Molėtų plentas",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2118",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "34",
        "48",
        "49",
        "57",
        "87"
      ],
      "wgs84": {
        "latitude": 54.75031,
        "longitude": 25.27754
      },
      "lks94": {
        "easting": 582243.247,
        "northing": 6068969.462
      }
    },
    {
      "id": "judu:stop:6788",
      "stopId": "6788",
      "name": "Žalgirio st.",
      "description": "link Žaliųjų ežerų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0915",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "35",
        "36",
        "66"
      ],
      "wgs84": {
        "latitude": 54.70436,
        "longitude": 25.28434
      },
      "lks94": {
        "easting": 582774.58,
        "northing": 6063863.82
      }
    },
    {
      "id": "judu:stop:6797",
      "stopId": "6797",
      "name": "Verkių rūmai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2129",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "35",
        "36",
        "65",
        "66",
        "76",
        "120",
        "121"
      ],
      "wgs84": {
        "latitude": 54.75236,
        "longitude": 25.29645
      },
      "lks94": {
        "easting": 583456.317,
        "northing": 6069219.934
      }
    },
    {
      "id": "judu:stop:6798",
      "stopId": "6798",
      "name": "Verkių rūmai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2128",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "35",
        "36",
        "65",
        "66",
        "76",
        "120",
        "121"
      ],
      "wgs84": {
        "latitude": 54.75224,
        "longitude": 25.29599
      },
      "lks94": {
        "easting": 583426.954,
        "northing": 6069206.033
      }
    },
    {
      "id": "judu:stop:6800",
      "stopId": "6800",
      "name": "Ežerėliai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2130",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "35",
        "36",
        "65",
        "66",
        "76",
        "120",
        "121"
      ],
      "wgs84": {
        "latitude": 54.76131,
        "longitude": 25.30666
      },
      "lks94": {
        "easting": 584094.973,
        "northing": 6070228.149
      }
    },
    {
      "id": "judu:stop:6801",
      "stopId": "6801",
      "name": "Ežerėliai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2201",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "35",
        "36",
        "65",
        "66",
        "76",
        "120"
      ],
      "wgs84": {
        "latitude": 54.76255,
        "longitude": 25.31018
      },
      "lks94": {
        "easting": 584318.925,
        "northing": 6070370.37
      }
    },
    {
      "id": "judu:stop:6803",
      "stopId": "6803",
      "name": "Verkių bendruomenės namai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2211",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "35",
        "36",
        "65",
        "66",
        "76",
        "120"
      ],
      "wgs84": {
        "latitude": 54.77033,
        "longitude": 25.32744
      },
      "lks94": {
        "easting": 585413.269,
        "northing": 6071257.069
      }
    },
    {
      "id": "judu:stop:6804",
      "stopId": "6804",
      "name": "Verkių bendruomenės namai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2210",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "35",
        "36",
        "65",
        "66",
        "76",
        "120"
      ],
      "wgs84": {
        "latitude": 54.77002,
        "longitude": 25.3265
      },
      "lks94": {
        "easting": 585353.441,
        "northing": 6071221.425
      }
    },
    {
      "id": "judu:stop:6808",
      "stopId": "6808",
      "name": "Popieriaus st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2208",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "35",
        "65"
      ],
      "wgs84": {
        "latitude": 54.76987,
        "longitude": 25.33202
      },
      "lks94": {
        "easting": 585708.92,
        "northing": 6071211.464
      }
    },
    {
      "id": "judu:stop:6809",
      "stopId": "6809",
      "name": "Popieriaus st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2209",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "35",
        "65"
      ],
      "wgs84": {
        "latitude": 54.76996,
        "longitude": 25.33261
      },
      "lks94": {
        "easting": 585746.691,
        "northing": 6071222.201
      }
    },
    {
      "id": "judu:stop:6810",
      "stopId": "6810",
      "name": "Kremplių st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2206",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "35",
        "65"
      ],
      "wgs84": {
        "latitude": 54.76698,
        "longitude": 25.33586
      },
      "lks94": {
        "easting": 585962.117,
        "northing": 6070894.544
      }
    },
    {
      "id": "judu:stop:6811",
      "stopId": "6811",
      "name": "Kremplių st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2207",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "35",
        "65"
      ],
      "wgs84": {
        "latitude": 54.76725,
        "longitude": 25.33566
      },
      "lks94": {
        "easting": 585948.675,
        "northing": 6070924.347
      }
    },
    {
      "id": "judu:stop:6814",
      "stopId": "6814",
      "name": "Vaikų darželis",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2204",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "35",
        "65"
      ],
      "wgs84": {
        "latitude": 54.76306,
        "longitude": 25.33591
      },
      "lks94": {
        "easting": 585973.643,
        "northing": 6070458.361
      }
    },
    {
      "id": "judu:stop:6816",
      "stopId": "6816",
      "name": "Naujoji st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2224",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "35",
        "65"
      ],
      "wgs84": {
        "latitude": 54.76332,
        "longitude": 25.34632
      },
      "lks94": {
        "easting": 586642.992,
        "northing": 6070500.106
      }
    },
    {
      "id": "judu:stop:6817",
      "stopId": "6817",
      "name": "Naujoji st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2225",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "35",
        "65"
      ],
      "wgs84": {
        "latitude": 54.76349,
        "longitude": 25.34598
      },
      "lks94": {
        "easting": 586620.749,
        "northing": 6070518.604
      }
    },
    {
      "id": "judu:stop:6818",
      "stopId": "6818",
      "name": "Staviškės",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2215",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "35",
        "65"
      ],
      "wgs84": {
        "latitude": 54.76398,
        "longitude": 25.35276
      },
      "lks94": {
        "easting": 587055.998,
        "northing": 6070581.529
      }
    },
    {
      "id": "judu:stop:6819",
      "stopId": "6819",
      "name": "Staviškės",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2214",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "35",
        "65"
      ],
      "wgs84": {
        "latitude": 54.76345,
        "longitude": 25.35162
      },
      "lks94": {
        "easting": 586983.775,
        "northing": 6070521.133
      }
    },
    {
      "id": "judu:stop:6820",
      "stopId": "6820",
      "name": "Ožkiniai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2217",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "35",
        "65"
      ],
      "wgs84": {
        "latitude": 54.76718,
        "longitude": 25.3615
      },
      "lks94": {
        "easting": 587611.507,
        "northing": 6070948.529
      }
    },
    {
      "id": "judu:stop:6821",
      "stopId": "6821",
      "name": "Ožkiniai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2216",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "35",
        "65"
      ],
      "wgs84": {
        "latitude": 54.76706,
        "longitude": 25.36011
      },
      "lks94": {
        "easting": 587522.326,
        "northing": 6070933.439
      }
    },
    {
      "id": "judu:stop:6834",
      "stopId": "6834",
      "name": "Rūdninkų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0413",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "1G",
        "2",
        "2G",
        "7",
        "10",
        "11",
        "15",
        "20",
        "53",
        "88",
        "N5",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.67454,
        "longitude": 25.28492
      },
      "lks94": {
        "easting": 582872.7,
        "northing": 6060545.948
      }
    },
    {
      "id": "judu:stop:6842",
      "stopId": "6842",
      "name": "Vingis",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0508",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "6",
        "12",
        "21",
        "22",
        "54",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.67754,
        "longitude": 25.25555
      },
      "lks94": {
        "easting": 580972.572,
        "northing": 6060845.54
      }
    },
    {
      "id": "judu:stop:6843",
      "stopId": "6843",
      "name": "Kalvarijų turgus",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0704",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1G",
        "2G",
        "3G",
        "6",
        "9",
        "10",
        "27",
        "30",
        "37",
        "53",
        "55",
        "56",
        "63",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.70019,
        "longitude": 25.28301
      },
      "lks94": {
        "easting": 582697.35,
        "northing": 6063398.188
      }
    },
    {
      "id": "judu:stop:6844",
      "stopId": "6844",
      "name": "Broniaus Laurinavičiaus skveras",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0914",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1G",
        "2G",
        "3G",
        "6",
        "9",
        "10",
        "26",
        "30",
        "34",
        "37",
        "49",
        "53",
        "55",
        "56",
        "63",
        "65",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.70419,
        "longitude": 25.28405
      },
      "lks94": {
        "easting": 582756.237,
        "northing": 6063844.56
      }
    },
    {
      "id": "judu:stop:6845",
      "stopId": "6845",
      "name": "Giedraičių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0916",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "6",
        "9",
        "10",
        "26",
        "30",
        "34",
        "35",
        "36",
        "37",
        "49",
        "53",
        "55",
        "56",
        "63",
        "65",
        "66",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.70804,
        "longitude": 25.2855
      },
      "lks94": {
        "easting": 582841.836,
        "northing": 6064274.724
      }
    },
    {
      "id": "judu:stop:6846",
      "stopId": "6846",
      "name": "Pramogų arena",
      "description": "link Žirmūnų ir Saulėtekio",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0804",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1G",
        "2G",
        "3G",
        "5G",
        "6",
        "6G",
        "7",
        "8",
        "9",
        "10",
        "25",
        "29",
        "34",
        "35",
        "36",
        "37",
        "46",
        "48",
        "49",
        "53",
        "56",
        "63",
        "66",
        "87",
        "89",
        "N4",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.71504,
        "longitude": 25.28821
      },
      "lks94": {
        "easting": 583002.169,
        "northing": 6065056.932
      }
    },
    {
      "id": "judu:stop:6847",
      "stopId": "6847",
      "name": "Verkių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0823",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1G",
        "2G",
        "3G",
        "5G",
        "6",
        "6G",
        "7",
        "8",
        "9",
        "10",
        "25",
        "29",
        "34",
        "35",
        "36",
        "37",
        "46",
        "48",
        "49",
        "53",
        "56",
        "63",
        "66",
        "87",
        "89",
        "N4",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.71843,
        "longitude": 25.29553
      },
      "lks94": {
        "easting": 583466.821,
        "northing": 6065442.875
      }
    },
    {
      "id": "judu:stop:6850",
      "stopId": "6850",
      "name": "Vaduvos st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2415",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "6",
        "8",
        "12",
        "15",
        "18",
        "20",
        "24",
        "25",
        "28",
        "51",
        "62",
        "123",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.64438,
        "longitude": 25.20665
      },
      "lks94": {
        "easting": 577882.491,
        "northing": 6057099.975
      }
    },
    {
      "id": "judu:stop:6851",
      "stopId": "6851",
      "name": "Sausupio st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2412",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "6",
        "8",
        "12",
        "15",
        "18",
        "20",
        "24",
        "25",
        "28",
        "51",
        "62",
        "123",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.64722,
        "longitude": 25.21217
      },
      "lks94": {
        "easting": 578233.305,
        "northing": 6057422.163
      }
    },
    {
      "id": "judu:stop:6852",
      "stopId": "6852",
      "name": "Vytenio st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0513",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "73"
      ],
      "wgs84": {
        "latitude": 54.67342,
        "longitude": 25.26607
      },
      "lks94": {
        "easting": 581659.256,
        "northing": 6060399.223
      }
    },
    {
      "id": "judu:stop:6853",
      "stopId": "6853",
      "name": "Taraso Ševčenkos st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0510",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3G",
        "9",
        "10",
        "11",
        "17",
        "21",
        "43",
        "54",
        "55",
        "57",
        "73",
        "116",
        "125",
        "N2",
        "N8",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.67869,
        "longitude": 25.26718
      },
      "lks94": {
        "easting": 581720.261,
        "northing": 6060986.994
      }
    },
    {
      "id": "judu:stop:6854",
      "stopId": "6854",
      "name": "Prūsų st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1504",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "4",
        "7",
        "9",
        "10",
        "11",
        "13",
        "14",
        "15",
        "17",
        "26",
        "38",
        "41",
        "42",
        "43",
        "55",
        "57",
        "61",
        "65",
        "78",
        "114",
        "116",
        "125",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.66505,
        "longitude": 25.27316
      },
      "lks94": {
        "easting": 582133.412,
        "northing": 6059476.027
      }
    },
    {
      "id": "judu:stop:6856",
      "stopId": "6856",
      "name": "Verkių Riešė",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2213",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "36",
        "65",
        "66",
        "76",
        "120"
      ],
      "wgs84": {
        "latitude": 54.77739,
        "longitude": 25.33811
      },
      "lks94": {
        "easting": 586084.789,
        "northing": 6072055.801
      }
    },
    {
      "id": "judu:stop:6857",
      "stopId": "6857",
      "name": "Verkių Riešė",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2212",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "36",
        "65",
        "66",
        "76",
        "120"
      ],
      "wgs84": {
        "latitude": 54.77695,
        "longitude": 25.33699
      },
      "lks94": {
        "easting": 586013.674,
        "northing": 6072005.461
      }
    },
    {
      "id": "judu:stop:6860",
      "stopId": "6860",
      "name": "Ragučio st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2220",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "36",
        "66",
        "76",
        "120"
      ],
      "wgs84": {
        "latitude": 54.78076,
        "longitude": 25.34263
      },
      "lks94": {
        "easting": 586368.377,
        "northing": 6072436.396
      }
    },
    {
      "id": "judu:stop:6861",
      "stopId": "6861",
      "name": "Ragučio st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2219",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "36",
        "66",
        "120"
      ],
      "wgs84": {
        "latitude": 54.78026,
        "longitude": 25.34204
      },
      "lks94": {
        "easting": 586331.49,
        "northing": 6072380.026
      }
    },
    {
      "id": "judu:stop:6871",
      "stopId": "6871",
      "name": "Verkių st.",
      "description": "link Valakampių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0806",
      "modes": [
        "trolleybus"
      ],
      "routeShortNames": [
        "6",
        "10"
      ],
      "wgs84": {
        "latitude": 54.71732,
        "longitude": 25.29562
      },
      "lks94": {
        "easting": 583474.9,
        "northing": 6065319.454
      }
    },
    {
      "id": "judu:stop:6873",
      "stopId": "6873",
      "name": "Kareivių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0812",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3",
        "5G",
        "6",
        "10",
        "17",
        "18",
        "39",
        "50",
        "114",
        "115",
        "121",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.72062,
        "longitude": 25.30316
      },
      "lks94": {
        "easting": 583953.844,
        "northing": 6065695.694
      }
    },
    {
      "id": "judu:stop:6874",
      "stopId": "6874",
      "name": "Valakampių tiltas",
      "description": "link Antakalnio",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0820",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3",
        "6",
        "10",
        "17",
        "18",
        "39",
        "50",
        "114",
        "115",
        "121",
        "N1"
      ],
      "wgs84": {
        "latitude": 54.72409,
        "longitude": 25.30849
      },
      "lks94": {
        "easting": 584289.999,
        "northing": 6066088.247
      }
    },
    {
      "id": "judu:stop:6880",
      "stopId": "6880",
      "name": "Viršupis",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1128",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "37",
        "119"
      ],
      "wgs84": {
        "latitude": 54.69579,
        "longitude": 25.34397
      },
      "lks94": {
        "easting": 586635.714,
        "northing": 6062982.055
      }
    },
    {
      "id": "judu:stop:6881",
      "stopId": "6881",
      "name": "Viršupis",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2303",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "37",
        "119"
      ],
      "wgs84": {
        "latitude": 54.69615,
        "longitude": 25.34496
      },
      "lks94": {
        "easting": 586698.76,
        "northing": 6063023.34
      }
    },
    {
      "id": "judu:stop:6883",
      "stopId": "6883",
      "name": "Šilo st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2304",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "37",
        "119"
      ],
      "wgs84": {
        "latitude": 54.70009,
        "longitude": 25.34933
      },
      "lks94": {
        "easting": 586972.013,
        "northing": 6063467.211
      }
    },
    {
      "id": "judu:stop:6886",
      "stopId": "6886",
      "name": "Lyglaukiai",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1126",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "37",
        "119"
      ],
      "wgs84": {
        "latitude": 54.70277,
        "longitude": 25.35406
      },
      "lks94": {
        "easting": 587271.116,
        "northing": 6063771.327
      }
    },
    {
      "id": "judu:stop:6887",
      "stopId": "6887",
      "name": "Lyglaukiai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2305",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "37",
        "119"
      ],
      "wgs84": {
        "latitude": 54.70237,
        "longitude": 25.35381
      },
      "lks94": {
        "easting": 587255.863,
        "northing": 6063726.502
      }
    },
    {
      "id": "judu:stop:6888",
      "stopId": "6888",
      "name": "Rokantiškės",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1019",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "37",
        "115",
        "119"
      ],
      "wgs84": {
        "latitude": 54.70411,
        "longitude": 25.36406
      },
      "lks94": {
        "easting": 587912.692,
        "northing": 6063932.928
      }
    },
    {
      "id": "judu:stop:6895",
      "stopId": "6895",
      "name": "Gvazdikų st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3528",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "38",
        "114"
      ],
      "wgs84": {
        "latitude": 54.74315,
        "longitude": 25.39835
      },
      "lks94": {
        "easting": 590035.934,
        "northing": 6068320.988
      }
    },
    {
      "id": "judu:stop:6896",
      "stopId": "6896",
      "name": "Gvazdikų st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3527",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "38",
        "114"
      ],
      "wgs84": {
        "latitude": 54.74366,
        "longitude": 25.39804
      },
      "lks94": {
        "easting": 590014.845,
        "northing": 6068377.345
      }
    },
    {
      "id": "judu:stop:6898",
      "stopId": "6898",
      "name": "Žemoji Veržuva",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3529",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "38",
        "114"
      ],
      "wgs84": {
        "latitude": 54.75002,
        "longitude": 25.40124
      },
      "lks94": {
        "easting": 590206.73,
        "northing": 6069089.232
      }
    },
    {
      "id": "judu:stop:6899",
      "stopId": "6899",
      "name": "Žemoji Veržuva",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3530",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "38",
        "114"
      ],
      "wgs84": {
        "latitude": 54.75002,
        "longitude": 25.40151
      },
      "lks94": {
        "easting": 590224.11,
        "northing": 6069089.579
      }
    },
    {
      "id": "judu:stop:6901",
      "stopId": "6901",
      "name": "Vaguva",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3532",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "38"
      ],
      "wgs84": {
        "latitude": 54.74711,
        "longitude": 25.41714
      },
      "lks94": {
        "easting": 591236.787,
        "northing": 6068785.953
      }
    },
    {
      "id": "judu:stop:6902",
      "stopId": "6902",
      "name": "Vaguva",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3531",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "38"
      ],
      "wgs84": {
        "latitude": 54.74725,
        "longitude": 25.41687
      },
      "lks94": {
        "easting": 591219.091,
        "northing": 6068801.182
      }
    },
    {
      "id": "judu:stop:6905",
      "stopId": "6905",
      "name": "Miškas",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3544",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "39"
      ],
      "wgs84": {
        "latitude": 54.78333,
        "longitude": 25.40463
      },
      "lks94": {
        "easting": 590350.707,
        "northing": 6072800.526
      }
    },
    {
      "id": "judu:stop:6906",
      "stopId": "6906",
      "name": "Miškas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3545",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "39"
      ],
      "wgs84": {
        "latitude": 54.78307,
        "longitude": 25.40316
      },
      "lks94": {
        "easting": 590256.737,
        "northing": 6072769.699
      }
    },
    {
      "id": "judu:stop:6907",
      "stopId": "6907",
      "name": "Balžio st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3546",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "39"
      ],
      "wgs84": {
        "latitude": 54.79303,
        "longitude": 25.42904
      },
      "lks94": {
        "easting": 591898.734,
        "northing": 6073911.723
      }
    },
    {
      "id": "judu:stop:6911",
      "stopId": "6911",
      "name": "Sporto gimnazija",
      "description": "link Fabijoniškių g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3814",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G-A",
        "5",
        "24",
        "40",
        "48",
        "57",
        "125",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.73299,
        "longitude": 25.2447
      },
      "lks94": {
        "easting": 580163.441,
        "northing": 6067003.953
      }
    },
    {
      "id": "judu:stop:6913",
      "stopId": "6913",
      "name": "Pijaus Žadeikos st.",
      "description": "link Ateities g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3816",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5",
        "24",
        "40",
        "48",
        "53",
        "56",
        "57",
        "125",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.73504,
        "longitude": 25.24753
      },
      "lks94": {
        "easting": 580341.637,
        "northing": 6067235.329
      }
    },
    {
      "id": "judu:stop:6914",
      "stopId": "6914",
      "name": "Pijaus Žadeikos st.",
      "description": "link Ukmergės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3815",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G-A",
        "5",
        "24",
        "40",
        "48",
        "57",
        "125",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.7349,
        "longitude": 25.24626
      },
      "lks94": {
        "easting": 580260.13,
        "northing": 6067218.296
      }
    },
    {
      "id": "judu:stop:6915",
      "stopId": "6915",
      "name": "Pijaus Žadeikos st.",
      "description": "link Gedvydžių g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3831",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G-A",
        "5",
        "24",
        "53",
        "56",
        "57"
      ],
      "wgs84": {
        "latitude": 54.73552,
        "longitude": 25.24623
      },
      "lks94": {
        "easting": 580256.972,
        "northing": 6067287.26
      }
    },
    {
      "id": "judu:stop:6917",
      "stopId": "6917",
      "name": "Pamiškė",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3825",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "40",
        "53",
        "56",
        "75",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.72958,
        "longitude": 25.25452
      },
      "lks94": {
        "easting": 580802.638,
        "northing": 6066635.726
      }
    },
    {
      "id": "judu:stop:6918",
      "stopId": "6918",
      "name": "Pamiškė",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3824",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "40",
        "53",
        "56",
        "75",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.73041,
        "longitude": 25.2549
      },
      "lks94": {
        "easting": 580825.46,
        "northing": 6066728.532
      }
    },
    {
      "id": "judu:stop:6921",
      "stopId": "6921",
      "name": "Simono Stanevičiaus st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3827",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "40",
        "53",
        "56",
        "75",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.7252,
        "longitude": 25.25372
      },
      "lks94": {
        "easting": 580759.822,
        "northing": 6066147.366
      }
    },
    {
      "id": "judu:stop:6922",
      "stopId": "6922",
      "name": "Simono Stanevičiaus st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3826",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "40",
        "53",
        "56",
        "75",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.7261,
        "longitude": 25.25418
      },
      "lks94": {
        "easting": 580787.662,
        "northing": 6066248.054
      }
    },
    {
      "id": "judu:stop:6924",
      "stopId": "6924",
      "name": "Jovaro st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3829",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "40",
        "53",
        "56",
        "75",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.72287,
        "longitude": 25.25407
      },
      "lks94": {
        "easting": 580787.001,
        "northing": 6065888.47
      }
    },
    {
      "id": "judu:stop:6925",
      "stopId": "6925",
      "name": "Medeinos st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3304",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "5G",
        "7",
        "18",
        "32",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.72967,
        "longitude": 25.21902
      },
      "lks94": {
        "easting": 578516.053,
        "northing": 6066605.441
      }
    },
    {
      "id": "judu:stop:6926",
      "stopId": "6926",
      "name": "Jovaro st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3828",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "40",
        "53",
        "56",
        "75",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.72384,
        "longitude": 25.25396
      },
      "lks94": {
        "easting": 580777.986,
        "northing": 6065996.292
      }
    },
    {
      "id": "judu:stop:6928",
      "stopId": "6928",
      "name": "Gelvonų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1927",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "40",
        "53",
        "56",
        "75",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.71764,
        "longitude": 25.25763
      },
      "lks94": {
        "easting": 581026.754,
        "northing": 6065310.542
      }
    },
    {
      "id": "judu:stop:6929",
      "stopId": "6929",
      "name": "Gelvonų st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1928",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "40",
        "53",
        "56",
        "75",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.71838,
        "longitude": 25.25767
      },
      "lks94": {
        "easting": 581027.855,
        "northing": 6065392.94
      }
    },
    {
      "id": "judu:stop:6931",
      "stopId": "6931",
      "name": "Skalvių st.",
      "description": "išlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3306",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3G",
        "5G",
        "7",
        "18",
        "32",
        "40",
        "46",
        "118",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.73471,
        "longitude": 25.22005
      },
      "lks94": {
        "easting": 578572.639,
        "northing": 6067167.486
      }
    },
    {
      "id": "judu:stop:6933",
      "stopId": "6933",
      "name": "Gelvonėlio st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1924",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "25",
        "40",
        "48",
        "53",
        "56",
        "87",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.71443,
        "longitude": 25.25677
      },
      "lks94": {
        "easting": 580977.746,
        "northing": 6064952.318
      }
    },
    {
      "id": "judu:stop:6934",
      "stopId": "6934",
      "name": "Gelvonėlio st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1925",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "25",
        "48",
        "53",
        "56",
        "87",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.71505,
        "longitude": 25.25741
      },
      "lks94": {
        "easting": 581017.745,
        "northing": 6065022.054
      }
    },
    {
      "id": "judu:stop:6937",
      "stopId": "6937",
      "name": "Šeškinės kalvos",
      "description": "link Ukmergės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1931",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5G",
        "7",
        "40",
        "46",
        "48",
        "56"
      ],
      "wgs84": {
        "latitude": 54.71085,
        "longitude": 25.25622
      },
      "lks94": {
        "easting": 580949.441,
        "northing": 6064553.275
      }
    },
    {
      "id": "judu:stop:6940",
      "stopId": "6940",
      "name": "Paberžės st.",
      "description": "link Fabijoniškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1926",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "25",
        "40",
        "48",
        "56",
        "75",
        "87"
      ],
      "wgs84": {
        "latitude": 54.71616,
        "longitude": 25.25481
      },
      "lks94": {
        "easting": 580848.022,
        "northing": 6065142.585
      }
    },
    {
      "id": "judu:stop:6941",
      "stopId": "6941",
      "name": "Paberžės st.",
      "description": "link žiedo",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1929",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "25",
        "48",
        "75",
        "87"
      ],
      "wgs84": {
        "latitude": 54.71617,
        "longitude": 25.25358
      },
      "lks94": {
        "easting": 580768.756,
        "northing": 6065142.281
      }
    },
    {
      "id": "judu:stop:6947",
      "stopId": "6947",
      "name": "Hidrogeologijos st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2614",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "7",
        "9",
        "41",
        "42",
        "43",
        "55",
        "78"
      ],
      "wgs84": {
        "latitude": 54.64344,
        "longitude": 25.26321
      },
      "lks94": {
        "easting": 581534.813,
        "northing": 6057059.546
      }
    },
    {
      "id": "judu:stop:6948",
      "stopId": "6948",
      "name": "Hidrogeologijos st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2615",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "7",
        "9",
        "41",
        "42",
        "43",
        "55",
        "78"
      ],
      "wgs84": {
        "latitude": 54.64295,
        "longitude": 25.26267
      },
      "lks94": {
        "easting": 581500.94,
        "northing": 6057004.389
      }
    },
    {
      "id": "judu:stop:6949",
      "stopId": "6949",
      "name": "Verslo st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2625",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "7",
        "9",
        "41",
        "42",
        "43",
        "55",
        "78"
      ],
      "wgs84": {
        "latitude": 54.63898,
        "longitude": 25.25882
      },
      "lks94": {
        "easting": 581260.367,
        "northing": 6056558.125
      }
    },
    {
      "id": "judu:stop:6950",
      "stopId": "6950",
      "name": "Verslo st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2624",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "7",
        "9",
        "41",
        "42",
        "43",
        "55",
        "78"
      ],
      "wgs84": {
        "latitude": 54.63933,
        "longitude": 25.25934
      },
      "lks94": {
        "easting": 581293.234,
        "northing": 6056597.676
      }
    },
    {
      "id": "judu:stop:6956",
      "stopId": "6956",
      "name": "Dieveniškių st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2717",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "41"
      ],
      "wgs84": {
        "latitude": 54.63383,
        "longitude": 25.24933
      },
      "lks94": {
        "easting": 580657.986,
        "northing": 6055974.066
      }
    },
    {
      "id": "judu:stop:6957",
      "stopId": "6957",
      "name": "Dieveniškių st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2716",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "41"
      ],
      "wgs84": {
        "latitude": 54.63407,
        "longitude": 25.2488
      },
      "lks94": {
        "easting": 580623.295,
        "northing": 6056000.167
      }
    },
    {
      "id": "judu:stop:6959",
      "stopId": "6959",
      "name": "Užusienis",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2701",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "41"
      ],
      "wgs84": {
        "latitude": 54.63298,
        "longitude": 25.23943
      },
      "lks94": {
        "easting": 580020.534,
        "northing": 6055868.152
      }
    },
    {
      "id": "judu:stop:6961",
      "stopId": "6961",
      "name": "Dilgynė",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2628",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "4G",
        "7",
        "9",
        "41",
        "42",
        "43",
        "51",
        "55",
        "78"
      ],
      "wgs84": {
        "latitude": 54.63435,
        "longitude": 25.25372
      },
      "lks94": {
        "easting": 580940.361,
        "northing": 6056036.984
      }
    },
    {
      "id": "judu:stop:6963",
      "stopId": "6963",
      "name": "Eišiškių sodai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2702",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "7",
        "9",
        "42",
        "43",
        "51",
        "55",
        "78"
      ],
      "wgs84": {
        "latitude": 54.6274,
        "longitude": 25.24954
      },
      "lks94": {
        "easting": 580684.27,
        "northing": 6055258.74
      }
    },
    {
      "id": "judu:stop:6964",
      "stopId": "6964",
      "name": "Eišiškių sodai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2703",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "9",
        "42",
        "51",
        "78"
      ],
      "wgs84": {
        "latitude": 54.62625,
        "longitude": 25.24947
      },
      "lks94": {
        "easting": 580682.026,
        "northing": 6055130.681
      }
    },
    {
      "id": "judu:stop:6966",
      "stopId": "6966",
      "name": "Ąžuolijai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2704",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "9",
        "42",
        "51",
        "78"
      ],
      "wgs84": {
        "latitude": 54.62186,
        "longitude": 25.24387
      },
      "lks94": {
        "easting": 580329.086,
        "northing": 6054635.721
      }
    },
    {
      "id": "judu:stop:6967",
      "stopId": "6967",
      "name": "Ąžuolijai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2705",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "42"
      ],
      "wgs84": {
        "latitude": 54.62026,
        "longitude": 25.24455
      },
      "lks94": {
        "easting": 580376.152,
        "northing": 6054458.442
      }
    },
    {
      "id": "judu:stop:6968",
      "stopId": "6968",
      "name": "Ąžuolijai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5117",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "4G",
        "7",
        "9",
        "43",
        "51",
        "55",
        "78"
      ],
      "wgs84": {
        "latitude": 54.62168,
        "longitude": 25.24273
      },
      "lks94": {
        "easting": 580255.823,
        "northing": 6054614.387
      }
    },
    {
      "id": "judu:stop:6972",
      "stopId": "6972",
      "name": "Kelmijos sodai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5137",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "9",
        "82"
      ],
      "wgs84": {
        "latitude": 54.60789,
        "longitude": 25.24404
      },
      "lks94": {
        "easting": 580367.588,
        "northing": 6053081.256
      }
    },
    {
      "id": "judu:stop:6973",
      "stopId": "6973",
      "name": "Kelmijos sodai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5136",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "9",
        "82"
      ],
      "wgs84": {
        "latitude": 54.60828,
        "longitude": 25.24382
      },
      "lks94": {
        "easting": 580352.608,
        "northing": 6053124.406
      }
    },
    {
      "id": "judu:stop:6974",
      "stopId": "6974",
      "name": "Raisteliai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5108",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "9",
        "51",
        "78"
      ],
      "wgs84": {
        "latitude": 54.61123,
        "longitude": 25.21761
      },
      "lks94": {
        "easting": 578653.8,
        "northing": 6053423.047
      }
    },
    {
      "id": "judu:stop:6975",
      "stopId": "6975",
      "name": "Raisteliai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5109",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "9",
        "51",
        "78"
      ],
      "wgs84": {
        "latitude": 54.61139,
        "longitude": 25.21812
      },
      "lks94": {
        "easting": 578686.434,
        "northing": 6053441.424
      }
    },
    {
      "id": "judu:stop:6978",
      "stopId": "6978",
      "name": "Durpių st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5139",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51",
        "78"
      ],
      "wgs84": {
        "latitude": 54.59582,
        "longitude": 25.20494
      },
      "lks94": {
        "easting": 577864.801,
        "northing": 6051694.025
      }
    },
    {
      "id": "judu:stop:6979",
      "stopId": "6979",
      "name": "Durpių st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5138",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51",
        "78"
      ],
      "wgs84": {
        "latitude": 54.59657,
        "longitude": 25.20456
      },
      "lks94": {
        "easting": 577838.815,
        "northing": 6051777.068
      }
    },
    {
      "id": "judu:stop:6990",
      "stopId": "6990",
      "name": "Justiniškių žiedas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3216",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "43",
        "73"
      ],
      "wgs84": {
        "latitude": 54.70933,
        "longitude": 25.21334
      },
      "lks94": {
        "easting": 578189.365,
        "northing": 6064335.507
      }
    },
    {
      "id": "judu:stop:6992",
      "stopId": "6992",
      "name": "Šiaurinė st.",
      "description": "link žiedo",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3213",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "43",
        "73"
      ],
      "wgs84": {
        "latitude": 54.71497,
        "longitude": 25.21486
      },
      "lks94": {
        "easting": 578276.446,
        "northing": 6064964.864
      }
    },
    {
      "id": "judu:stop:6993",
      "stopId": "6993",
      "name": "Šiaurinė st.",
      "description": "link Rygos g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3212",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "43",
        "73"
      ],
      "wgs84": {
        "latitude": 54.71554,
        "longitude": 25.21511
      },
      "lks94": {
        "easting": 578291.455,
        "northing": 6065028.576
      }
    },
    {
      "id": "judu:stop:6995",
      "stopId": "6995",
      "name": "Atžalyno st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3208",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "43",
        "73"
      ],
      "wgs84": {
        "latitude": 54.71826,
        "longitude": 25.21413
      },
      "lks94": {
        "easting": 578223.078,
        "northing": 6065330.186
      }
    },
    {
      "id": "judu:stop:7001",
      "stopId": "7001",
      "name": "Justiniškės",
      "description": "link Laisvės pr.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1801",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5G",
        "43",
        "73",
        "75"
      ],
      "wgs84": {
        "latitude": 54.71676,
        "longitude": 25.22203
      },
      "lks94": {
        "easting": 578734.935,
        "northing": 6065172.089
      }
    },
    {
      "id": "judu:stop:7003",
      "stopId": "7003",
      "name": "Dūkštų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1917",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "43",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.71486,
        "longitude": 25.24528
      },
      "lks94": {
        "easting": 580236.598,
        "northing": 6064986.975
      }
    },
    {
      "id": "judu:stop:7017",
      "stopId": "7017",
      "name": "Šeškinės kalvos",
      "description": "link Žirmūnų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1923",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5G",
        "7",
        "25",
        "46",
        "48",
        "53",
        "56",
        "87",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.71109,
        "longitude": 25.25819
      },
      "lks94": {
        "easting": 581075.9,
        "northing": 6064582.258
      }
    },
    {
      "id": "judu:stop:7022",
      "stopId": "7022",
      "name": "Gabijos st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3307",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "40",
        "46"
      ],
      "wgs84": {
        "latitude": 54.73135,
        "longitude": 25.22435
      },
      "lks94": {
        "easting": 578856.074,
        "northing": 6066798.382
      }
    },
    {
      "id": "judu:stop:7023",
      "stopId": "7023",
      "name": "Gabijos st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3308",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "40",
        "46"
      ],
      "wgs84": {
        "latitude": 54.7314,
        "longitude": 25.22632
      },
      "lks94": {
        "easting": 578982.852,
        "northing": 6066806.162
      }
    },
    {
      "id": "judu:stop:7027",
      "stopId": "7027",
      "name": "Pašilaičiai",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3312",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "40",
        "46",
        "125"
      ],
      "wgs84": {
        "latitude": 54.73141,
        "longitude": 25.23164
      },
      "lks94": {
        "easting": 579325.457,
        "northing": 6066813.276
      }
    },
    {
      "id": "judu:stop:7028",
      "stopId": "7028",
      "name": "Pašilaičiai",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3311",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "40",
        "46",
        "125"
      ],
      "wgs84": {
        "latitude": 54.73195,
        "longitude": 25.2305
      },
      "lks94": {
        "easting": 579250.983,
        "northing": 6066872.083
      }
    },
    {
      "id": "judu:stop:7042",
      "stopId": "7042",
      "name": "Minties st.",
      "description": "link Kalvarijų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0919",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "50"
      ],
      "wgs84": {
        "latitude": 54.70507,
        "longitude": 25.29864
      },
      "lks94": {
        "easting": 583694.689,
        "northing": 6063959.791
      }
    },
    {
      "id": "judu:stop:7043",
      "stopId": "7043",
      "name": "Minties st.",
      "description": "link Žirmūnų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0920",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "50"
      ],
      "wgs84": {
        "latitude": 54.70506,
        "longitude": 25.29968
      },
      "lks94": {
        "easting": 583761.731,
        "northing": 6063959.919
      }
    },
    {
      "id": "judu:stop:7044",
      "stopId": "7044",
      "name": "Apkasų st.",
      "description": "link Šilo tilto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0918",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "50"
      ],
      "wgs84": {
        "latitude": 54.70393,
        "longitude": 25.2927
      },
      "lks94": {
        "easting": 583314.226,
        "northing": 6063825.858
      }
    },
    {
      "id": "judu:stop:7045",
      "stopId": "7045",
      "name": "Apkasų st.",
      "description": "link Kalvarijų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0917",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "50"
      ],
      "wgs84": {
        "latitude": 54.70394,
        "longitude": 25.29142
      },
      "lks94": {
        "easting": 583231.715,
        "northing": 6063825.452
      }
    },
    {
      "id": "judu:stop:7046",
      "stopId": "7046",
      "name": "Jono Kairiūkščio st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2110",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "34",
        "120",
        "121",
        "125"
      ],
      "wgs84": {
        "latitude": 54.75718,
        "longitude": 25.26991
      },
      "lks94": {
        "easting": 581738.242,
        "northing": 6069725.09
      }
    },
    {
      "id": "judu:stop:7047",
      "stopId": "7047",
      "name": "Jono Kairiūkščio st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2109",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "34",
        "120",
        "121",
        "125"
      ],
      "wgs84": {
        "latitude": 54.75705,
        "longitude": 25.27026
      },
      "lks94": {
        "easting": 581761.031,
        "northing": 6069711.03
      }
    },
    {
      "id": "judu:stop:7052",
      "stopId": "7052",
      "name": "Chemijos institutas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2133",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "49",
        "50",
        "57",
        "125",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.75385,
        "longitude": 25.26385
      },
      "lks94": {
        "easting": 581354.886,
        "northing": 6069347.457
      }
    },
    {
      "id": "judu:stop:7055",
      "stopId": "7055",
      "name": "Stasylų st.",
      "description": "link Ž. Panerių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2941",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.62871,
        "longitude": 25.13342
      },
      "lks94": {
        "easting": 573184.251,
        "northing": 6055277.374
      }
    },
    {
      "id": "judu:stop:7056",
      "stopId": "7056",
      "name": "Stasylų st.",
      "description": "link Trakų Vokės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2940",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.62829,
        "longitude": 25.13073
      },
      "lks94": {
        "easting": 573011.319,
        "northing": 6055227.834
      }
    },
    {
      "id": "judu:stop:7059",
      "stopId": "7059",
      "name": "Trakų Vokė",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3106",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.62368,
        "longitude": 25.11
      },
      "lks94": {
        "easting": 571680.943,
        "northing": 6054693.455
      }
    },
    {
      "id": "judu:stop:7062",
      "stopId": "7062",
      "name": "Eduardo Andrė st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3101",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.62843,
        "longitude": 25.10818
      },
      "lks94": {
        "easting": 571555.079,
        "northing": 6055220.215
      }
    },
    {
      "id": "judu:stop:7068",
      "stopId": "7068",
      "name": "Juodbaliai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3102",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.61208,
        "longitude": 25.12092
      },
      "lks94": {
        "easting": 572406.692,
        "northing": 6053413.718
      }
    },
    {
      "id": "judu:stop:7069",
      "stopId": "7069",
      "name": "Juodbaliai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3103",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.61189,
        "longitude": 25.12084
      },
      "lks94": {
        "easting": 572401.862,
        "northing": 6053392.491
      }
    },
    {
      "id": "judu:stop:7076",
      "stopId": "7076",
      "name": "Pavilionys",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5001",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "52",
        "87"
      ],
      "wgs84": {
        "latitude": 54.74187,
        "longitude": 25.2241
      },
      "lks94": {
        "easting": 578819.548,
        "northing": 6067968.85
      }
    },
    {
      "id": "judu:stop:7077",
      "stopId": "7077",
      "name": "Pavilionys",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5002",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G",
        "52",
        "87",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.74197,
        "longitude": 25.22351
      },
      "lks94": {
        "easting": 578781.366,
        "northing": 6067979.316
      }
    },
    {
      "id": "judu:stop:7080",
      "stopId": "7080",
      "name": "1-osios Bukiškės",
      "description": "link Riešės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4902",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "87"
      ],
      "wgs84": {
        "latitude": 54.76356,
        "longitude": 25.20003
      },
      "lks94": {
        "easting": 577228.467,
        "northing": 6070355.925
      }
    },
    {
      "id": "judu:stop:7082",
      "stopId": "7082",
      "name": "2-osios Bukiškės",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4901",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "87"
      ],
      "wgs84": {
        "latitude": 54.76309,
        "longitude": 25.19852
      },
      "lks94": {
        "easting": 577132.189,
        "northing": 6070301.957
      }
    },
    {
      "id": "judu:stop:7092",
      "stopId": "7092",
      "name": "Skersinės st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5116",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26",
        "87"
      ],
      "wgs84": {
        "latitude": 54.76518,
        "longitude": 25.2719
      },
      "lks94": {
        "easting": 581850.178,
        "northing": 6070617.712
      }
    },
    {
      "id": "judu:stop:7093",
      "stopId": "7093",
      "name": "Skersinės st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5115",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26",
        "87"
      ],
      "wgs84": {
        "latitude": 54.76453,
        "longitude": 25.2716
      },
      "lks94": {
        "easting": 581832.184,
        "northing": 6070545.025
      }
    },
    {
      "id": "judu:stop:7094",
      "stopId": "7094",
      "name": "Vanaginė",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5107",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26",
        "87"
      ],
      "wgs84": {
        "latitude": 54.7738,
        "longitude": 25.27197
      },
      "lks94": {
        "easting": 581837.283,
        "northing": 6071577.095
      }
    },
    {
      "id": "judu:stop:7095",
      "stopId": "7095",
      "name": "Vanaginė",
      "description": "link Riešės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5106",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26",
        "87"
      ],
      "wgs84": {
        "latitude": 54.77539,
        "longitude": 25.27291
      },
      "lks94": {
        "easting": 581894.547,
        "northing": 6071755.14
      }
    },
    {
      "id": "judu:stop:7097",
      "stopId": "7097",
      "name": "Kiparisų st.",
      "description": "link Molėtų pl.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5125",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26",
        "87"
      ],
      "wgs84": {
        "latitude": 54.78219,
        "longitude": 25.27196
      },
      "lks94": {
        "easting": 581819.704,
        "northing": 6072510.79
      }
    },
    {
      "id": "judu:stop:7098",
      "stopId": "7098",
      "name": "Kiparisų st.",
      "description": "link Riešės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5126",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26",
        "87"
      ],
      "wgs84": {
        "latitude": 54.78325,
        "longitude": 25.27173
      },
      "lks94": {
        "easting": 581802.77,
        "northing": 6072628.487
      }
    },
    {
      "id": "judu:stop:7099",
      "stopId": "7099",
      "name": "Samanų st.",
      "description": "link Molėtų pl.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5127",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26",
        "87"
      ],
      "wgs84": {
        "latitude": 54.78641,
        "longitude": 25.26938
      },
      "lks94": {
        "easting": 581645.251,
        "northing": 6072977.419
      }
    },
    {
      "id": "judu:stop:7100",
      "stopId": "7100",
      "name": "Samanų st.",
      "description": "link Riešės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5128",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26",
        "87"
      ],
      "wgs84": {
        "latitude": 54.78714,
        "longitude": 25.26907
      },
      "lks94": {
        "easting": 581623.842,
        "northing": 6073058.298
      }
    },
    {
      "id": "judu:stop:7101",
      "stopId": "7101",
      "name": "Lauko st.",
      "description": "link Molėtų pl.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5129",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26",
        "87"
      ],
      "wgs84": {
        "latitude": 54.79221,
        "longitude": 25.26597
      },
      "lks94": {
        "easting": 581414.28,
        "northing": 6073618.926
      }
    },
    {
      "id": "judu:stop:7102",
      "stopId": "7102",
      "name": "Lauko st.",
      "description": "link Riešės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5130",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26",
        "87"
      ],
      "wgs84": {
        "latitude": 54.79315,
        "longitude": 25.26582
      },
      "lks94": {
        "easting": 581402.746,
        "northing": 6073723.363
      }
    },
    {
      "id": "judu:stop:7103",
      "stopId": "7103",
      "name": "Kaštonų st.",
      "description": "link Molėtų pl.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5131",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26",
        "87"
      ],
      "wgs84": {
        "latitude": 54.79815,
        "longitude": 25.26213
      },
      "lks94": {
        "easting": 581155.444,
        "northing": 6074275.527
      }
    },
    {
      "id": "judu:stop:7104",
      "stopId": "7104",
      "name": "Kaštonų st.",
      "description": "link Riešės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5132",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26",
        "87"
      ],
      "wgs84": {
        "latitude": 54.79836,
        "longitude": 25.26211
      },
      "lks94": {
        "easting": 581153.737,
        "northing": 6074298.875
      }
    },
    {
      "id": "judu:stop:7106",
      "stopId": "7106",
      "name": "Didžioji Riešė",
      "description": "link Molėtų pl.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5101",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26",
        "87"
      ],
      "wgs84": {
        "latitude": 54.80607,
        "longitude": 25.25677
      },
      "lks94": {
        "easting": 580795.011,
        "northing": 6075150.742
      }
    },
    {
      "id": "judu:stop:7107",
      "stopId": "7107",
      "name": "Didžioji Riešė",
      "description": "link Riešės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5102",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26",
        "87"
      ],
      "wgs84": {
        "latitude": 54.80688,
        "longitude": 25.25676
      },
      "lks94": {
        "easting": 580792.752,
        "northing": 6075240.874
      }
    },
    {
      "id": "judu:stop:7108",
      "stopId": "7108",
      "name": "Beržų st.",
      "description": "link Molėtų pl.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5135",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "87"
      ],
      "wgs84": {
        "latitude": 54.80761,
        "longitude": 25.24898
      },
      "lks94": {
        "easting": 580291.182,
        "northing": 6075313.177
      }
    },
    {
      "id": "judu:stop:7109",
      "stopId": "7109",
      "name": "Riešės gimnazija",
      "description": "link Molėtų pl.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5104",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "87"
      ],
      "wgs84": {
        "latitude": 54.80852,
        "longitude": 25.23468
      },
      "lks94": {
        "easting": 579370.165,
        "northing": 6075398.165
      }
    },
    {
      "id": "judu:stop:7110",
      "stopId": "7110",
      "name": "Riešės gimnazija",
      "description": "link Bendorių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5103",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "87"
      ],
      "wgs84": {
        "latitude": 54.80876,
        "longitude": 25.2333
      },
      "lks94": {
        "easting": 579280.988,
        "northing": 6075423.313
      }
    },
    {
      "id": "judu:stop:7124",
      "stopId": "7124",
      "name": "Užupio st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0426",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "11"
      ],
      "wgs84": {
        "latitude": 54.67991,
        "longitude": 25.29266
      },
      "lks94": {
        "easting": 583360.871,
        "northing": 6061152.716
      }
    },
    {
      "id": "judu:stop:7171",
      "stopId": "7171",
      "name": "Žaros st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1637",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "21",
        "69"
      ],
      "wgs84": {
        "latitude": 54.66672,
        "longitude": 25.19581
      },
      "lks94": {
        "easting": 577140.533,
        "northing": 6059574.16
      }
    },
    {
      "id": "judu:stop:7180",
      "stopId": "7180",
      "name": "Kazbėjų žiedas",
      "description": "visos kryptys",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2822",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "25"
      ],
      "wgs84": {
        "latitude": 54.6166,
        "longitude": 25.13801
      },
      "lks94": {
        "easting": 573502.44,
        "northing": 6053934.478
      }
    },
    {
      "id": "judu:stop:7187",
      "stopId": "7187",
      "name": "Margirio st.",
      "description": "link A.Panerių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5123",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9"
      ],
      "wgs84": {
        "latitude": 54.61288,
        "longitude": 25.18688
      },
      "lks94": {
        "easting": 576665.731,
        "northing": 6053572.709
      }
    },
    {
      "id": "judu:stop:7188",
      "stopId": "7188",
      "name": "Margirio st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5118",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9"
      ],
      "wgs84": {
        "latitude": 54.61256,
        "longitude": 25.18706
      },
      "lks94": {
        "easting": 576677.959,
        "northing": 6053537.293
      }
    },
    {
      "id": "judu:stop:7189",
      "stopId": "7189",
      "name": "Agrastų st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5124",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9"
      ],
      "wgs84": {
        "latitude": 54.62943,
        "longitude": 25.17703
      },
      "lks94": {
        "easting": 575998.653,
        "northing": 6055403.8
      }
    },
    {
      "id": "judu:stop:7278",
      "stopId": "7278",
      "name": "Karaliaus Mindaugo tiltas",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0441",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "6",
        "10",
        "15",
        "17",
        "20",
        "33",
        "89",
        "N1",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.68822,
        "longitude": 25.289
      },
      "lks94": {
        "easting": 583107.88,
        "northing": 6062073.164
      }
    },
    {
      "id": "judu:stop:7319",
      "stopId": "7319",
      "name": "Girinaičių st.",
      "description": "link žiedo",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5180",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "39"
      ],
      "wgs84": {
        "latitude": 54.77542,
        "longitude": 25.38551
      },
      "lks94": {
        "easting": 589138.316,
        "northing": 6071895.783
      }
    },
    {
      "id": "judu:stop:7322",
      "stopId": "7322",
      "name": "Žvejų st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5182",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "33",
        "89"
      ],
      "wgs84": {
        "latitude": 54.69004,
        "longitude": 25.2887
      },
      "lks94": {
        "easting": 583084.82,
        "northing": 6062275.35
      }
    },
    {
      "id": "judu:stop:7323",
      "stopId": "7323",
      "name": "Žvejų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5183",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "33",
        "89"
      ],
      "wgs84": {
        "latitude": 54.6917,
        "longitude": 25.2891
      },
      "lks94": {
        "easting": 583107.215,
        "northing": 6062460.559
      }
    },
    {
      "id": "judu:stop:7324",
      "stopId": "7324",
      "name": "Rinktinės st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5184",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "33"
      ],
      "wgs84": {
        "latitude": 54.69508,
        "longitude": 25.28838
      },
      "lks94": {
        "easting": 583053.896,
        "northing": 6062835.854
      }
    },
    {
      "id": "judu:stop:7325",
      "stopId": "7325",
      "name": "Herkaus Manto st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5185",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "33"
      ],
      "wgs84": {
        "latitude": 54.7011,
        "longitude": 25.2866
      },
      "lks94": {
        "easting": 582926.877,
        "northing": 6063503.694
      }
    },
    {
      "id": "judu:stop:7326",
      "stopId": "7326",
      "name": "Herkaus Manto st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5186",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "33"
      ],
      "wgs84": {
        "latitude": 54.70068,
        "longitude": 25.28623
      },
      "lks94": {
        "easting": 582903.887,
        "northing": 6063456.517
      }
    },
    {
      "id": "judu:stop:7331",
      "stopId": "7331",
      "name": "Žygio st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5187",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "33",
        "50",
        "69"
      ],
      "wgs84": {
        "latitude": 54.7046,
        "longitude": 25.28946
      },
      "lks94": {
        "easting": 583104.051,
        "northing": 6063896.579
      }
    },
    {
      "id": "judu:stop:7337",
      "stopId": "7337",
      "name": "Rinktinės st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5188",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "33"
      ],
      "wgs84": {
        "latitude": 54.69506,
        "longitude": 25.28809
      },
      "lks94": {
        "easting": 583035.244,
        "northing": 6062833.286
      }
    },
    {
      "id": "judu:stop:7341",
      "stopId": "7341",
      "name": "Erfurto st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5189",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "7",
        "20",
        "21",
        "55",
        "62",
        "68",
        "69",
        "116"
      ],
      "wgs84": {
        "latitude": 54.67357,
        "longitude": 25.20062
      },
      "lks94": {
        "easting": 577437.772,
        "northing": 6060341.771
      }
    },
    {
      "id": "judu:stop:7342",
      "stopId": "7342",
      "name": "Sietyno st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5190",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "4G",
        "30",
        "32",
        "63"
      ],
      "wgs84": {
        "latitude": 54.69893,
        "longitude": 25.22087
      },
      "lks94": {
        "easting": 578694.716,
        "northing": 6063186.532
      }
    },
    {
      "id": "judu:stop:7343",
      "stopId": "7343",
      "name": "Prašiškės",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5191",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26",
        "87"
      ],
      "wgs84": {
        "latitude": 54.76817,
        "longitude": 25.27152
      },
      "lks94": {
        "easting": 581819.692,
        "northing": 6070950.019
      }
    },
    {
      "id": "judu:stop:7344",
      "stopId": "7344",
      "name": "Beržų st.",
      "description": "link Bendorių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5192",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "87"
      ],
      "wgs84": {
        "latitude": 54.80782,
        "longitude": 25.24738
      },
      "lks94": {
        "easting": 580187.915,
        "northing": 6075334.716
      }
    },
    {
      "id": "judu:stop:7350",
      "stopId": "7350",
      "name": "Erfurto st.",
      "description": "link Karoliniškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5193",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "21",
        "55",
        "68"
      ],
      "wgs84": {
        "latitude": 54.67448,
        "longitude": 25.2008
      },
      "lks94": {
        "easting": 577447.65,
        "northing": 6060443.241
      }
    },
    {
      "id": "judu:stop:7356",
      "stopId": "7356",
      "name": "Karklėnai",
      "description": "link Grigaičių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5194",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "58"
      ],
      "wgs84": {
        "latitude": 54.67551,
        "longitude": 25.41435
      },
      "lks94": {
        "easting": 591217.758,
        "northing": 6060814.345
      }
    },
    {
      "id": "judu:stop:7357",
      "stopId": "7357",
      "name": "Karklėnai",
      "description": "link N.Vilnios",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5195",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "58"
      ],
      "wgs84": {
        "latitude": 54.67511,
        "longitude": 25.4144
      },
      "lks94": {
        "easting": 591221.879,
        "northing": 6060769.896
      }
    },
    {
      "id": "judu:stop:7358",
      "stopId": "7358",
      "name": "Giraitės st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5196",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "24",
        "25",
        "123"
      ],
      "wgs84": {
        "latitude": 54.66898,
        "longitude": 25.23783
      },
      "lks94": {
        "easting": 579846.632,
        "northing": 6059872.636
      }
    },
    {
      "id": "judu:stop:7359",
      "stopId": "7359",
      "name": "Giraitės st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5197",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "24",
        "25",
        "123"
      ],
      "wgs84": {
        "latitude": 54.66873,
        "longitude": 25.23817
      },
      "lks94": {
        "easting": 579869.053,
        "northing": 6059845.201
      }
    },
    {
      "id": "judu:stop:7364",
      "stopId": "7364",
      "name": "Žemasis Pavilnys",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1421",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "13"
      ],
      "wgs84": {
        "latitude": 54.67924,
        "longitude": 25.35934
      },
      "lks94": {
        "easting": 587662.105,
        "northing": 6061159.364
      }
    },
    {
      "id": "judu:stop:7374",
      "stopId": "7374",
      "name": "Prašiškės",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5198",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26",
        "87"
      ],
      "wgs84": {
        "latitude": 54.7686,
        "longitude": 25.27183
      },
      "lks94": {
        "easting": 581838.771,
        "northing": 6070998.235
      }
    },
    {
      "id": "judu:stop:7381",
      "stopId": "7381",
      "name": "Nacionalinė dailės galerija",
      "description": "link Žirmūnų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0113",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "9",
        "19",
        "30",
        "43",
        "56",
        "63",
        "89"
      ],
      "wgs84": {
        "latitude": 54.69671,
        "longitude": 25.27311
      },
      "lks94": {
        "easting": 582066.298,
        "northing": 6062999.293
      }
    },
    {
      "id": "judu:stop:7382",
      "stopId": "7382",
      "name": "Nacionalinė dailės galerija",
      "description": "link Pilaitės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0114",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "9",
        "19",
        "30",
        "43",
        "46",
        "56",
        "63",
        "69",
        "89"
      ],
      "wgs84": {
        "latitude": 54.69793,
        "longitude": 25.27003
      },
      "lks94": {
        "easting": 581865.311,
        "northing": 6063131.466
      }
    },
    {
      "id": "judu:stop:7392",
      "stopId": "7392",
      "name": "Antežeriai",
      "description": "link Pašilaičių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4408",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32",
        "118"
      ],
      "wgs84": {
        "latitude": 54.73377,
        "longitude": 25.18649
      },
      "lks94": {
        "easting": 576413.209,
        "northing": 6067025.811
      }
    },
    {
      "id": "judu:stop:7393",
      "stopId": "7393",
      "name": "Antežeriai",
      "description": "link Zujūnų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4409",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32",
        "118"
      ],
      "wgs84": {
        "latitude": 54.73255,
        "longitude": 25.18527
      },
      "lks94": {
        "easting": 576336.935,
        "northing": 6066888.711
      }
    },
    {
      "id": "judu:stop:7395",
      "stopId": "7395",
      "name": "Naujosios Gineitiškės",
      "description": "link Pašilaičių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4411",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32",
        "118"
      ],
      "wgs84": {
        "latitude": 54.73583,
        "longitude": 25.20239
      },
      "lks94": {
        "easting": 577433.234,
        "northing": 6067272.496
      }
    },
    {
      "id": "judu:stop:7414",
      "stopId": "7414",
      "name": "Naujininkai",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1517",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "3G",
        "4",
        "4G",
        "7",
        "9",
        "11",
        "13",
        "14",
        "15",
        "26",
        "38",
        "41",
        "42",
        "43",
        "55",
        "57",
        "61",
        "65",
        "78",
        "114",
        "116",
        "122",
        "125",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.66192,
        "longitude": 25.2737
      },
      "lks94": {
        "easting": 582174.565,
        "northing": 6059128.334
      }
    },
    {
      "id": "judu:stop:7415",
      "stopId": "7415",
      "name": "Teodoro Narbuto st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1820",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "4G",
        "7",
        "9",
        "19",
        "21",
        "22",
        "30",
        "32",
        "49",
        "59",
        "63",
        "69",
        "116",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.70018,
        "longitude": 25.22967
      },
      "lks94": {
        "easting": 579259.48,
        "northing": 6063335.542
      }
    },
    {
      "id": "judu:stop:7416",
      "stopId": "7416",
      "name": "Teodoro Narbuto st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1718",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "4G",
        "7",
        "9",
        "19",
        "22",
        "30",
        "32",
        "49",
        "59",
        "63",
        "69",
        "73",
        "116",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.69995,
        "longitude": 25.23016
      },
      "lks94": {
        "easting": 579291.51,
        "northing": 6063310.499
      }
    },
    {
      "id": "judu:stop:7444",
      "stopId": "7444",
      "name": "Naujosios Vilnios žiedas",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2378",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "6G",
        "18",
        "67",
        "74",
        "115",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.68543,
        "longitude": 25.42889
      },
      "lks94": {
        "easting": 592132.975,
        "northing": 6061937.268
      }
    },
    {
      "id": "judu:stop:7470",
      "stopId": "7470",
      "name": "Balžio žiedas",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3558",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "39"
      ],
      "wgs84": {
        "latitude": 54.79419,
        "longitude": 25.43652
      },
      "lks94": {
        "easting": 592377.079,
        "northing": 6074050.645
      }
    },
    {
      "id": "judu:stop:7471",
      "stopId": "7471",
      "name": "Balžio st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3559",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "39"
      ],
      "wgs84": {
        "latitude": 54.793,
        "longitude": 25.42967
      },
      "lks94": {
        "easting": 591939.313,
        "northing": 6073909.211
      }
    },
    {
      "id": "judu:stop:7553",
      "stopId": "7553",
      "name": "Jankiškių st.",
      "description": "link žiedo",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2422",
      "modes": [
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "15",
        "18"
      ],
      "wgs84": {
        "latitude": 54.64537,
        "longitude": 25.19468
      },
      "lks94": {
        "easting": 577108.058,
        "northing": 6057196.943
      }
    },
    {
      "id": "judu:stop:7554",
      "stopId": "7554",
      "name": "Jankiškių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2423",
      "modes": [
        "trolleybus"
      ],
      "routeShortNames": [
        "15",
        "18"
      ],
      "wgs84": {
        "latitude": 54.64506,
        "longitude": 25.19522
      },
      "lks94": {
        "easting": 577143.497,
        "northing": 6057163.037
      }
    },
    {
      "id": "judu:stop:7560",
      "stopId": "7560",
      "name": "Oslo st.",
      "description": "link Lazdynėlių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1623",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "21",
        "69"
      ],
      "wgs84": {
        "latitude": 54.66953,
        "longitude": 25.19796
      },
      "lks94": {
        "easting": 577273.886,
        "northing": 6059889.241
      }
    },
    {
      "id": "judu:stop:7573",
      "stopId": "7573",
      "name": "Stotis",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0546",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1",
        "1G",
        "41",
        "53",
        "61",
        "89"
      ],
      "wgs84": {
        "latitude": 54.6714,
        "longitude": 25.283
      },
      "lks94": {
        "easting": 582755.259,
        "northing": 6060194.246
      }
    },
    {
      "id": "judu:stop:7586",
      "stopId": "7586",
      "name": "Alberto Kojelavičiaus st.",
      "description": "link Šiaurės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2376",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "27"
      ],
      "wgs84": {
        "latitude": 54.69511,
        "longitude": 25.3953
      },
      "lks94": {
        "easting": 589945.867,
        "northing": 6062970.94
      }
    },
    {
      "id": "judu:stop:7587",
      "stopId": "7587",
      "name": "Mildos st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2302",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "18",
        "27",
        "31",
        "37",
        "58",
        "67",
        "74",
        "115",
        "119"
      ],
      "wgs84": {
        "latitude": 54.69147,
        "longitude": 25.34376
      },
      "lks94": {
        "easting": 586631.381,
        "northing": 6062501.043
      }
    },
    {
      "id": "judu:stop:7588",
      "stopId": "7588",
      "name": "Mildos st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2301",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "37",
        "119"
      ],
      "wgs84": {
        "latitude": 54.69302,
        "longitude": 25.3421
      },
      "lks94": {
        "easting": 586521.07,
        "northing": 6062671.488
      }
    },
    {
      "id": "judu:stop:7589",
      "stopId": "7589",
      "name": "Povilo Lukšio st.",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0921",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3",
        "5",
        "7",
        "30",
        "33",
        "69",
        "114",
        "119"
      ],
      "wgs84": {
        "latitude": 54.71072,
        "longitude": 25.30239
      },
      "lks94": {
        "easting": 583924.687,
        "northing": 6064593.037
      }
    },
    {
      "id": "judu:stop:7603",
      "stopId": "7603",
      "name": "Skalvių st.",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3305",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3G",
        "5G",
        "7",
        "18",
        "32",
        "40",
        "46",
        "118",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.73455,
        "longitude": 25.21963
      },
      "lks94": {
        "easting": 578545.901,
        "northing": 6067149.209
      }
    },
    {
      "id": "judu:stop:7615",
      "stopId": "7615",
      "name": "Raudonbalė",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3910",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "52"
      ],
      "wgs84": {
        "latitude": 54.74939,
        "longitude": 25.18096
      },
      "lks94": {
        "easting": 576027.817,
        "northing": 6068758.131
      }
    },
    {
      "id": "judu:stop:7624",
      "stopId": "7624",
      "name": "Platiniškės",
      "description": "galinė st.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3610",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "117"
      ],
      "wgs84": {
        "latitude": 54.71351,
        "longitude": 25.13098
      },
      "lks94": {
        "easting": 572874.71,
        "northing": 6064712.06
      }
    },
    {
      "id": "judu:stop:7625",
      "stopId": "7625",
      "name": "Šventapilės st.",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3611",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "117"
      ],
      "wgs84": {
        "latitude": 54.70409,
        "longitude": 25.12483
      },
      "lks94": {
        "easting": 572495.252,
        "northing": 6063657.351
      }
    },
    {
      "id": "judu:stop:7653",
      "stopId": "7653",
      "name": "Polocko kryptis",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2380regio",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "67"
      ],
      "wgs84": {
        "latitude": 54.69237,
        "longitude": 25.46002
      },
      "lks94": {
        "easting": 594123.992,
        "northing": 6062750.873
      }
    },
    {
      "id": "judu:stop:7654",
      "stopId": "7654",
      "name": "Polocko kryptis",
      "description": "į miestą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2381regio",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "67"
      ],
      "wgs84": {
        "latitude": 54.69259,
        "longitude": 25.45939
      },
      "lks94": {
        "easting": 594082.871,
        "northing": 6062774.511
      }
    },
    {
      "id": "judu:stop:7663",
      "stopId": "7663",
      "name": "Lukiškės",
      "description": "link J.Tumo-Vaižganto g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0236",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "22",
        "123"
      ],
      "wgs84": {
        "latitude": 54.69037,
        "longitude": 25.27231
      },
      "lks94": {
        "easting": 582027.52,
        "northing": 6062292.801
      }
    },
    {
      "id": "judu:stop:7688",
      "stopId": "7688",
      "name": "Balstogės st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1318",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "33",
        "119"
      ],
      "wgs84": {
        "latitude": 54.67221,
        "longitude": 25.30501
      },
      "lks94": {
        "easting": 584173.178,
        "northing": 6060310.549
      }
    },
    {
      "id": "judu:stop:7689",
      "stopId": "7689",
      "name": "Balstogės st.",
      "description": "link Senamiesčio",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1319",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "12",
        "16",
        "19",
        "33",
        "42",
        "119"
      ],
      "wgs84": {
        "latitude": 54.67137,
        "longitude": 25.30457
      },
      "lks94": {
        "easting": 584146.536,
        "northing": 6060216.541
      }
    },
    {
      "id": "judu:stop:7691",
      "stopId": "7691",
      "name": "Žalgirio st.",
      "description": "link Žirmūnų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0711",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5",
        "69"
      ],
      "wgs84": {
        "latitude": 54.70378,
        "longitude": 25.28221
      },
      "lks94": {
        "easting": 582638.49,
        "northing": 6063796.765
      }
    },
    {
      "id": "judu:stop:7692",
      "stopId": "7692",
      "name": "Karveliškių kapinės",
      "description": "išlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5144a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "63"
      ],
      "wgs84": {
        "latitude": 54.70928,
        "longitude": 25.10079
      },
      "lks94": {
        "easting": 570936.881,
        "northing": 6064210.379
      }
    },
    {
      "id": "judu:stop:7693",
      "stopId": "7693",
      "name": "Bitėnų st.",
      "description": "išlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3612",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "4G",
        "30",
        "54",
        "75",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.70178,
        "longitude": 25.17195
      },
      "lks94": {
        "easting": 575536.289,
        "northing": 6063449.96
      }
    },
    {
      "id": "judu:stop:7694",
      "stopId": "7694",
      "name": "Bitėnų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3613",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "4G",
        "30",
        "54",
        "75",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.70169,
        "longitude": 25.17235
      },
      "lks94": {
        "easting": 575562.237,
        "northing": 6063440.375
      }
    },
    {
      "id": "judu:stop:7695",
      "stopId": "7695",
      "name": "Gilužio st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3614",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "4G",
        "30",
        "54",
        "75",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.70451,
        "longitude": 25.17449
      },
      "lks94": {
        "easting": 575694.91,
        "northing": 6063756.513
      }
    },
    {
      "id": "judu:stop:7699",
      "stopId": "7699",
      "name": "Kriaučiūnai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3616",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "63"
      ],
      "wgs84": {
        "latitude": 54.712,
        "longitude": 25.15055
      },
      "lks94": {
        "easting": 574138.402,
        "northing": 6064564.51
      }
    },
    {
      "id": "judu:stop:7700",
      "stopId": "7700",
      "name": "Papiškės",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3617",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "63"
      ],
      "wgs84": {
        "latitude": 54.71607,
        "longitude": 25.13202
      },
      "lks94": {
        "easting": 572937.124,
        "northing": 6064998.039
      }
    },
    {
      "id": "judu:stop:7701",
      "stopId": "7701",
      "name": "Papiškės",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3618",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "63"
      ],
      "wgs84": {
        "latitude": 54.71643,
        "longitude": 25.12997
      },
      "lks94": {
        "easting": 572804.401,
        "northing": 6065035.975
      }
    },
    {
      "id": "judu:stop:7702",
      "stopId": "7702",
      "name": "Vaivadiškės",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3619",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "63"
      ],
      "wgs84": {
        "latitude": 54.71746,
        "longitude": 25.11279
      },
      "lks94": {
        "easting": 571695.716,
        "northing": 6065132.916
      }
    },
    {
      "id": "judu:stop:7703",
      "stopId": "7703",
      "name": "Vaivadiškės",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3620",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "63"
      ],
      "wgs84": {
        "latitude": 54.7172,
        "longitude": 25.11156
      },
      "lks94": {
        "easting": 571616.93,
        "northing": 6065102.726
      }
    },
    {
      "id": "judu:stop:7710",
      "stopId": "7710",
      "name": "Guriai",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1422",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "33",
        "58",
        "122"
      ],
      "wgs84": {
        "latitude": 54.66245,
        "longitude": 25.34243
      },
      "lks94": {
        "easting": 586607.39,
        "northing": 6059269.906
      }
    },
    {
      "id": "judu:stop:7711",
      "stopId": "7711",
      "name": "Pranciškaus Baltraus Šivickio st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1423",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "33",
        "58",
        "122"
      ],
      "wgs84": {
        "latitude": 54.66124,
        "longitude": 25.34986
      },
      "lks94": {
        "easting": 587089.298,
        "northing": 6059144.439
      }
    },
    {
      "id": "judu:stop:7712",
      "stopId": "7712",
      "name": "Pranciškaus Baltraus Šivickio st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1424",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "33",
        "58",
        "122"
      ],
      "wgs84": {
        "latitude": 54.66132,
        "longitude": 25.34958
      },
      "lks94": {
        "easting": 587071.063,
        "northing": 6059152.995
      }
    },
    {
      "id": "judu:stop:7714",
      "stopId": "7714",
      "name": "Gurių sodai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1425",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "33",
        "58"
      ],
      "wgs84": {
        "latitude": 54.65986,
        "longitude": 25.35971
      },
      "lks94": {
        "easting": 587727.727,
        "northing": 6059003.126
      }
    },
    {
      "id": "judu:stop:7715",
      "stopId": "7715",
      "name": "Gurių sodai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1426",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "33",
        "58"
      ],
      "wgs84": {
        "latitude": 54.65997,
        "longitude": 25.35911
      },
      "lks94": {
        "easting": 587688.781,
        "northing": 6059014.618
      }
    },
    {
      "id": "judu:stop:7716",
      "stopId": "7716",
      "name": "Šumsko kryptis",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1427",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "33"
      ],
      "wgs84": {
        "latitude": 54.65889,
        "longitude": 25.3644
      },
      "lks94": {
        "easting": 588032.402,
        "northing": 6058901.049
      }
    },
    {
      "id": "judu:stop:7722",
      "stopId": "7722",
      "name": "Užutekio st.",
      "description": "link žiedo",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1649",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "49",
        "116"
      ],
      "wgs84": {
        "latitude": 54.65918,
        "longitude": 25.20776
      },
      "lks94": {
        "easting": 577925.81,
        "northing": 6058748.249
      }
    },
    {
      "id": "judu:stop:7723",
      "stopId": "7723",
      "name": "Užutekio st.",
      "description": "link Žvėryno",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1650",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "49",
        "116"
      ],
      "wgs84": {
        "latitude": 54.65907,
        "longitude": 25.2074
      },
      "lks94": {
        "easting": 577902.794,
        "northing": 6058735.608
      }
    },
    {
      "id": "judu:stop:7724",
      "stopId": "7724",
      "name": "Bičiulių st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3110",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.60393,
        "longitude": 25.13419
      },
      "lks94": {
        "easting": 573278.48,
        "northing": 6052520.484
      }
    },
    {
      "id": "judu:stop:7725",
      "stopId": "7725",
      "name": "Bičiulių st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3111",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.60313,
        "longitude": 25.13479
      },
      "lks94": {
        "easting": 573318.681,
        "northing": 6052432.08
      }
    },
    {
      "id": "judu:stop:7726",
      "stopId": "7726",
      "name": "Metropolis",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3114",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.60831,
        "longitude": 25.12912
      },
      "lks94": {
        "easting": 572943.097,
        "northing": 6053002.646
      }
    },
    {
      "id": "judu:stop:7727",
      "stopId": "7727",
      "name": "Metropolis",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3115",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.6087,
        "longitude": 25.12891
      },
      "lks94": {
        "easting": 572928.833,
        "northing": 6053045.83
      }
    },
    {
      "id": "judu:stop:7728",
      "stopId": "7728",
      "name": "Panerių miškas",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5199",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "51",
        "78"
      ],
      "wgs84": {
        "latitude": 54.61641,
        "longitude": 25.2278
      },
      "lks94": {
        "easting": 579301.936,
        "northing": 6054010.96
      }
    },
    {
      "id": "judu:stop:7729",
      "stopId": "7729",
      "name": "Panerių miškas",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5200",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "51",
        "78"
      ],
      "wgs84": {
        "latitude": 54.61701,
        "longitude": 25.22945
      },
      "lks94": {
        "easting": 579407.334,
        "northing": 6054079.595
      }
    },
    {
      "id": "judu:stop:7730",
      "stopId": "7730",
      "name": "Elektrinės st.",
      "description": "link Gariūnų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2932",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20"
      ],
      "wgs84": {
        "latitude": 54.66746,
        "longitude": 25.16205
      },
      "lks94": {
        "easting": 574961.446,
        "northing": 6059619.952
      }
    },
    {
      "id": "judu:stop:7731",
      "stopId": "7731",
      "name": "Elektrinės st.",
      "description": "iš Gariūnų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2944",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20"
      ],
      "wgs84": {
        "latitude": 54.66774,
        "longitude": 25.16234
      },
      "lks94": {
        "easting": 574979.637,
        "northing": 6059651.422
      }
    },
    {
      "id": "judu:stop:7769",
      "stopId": "7769",
      "name": "Šnipiškės",
      "description": "link Žalgirio g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0115",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5",
        "49"
      ],
      "wgs84": {
        "latitude": 54.69983,
        "longitude": 25.26892
      },
      "lks94": {
        "easting": 581789.943,
        "northing": 6063341.617
      }
    },
    {
      "id": "judu:stop:7804",
      "stopId": "7804",
      "name": "Emilijos Pliaterytės st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3112",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.61762,
        "longitude": 25.11657
      },
      "lks94": {
        "easting": 572115.916,
        "northing": 6054025.776
      }
    },
    {
      "id": "judu:stop:7805",
      "stopId": "7805",
      "name": "Emilijos Pliaterytės st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3113",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.617,
        "longitude": 25.11674
      },
      "lks94": {
        "easting": 572127.992,
        "northing": 6053956.952
      }
    },
    {
      "id": "judu:stop:7809",
      "stopId": "7809",
      "name": "Vėtrungių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3833",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "40",
        "52",
        "125",
        "N4"
      ],
      "wgs84": {
        "latitude": 54.73729,
        "longitude": 25.23245
      },
      "lks94": {
        "easting": 579366.129,
        "northing": 6067468.564
      }
    },
    {
      "id": "judu:stop:7810",
      "stopId": "7810",
      "name": "Vėtrungių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3834",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "40"
      ],
      "wgs84": {
        "latitude": 54.73817,
        "longitude": 25.23175
      },
      "lks94": {
        "easting": 579319.334,
        "northing": 6067565.706
      }
    },
    {
      "id": "judu:stop:7811",
      "stopId": "7811",
      "name": "Liudviko Zamenhofo st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3835",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "40"
      ],
      "wgs84": {
        "latitude": 54.74106,
        "longitude": 25.22889
      },
      "lks94": {
        "easting": 579129.538,
        "northing": 6067884.099
      }
    },
    {
      "id": "judu:stop:7817",
      "stopId": "7817",
      "name": "Rodūnios kelias",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2644",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1"
      ],
      "wgs84": {
        "latitude": 54.6416,
        "longitude": 25.27772
      },
      "lks94": {
        "easting": 582475.045,
        "northing": 6056871.719
      }
    },
    {
      "id": "judu:stop:7818",
      "stopId": "7818",
      "name": "Ašmenėlės st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1428",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "33",
        "58",
        "122"
      ],
      "wgs84": {
        "latitude": 54.66035,
        "longitude": 25.35536
      },
      "lks94": {
        "easting": 587446.033,
        "northing": 6059052.23
      }
    },
    {
      "id": "judu:stop:7819",
      "stopId": "7819",
      "name": "Ašmenėlės st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1429",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "33",
        "58",
        "122"
      ],
      "wgs84": {
        "latitude": 54.66028,
        "longitude": 25.35559
      },
      "lks94": {
        "easting": 587461.022,
        "northing": 6059044.727
      }
    },
    {
      "id": "judu:stop:7820",
      "stopId": "7820",
      "name": "Rodūnios kelias",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2645",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1"
      ],
      "wgs84": {
        "latitude": 54.64221,
        "longitude": 25.27783
      },
      "lks94": {
        "easting": 582480.91,
        "northing": 6056939.733
      }
    },
    {
      "id": "judu:stop:7826",
      "stopId": "7826",
      "name": "Muzikų st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2134",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "55",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.75921,
        "longitude": 25.28157
      },
      "lks94": {
        "easting": 582484.573,
        "northing": 6069964.653
      }
    },
    {
      "id": "judu:stop:7827",
      "stopId": "7827",
      "name": "Muzikų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2135",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "55",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.75832,
        "longitude": 25.28103
      },
      "lks94": {
        "easting": 582451.629,
        "northing": 6069864.972
      }
    },
    {
      "id": "judu:stop:7830",
      "stopId": "7830",
      "name": "Santariškių žiedas",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2137",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1G",
        "55",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.7637,
        "longitude": 25.28215
      },
      "lks94": {
        "easting": 582512.767,
        "northing": 6070465.016
      }
    },
    {
      "id": "judu:stop:7831",
      "stopId": "7831",
      "name": "Vaikų ligoninė",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2138",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1G",
        "2G",
        "26",
        "48",
        "55",
        "75",
        "120",
        "121",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.75551,
        "longitude": 25.28054
      },
      "lks94": {
        "easting": 582425.801,
        "northing": 6069551.678
      }
    },
    {
      "id": "judu:stop:7840",
      "stopId": "7840",
      "name": "Gervėčių st.",
      "description": "link Olandų žiedo",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0443",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "7",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "19",
        "26",
        "38",
        "42",
        "58",
        "65",
        "78",
        "82",
        "89",
        "114"
      ],
      "wgs84": {
        "latitude": 54.6739,
        "longitude": 25.29923
      },
      "lks94": {
        "easting": 583796.909,
        "northing": 6060491.708
      }
    },
    {
      "id": "judu:stop:7841",
      "stopId": "7841",
      "name": "Gervėčių st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0444",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "4G",
        "7",
        "12",
        "13",
        "14",
        "15",
        "16",
        "19",
        "26",
        "38",
        "42",
        "58",
        "65",
        "78",
        "82",
        "89",
        "114",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.67365,
        "longitude": 25.29757
      },
      "lks94": {
        "easting": 583690.364,
        "northing": 6060461.907
      }
    },
    {
      "id": "judu:stop:7844",
      "stopId": "7844",
      "name": "Senosios Gineitiškės",
      "description": "link Antežerių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4412",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32",
        "118"
      ],
      "wgs84": {
        "latitude": 54.7359,
        "longitude": 25.18928
      },
      "lks94": {
        "easting": 576588.866,
        "northing": 6067265.897
      }
    },
    {
      "id": "judu:stop:7845",
      "stopId": "7845",
      "name": "Senosios Gineitiškės",
      "description": "link Pašilaičių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4413",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32",
        "118"
      ],
      "wgs84": {
        "latitude": 54.73565,
        "longitude": 25.19373
      },
      "lks94": {
        "easting": 576875.903,
        "northing": 6067242.941
      }
    },
    {
      "id": "judu:stop:7851",
      "stopId": "7851",
      "name": "Vienaragių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0522a",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "3G",
        "4",
        "4G",
        "7",
        "9",
        "10",
        "11",
        "17",
        "41",
        "42",
        "43",
        "55",
        "57",
        "61",
        "78",
        "116",
        "125"
      ],
      "wgs84": {
        "latitude": 54.67111,
        "longitude": 25.26955
      },
      "lks94": {
        "easting": 581888.346,
        "northing": 6060146.205
      }
    },
    {
      "id": "judu:stop:7852",
      "stopId": "7852",
      "name": "Savanorių prospektas",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0603",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "4",
        "4G",
        "6",
        "7",
        "12",
        "15",
        "16",
        "21",
        "22",
        "29",
        "54",
        "55",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.6734,
        "longitude": 25.247
      },
      "lks94": {
        "easting": 580429.38,
        "northing": 6060374.988
      }
    },
    {
      "id": "judu:stop:7853",
      "stopId": "7853",
      "name": "Savanorių prospektas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0602a",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "2G",
        "4",
        "4G",
        "6",
        "7",
        "12",
        "15",
        "16",
        "21",
        "22",
        "29",
        "54",
        "55",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.67403,
        "longitude": 25.2486
      },
      "lks94": {
        "easting": 580531.325,
        "northing": 6060446.932
      }
    },
    {
      "id": "judu:stop:7874",
      "stopId": "7874",
      "name": "Kuprioniškės",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5178",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "61"
      ],
      "wgs84": {
        "latitude": 54.64132,
        "longitude": 25.33186
      },
      "lks94": {
        "easting": 585970.094,
        "northing": 6056905.471
      }
    },
    {
      "id": "judu:stop:7896",
      "stopId": "7896",
      "name": "Jurgio Baltrušaičio st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3326",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G",
        "3G-A",
        "5",
        "24",
        "57",
        "87",
        "125"
      ],
      "wgs84": {
        "latitude": 54.72934,
        "longitude": 25.23892
      },
      "lks94": {
        "easting": 579798.378,
        "northing": 6066591.165
      }
    },
    {
      "id": "judu:stop:7897",
      "stopId": "7897",
      "name": "Jurgio Baltrušaičio st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3327",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G",
        "3G-A",
        "5",
        "24",
        "57",
        "87",
        "125"
      ],
      "wgs84": {
        "latitude": 54.72903,
        "longitude": 25.23961
      },
      "lks94": {
        "easting": 579843.428,
        "northing": 6066557.451
      }
    },
    {
      "id": "judu:stop:7898",
      "stopId": "7898",
      "name": "Juliaus Juzeliūno st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3328",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "40",
        "46",
        "125"
      ],
      "wgs84": {
        "latitude": 54.73054,
        "longitude": 25.23504
      },
      "lks94": {
        "easting": 579546.131,
        "northing": 6066720.305
      }
    },
    {
      "id": "judu:stop:7910",
      "stopId": "7910",
      "name": "Chemijos st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2810a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8"
      ],
      "wgs84": {
        "latitude": 54.62689,
        "longitude": 25.14704
      },
      "lks94": {
        "easting": 574066.955,
        "northing": 6055089.103
      }
    },
    {
      "id": "judu:stop:7914",
      "stopId": "7914",
      "name": "Stotis",
      "description": "\"H\" stotelė",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0530h",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "41",
        "42",
        "78"
      ],
      "wgs84": {
        "latitude": 54.67077,
        "longitude": 25.28326
      },
      "lks94": {
        "easting": 582773.309,
        "northing": 6060124.442
      }
    },
    {
      "id": "judu:stop:7936",
      "stopId": "7936",
      "name": "Laurų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3560",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "121"
      ],
      "wgs84": {
        "latitude": 54.78949,
        "longitude": 25.38327
      },
      "lks94": {
        "easting": 588963.323,
        "northing": 6073458.738
      }
    },
    {
      "id": "judu:stop:7941",
      "stopId": "7941",
      "name": "Burbiškės",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2402",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "13",
        "20",
        "28",
        "29",
        "51",
        "56",
        "62",
        "73",
        "123",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.6668,
        "longitude": 25.25275
      },
      "lks94": {
        "easting": 580813.329,
        "northing": 6059647.099
      }
    },
    {
      "id": "judu:stop:7947",
      "stopId": "7947",
      "name": "Smalinės st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3622",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "30",
        "54",
        "63",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.70932,
        "longitude": 25.18742
      },
      "lks94": {
        "easting": 576519.142,
        "northing": 6064305.828
      }
    },
    {
      "id": "judu:stop:7948",
      "stopId": "7948",
      "name": "Įsruties st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3623",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "30",
        "54",
        "63",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.71045,
        "longitude": 25.18122
      },
      "lks94": {
        "easting": 576117.507,
        "northing": 6064424.842
      }
    },
    {
      "id": "judu:stop:7949",
      "stopId": "7949",
      "name": "Įsruties st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3624",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "30",
        "54",
        "63",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.70994,
        "longitude": 25.18293
      },
      "lks94": {
        "easting": 576228.65,
        "northing": 6064369.941
      }
    },
    {
      "id": "judu:stop:7950",
      "stopId": "7950",
      "name": "Pajautos st.",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3625",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "63",
        "118"
      ],
      "wgs84": {
        "latitude": 54.7105,
        "longitude": 25.17406
      },
      "lks94": {
        "easting": 575656.047,
        "northing": 6064422.665
      }
    },
    {
      "id": "judu:stop:7951",
      "stopId": "7951",
      "name": "Pajautos st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3626",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "30",
        "54",
        "63",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.71018,
        "longitude": 25.17608
      },
      "lks94": {
        "easting": 575786.806,
        "northing": 6064389.232
      }
    },
    {
      "id": "judu:stop:7959",
      "stopId": "7959",
      "name": "Pajautos st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3627",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "30",
        "54",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.70977,
        "longitude": 25.17488
      },
      "lks94": {
        "easting": 575710.245,
        "northing": 6064342.309
      }
    },
    {
      "id": "judu:stop:7968",
      "stopId": "7968",
      "name": "Akademijos st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2144",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "49",
        "50",
        "57",
        "125",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.75352,
        "longitude": 25.26838
      },
      "lks94": {
        "easting": 581647.134,
        "northing": 6069315.995
      }
    },
    {
      "id": "judu:stop:7980",
      "stopId": "7980",
      "name": "Akademijos st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2143",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "34",
        "87",
        "125"
      ],
      "wgs84": {
        "latitude": 54.75391,
        "longitude": 25.27025
      },
      "lks94": {
        "easting": 581766.715,
        "northing": 6069361.575
      }
    },
    {
      "id": "judu:stop:8001",
      "stopId": "8001",
      "name": "Ąžuolų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4414",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32"
      ],
      "wgs84": {
        "latitude": 54.7205,
        "longitude": 25.19473
      },
      "lks94": {
        "easting": 576969.006,
        "northing": 6065558.021
      }
    },
    {
      "id": "judu:stop:8002",
      "stopId": "8002",
      "name": "Ąžuolų st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4415",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32"
      ],
      "wgs84": {
        "latitude": 54.72171,
        "longitude": 25.19339
      },
      "lks94": {
        "easting": 576880.392,
        "northing": 6065691.211
      }
    },
    {
      "id": "judu:stop:8004",
      "stopId": "8004",
      "name": "Kryžiokai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2223",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "36",
        "65",
        "66",
        "76",
        "120"
      ],
      "wgs84": {
        "latitude": 54.79219,
        "longitude": 25.35118
      },
      "lks94": {
        "easting": 586893.832,
        "northing": 6073718.971
      }
    },
    {
      "id": "judu:stop:8005",
      "stopId": "8005",
      "name": "Krakiškės",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2238",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "36",
        "65",
        "66",
        "76",
        "120"
      ],
      "wgs84": {
        "latitude": 54.79594,
        "longitude": 25.34992
      },
      "lks94": {
        "easting": 586804.772,
        "northing": 6074134.736
      }
    },
    {
      "id": "judu:stop:8006",
      "stopId": "8006",
      "name": "Naujaneriai",
      "description": "link miesto, Birelių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2226",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "36",
        "65",
        "76"
      ],
      "wgs84": {
        "latitude": 54.80173,
        "longitude": 25.34841
      },
      "lks94": {
        "easting": 586695.286,
        "northing": 6074777.221
      }
    },
    {
      "id": "judu:stop:8008",
      "stopId": "8008",
      "name": "Paežerys",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2228",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "36",
        "65",
        "76"
      ],
      "wgs84": {
        "latitude": 54.8003,
        "longitude": 25.33611
      },
      "lks94": {
        "easting": 585907.545,
        "northing": 6074602.939
      }
    },
    {
      "id": "judu:stop:8009",
      "stopId": "8009",
      "name": "Diemedis",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2230",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "36",
        "65",
        "76"
      ],
      "wgs84": {
        "latitude": 54.80323,
        "longitude": 25.32958
      },
      "lks94": {
        "easting": 585481.528,
        "northing": 6074921.03
      }
    },
    {
      "id": "judu:stop:8010",
      "stopId": "8010",
      "name": "Sakališkės",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2237",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "76"
      ],
      "wgs84": {
        "latitude": 54.81469,
        "longitude": 25.32187
      },
      "lks94": {
        "easting": 584961.815,
        "northing": 6076187.014
      }
    },
    {
      "id": "judu:stop:8011",
      "stopId": "8011",
      "name": "Pagubė",
      "description": "į miestą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2235",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "36",
        "65"
      ],
      "wgs84": {
        "latitude": 54.80796,
        "longitude": 25.3132
      },
      "lks94": {
        "easting": 584418.624,
        "northing": 6075427.572
      }
    },
    {
      "id": "judu:stop:8012",
      "stopId": "8012",
      "name": "Gulbinų st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2233",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "36",
        "65"
      ],
      "wgs84": {
        "latitude": 54.80584,
        "longitude": 25.31892
      },
      "lks94": {
        "easting": 584790.75,
        "northing": 6075198.545
      }
    },
    {
      "id": "judu:stop:8016",
      "stopId": "8016",
      "name": "Gulbinų st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2234",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "36",
        "65"
      ],
      "wgs84": {
        "latitude": 54.8056,
        "longitude": 25.31976
      },
      "lks94": {
        "easting": 584845.252,
        "northing": 6075172.852
      }
    },
    {
      "id": "judu:stop:8017",
      "stopId": "8017",
      "name": "Diemedis",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2231",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "36",
        "65",
        "76"
      ],
      "wgs84": {
        "latitude": 54.80289,
        "longitude": 25.32974
      },
      "lks94": {
        "easting": 585492.532,
        "northing": 6074883.387
      }
    },
    {
      "id": "judu:stop:8018",
      "stopId": "8018",
      "name": "Paežerys",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2229",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "36",
        "65",
        "76"
      ],
      "wgs84": {
        "latitude": 54.80012,
        "longitude": 25.33534
      },
      "lks94": {
        "easting": 585858.421,
        "northing": 6074581.964
      }
    },
    {
      "id": "judu:stop:8021",
      "stopId": "8021",
      "name": "Krakiškės",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2239",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "36",
        "65",
        "66",
        "76",
        "120"
      ],
      "wgs84": {
        "latitude": 54.79522,
        "longitude": 25.35003
      },
      "lks94": {
        "easting": 586813.388,
        "northing": 6074054.746
      }
    },
    {
      "id": "judu:stop:8022",
      "stopId": "8022",
      "name": "Kryžiokai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2236",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "36",
        "65",
        "66",
        "76",
        "120"
      ],
      "wgs84": {
        "latitude": 54.79161,
        "longitude": 25.35127
      },
      "lks94": {
        "easting": 586900.864,
        "northing": 6073654.536
      }
    },
    {
      "id": "judu:stop:8024",
      "stopId": "8024",
      "name": "Bireliai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2244",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "76"
      ],
      "wgs84": {
        "latitude": 54.82099,
        "longitude": 25.32052
      },
      "lks94": {
        "easting": 584861.841,
        "northing": 6076886.493
      }
    },
    {
      "id": "judu:stop:8025",
      "stopId": "8025",
      "name": "Birelių žiedas",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2245",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "76"
      ],
      "wgs84": {
        "latitude": 54.82336,
        "longitude": 25.3303
      },
      "lks94": {
        "easting": 585485.299,
        "northing": 6077162.131
      }
    },
    {
      "id": "judu:stop:8043",
      "stopId": "8043",
      "name": "Tarandė",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5006",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "52"
      ],
      "wgs84": {
        "latitude": 54.74938,
        "longitude": 25.20812
      },
      "lks94": {
        "easting": 577776.257,
        "northing": 6068786.791
      }
    },
    {
      "id": "judu:stop:8044",
      "stopId": "8044",
      "name": "Tarandė",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5007",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "52"
      ],
      "wgs84": {
        "latitude": 54.74919,
        "longitude": 25.20642
      },
      "lks94": {
        "easting": 577667.183,
        "northing": 6068763.762
      }
    },
    {
      "id": "judu:stop:8046",
      "stopId": "8046",
      "name": "Laidagalių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5009",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "52"
      ],
      "wgs84": {
        "latitude": 54.74664,
        "longitude": 25.18815
      },
      "lks94": {
        "easting": 576495.856,
        "northing": 6068459.903
      }
    },
    {
      "id": "judu:stop:8048",
      "stopId": "8048",
      "name": "Tomo Žebrausko st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5011",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "52"
      ],
      "wgs84": {
        "latitude": 54.74845,
        "longitude": 25.2022
      },
      "lks94": {
        "easting": 577396.932,
        "northing": 6068676.745
      }
    },
    {
      "id": "judu:stop:8060",
      "stopId": "8060",
      "name": "Pilaitė",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3602",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "4G",
        "30",
        "54",
        "63",
        "75",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.70247,
        "longitude": 25.20345
      },
      "lks94": {
        "easting": 577565.16,
        "northing": 6063561.101
      }
    },
    {
      "id": "judu:stop:8067",
      "stopId": "8067",
      "name": "Karaliaučiaus st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3628",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "30",
        "54",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.70798,
        "longitude": 25.1751
      },
      "lks94": {
        "easting": 575727.757,
        "northing": 6064143.34
      }
    },
    {
      "id": "judu:stop:8069",
      "stopId": "8069",
      "name": "Smalinės st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3629",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "30",
        "54",
        "63",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.70855,
        "longitude": 25.18792
      },
      "lks94": {
        "easting": 576552.812,
        "northing": 6064220.681
      }
    },
    {
      "id": "judu:stop:8085",
      "stopId": "8085",
      "name": "Juozapiškės",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2246",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "66",
        "120"
      ],
      "wgs84": {
        "latitude": 54.80947,
        "longitude": 25.35237
      },
      "lks94": {
        "easting": 586933.258,
        "northing": 6075643.489
      }
    },
    {
      "id": "judu:stop:8086",
      "stopId": "8086",
      "name": "Juozapiškės",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2247",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "66",
        "120"
      ],
      "wgs84": {
        "latitude": 54.80698,
        "longitude": 25.3528
      },
      "lks94": {
        "easting": 586966.246,
        "northing": 6075366.917
      }
    },
    {
      "id": "judu:stop:8090",
      "stopId": "8090",
      "name": "Naujaneriai",
      "description": "link Skirgiškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2227",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "66",
        "120"
      ],
      "wgs84": {
        "latitude": 54.80194,
        "longitude": 25.34928
      },
      "lks94": {
        "easting": 586750.769,
        "northing": 6074801.668
      }
    },
    {
      "id": "judu:stop:8094",
      "stopId": "8094",
      "name": "Chemijos institutas",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2106",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "49",
        "50",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.75508,
        "longitude": 25.26182
      },
      "lks94": {
        "easting": 581221.758,
        "northing": 6069481.989
      }
    },
    {
      "id": "judu:stop:8240",
      "stopId": "8240",
      "name": "Felikso Vaitkaus st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2611",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "4",
        "7",
        "43",
        "51",
        "55",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.64478,
        "longitude": 25.27357
      },
      "lks94": {
        "easting": 582200.767,
        "northing": 6057220.743
      }
    },
    {
      "id": "judu:stop:8250",
      "stopId": "8250",
      "name": "Lazerių st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1027",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18",
        "38",
        "114"
      ],
      "wgs84": {
        "latitude": 54.72937,
        "longitude": 25.37476
      },
      "lks94": {
        "easting": 588547.186,
        "northing": 6066757.451
      }
    },
    {
      "id": "judu:stop:8258",
      "stopId": "8258",
      "name": "Kaimelio žiedas",
      "description": "išlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3890",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "10"
      ],
      "wgs84": {
        "latitude": 54.73141,
        "longitude": 25.2443
      },
      "lks94": {
        "easting": 580140.799,
        "northing": 6066827.662
      }
    },
    {
      "id": "judu:stop:8262",
      "stopId": "8262",
      "name": "Stotis",
      "description": "\"I\" stotelė",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0530i",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1",
        "2",
        "3",
        "4",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.67066,
        "longitude": 25.28313
      },
      "lks94": {
        "easting": 582765.148,
        "northing": 6060112.047
      }
    },
    {
      "id": "judu:stop:8264",
      "stopId": "8264",
      "name": "Stotis",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0530p",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2",
        "3",
        "4",
        "12",
        "16",
        "19",
        "31",
        "34",
        "42",
        "58",
        "61",
        "74",
        "78",
        "82",
        "89"
      ],
      "wgs84": {
        "latitude": 54.67115,
        "longitude": 25.28513
      },
      "lks94": {
        "easting": 582893.148,
        "northing": 6060168.936
      }
    },
    {
      "id": "judu:stop:8266",
      "stopId": "8266",
      "name": "Žolyno st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1134",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "15"
      ],
      "wgs84": {
        "latitude": 54.70782,
        "longitude": 25.33774
      },
      "lks94": {
        "easting": 586208.621,
        "northing": 6064313.151
      }
    },
    {
      "id": "judu:stop:8268",
      "stopId": "8268",
      "name": "Jurgio Baltrušaičio st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3329",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "40",
        "48",
        "52",
        "55",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.72944,
        "longitude": 25.23738
      },
      "lks94": {
        "easting": 579698.996,
        "northing": 6066600.544
      }
    },
    {
      "id": "judu:stop:8269",
      "stopId": "8269",
      "name": "Kaimelio st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3839",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2G",
        "3G-A",
        "5",
        "24",
        "40",
        "52",
        "55",
        "57",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.73059,
        "longitude": 25.24448
      },
      "lks94": {
        "easting": 580154.01,
        "northing": 6066736.611
      }
    },
    {
      "id": "judu:stop:8270",
      "stopId": "8270",
      "name": "Kaimelio žiedas",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3840",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "48",
        "52"
      ],
      "wgs84": {
        "latitude": 54.73155,
        "longitude": 25.24488
      },
      "lks94": {
        "easting": 580177.876,
        "northing": 6066843.905
      }
    },
    {
      "id": "judu:stop:8275",
      "stopId": "8275",
      "name": "Pašilaičių žiedas",
      "description": "išlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3335",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "16",
        "19",
        "52"
      ],
      "wgs84": {
        "latitude": 54.72842,
        "longitude": 25.2343
      },
      "lks94": {
        "easting": 579502.622,
        "northing": 6066483.536
      }
    },
    {
      "id": "judu:stop:8309",
      "stopId": "8309",
      "name": "Burbiškės",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0527",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "13",
        "29",
        "56",
        "73",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.66671,
        "longitude": 25.2531
      },
      "lks94": {
        "easting": 580836.085,
        "northing": 6059637.486
      }
    },
    {
      "id": "judu:stop:8311",
      "stopId": "8311",
      "name": "Vilkpėdės žiedas",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2424",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "13",
        "29",
        "56",
        "73",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.66563,
        "longitude": 25.24565
      },
      "lks94": {
        "easting": 580357.651,
        "northing": 6059508.746
      }
    },
    {
      "id": "judu:stop:8312",
      "stopId": "8312",
      "name": "Vilkpėdės žiedas",
      "description": "išlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2425",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "N9"
      ],
      "wgs84": {
        "latitude": 54.66575,
        "longitude": 25.24501
      },
      "lks94": {
        "easting": 580316.129,
        "northing": 6059521.369
      }
    },
    {
      "id": "judu:stop:8315",
      "stopId": "8315",
      "name": "Balsiai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2222",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "36",
        "65",
        "66",
        "76",
        "120"
      ],
      "wgs84": {
        "latitude": 54.78618,
        "longitude": 25.34781
      },
      "lks94": {
        "easting": 586689.98,
        "northing": 6073045.964
      }
    },
    {
      "id": "judu:stop:8324",
      "stopId": "8324",
      "name": "Kooperatyvo st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5202",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26",
        "87"
      ],
      "wgs84": {
        "latitude": 54.8018,
        "longitude": 25.25981
      },
      "lks94": {
        "easting": 580998.975,
        "northing": 6074679.047
      }
    },
    {
      "id": "judu:stop:8325",
      "stopId": "8325",
      "name": "Kooperatyvo st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5201",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26",
        "87"
      ],
      "wgs84": {
        "latitude": 54.80107,
        "longitude": 25.26002
      },
      "lks94": {
        "easting": 581013.937,
        "northing": 6074598.049
      }
    },
    {
      "id": "judu:stop:8326",
      "stopId": "8326",
      "name": "Akademijos st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2141",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "34",
        "48",
        "49",
        "57",
        "87"
      ],
      "wgs84": {
        "latitude": 54.75263,
        "longitude": 25.27239
      },
      "lks94": {
        "easting": 581907.045,
        "northing": 6069221.624
      }
    },
    {
      "id": "judu:stop:8327",
      "stopId": "8327",
      "name": "Molėtų plentas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2117",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "34",
        "48",
        "49",
        "57",
        "87"
      ],
      "wgs84": {
        "latitude": 54.74975,
        "longitude": 25.2781
      },
      "lks94": {
        "easting": 582280.432,
        "northing": 6068907.798
      }
    },
    {
      "id": "judu:stop:8328",
      "stopId": "8328",
      "name": "Bijūnų st.",
      "description": "link Žvėryno",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1651",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "49",
        "116"
      ],
      "wgs84": {
        "latitude": 54.66729,
        "longitude": 25.21606
      },
      "lks94": {
        "easting": 578445.678,
        "northing": 6059660.026
      }
    },
    {
      "id": "judu:stop:8329",
      "stopId": "8329",
      "name": "Pupinė",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2646",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "19",
        "42",
        "82"
      ],
      "wgs84": {
        "latitude": 54.62137,
        "longitude": 25.29469
      },
      "lks94": {
        "easting": 583611.864,
        "northing": 6054640.478
      }
    },
    {
      "id": "judu:stop:8330",
      "stopId": "8330",
      "name": "Pupinė",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2647",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "19",
        "82"
      ],
      "wgs84": {
        "latitude": 54.62153,
        "longitude": 25.29581
      },
      "lks94": {
        "easting": 583683.862,
        "northing": 6054659.617
      }
    },
    {
      "id": "judu:stop:8331",
      "stopId": "8331",
      "name": "Žiedų st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1430",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "13"
      ],
      "wgs84": {
        "latitude": 54.67762,
        "longitude": 25.35552
      },
      "lks94": {
        "easting": 587419.254,
        "northing": 6060974.319
      }
    },
    {
      "id": "judu:stop:8332",
      "stopId": "8332",
      "name": "Žiedų st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1431",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "13"
      ],
      "wgs84": {
        "latitude": 54.67737,
        "longitude": 25.35472
      },
      "lks94": {
        "easting": 587368.201,
        "northing": 6060945.502
      }
    },
    {
      "id": "judu:stop:8333",
      "stopId": "8333",
      "name": "Žemoji st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1432",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "13"
      ],
      "wgs84": {
        "latitude": 54.67615,
        "longitude": 25.35091
      },
      "lks94": {
        "easting": 587125.115,
        "northing": 6060805
      }
    },
    {
      "id": "judu:stop:8335",
      "stopId": "8335",
      "name": "Žemoji st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1433",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "13"
      ],
      "wgs84": {
        "latitude": 54.67619,
        "longitude": 25.35063
      },
      "lks94": {
        "easting": 587106.972,
        "northing": 6060809.104
      }
    },
    {
      "id": "judu:stop:8336",
      "stopId": "8336",
      "name": "Markučiai",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1206",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "10",
        "13"
      ],
      "wgs84": {
        "latitude": 54.67437,
        "longitude": 25.32209
      },
      "lks94": {
        "easting": 585270.248,
        "northing": 6060571.533
      }
    },
    {
      "id": "judu:stop:8339",
      "stopId": "8339",
      "name": "Metalo st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2605",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "7",
        "9",
        "41",
        "42",
        "43",
        "55",
        "78"
      ],
      "wgs84": {
        "latitude": 54.64581,
        "longitude": 25.26501
      },
      "lks94": {
        "easting": 581646.239,
        "northing": 6057325.384
      }
    },
    {
      "id": "judu:stop:8342",
      "stopId": "8342",
      "name": "Verbų st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2387regio",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "67"
      ],
      "wgs84": {
        "latitude": 54.69446,
        "longitude": 25.44467
      },
      "lks94": {
        "easting": 593129.697,
        "northing": 6062962.983
      }
    },
    {
      "id": "judu:stop:8343",
      "stopId": "8343",
      "name": "Verbų st.",
      "description": "į miestą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2388regio",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "67"
      ],
      "wgs84": {
        "latitude": 54.69455,
        "longitude": 25.44464
      },
      "lks94": {
        "easting": 593127.557,
        "northing": 6062972.959
      }
    },
    {
      "id": "judu:stop:8344",
      "stopId": "8344",
      "name": "Tuputiškės",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1434",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "13"
      ],
      "wgs84": {
        "latitude": 54.67649,
        "longitude": 25.34376
      },
      "lks94": {
        "easting": 586663.289,
        "northing": 6060833.989
      }
    },
    {
      "id": "judu:stop:8345",
      "stopId": "8345",
      "name": "Tuputiškės",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1435",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "13"
      ],
      "wgs84": {
        "latitude": 54.67655,
        "longitude": 25.34235
      },
      "lks94": {
        "easting": 586572.232,
        "northing": 6060838.927
      }
    },
    {
      "id": "judu:stop:8347",
      "stopId": "8347",
      "name": "Dilgynė",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2630",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "4G",
        "7",
        "9",
        "41",
        "42",
        "43",
        "51",
        "55",
        "78"
      ],
      "wgs84": {
        "latitude": 54.6349,
        "longitude": 25.25412
      },
      "lks94": {
        "easting": 580965.091,
        "northing": 6056098.652
      }
    },
    {
      "id": "judu:stop:8363",
      "stopId": "8363",
      "name": "Pagubės sodai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2252",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "36",
        "65"
      ],
      "wgs84": {
        "latitude": 54.80621,
        "longitude": 25.32679
      },
      "lks94": {
        "easting": 585295.887,
        "northing": 6075249.269
      }
    },
    {
      "id": "judu:stop:8364",
      "stopId": "8364",
      "name": "Sakališkės",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2249",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "76"
      ],
      "wgs84": {
        "latitude": 54.81465,
        "longitude": 25.32173
      },
      "lks94": {
        "easting": 584952.901,
        "northing": 6076182.393
      }
    },
    {
      "id": "judu:stop:8365",
      "stopId": "8365",
      "name": "Liepkalnis",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1519",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "58"
      ],
      "wgs84": {
        "latitude": 54.66277,
        "longitude": 25.29962
      },
      "lks94": {
        "easting": 583844.986,
        "northing": 6059253.564
      }
    },
    {
      "id": "judu:stop:8367",
      "stopId": "8367",
      "name": "Pagubės sodai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2250",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "36",
        "65",
        "76"
      ],
      "wgs84": {
        "latitude": 54.80599,
        "longitude": 25.32749
      },
      "lks94": {
        "easting": 585341.349,
        "northing": 6075225.637
      }
    },
    {
      "id": "judu:stop:8368",
      "stopId": "8368",
      "name": "Pagubės sodai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2251",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "76"
      ],
      "wgs84": {
        "latitude": 54.80638,
        "longitude": 25.32727
      },
      "lks94": {
        "easting": 585326.385,
        "northing": 6075268.772
      }
    },
    {
      "id": "judu:stop:8370",
      "stopId": "8370",
      "name": "Padekaniškės",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3632",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "63"
      ],
      "wgs84": {
        "latitude": 54.71059,
        "longitude": 25.16035
      },
      "lks94": {
        "easting": 574772.454,
        "northing": 6064417.989
      }
    },
    {
      "id": "judu:stop:8371",
      "stopId": "8371",
      "name": "Padekaniškės",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3633",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "63",
        "118"
      ],
      "wgs84": {
        "latitude": 54.71045,
        "longitude": 25.16312
      },
      "lks94": {
        "easting": 574951.201,
        "northing": 6064405.363
      }
    },
    {
      "id": "judu:stop:8373",
      "stopId": "8373",
      "name": "Naujoji Vilnia",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2379",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "67"
      ],
      "wgs84": {
        "latitude": 54.69526,
        "longitude": 25.43904
      },
      "lks94": {
        "easting": 592764.963,
        "northing": 6063044.556
      }
    },
    {
      "id": "judu:stop:8374",
      "stopId": "8374",
      "name": "Titnago žiedas",
      "description": "išlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2421a",
      "modes": [
        "trolleybus"
      ],
      "routeShortNames": [
        "18"
      ],
      "wgs84": {
        "latitude": 54.65049,
        "longitude": 25.18459
      },
      "lks94": {
        "easting": 576447.242,
        "northing": 6057755.703
      }
    },
    {
      "id": "judu:stop:8441",
      "stopId": "8441",
      "name": "Skalvių žiedas",
      "description": "galinė st.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3330",
      "modes": [
        "trolleybus"
      ],
      "routeShortNames": [
        "18"
      ],
      "wgs84": {
        "latitude": 54.73482,
        "longitude": 25.21859
      },
      "lks94": {
        "easting": 578478.405,
        "northing": 6067178.093
      }
    },
    {
      "id": "judu:stop:8444",
      "stopId": "8444",
      "name": "Pagrandos st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5012",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "52"
      ],
      "wgs84": {
        "latitude": 54.74662,
        "longitude": 25.18268
      },
      "lks94": {
        "easting": 576143.739,
        "northing": 6068451.727
      }
    },
    {
      "id": "judu:stop:8445",
      "stopId": "8445",
      "name": "Pagrandos st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5013",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "52"
      ],
      "wgs84": {
        "latitude": 54.74587,
        "longitude": 25.18319
      },
      "lks94": {
        "easting": 576177.98,
        "northing": 6068368.814
      }
    },
    {
      "id": "judu:stop:8447",
      "stopId": "8447",
      "name": "Kelmiškių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5014",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "52"
      ],
      "wgs84": {
        "latitude": 54.74907,
        "longitude": 25.17862
      },
      "lks94": {
        "easting": 575877.778,
        "northing": 6068719.985
      }
    },
    {
      "id": "judu:stop:8460",
      "stopId": "8460",
      "name": "Ozo žiedas",
      "description": "link Pramogų arenos",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0825",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26"
      ],
      "wgs84": {
        "latitude": 54.71465,
        "longitude": 25.2777
      },
      "lks94": {
        "easting": 582325.814,
        "northing": 6065001.151
      }
    },
    {
      "id": "judu:stop:8462",
      "stopId": "8462",
      "name": "Ozo žiedas",
      "description": "išlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0827",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26"
      ],
      "wgs84": {
        "latitude": 54.71539,
        "longitude": 25.2773
      },
      "lks94": {
        "easting": 582298.544,
        "northing": 6065083.034
      }
    },
    {
      "id": "judu:stop:8463",
      "stopId": "8463",
      "name": "Licėjus",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2016",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5G",
        "7",
        "8",
        "24",
        "25",
        "26",
        "29",
        "46",
        "48",
        "53",
        "56",
        "87",
        "N4",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.71314,
        "longitude": 25.27692
      },
      "lks94": {
        "easting": 582278.617,
        "northing": 6064832.193
      }
    },
    {
      "id": "judu:stop:8472",
      "stopId": "8472",
      "name": "Vanaginės žiedas",
      "description": "visos kryptys",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5206",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26",
        "87"
      ],
      "wgs84": {
        "latitude": 54.78134,
        "longitude": 25.27287
      },
      "lks94": {
        "easting": 581879.954,
        "northing": 6072417.257
      }
    },
    {
      "id": "judu:stop:8716",
      "stopId": "8716",
      "name": "Vaikų ligoninė",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2147",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1G",
        "26",
        "55",
        "120",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.75613,
        "longitude": 25.28085
      },
      "lks94": {
        "easting": 582444.494,
        "northing": 6069621.041
      }
    },
    {
      "id": "judu:stop:8784",
      "stopId": "8784",
      "name": "Aukštieji Paneriai",
      "description": "link Kirtimų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2945",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "20",
        "51",
        "62"
      ],
      "wgs84": {
        "latitude": 54.63126,
        "longitude": 25.17376
      },
      "lks94": {
        "easting": 575784.122,
        "northing": 6055603.922
      }
    },
    {
      "id": "judu:stop:8821",
      "stopId": "8821",
      "name": "Ramybės st.",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0445",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31"
      ],
      "wgs84": {
        "latitude": 54.67203,
        "longitude": 25.29905
      },
      "lks94": {
        "easting": 583789.15,
        "northing": 6060283.389
      }
    },
    {
      "id": "judu:stop:8934",
      "stopId": "8934",
      "name": "Pilaitė",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3634",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "4G",
        "30",
        "32",
        "54",
        "63",
        "75",
        "117",
        "118",
        "N2"
      ],
      "wgs84": {
        "latitude": 54.70095,
        "longitude": 25.20542
      },
      "lks94": {
        "easting": 577695.03,
        "northing": 6063394.122
      }
    },
    {
      "id": "judu:stop:8944",
      "stopId": "8944",
      "name": "Šviesos st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4103",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "28",
        "29",
        "59",
        "68",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.66945,
        "longitude": 25.09672
      },
      "lks94": {
        "easting": 570743.859,
        "northing": 6059773.641
      }
    },
    {
      "id": "judu:stop:8945",
      "stopId": "8945",
      "name": "Kunigiškių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4107",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "28",
        "29",
        "59",
        "68",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.67045,
        "longitude": 25.09297
      },
      "lks94": {
        "easting": 570500.243,
        "northing": 6059881.158
      }
    },
    {
      "id": "judu:stop:9001",
      "stopId": "9001",
      "name": "Ąžuolynas",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2253",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "76"
      ],
      "wgs84": {
        "latitude": 54.81125,
        "longitude": 25.32378
      },
      "lks94": {
        "easting": 585091.801,
        "northing": 6075806.501
      }
    },
    {
      "id": "judu:stop:9002",
      "stopId": "9002",
      "name": "Ąžuolynas",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2254",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "76"
      ],
      "wgs84": {
        "latitude": 54.81099,
        "longitude": 25.32384
      },
      "lks94": {
        "easting": 585096.204,
        "northing": 6075777.639
      }
    },
    {
      "id": "judu:stop:9003",
      "stopId": "9003",
      "name": "Salininkai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2719",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "9",
        "82"
      ],
      "wgs84": {
        "latitude": 54.60589,
        "longitude": 25.2496
      },
      "lks94": {
        "easting": 580730.715,
        "northing": 6052865.058
      }
    },
    {
      "id": "judu:stop:9004",
      "stopId": "9004",
      "name": "Antano Tumėno st.",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0237",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "89"
      ],
      "wgs84": {
        "latitude": 54.69225,
        "longitude": 25.26124
      },
      "lks94": {
        "easting": 581310.101,
        "northing": 6062489.142
      }
    },
    {
      "id": "judu:stop:9007",
      "stopId": "9007",
      "name": "Nepriklausomybės aikštė",
      "description": "link Žaliojo tilto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0239",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "56",
        "123"
      ],
      "wgs84": {
        "latitude": 54.69118,
        "longitude": 25.26026
      },
      "lks94": {
        "easting": 581249.063,
        "northing": 6062368.931
      }
    },
    {
      "id": "judu:stop:9045",
      "stopId": "9045",
      "name": "Austėjos st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2255",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "65",
        "76",
        "120"
      ],
      "wgs84": {
        "latitude": 54.77823,
        "longitude": 25.34554
      },
      "lks94": {
        "easting": 586560.961,
        "northing": 6072158.428
      }
    },
    {
      "id": "judu:stop:9046",
      "stopId": "9046",
      "name": "Austėjos st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2256",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "65",
        "76",
        "120"
      ],
      "wgs84": {
        "latitude": 54.77817,
        "longitude": 25.34615
      },
      "lks94": {
        "easting": 586600.33,
        "northing": 6072152.504
      }
    },
    {
      "id": "judu:stop:9047",
      "stopId": "9047",
      "name": "Žalčių st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2257",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "65",
        "76",
        "120"
      ],
      "wgs84": {
        "latitude": 54.77816,
        "longitude": 25.35174
      },
      "lks94": {
        "easting": 586959.944,
        "northing": 6072158.309
      }
    },
    {
      "id": "judu:stop:9048",
      "stopId": "9048",
      "name": "Žalčių st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2258",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "65",
        "76",
        "120"
      ],
      "wgs84": {
        "latitude": 54.77804,
        "longitude": 25.35262
      },
      "lks94": {
        "easting": 587016.81,
        "northing": 6072146.046
      }
    },
    {
      "id": "judu:stop:9053",
      "stopId": "9053",
      "name": "Ragės st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2261",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "65",
        "76"
      ],
      "wgs84": {
        "latitude": 54.78495,
        "longitude": 25.35139
      },
      "lks94": {
        "easting": 586922.866,
        "northing": 6072913.513
      }
    },
    {
      "id": "judu:stop:9054",
      "stopId": "9054",
      "name": "Ragės st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2262",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "65",
        "76",
        "120"
      ],
      "wgs84": {
        "latitude": 54.78468,
        "longitude": 25.35194
      },
      "lks94": {
        "easting": 586958.82,
        "northing": 6072884.147
      }
    },
    {
      "id": "judu:stop:9081",
      "stopId": "9081",
      "name": "Balsių mokykla",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2259",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "65",
        "76",
        "120"
      ],
      "wgs84": {
        "latitude": 54.78058,
        "longitude": 25.3598
      },
      "lks94": {
        "easting": 587473.204,
        "northing": 6072437.647
      }
    },
    {
      "id": "judu:stop:9082",
      "stopId": "9082",
      "name": "Grigiškių poliklinika",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4105",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "28",
        "29",
        "59",
        "68",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.67194,
        "longitude": 25.08946
      },
      "lks94": {
        "easting": 570271.273,
        "northing": 6060043.46
      }
    },
    {
      "id": "judu:stop:9102",
      "stopId": "9102",
      "name": "Bijūnų st.",
      "description": "link žiedo",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1631",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "49",
        "116"
      ],
      "wgs84": {
        "latitude": 54.6674,
        "longitude": 25.21588
      },
      "lks94": {
        "easting": 578433.855,
        "northing": 6059672.066
      }
    },
    {
      "id": "judu:stop:9109",
      "stopId": "9109",
      "name": "Neravų st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4106",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "28",
        "29",
        "59",
        "68",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.66864,
        "longitude": 25.11174
      },
      "lks94": {
        "easting": 571714.11,
        "northing": 6059698.732
      }
    },
    {
      "id": "judu:stop:9115",
      "stopId": "9115",
      "name": "Fermentų st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2802a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "25"
      ],
      "wgs84": {
        "latitude": 54.62654,
        "longitude": 25.13932
      },
      "lks94": {
        "easting": 573569.111,
        "northing": 6055042.042
      }
    },
    {
      "id": "judu:stop:9152",
      "stopId": "9152",
      "name": "Perkūno st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3331",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G",
        "52",
        "87",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.73936,
        "longitude": 25.22774
      },
      "lks94": {
        "easting": 579058.803,
        "northing": 6067693.613
      }
    },
    {
      "id": "judu:stop:9153",
      "stopId": "9153",
      "name": "Perkūno st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3332",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G",
        "52",
        "87",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.73936,
        "longitude": 25.2272
      },
      "lks94": {
        "easting": 579024.032,
        "northing": 6067693.005
      }
    },
    {
      "id": "judu:stop:9200",
      "stopId": "9200",
      "name": "Baltoji Vokė",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5111",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "9",
        "51",
        "78"
      ],
      "wgs84": {
        "latitude": 54.60365,
        "longitude": 25.19329
      },
      "lks94": {
        "easting": 577097.203,
        "northing": 6052552.55
      }
    },
    {
      "id": "judu:stop:9201",
      "stopId": "9201",
      "name": "Baltoji Vokė",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5110",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "8",
        "9",
        "51",
        "78"
      ],
      "wgs84": {
        "latitude": 54.6024,
        "longitude": 25.19557
      },
      "lks94": {
        "easting": 577246.871,
        "northing": 6052415.946
      }
    },
    {
      "id": "judu:stop:9226",
      "stopId": "9226",
      "name": "Rodūnios sodų st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2648",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1"
      ],
      "wgs84": {
        "latitude": 54.63249,
        "longitude": 25.27778
      },
      "lks94": {
        "easting": 582497.359,
        "northing": 6055857.979
      }
    },
    {
      "id": "judu:stop:9276",
      "stopId": "9276",
      "name": "Paštas",
      "description": "visos kryptys",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2649",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1"
      ],
      "wgs84": {
        "latitude": 54.63595,
        "longitude": 25.27704
      },
      "lks94": {
        "easting": 582442.585,
        "northing": 6056242.158
      }
    },
    {
      "id": "judu:stop:9298",
      "stopId": "9298",
      "name": "Vilniaus Pergalė",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2823",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "25"
      ],
      "wgs84": {
        "latitude": 54.6141,
        "longitude": 25.15204
      },
      "lks94": {
        "easting": 574413.139,
        "northing": 6053671.027
      }
    },
    {
      "id": "judu:stop:9303",
      "stopId": "9303",
      "name": "Zuikių st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2946",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9"
      ],
      "wgs84": {
        "latitude": 54.63242,
        "longitude": 25.19844
      },
      "lks94": {
        "easting": 577375.315,
        "northing": 6055759.916
      }
    },
    {
      "id": "judu:stop:9308",
      "stopId": "9308",
      "name": "Vasarotojų st.",
      "description": "link Baltosios Vokės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2947",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9"
      ],
      "wgs84": {
        "latitude": 54.62322,
        "longitude": 25.1901
      },
      "lks94": {
        "easting": 576854.225,
        "northing": 6054726.927
      }
    },
    {
      "id": "judu:stop:9310",
      "stopId": "9310",
      "name": "Vasarotojų st.",
      "description": "link Ž. Panerių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2948",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9"
      ],
      "wgs84": {
        "latitude": 54.62365,
        "longitude": 25.18902
      },
      "lks94": {
        "easting": 576783.674,
        "northing": 6054773.599
      }
    },
    {
      "id": "judu:stop:9311",
      "stopId": "9311",
      "name": "Kadugių st.",
      "description": "link Baltosios Vokės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2949",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9"
      ],
      "wgs84": {
        "latitude": 54.62743,
        "longitude": 25.17996
      },
      "lks94": {
        "easting": 576191.567,
        "northing": 6055184.4
      }
    },
    {
      "id": "judu:stop:9312",
      "stopId": "9312",
      "name": "Kadugių st.",
      "description": "link Ž. Panerių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2950",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9"
      ],
      "wgs84": {
        "latitude": 54.62674,
        "longitude": 25.18154
      },
      "lks94": {
        "easting": 576294.876,
        "northing": 6055109.326
      }
    },
    {
      "id": "judu:stop:9313",
      "stopId": "9313",
      "name": "Bazilijonų st.",
      "description": "link Rotušės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0446",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "89"
      ],
      "wgs84": {
        "latitude": 54.67442,
        "longitude": 25.28595
      },
      "lks94": {
        "easting": 582939.372,
        "northing": 6060533.81
      }
    },
    {
      "id": "judu:stop:9384",
      "stopId": "9384",
      "name": "Pakalniškių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2408",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "6",
        "8",
        "12",
        "15",
        "18",
        "20",
        "24",
        "25",
        "28",
        "51",
        "62",
        "123",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.65453,
        "longitude": 25.22513
      },
      "lks94": {
        "easting": 579055.51,
        "northing": 6058250.178
      }
    },
    {
      "id": "judu:stop:9466",
      "stopId": "9466",
      "name": "Monikos Mironaitės st.",
      "description": "link Žvėryno",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1654",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "116"
      ],
      "wgs84": {
        "latitude": 54.68081,
        "longitude": 25.18967
      },
      "lks94": {
        "easting": 576717.9,
        "northing": 6061135.471
      }
    },
    {
      "id": "judu:stop:9468",
      "stopId": "9468",
      "name": "Vokės parkas",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2721",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "82"
      ],
      "wgs84": {
        "latitude": 54.59416,
        "longitude": 25.21924
      },
      "lks94": {
        "easting": 578792.044,
        "northing": 6051525.226
      }
    },
    {
      "id": "judu:stop:9479",
      "stopId": "9479",
      "name": "Juliaus Janonio st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3902",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "68"
      ],
      "wgs84": {
        "latitude": 54.64765,
        "longitude": 25.11084
      },
      "lks94": {
        "easting": 571693.005,
        "northing": 6057361.877
      }
    },
    {
      "id": "judu:stop:9481",
      "stopId": "9481",
      "name": "Bališkės",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3904",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "68"
      ],
      "wgs84": {
        "latitude": 54.64632,
        "longitude": 25.09966
      },
      "lks94": {
        "easting": 570973.8,
        "northing": 6057202.511
      }
    },
    {
      "id": "judu:stop:9482",
      "stopId": "9482",
      "name": "Bališkės",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3905",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "68"
      ],
      "wgs84": {
        "latitude": 54.64613,
        "longitude": 25.09864
      },
      "lks94": {
        "easting": 570908.301,
        "northing": 6057180.336
      }
    },
    {
      "id": "judu:stop:9483",
      "stopId": "9483",
      "name": "1-asis Lentvaris",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3906",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "68"
      ],
      "wgs84": {
        "latitude": 54.64437,
        "longitude": 25.06552
      },
      "lks94": {
        "easting": 568773.727,
        "northing": 6056951.539
      }
    },
    {
      "id": "judu:stop:9484",
      "stopId": "9484",
      "name": "Kranto st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4112",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "68"
      ],
      "wgs84": {
        "latitude": 54.67349,
        "longitude": 25.08072
      },
      "lks94": {
        "easting": 569704.901,
        "northing": 6060207.246
      }
    },
    {
      "id": "judu:stop:9485",
      "stopId": "9485",
      "name": "Žalioji st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4113",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "68"
      ],
      "wgs84": {
        "latitude": 54.66999,
        "longitude": 25.0772
      },
      "lks94": {
        "easting": 569483.85,
        "northing": 6059814.247
      }
    },
    {
      "id": "judu:stop:9496",
      "stopId": "9496",
      "name": "Bajorai",
      "description": "link Santariškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2148",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "57",
        "125"
      ],
      "wgs84": {
        "latitude": 54.75673,
        "longitude": 25.23716
      },
      "lks94": {
        "easting": 579631.27,
        "northing": 6069637.34
      }
    },
    {
      "id": "judu:stop:9561",
      "stopId": "9561",
      "name": "Papilėnų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3635",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "4G"
      ],
      "wgs84": {
        "latitude": 54.70753,
        "longitude": 25.18781
      },
      "lks94": {
        "easting": 576547.644,
        "northing": 6064107.048
      }
    },
    {
      "id": "judu:stop:9565",
      "stopId": "9565",
      "name": "Šiaurės miestelis",
      "description": "link Kalvarijų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0924",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "30",
        "33",
        "69"
      ],
      "wgs84": {
        "latitude": 54.71152,
        "longitude": 25.29786
      },
      "lks94": {
        "easting": 583631.149,
        "northing": 6064676.659
      }
    },
    {
      "id": "judu:stop:9566",
      "stopId": "9566",
      "name": "Šiaurės miestelis",
      "description": "link Žirmūnų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0925",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "30",
        "33",
        "69"
      ],
      "wgs84": {
        "latitude": 54.71119,
        "longitude": 25.29938
      },
      "lks94": {
        "easting": 583729.768,
        "northing": 6064641.746
      }
    },
    {
      "id": "judu:stop:9567",
      "stopId": "9567",
      "name": "Vokės parkas",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2725",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "82"
      ],
      "wgs84": {
        "latitude": 54.59525,
        "longitude": 25.21919
      },
      "lks94": {
        "easting": 578786.709,
        "northing": 6051646.471
      }
    },
    {
      "id": "judu:stop:9585",
      "stopId": "9585",
      "name": "Vilties st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4357",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "61"
      ],
      "wgs84": {
        "latitude": 54.64449,
        "longitude": 25.33474
      },
      "lks94": {
        "easting": 586149.281,
        "northing": 6057261.772
      }
    },
    {
      "id": "judu:stop:9593",
      "stopId": "9593",
      "name": "Kalnėnai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4016",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "58",
        "122"
      ],
      "wgs84": {
        "latitude": 54.6546,
        "longitude": 25.33164
      },
      "lks94": {
        "easting": 585927.875,
        "northing": 6058383.065
      }
    },
    {
      "id": "judu:stop:9599",
      "stopId": "9599",
      "name": "Juodupio st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4017",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "33",
        "122"
      ],
      "wgs84": {
        "latitude": 54.65328,
        "longitude": 25.34091
      },
      "lks94": {
        "easting": 586528.817,
        "northing": 6058247.55
      }
    },
    {
      "id": "judu:stop:9600",
      "stopId": "9600",
      "name": "Juodupio st.",
      "description": "link Gurių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4018",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "33",
        "122"
      ],
      "wgs84": {
        "latitude": 54.65322,
        "longitude": 25.34072
      },
      "lks94": {
        "easting": 586516.685,
        "northing": 6058240.639
      }
    },
    {
      "id": "judu:stop:9604",
      "stopId": "9604",
      "name": "Uosių sodai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2391",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "115",
        "119"
      ],
      "wgs84": {
        "latitude": 54.70754,
        "longitude": 25.38691
      },
      "lks94": {
        "easting": 589377.721,
        "northing": 6064343.494
      }
    },
    {
      "id": "judu:stop:9605",
      "stopId": "9605",
      "name": "Uosių sodai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2392",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "115",
        "119"
      ],
      "wgs84": {
        "latitude": 54.7077,
        "longitude": 25.38548
      },
      "lks94": {
        "easting": 589285.221,
        "northing": 6064359.48
      }
    },
    {
      "id": "judu:stop:9606",
      "stopId": "9606",
      "name": "Rokantiškių sodai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2393",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "115",
        "119"
      ],
      "wgs84": {
        "latitude": 54.7059,
        "longitude": 25.37578
      },
      "lks94": {
        "easting": 588664.085,
        "northing": 6064146.871
      }
    },
    {
      "id": "judu:stop:9607",
      "stopId": "9607",
      "name": "Rokantiškių sodai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2394",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "115",
        "119"
      ],
      "wgs84": {
        "latitude": 54.70606,
        "longitude": 25.37675
      },
      "lks94": {
        "easting": 588726.245,
        "northing": 6064165.902
      }
    },
    {
      "id": "judu:stop:9608",
      "stopId": "9608",
      "name": "Anapilio st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2395",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "115"
      ],
      "wgs84": {
        "latitude": 54.70764,
        "longitude": 25.35853
      },
      "lks94": {
        "easting": 587548.706,
        "northing": 6064318.854
      }
    },
    {
      "id": "judu:stop:9609",
      "stopId": "9609",
      "name": "Anapilio st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2396",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "115"
      ],
      "wgs84": {
        "latitude": 54.70771,
        "longitude": 25.3584
      },
      "lks94": {
        "easting": 587540.178,
        "northing": 6064326.481
      }
    },
    {
      "id": "judu:stop:9612",
      "stopId": "9612",
      "name": "Mileišiškių sodai",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2399",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "114",
        "115"
      ],
      "wgs84": {
        "latitude": 54.71312,
        "longitude": 25.34809
      },
      "lks94": {
        "easting": 586864.241,
        "northing": 6064915.727
      }
    },
    {
      "id": "judu:stop:9613",
      "stopId": "9613",
      "name": "Mileišiškių sodai",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2400",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "114",
        "115"
      ],
      "wgs84": {
        "latitude": 54.71297,
        "longitude": 25.34743
      },
      "lks94": {
        "easting": 586822.037,
        "northing": 6064898.217
      }
    },
    {
      "id": "judu:stop:9614",
      "stopId": "9614",
      "name": "Grigiškių žiedas",
      "description": "visos kryptys",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4114",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "28",
        "29",
        "59",
        "68",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.67362,
        "longitude": 25.08231
      },
      "lks94": {
        "easting": 569807.227,
        "northing": 6060223.293
      }
    },
    {
      "id": "judu:stop:9615",
      "stopId": "9615",
      "name": "Kranto st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4115",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "68"
      ],
      "wgs84": {
        "latitude": 54.67329,
        "longitude": 25.08022
      },
      "lks94": {
        "easting": 569672.995,
        "northing": 6060184.492
      }
    },
    {
      "id": "judu:stop:9616",
      "stopId": "9616",
      "name": "Žalioji st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4116",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "68"
      ],
      "wgs84": {
        "latitude": 54.66959,
        "longitude": 25.07668
      },
      "lks94": {
        "easting": 569450.992,
        "northing": 6059769.217
      }
    },
    {
      "id": "judu:stop:9618",
      "stopId": "9618",
      "name": "Lentvaris",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3003",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "68"
      ],
      "wgs84": {
        "latitude": 54.64505,
        "longitude": 25.05501
      },
      "lks94": {
        "easting": 568094.251,
        "northing": 6057016.977
      }
    },
    {
      "id": "judu:stop:9626",
      "stopId": "9626",
      "name": "Mūrinė Vokė",
      "description": "visos kryptys",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3911",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20",
        "62",
        "68"
      ],
      "wgs84": {
        "latitude": 54.64838,
        "longitude": 25.12157
      },
      "lks94": {
        "easting": 572384.187,
        "northing": 6057454.121
      }
    },
    {
      "id": "judu:stop:9627",
      "stopId": "9627",
      "name": "Stasio Krasausko st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3912",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "68"
      ],
      "wgs84": {
        "latitude": 54.64433,
        "longitude": 25.09079
      },
      "lks94": {
        "easting": 570404.778,
        "northing": 6056972.121
      }
    },
    {
      "id": "judu:stop:9628",
      "stopId": "9628",
      "name": "Stasio Krasausko st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3913",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "68"
      ],
      "wgs84": {
        "latitude": 54.64446,
        "longitude": 25.0912
      },
      "lks94": {
        "easting": 570431.016,
        "northing": 6056987
      }
    },
    {
      "id": "judu:stop:9635",
      "stopId": "9635",
      "name": "Gudeliai",
      "description": "link Žvėryno",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1655",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "116"
      ],
      "wgs84": {
        "latitude": 54.67585,
        "longitude": 25.19278
      },
      "lks94": {
        "easting": 576927.821,
        "northing": 6060586.888
      }
    },
    {
      "id": "judu:stop:9636",
      "stopId": "9636",
      "name": "Gudeliai",
      "description": "link žiedo",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1656",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "116"
      ],
      "wgs84": {
        "latitude": 54.67558,
        "longitude": 25.19308
      },
      "lks94": {
        "easting": 576947.679,
        "northing": 6060557.169
      }
    },
    {
      "id": "judu:stop:9637",
      "stopId": "9637",
      "name": "Jono Galvydžio st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0926",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "30",
        "33",
        "69"
      ],
      "wgs84": {
        "latitude": 54.71183,
        "longitude": 25.29233
      },
      "lks94": {
        "easting": 583274.193,
        "northing": 6064704.582
      }
    },
    {
      "id": "judu:stop:9638",
      "stopId": "9638",
      "name": "Ulonų st.",
      "description": "link Žirmūnų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0927",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "30",
        "33",
        "69"
      ],
      "wgs84": {
        "latitude": 54.70889,
        "longitude": 25.29121
      },
      "lks94": {
        "easting": 583208.047,
        "northing": 6064376.071
      }
    },
    {
      "id": "judu:stop:9640",
      "stopId": "9640",
      "name": "Ulonų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0928",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "30",
        "33",
        "69"
      ],
      "wgs84": {
        "latitude": 54.70921,
        "longitude": 25.291
      },
      "lks94": {
        "easting": 583193.859,
        "northing": 6064411.434
      }
    },
    {
      "id": "judu:stop:9642",
      "stopId": "9642",
      "name": "Skroblų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0536",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "29",
        "56",
        "73",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.66815,
        "longitude": 25.2557
      },
      "lks94": {
        "easting": 581000.933,
        "northing": 6059800.734
      }
    },
    {
      "id": "judu:stop:9659",
      "stopId": "9659",
      "name": "Kalnėnai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4020",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "58",
        "122"
      ],
      "wgs84": {
        "latitude": 54.65453,
        "longitude": 25.33125
      },
      "lks94": {
        "easting": 585902.858,
        "northing": 6058374.798
      }
    },
    {
      "id": "judu:stop:9660",
      "stopId": "9660",
      "name": "Pavilnio regioninis parkas",
      "description": "link Gurių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1436",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "33",
        "58"
      ],
      "wgs84": {
        "latitude": 54.66046,
        "longitude": 25.33769
      },
      "lks94": {
        "easting": 586305.823,
        "northing": 6059042.613
      }
    },
    {
      "id": "judu:stop:9661",
      "stopId": "9661",
      "name": "Pavilnio regioninis parkas",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1437",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "33",
        "58"
      ],
      "wgs84": {
        "latitude": 54.6607,
        "longitude": 25.33762
      },
      "lks94": {
        "easting": 586300.799,
        "northing": 6059069.236
      }
    },
    {
      "id": "judu:stop:9675",
      "stopId": "9675",
      "name": "Viršupio sodai",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2397",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "115"
      ],
      "wgs84": {
        "latitude": 54.71267,
        "longitude": 25.35319
      },
      "lks94": {
        "easting": 587193.805,
        "northing": 6064871.972
      }
    },
    {
      "id": "judu:stop:9676",
      "stopId": "9676",
      "name": "Viršupio sodai",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2398",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "115"
      ],
      "wgs84": {
        "latitude": 54.71332,
        "longitude": 25.3526
      },
      "lks94": {
        "easting": 587154.396,
        "northing": 6064943.575
      }
    },
    {
      "id": "judu:stop:9677",
      "stopId": "9677",
      "name": "Nemėžis",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4350",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "61"
      ],
      "wgs84": {
        "latitude": 54.639,
        "longitude": 25.3558
      },
      "lks94": {
        "easting": 587520.284,
        "northing": 6056676.854
      }
    },
    {
      "id": "judu:stop:9678",
      "stopId": "9678",
      "name": "Vladislavo Sirokomlės st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4352",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "61"
      ],
      "wgs84": {
        "latitude": 54.63453,
        "longitude": 25.35393
      },
      "lks94": {
        "easting": 587409.166,
        "northing": 6056177.085
      }
    },
    {
      "id": "judu:stop:9680",
      "stopId": "9680",
      "name": "Baltarusių st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4351",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "61"
      ],
      "wgs84": {
        "latitude": 54.63364,
        "longitude": 25.34363
      },
      "lks94": {
        "easting": 586746.137,
        "northing": 6056065.275
      }
    },
    {
      "id": "judu:stop:9681",
      "stopId": "9681",
      "name": "Sodybų st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4353",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "61"
      ],
      "wgs84": {
        "latitude": 54.63182,
        "longitude": 25.32668
      },
      "lks94": {
        "easting": 585655.717,
        "northing": 6055841.939
      }
    },
    {
      "id": "judu:stop:9682",
      "stopId": "9682",
      "name": "Vyturių st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4355",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "61"
      ],
      "wgs84": {
        "latitude": 54.63744,
        "longitude": 25.32758
      },
      "lks94": {
        "easting": 585702.002,
        "northing": 6056468.457
      }
    },
    {
      "id": "judu:stop:9683",
      "stopId": "9683",
      "name": "Juliaus Janonio st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3903",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "68"
      ],
      "wgs84": {
        "latitude": 54.64778,
        "longitude": 25.10911
      },
      "lks94": {
        "easting": 571581.128,
        "northing": 6057374.58
      }
    },
    {
      "id": "judu:stop:9685",
      "stopId": "9685",
      "name": "Kilimų fabrikas",
      "description": "link Grigiškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3000",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "68"
      ],
      "wgs84": {
        "latitude": 54.65364,
        "longitude": 25.04649
      },
      "lks94": {
        "easting": 567530.116,
        "northing": 6057964.721
      }
    },
    {
      "id": "judu:stop:9686",
      "stopId": "9686",
      "name": "Naujasis Lentvaris",
      "description": "link Grigiškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3001",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "68"
      ],
      "wgs84": {
        "latitude": 54.658,
        "longitude": 25.05965
      },
      "lks94": {
        "easting": 568371.98,
        "northing": 6058462.671
      }
    },
    {
      "id": "judu:stop:9688",
      "stopId": "9688",
      "name": "Naujasis Lentvaris",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3002",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "68"
      ],
      "wgs84": {
        "latitude": 54.65801,
        "longitude": 25.05934
      },
      "lks94": {
        "easting": 568351.961,
        "northing": 6058463.482
      }
    },
    {
      "id": "judu:stop:9689",
      "stopId": "9689",
      "name": "Vandenų st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3005",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "68"
      ],
      "wgs84": {
        "latitude": 54.65804,
        "longitude": 25.04874
      },
      "lks94": {
        "easting": 567667.991,
        "northing": 6058456.557
      }
    },
    {
      "id": "judu:stop:9690",
      "stopId": "9690",
      "name": "Kilimų fabrikas",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3004",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "68"
      ],
      "wgs84": {
        "latitude": 54.65519,
        "longitude": 25.04569
      },
      "lks94": {
        "easting": 567475.925,
        "northing": 6058136.449
      }
    },
    {
      "id": "judu:stop:9692",
      "stopId": "9692",
      "name": "1-asis Lentvaris",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3907",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "68"
      ],
      "wgs84": {
        "latitude": 54.64427,
        "longitude": 25.06487
      },
      "lks94": {
        "easting": 568731.944,
        "northing": 6056939.774
      }
    },
    {
      "id": "judu:stop:9693",
      "stopId": "9693",
      "name": "Mokslininkų st.",
      "description": "link Bajorų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2150",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "57",
        "125"
      ],
      "wgs84": {
        "latitude": 54.75445,
        "longitude": 25.24977
      },
      "lks94": {
        "easting": 580447.406,
        "northing": 6069397.992
      }
    },
    {
      "id": "judu:stop:9694",
      "stopId": "9694",
      "name": "Mokslininkų st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2149",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "57",
        "125"
      ],
      "wgs84": {
        "latitude": 54.75454,
        "longitude": 25.2493
      },
      "lks94": {
        "easting": 580416.975,
        "northing": 6069407.469
      }
    },
    {
      "id": "judu:stop:9701",
      "stopId": "9701",
      "name": "Skroblų st.",
      "description": "link Vilkpėdės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0535",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "29",
        "56",
        "73",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.66983,
        "longitude": 25.25833
      },
      "lks94": {
        "easting": 581167.226,
        "northing": 6059990.732
      }
    },
    {
      "id": "judu:stop:9726",
      "stopId": "9726",
      "name": "Juodšilių st.",
      "description": "link Galvės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2814",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8"
      ],
      "wgs84": {
        "latitude": 54.61669,
        "longitude": 25.16242
      },
      "lks94": {
        "easting": 575078.811,
        "northing": 6053970.3
      }
    },
    {
      "id": "judu:stop:9727",
      "stopId": "9727",
      "name": "Juodšilių st.",
      "description": "link Baltosios Vokės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2820",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8"
      ],
      "wgs84": {
        "latitude": 54.61606,
        "longitude": 25.16298
      },
      "lks94": {
        "easting": 575116.14,
        "northing": 6053900.788
      }
    },
    {
      "id": "judu:stop:9728",
      "stopId": "9728",
      "name": "Elektros st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2650",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3"
      ],
      "wgs84": {
        "latitude": 54.63374,
        "longitude": 25.25639
      },
      "lks94": {
        "easting": 581113.941,
        "northing": 6055972.179
      }
    },
    {
      "id": "judu:stop:9729",
      "stopId": "9729",
      "name": "Meistrų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2651",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3"
      ],
      "wgs84": {
        "latitude": 54.63073,
        "longitude": 25.25939
      },
      "lks94": {
        "easting": 581313.62,
        "northing": 6055640.677
      }
    },
    {
      "id": "judu:stop:9730",
      "stopId": "9730",
      "name": "Katilinė",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2652",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "117",
        "118",
        "119",
        "122",
        "123",
        "125"
      ],
      "wgs84": {
        "latitude": 54.63488,
        "longitude": 25.26621
      },
      "lks94": {
        "easting": 581745.611,
        "northing": 6056110.427
      }
    },
    {
      "id": "judu:stop:9731",
      "stopId": "9731",
      "name": "Pameistrių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2653",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3"
      ],
      "wgs84": {
        "latitude": 54.63079,
        "longitude": 25.26495
      },
      "lks94": {
        "easting": 581672.466,
        "northing": 6055653.804
      }
    },
    {
      "id": "judu:stop:9732",
      "stopId": "9732",
      "name": "Vėjo st.",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2502",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "9"
      ],
      "wgs84": {
        "latitude": 54.59597,
        "longitude": 25.17562
      },
      "lks94": {
        "easting": 575969.913,
        "northing": 6051678.632
      }
    },
    {
      "id": "judu:stop:9738",
      "stopId": "9738",
      "name": "Vikingų st.",
      "description": "link Oro uosto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1520",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1",
        "2",
        "88"
      ],
      "wgs84": {
        "latitude": 54.65123,
        "longitude": 25.28203
      },
      "lks94": {
        "easting": 582733.674,
        "northing": 6057948.468
      }
    },
    {
      "id": "judu:stop:9740",
      "stopId": "9740",
      "name": "Salininkai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2731",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3"
      ],
      "wgs84": {
        "latitude": 54.60621,
        "longitude": 25.2505
      },
      "lks94": {
        "easting": 580788.223,
        "northing": 6052901.704
      }
    },
    {
      "id": "judu:stop:9750",
      "stopId": "9750",
      "name": "Vikingų st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1521",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1",
        "2",
        "14",
        "88"
      ],
      "wgs84": {
        "latitude": 54.65183,
        "longitude": 25.28255
      },
      "lks94": {
        "easting": 582766.01,
        "northing": 6058015.852
      }
    },
    {
      "id": "judu:stop:9755",
      "stopId": "9755",
      "name": "Mileišiškės",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2299",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "114",
        "115"
      ],
      "wgs84": {
        "latitude": 54.71201,
        "longitude": 25.34315
      },
      "lks94": {
        "easting": 586548.315,
        "northing": 6064786.097
      }
    },
    {
      "id": "judu:stop:9756",
      "stopId": "9756",
      "name": "Mileišiškės",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2298",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "114",
        "115"
      ],
      "wgs84": {
        "latitude": 54.71201,
        "longitude": 25.344
      },
      "lks94": {
        "easting": 586603.083,
        "northing": 6064787.145
      }
    },
    {
      "id": "judu:stop:9757",
      "stopId": "9757",
      "name": "Avinėlių st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2732",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "82"
      ],
      "wgs84": {
        "latitude": 54.60081,
        "longitude": 25.27358
      },
      "lks94": {
        "easting": 582290.111,
        "northing": 6052327.542
      }
    },
    {
      "id": "judu:stop:9759",
      "stopId": "9759",
      "name": "Avinėlių st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2733",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "82"
      ],
      "wgs84": {
        "latitude": 54.60091,
        "longitude": 25.27383
      },
      "lks94": {
        "easting": 582306.062,
        "northing": 6052338.963
      }
    },
    {
      "id": "judu:stop:9766",
      "stopId": "9766",
      "name": "Pavilnionių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3336",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32",
        "118"
      ],
      "wgs84": {
        "latitude": 54.73575,
        "longitude": 25.21449
      },
      "lks94": {
        "easting": 578212.583,
        "northing": 6067277.013
      }
    },
    {
      "id": "judu:stop:9768",
      "stopId": "9768",
      "name": "Pavilnionių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3337",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32",
        "118"
      ],
      "wgs84": {
        "latitude": 54.73569,
        "longitude": 25.21497
      },
      "lks94": {
        "easting": 578243.608,
        "northing": 6067270.871
      }
    },
    {
      "id": "judu:stop:9773",
      "stopId": "9773",
      "name": "Krantinės st.",
      "description": "link Vaidotų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2824",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "8",
        "9"
      ],
      "wgs84": {
        "latitude": 54.60412,
        "longitude": 25.19113
      },
      "lks94": {
        "easting": 576956.768,
        "northing": 6052602.487
      }
    },
    {
      "id": "judu:stop:9776",
      "stopId": "9776",
      "name": "Galvės st.",
      "description": "link Savanorių pr.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2908",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "20",
        "25",
        "51",
        "62"
      ],
      "wgs84": {
        "latitude": 54.63247,
        "longitude": 25.15096
      },
      "lks94": {
        "easting": 574309.894,
        "northing": 6055714.225
      }
    },
    {
      "id": "judu:stop:9790",
      "stopId": "9790",
      "name": "Šveicarų st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4358",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "61"
      ],
      "wgs84": {
        "latitude": 54.63509,
        "longitude": 25.32657
      },
      "lks94": {
        "easting": 585641.744,
        "northing": 6056205.706
      }
    },
    {
      "id": "judu:stop:9798",
      "stopId": "9798",
      "name": "Balsiai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2263",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "65",
        "76",
        "120"
      ],
      "wgs84": {
        "latitude": 54.78604,
        "longitude": 25.34776
      },
      "lks94": {
        "easting": 586687.063,
        "northing": 6073030.322
      }
    },
    {
      "id": "judu:stop:9815",
      "stopId": "9815",
      "name": "Riaubonių st.",
      "description": "link Santariškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2152",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "57",
        "125"
      ],
      "wgs84": {
        "latitude": 54.75526,
        "longitude": 25.23294
      },
      "lks94": {
        "easting": 579362.534,
        "northing": 6069468.964
      }
    },
    {
      "id": "judu:stop:9834",
      "stopId": "9834",
      "name": "Salos",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4104",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "28",
        "29",
        "59",
        "68",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.66833,
        "longitude": 25.10068
      },
      "lks94": {
        "easting": 571001.242,
        "northing": 6059652.994
      }
    },
    {
      "id": "judu:stop:9925",
      "stopId": "9925",
      "name": "Vinciūniškės",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3561",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "114"
      ],
      "wgs84": {
        "latitude": 54.7591,
        "longitude": 25.39505
      },
      "lks94": {
        "easting": 589788.169,
        "northing": 6070091.764
      }
    },
    {
      "id": "judu:stop:9961",
      "stopId": "9961",
      "name": "Monikos Mironaitės st.",
      "description": "link Ungurių žiedo",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1657",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "116"
      ],
      "wgs84": {
        "latitude": 54.68083,
        "longitude": 25.1895
      },
      "lks94": {
        "easting": 576706.9,
        "northing": 6061137.511
      }
    },
    {
      "id": "judu:stop:9964",
      "stopId": "9964",
      "name": "Šiltnamių žiedas",
      "description": "išlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1658",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "55"
      ],
      "wgs84": {
        "latitude": 54.66691,
        "longitude": 25.22117
      },
      "lks94": {
        "easting": 578776.033,
        "northing": 6059623.457
      }
    },
    {
      "id": "judu:stop:9965",
      "stopId": "9965",
      "name": "Šiltnamių žiedas",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1659",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "55"
      ],
      "wgs84": {
        "latitude": 54.66708,
        "longitude": 25.22145
      },
      "lks94": {
        "easting": 578793.766,
        "northing": 6059642.69
      }
    },
    {
      "id": "judu:stop:9966",
      "stopId": "9966",
      "name": "Bijūnų st.",
      "description": "link žiedo",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1660",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "55"
      ],
      "wgs84": {
        "latitude": 54.66748,
        "longitude": 25.21675
      },
      "lks94": {
        "easting": 578489.82,
        "northing": 6059681.941
      }
    },
    {
      "id": "judu:stop:9967",
      "stopId": "9967",
      "name": "Vilijos st.",
      "description": "link žiedo",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2951",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "20",
        "51",
        "62"
      ],
      "wgs84": {
        "latitude": 54.63484,
        "longitude": 25.17254
      },
      "lks94": {
        "easting": 575698.706,
        "northing": 6056001.014
      }
    },
    {
      "id": "judu:stop:9968",
      "stopId": "9968",
      "name": "Sapieginės miškas",
      "description": "link N.Vilnios",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1047",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "115"
      ],
      "wgs84": {
        "latitude": 54.71025,
        "longitude": 25.35687
      },
      "lks94": {
        "easting": 587436.12,
        "northing": 6064607.239
      }
    },
    {
      "id": "judu:stop:9969",
      "stopId": "9969",
      "name": "Sapieginės miškas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1048",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "115"
      ],
      "wgs84": {
        "latitude": 54.70983,
        "longitude": 25.35769
      },
      "lks94": {
        "easting": 587489.862,
        "northing": 6064561.521
      }
    },
    {
      "id": "judu:stop:9970",
      "stopId": "9970",
      "name": "Bajorų miškas",
      "description": "link Bajorų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2154",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "57",
        "125"
      ],
      "wgs84": {
        "latitude": 54.75623,
        "longitude": 25.24332
      },
      "lks94": {
        "easting": 580028.731,
        "northing": 6069588.706
      }
    },
    {
      "id": "judu:stop:9971",
      "stopId": "9971",
      "name": "Bajorų miškas",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2155",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "57",
        "125"
      ],
      "wgs84": {
        "latitude": 54.75626,
        "longitude": 25.2425
      },
      "lks94": {
        "easting": 579975.894,
        "northing": 6069591.11
      }
    },
    {
      "id": "judu:stop:10089",
      "stopId": "10089",
      "name": "Mažoji Riešė",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5207",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "87"
      ],
      "wgs84": {
        "latitude": 54.80259,
        "longitude": 25.20262
      },
      "lks94": {
        "easting": 577320.644,
        "northing": 6074702.392
      }
    },
    {
      "id": "judu:stop:10091",
      "stopId": "10091",
      "name": "Mažoji Riešė",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5208",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "87"
      ],
      "wgs84": {
        "latitude": 54.80257,
        "longitude": 25.20164
      },
      "lks94": {
        "easting": 577257.678,
        "northing": 6074699.086
      }
    },
    {
      "id": "judu:stop:10092",
      "stopId": "10092",
      "name": "Bendoriai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5209",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "87"
      ],
      "wgs84": {
        "latitude": 54.79504,
        "longitude": 25.19782
      },
      "lks94": {
        "easting": 577026.406,
        "northing": 6073856.873
      }
    },
    {
      "id": "judu:stop:10094",
      "stopId": "10094",
      "name": "Bendoriai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5210",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "87"
      ],
      "wgs84": {
        "latitude": 54.79446,
        "longitude": 25.19728
      },
      "lks94": {
        "easting": 576992.785,
        "northing": 6073791.732
      }
    },
    {
      "id": "judu:stop:10095",
      "stopId": "10095",
      "name": "Bendorėliai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5211",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "87"
      ],
      "wgs84": {
        "latitude": 54.79055,
        "longitude": 25.19565
      },
      "lks94": {
        "easting": 576895.392,
        "northing": 6073354.802
      }
    },
    {
      "id": "judu:stop:10096",
      "stopId": "10096",
      "name": "Bendorėliai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5212",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "87"
      ],
      "wgs84": {
        "latitude": 54.78926,
        "longitude": 25.19489
      },
      "lks94": {
        "easting": 576848.963,
        "northing": 6073210.406
      }
    },
    {
      "id": "judu:stop:10097",
      "stopId": "10097",
      "name": "Klevinė",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5213",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "87"
      ],
      "wgs84": {
        "latitude": 54.7807,
        "longitude": 25.19317
      },
      "lks94": {
        "easting": 576754.557,
        "northing": 6072255.887
      }
    },
    {
      "id": "judu:stop:10098",
      "stopId": "10098",
      "name": "Klevinė",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5214",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "87"
      ],
      "wgs84": {
        "latitude": 54.77937,
        "longitude": 25.19272
      },
      "lks94": {
        "easting": 576728.128,
        "northing": 6072107.38
      }
    },
    {
      "id": "judu:stop:10099",
      "stopId": "10099",
      "name": "Durpynas",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5215",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "87"
      ],
      "wgs84": {
        "latitude": 54.77086,
        "longitude": 25.19584
      },
      "lks94": {
        "easting": 576944.979,
        "northing": 6071163.728
      }
    },
    {
      "id": "judu:stop:10100",
      "stopId": "10100",
      "name": "Durpynas",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5216",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "87"
      ],
      "wgs84": {
        "latitude": 54.77031,
        "longitude": 25.19593
      },
      "lks94": {
        "easting": 576951.813,
        "northing": 6071102.618
      }
    },
    {
      "id": "judu:stop:10122",
      "stopId": "10122",
      "name": "Ežero st.",
      "description": "link M.Riešės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5217",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "87"
      ],
      "wgs84": {
        "latitude": 54.80916,
        "longitude": 25.22766
      },
      "lks94": {
        "easting": 578917.667,
        "northing": 6075461.465
      }
    },
    {
      "id": "judu:stop:10123",
      "stopId": "10123",
      "name": "Ežero st.",
      "description": "link D.Riešės",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5218",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "87"
      ],
      "wgs84": {
        "latitude": 54.80892,
        "longitude": 25.22533
      },
      "lks94": {
        "easting": 578768.362,
        "northing": 6075432.135
      }
    },
    {
      "id": "judu:stop:10244",
      "stopId": "10244",
      "name": "Vaikų ligoninė",
      "description": "išlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2156",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2G"
      ],
      "wgs84": {
        "latitude": 54.75524,
        "longitude": 25.28088
      },
      "lks94": {
        "easting": 582448.234,
        "northing": 6069522.03
      }
    },
    {
      "id": "judu:stop:10250",
      "stopId": "10250",
      "name": "Valai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4117",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "28"
      ],
      "wgs84": {
        "latitude": 54.70001,
        "longitude": 25.06367
      },
      "lks94": {
        "easting": 568560.527,
        "northing": 6063141.843
      }
    },
    {
      "id": "judu:stop:10264",
      "stopId": "10264",
      "name": "Ungurių st.",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1663",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "116"
      ],
      "wgs84": {
        "latitude": 54.65354,
        "longitude": 25.20851
      },
      "lks94": {
        "easting": 577984.999,
        "northing": 6058121.424
      }
    },
    {
      "id": "judu:stop:10280",
      "stopId": "10280",
      "name": "Sidaronių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3404",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32"
      ],
      "wgs84": {
        "latitude": 54.70881,
        "longitude": 25.20298
      },
      "lks94": {
        "easting": 577522.776,
        "northing": 6064266.146
      }
    },
    {
      "id": "judu:stop:10281",
      "stopId": "10281",
      "name": "Sidaronių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3405",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32"
      ],
      "wgs84": {
        "latitude": 54.70795,
        "longitude": 25.20358
      },
      "lks94": {
        "easting": 577563.081,
        "northing": 6064171.101
      }
    },
    {
      "id": "judu:stop:10317",
      "stopId": "10317",
      "name": "Klonio st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1030",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "115",
        "119"
      ],
      "wgs84": {
        "latitude": 54.70586,
        "longitude": 25.37112
      },
      "lks94": {
        "easting": 588363.871,
        "northing": 6064136.543
      }
    },
    {
      "id": "judu:stop:10319",
      "stopId": "10319",
      "name": "Klonio st.",
      "description": "link N.Vilnios",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1031",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "115",
        "119"
      ],
      "wgs84": {
        "latitude": 54.70582,
        "longitude": 25.371
      },
      "lks94": {
        "easting": 588356.225,
        "northing": 6064131.94
      }
    },
    {
      "id": "judu:stop:10359",
      "stopId": "10359",
      "name": "Vikingų slėnis",
      "description": "visos kryptys",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1523",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1",
        "2"
      ],
      "wgs84": {
        "latitude": 54.65304,
        "longitude": 25.28045
      },
      "lks94": {
        "easting": 582628.044,
        "northing": 6058148.035
      }
    },
    {
      "id": "judu:stop:10360",
      "stopId": "10360",
      "name": "Gynėjų st.",
      "description": "link Pedagoginio žiedo",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0227",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "21",
        "22",
        "40",
        "57",
        "73",
        "125"
      ],
      "wgs84": {
        "latitude": 54.69349,
        "longitude": 25.26557
      },
      "lks94": {
        "easting": 581586.747,
        "northing": 6062632.161
      }
    },
    {
      "id": "judu:stop:10530",
      "stopId": "10530",
      "name": "Žilvičių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2297",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "115",
        "119"
      ],
      "wgs84": {
        "latitude": 54.70684,
        "longitude": 25.38076
      },
      "lks94": {
        "easting": 588982.95,
        "northing": 6064257.781
      }
    },
    {
      "id": "judu:stop:10531",
      "stopId": "10531",
      "name": "Žilvičių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2296",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "115",
        "119"
      ],
      "wgs84": {
        "latitude": 54.70689,
        "longitude": 25.38114
      },
      "lks94": {
        "easting": 589007.328,
        "northing": 6064263.827
      }
    },
    {
      "id": "judu:stop:10532",
      "stopId": "10532",
      "name": "Ramunių st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4359",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "61"
      ],
      "wgs84": {
        "latitude": 54.63259,
        "longitude": 25.33531
      },
      "lks94": {
        "easting": 586211.243,
        "northing": 6055938.184
      }
    },
    {
      "id": "judu:stop:10537",
      "stopId": "10537",
      "name": "Juodvarnių st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1032",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "114"
      ],
      "wgs84": {
        "latitude": 54.72255,
        "longitude": 25.37632
      },
      "lks94": {
        "easting": 588662.545,
        "northing": 6066000.454
      }
    },
    {
      "id": "judu:stop:10538",
      "stopId": "10538",
      "name": "Juodvarnių st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1033",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "114"
      ],
      "wgs84": {
        "latitude": 54.72228,
        "longitude": 25.37637
      },
      "lks94": {
        "easting": 588666.355,
        "northing": 6065970.47
      }
    },
    {
      "id": "judu:stop:10539",
      "stopId": "10539",
      "name": "Stanislovo Kerbedžio st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1034",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "114"
      ],
      "wgs84": {
        "latitude": 54.72065,
        "longitude": 25.37415
      },
      "lks94": {
        "easting": 588526.903,
        "northing": 6065786.272
      }
    },
    {
      "id": "judu:stop:10541",
      "stopId": "10541",
      "name": "Stanislovo Kerbedžio st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1036",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "114"
      ],
      "wgs84": {
        "latitude": 54.72063,
        "longitude": 25.37309
      },
      "lks94": {
        "easting": 588458.663,
        "northing": 6065782.709
      }
    },
    {
      "id": "judu:stop:10543",
      "stopId": "10543",
      "name": "Stepono Kairio st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1038",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "114"
      ],
      "wgs84": {
        "latitude": 54.72085,
        "longitude": 25.37036
      },
      "lks94": {
        "easting": 588282.321,
        "northing": 6065803.754
      }
    },
    {
      "id": "judu:stop:10544",
      "stopId": "10544",
      "name": "Stepono Kairio st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1039",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "114"
      ],
      "wgs84": {
        "latitude": 54.72081,
        "longitude": 25.36923
      },
      "lks94": {
        "easting": 588209.614,
        "northing": 6065797.882
      }
    },
    {
      "id": "judu:stop:10545",
      "stopId": "10545",
      "name": "Moliakalnio st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1040",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "114"
      ],
      "wgs84": {
        "latitude": 54.71583,
        "longitude": 25.35519
      },
      "lks94": {
        "easting": 587315.877,
        "northing": 6065226.122
      }
    },
    {
      "id": "judu:stop:10548",
      "stopId": "10548",
      "name": "Moliakalnio st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1042",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "114"
      ],
      "wgs84": {
        "latitude": 54.71578,
        "longitude": 25.35526
      },
      "lks94": {
        "easting": 587320.495,
        "northing": 6065220.644
      }
    },
    {
      "id": "judu:stop:10551",
      "stopId": "10551",
      "name": "Krakiškių sodai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2260",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "36",
        "65",
        "76"
      ],
      "wgs84": {
        "latitude": 54.80074,
        "longitude": 25.34014
      },
      "lks94": {
        "easting": 586165.709,
        "northing": 6074656.851
      }
    },
    {
      "id": "judu:stop:10552",
      "stopId": "10552",
      "name": "Krakiškių sodai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2264",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "36",
        "65",
        "76"
      ],
      "wgs84": {
        "latitude": 54.80091,
        "longitude": 25.34074
      },
      "lks94": {
        "easting": 586203.923,
        "northing": 6074676.508
      }
    },
    {
      "id": "judu:stop:10554",
      "stopId": "10554",
      "name": "Žaliojo Visalaukio st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2265",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "36",
        "65",
        "66",
        "76",
        "120"
      ],
      "wgs84": {
        "latitude": 54.7786,
        "longitude": 25.34072
      },
      "lks94": {
        "easting": 586250.114,
        "northing": 6072193.666
      }
    },
    {
      "id": "judu:stop:10556",
      "stopId": "10556",
      "name": "Žaliojo Visalaukio st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2267",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "36",
        "65",
        "66",
        "76",
        "120"
      ],
      "wgs84": {
        "latitude": 54.77863,
        "longitude": 25.34044
      },
      "lks94": {
        "easting": 586232.039,
        "northing": 6072196.66
      }
    },
    {
      "id": "judu:stop:10577",
      "stopId": "10577",
      "name": "Vilniaus Pergalė",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2825",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "8",
        "25"
      ],
      "wgs84": {
        "latitude": 54.61403,
        "longitude": 25.15191
      },
      "lks94": {
        "easting": 574404.871,
        "northing": 6053663.099
      }
    },
    {
      "id": "judu:stop:10609",
      "stopId": "10609",
      "name": "Pylimėliai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1043",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "114"
      ],
      "wgs84": {
        "latitude": 54.71888,
        "longitude": 25.35994
      },
      "lks94": {
        "easting": 587615.327,
        "northing": 6065571.463
      }
    },
    {
      "id": "judu:stop:10611",
      "stopId": "10611",
      "name": "Pylimėliai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1045",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "114"
      ],
      "wgs84": {
        "latitude": 54.71845,
        "longitude": 25.35947
      },
      "lks94": {
        "easting": 587585.975,
        "northing": 6065523.023
      }
    },
    {
      "id": "judu:stop:10612",
      "stopId": "10612",
      "name": "Duburio st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1046",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "115",
        "119"
      ],
      "wgs84": {
        "latitude": 54.70728,
        "longitude": 25.39168
      },
      "lks94": {
        "easting": 589685.671,
        "northing": 6064320.645
      }
    },
    {
      "id": "judu:stop:10614",
      "stopId": "10614",
      "name": "Tautų st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4021",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "58",
        "122"
      ],
      "wgs84": {
        "latitude": 54.65117,
        "longitude": 25.32442
      },
      "lks94": {
        "easting": 585469.21,
        "northing": 6057992.548
      }
    },
    {
      "id": "judu:stop:11046",
      "stopId": "11046",
      "name": "Vieversių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1136",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "15",
        "114",
        "115"
      ],
      "wgs84": {
        "latitude": 54.71065,
        "longitude": 25.32032
      },
      "lks94": {
        "easting": 585080.157,
        "northing": 6064606.834
      }
    },
    {
      "id": "judu:stop:11047",
      "stopId": "11047",
      "name": "Vieversių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1137",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "15",
        "114",
        "115"
      ],
      "wgs84": {
        "latitude": 54.70983,
        "longitude": 25.32257
      },
      "lks94": {
        "easting": 585226.856,
        "northing": 6064518.309
      }
    },
    {
      "id": "judu:stop:14663",
      "stopId": "14663",
      "name": "Duburio st.",
      "description": "link N.Vilnios",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1049",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "115",
        "119"
      ],
      "wgs84": {
        "latitude": 54.70731,
        "longitude": 25.39033
      },
      "lks94": {
        "easting": 589598.611,
        "northing": 6064322.259
      }
    },
    {
      "id": "judu:stop:15025",
      "stopId": "15025",
      "name": "Autobusų parkas",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0831",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1G",
        "2G",
        "3G",
        "3G-A",
        "5",
        "10",
        "24",
        "34",
        "40",
        "49",
        "50",
        "76",
        "87",
        "N3",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.72236,
        "longitude": 25.29522
      },
      "lks94": {
        "easting": 583438.778,
        "northing": 6065879.863
      }
    },
    {
      "id": "judu:stop:15113",
      "stopId": "15113",
      "name": "Laimos st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2268",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "65",
        "76",
        "120"
      ],
      "wgs84": {
        "latitude": 54.7781,
        "longitude": 25.35586
      },
      "lks94": {
        "easting": 587225.104,
        "northing": 6072156.748
      }
    },
    {
      "id": "judu:stop:15114",
      "stopId": "15114",
      "name": "Laimos st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2269",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "65",
        "76",
        "120"
      ],
      "wgs84": {
        "latitude": 54.77804,
        "longitude": 25.35628
      },
      "lks94": {
        "easting": 587252.251,
        "northing": 6072150.594
      }
    },
    {
      "id": "judu:stop:15167",
      "stopId": "15167",
      "name": "Povilo Lukšio st.",
      "description": "išlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0929",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5",
        "7",
        "30",
        "33",
        "69",
        "114",
        "119"
      ],
      "wgs84": {
        "latitude": 54.71097,
        "longitude": 25.30067
      },
      "lks94": {
        "easting": 583813.343,
        "northing": 6064618.803
      }
    },
    {
      "id": "judu:stop:15180",
      "stopId": "15180",
      "name": "Kalinas",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5148",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26"
      ],
      "wgs84": {
        "latitude": 54.80778,
        "longitude": 25.28081
      },
      "lks94": {
        "easting": 582336.928,
        "northing": 6075369.016
      }
    },
    {
      "id": "judu:stop:15181",
      "stopId": "15181",
      "name": "Didieji Gulbinai",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5149",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26"
      ],
      "wgs84": {
        "latitude": 54.80372,
        "longitude": 25.29594
      },
      "lks94": {
        "easting": 583317.858,
        "northing": 6074935.062
      }
    },
    {
      "id": "judu:stop:15182",
      "stopId": "15182",
      "name": "Kalinas",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5150",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26"
      ],
      "wgs84": {
        "latitude": 54.80772,
        "longitude": 25.28147
      },
      "lks94": {
        "easting": 582379.476,
        "northing": 6075363.114
      }
    },
    {
      "id": "judu:stop:15202",
      "stopId": "15202",
      "name": "Liepų st.",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4905",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "57"
      ],
      "wgs84": {
        "latitude": 54.76238,
        "longitude": 25.20977
      },
      "lks94": {
        "easting": 577857.523,
        "northing": 6070235.372
      }
    },
    {
      "id": "judu:stop:15411",
      "stopId": "15411",
      "name": "Justiniškės",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3221",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "43",
        "73"
      ],
      "wgs84": {
        "latitude": 54.71741,
        "longitude": 25.22023
      },
      "lks94": {
        "easting": 578617.71,
        "northing": 6065242.408
      }
    },
    {
      "id": "judu:stop:15412",
      "stopId": "15412",
      "name": "Atžalyno st.",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3222",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "43",
        "73"
      ],
      "wgs84": {
        "latitude": 54.71858,
        "longitude": 25.21516
      },
      "lks94": {
        "easting": 578288.819,
        "northing": 6065366.947
      }
    },
    {
      "id": "judu:stop:15548",
      "stopId": "15548",
      "name": "Bajorai",
      "description": "link Santariškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2157",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "57",
        "125"
      ],
      "wgs84": {
        "latitude": 54.75682,
        "longitude": 25.23783
      },
      "lks94": {
        "easting": 579674.216,
        "northing": 6069648.117
      }
    },
    {
      "id": "judu:stop:15550",
      "stopId": "15550",
      "name": "Šaulio st.",
      "description": "link Santariškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2153",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "57"
      ],
      "wgs84": {
        "latitude": 54.75759,
        "longitude": 25.22938
      },
      "lks94": {
        "easting": 579128.849,
        "northing": 6069724.244
      }
    },
    {
      "id": "judu:stop:15551",
      "stopId": "15551",
      "name": "Šaulio st.",
      "description": "link Bukiškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2158",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "57"
      ],
      "wgs84": {
        "latitude": 54.75772,
        "longitude": 25.229
      },
      "lks94": {
        "easting": 579104.138,
        "northing": 6069738.283
      }
    },
    {
      "id": "judu:stop:15556",
      "stopId": "15556",
      "name": "Aušros st.",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4907",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "57"
      ],
      "wgs84": {
        "latitude": 54.75959,
        "longitude": 25.20734
      },
      "lks94": {
        "easting": 577706.488,
        "northing": 6069922.182
      }
    },
    {
      "id": "judu:stop:15558",
      "stopId": "15558",
      "name": "Mėtų st.",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4910",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "57"
      ],
      "wgs84": {
        "latitude": 54.75899,
        "longitude": 25.2201
      },
      "lks94": {
        "easting": 578528.864,
        "northing": 6069869.619
      }
    },
    {
      "id": "judu:stop:15561",
      "stopId": "15561",
      "name": "Mėtų st.",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4911",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "57"
      ],
      "wgs84": {
        "latitude": 54.7593,
        "longitude": 25.2193
      },
      "lks94": {
        "easting": 578476.776,
        "northing": 6069903.223
      }
    },
    {
      "id": "judu:stop:15581",
      "stopId": "15581",
      "name": "Aušros vartai",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0440",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "10",
        "11",
        "88",
        "89",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.67417,
        "longitude": 25.28808
      },
      "lks94": {
        "easting": 583077.252,
        "northing": 6060508.506
      }
    },
    {
      "id": "judu:stop:15634",
      "stopId": "15634",
      "name": "Perkūnkiemis",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3309",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G",
        "40",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.73921,
        "longitude": 25.22016
      },
      "lks94": {
        "easting": 578571.013,
        "northing": 6067668.405
      }
    },
    {
      "id": "judu:stop:15636",
      "stopId": "15636",
      "name": "Perkūnkiemis",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3317",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G",
        "40",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.73854,
        "longitude": 25.21926
      },
      "lks94": {
        "easting": 578514.357,
        "northing": 6067592.834
      }
    },
    {
      "id": "judu:stop:15639",
      "stopId": "15639",
      "name": "Pavilionys",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3318",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3G",
        "40",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.74167,
        "longitude": 25.22222
      },
      "lks94": {
        "easting": 578698.889,
        "northing": 6067944.482
      }
    },
    {
      "id": "judu:stop:15829",
      "stopId": "15829",
      "name": "Gureliai",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3914",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "62"
      ],
      "wgs84": {
        "latitude": 54.64672,
        "longitude": 25.11176
      },
      "lks94": {
        "easting": 571754.017,
        "northing": 6057259.319
      }
    },
    {
      "id": "judu:stop:15831",
      "stopId": "15831",
      "name": "Gureliai",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3915",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "62"
      ],
      "wgs84": {
        "latitude": 54.64653,
        "longitude": 25.1118
      },
      "lks94": {
        "easting": 571756.933,
        "northing": 6057238.215
      }
    },
    {
      "id": "judu:stop:15833",
      "stopId": "15833",
      "name": "Jono Švažo st.",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3917",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "62"
      ],
      "wgs84": {
        "latitude": 54.64064,
        "longitude": 25.10896
      },
      "lks94": {
        "easting": 571583.992,
        "northing": 6056579.832
      }
    },
    {
      "id": "judu:stop:15835",
      "stopId": "15835",
      "name": "Jono Švažo st.",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3918",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "62"
      ],
      "wgs84": {
        "latitude": 54.64019,
        "longitude": 25.10786
      },
      "lks94": {
        "easting": 571513.779,
        "northing": 6056528.632
      }
    },
    {
      "id": "judu:stop:15837",
      "stopId": "15837",
      "name": "Kaimynų st.",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3920",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "62"
      ],
      "wgs84": {
        "latitude": 54.63664,
        "longitude": 25.11077
      },
      "lks94": {
        "easting": 571707.862,
        "northing": 6056136.527
      }
    },
    {
      "id": "judu:stop:15964",
      "stopId": "15964",
      "name": "Kovo 11-osios st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4121",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "28",
        "29",
        "59",
        "68",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.6745,
        "longitude": 25.08827
      },
      "lks94": {
        "easting": 570190.104,
        "northing": 6060327.168
      }
    },
    {
      "id": "judu:stop:16145",
      "stopId": "16145",
      "name": "1-asis paplūdimys",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3500",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3",
        "15"
      ],
      "wgs84": {
        "latitude": 54.73265,
        "longitude": 25.29831
      },
      "lks94": {
        "easting": 583616.637,
        "northing": 6067028.682
      }
    },
    {
      "id": "judu:stop:16147",
      "stopId": "16147",
      "name": "Lizdeikos st.",
      "description": "link Turniškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3564",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3",
        "15"
      ],
      "wgs84": {
        "latitude": 54.72898,
        "longitude": 25.31338
      },
      "lks94": {
        "easting": 584594.798,
        "northing": 6066638.323
      }
    },
    {
      "id": "judu:stop:16148",
      "stopId": "16148",
      "name": "Rato st.",
      "description": "link Turniškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3565",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3",
        "15"
      ],
      "wgs84": {
        "latitude": 54.73061,
        "longitude": 25.30952
      },
      "lks94": {
        "easting": 584342.804,
        "northing": 6066815.073
      }
    },
    {
      "id": "judu:stop:16149",
      "stopId": "16149",
      "name": "Vaidilutės st.",
      "description": "link Turniškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3566",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3",
        "15"
      ],
      "wgs84": {
        "latitude": 54.73707,
        "longitude": 25.29437
      },
      "lks94": {
        "easting": 583353.825,
        "northing": 6067515.882
      }
    },
    {
      "id": "judu:stop:16150",
      "stopId": "16150",
      "name": "2-asis paplūdimys",
      "description": "link Turniškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3567",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "15"
      ],
      "wgs84": {
        "latitude": 54.7419,
        "longitude": 25.29484
      },
      "lks94": {
        "easting": 583374.169,
        "northing": 6068053.957
      }
    },
    {
      "id": "judu:stop:16152",
      "stopId": "16152",
      "name": "Bruknių st.",
      "description": "link Turniškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3568",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "15"
      ],
      "wgs84": {
        "latitude": 54.74326,
        "longitude": 25.30429
      },
      "lks94": {
        "easting": 583979.802,
        "northing": 6068216.578
      }
    },
    {
      "id": "judu:stop:16153",
      "stopId": "16153",
      "name": "Svajonių st.",
      "description": "link Turniškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3569",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "15"
      ],
      "wgs84": {
        "latitude": 54.74109,
        "longitude": 25.31276
      },
      "lks94": {
        "easting": 584529.65,
        "northing": 6067985.257
      }
    },
    {
      "id": "judu:stop:16155",
      "stopId": "16155",
      "name": "Grybautojų st.",
      "description": "link Turniškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3571",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "15"
      ],
      "wgs84": {
        "latitude": 54.73258,
        "longitude": 25.31774
      },
      "lks94": {
        "easting": 584868.085,
        "northing": 6067044.219
      }
    },
    {
      "id": "judu:stop:16156",
      "stopId": "16156",
      "name": "Rytų st.",
      "description": "link Pergalės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4605",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14"
      ],
      "wgs84": {
        "latitude": 54.69016,
        "longitude": 25.4318
      },
      "lks94": {
        "easting": 592309.859,
        "northing": 6062467.464
      }
    },
    {
      "id": "judu:stop:16158",
      "stopId": "16158",
      "name": "Gerovės st.",
      "description": "link Pergalės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4606",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14"
      ],
      "wgs84": {
        "latitude": 54.69073,
        "longitude": 25.41208
      },
      "lks94": {
        "easting": 591037.297,
        "northing": 6062505.144
      }
    },
    {
      "id": "judu:stop:16160",
      "stopId": "16160",
      "name": "Karklėnų st.",
      "description": "link Pergalės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4608",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14"
      ],
      "wgs84": {
        "latitude": 54.69042,
        "longitude": 25.42695
      },
      "lks94": {
        "easting": 591996.607,
        "northing": 6062490.031
      }
    },
    {
      "id": "judu:stop:16162",
      "stopId": "16162",
      "name": "Karklėnų st.",
      "description": "link Linksmosios g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4610",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14"
      ],
      "wgs84": {
        "latitude": 54.69036,
        "longitude": 25.42668
      },
      "lks94": {
        "easting": 591979.337,
        "northing": 6062483
      }
    },
    {
      "id": "judu:stop:16164",
      "stopId": "16164",
      "name": "Žvirblių st.",
      "description": "link Pergalės g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4612",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14"
      ],
      "wgs84": {
        "latitude": 54.6907,
        "longitude": 25.41891
      },
      "lks94": {
        "easting": 591477.667,
        "northing": 6062510.684
      }
    },
    {
      "id": "judu:stop:16165",
      "stopId": "16165",
      "name": "Žvirblių st.",
      "description": "link Karklėnų g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4613",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14"
      ],
      "wgs84": {
        "latitude": 54.69059,
        "longitude": 25.41844
      },
      "lks94": {
        "easting": 591447.616,
        "northing": 6062497.831
      }
    },
    {
      "id": "judu:stop:16167",
      "stopId": "16167",
      "name": "Gerovės st.",
      "description": "link Darželio g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4615",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14"
      ],
      "wgs84": {
        "latitude": 54.69065,
        "longitude": 25.41253
      },
      "lks94": {
        "easting": 591066.486,
        "northing": 6062496.825
      }
    },
    {
      "id": "judu:stop:16169",
      "stopId": "16169",
      "name": "9-asis kilometras",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5219",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "58"
      ],
      "wgs84": {
        "latitude": 54.65775,
        "longitude": 25.37406
      },
      "lks94": {
        "easting": 588658.117,
        "northing": 6058786.336
      }
    },
    {
      "id": "judu:stop:16171",
      "stopId": "16171",
      "name": "9-asis kilometras",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5221",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "58"
      ],
      "wgs84": {
        "latitude": 54.65747,
        "longitude": 25.37603
      },
      "lks94": {
        "easting": 588785.83,
        "northing": 6058757.665
      }
    },
    {
      "id": "judu:stop:16173",
      "stopId": "16173",
      "name": "Slėnis",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5223",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "58"
      ],
      "wgs84": {
        "latitude": 54.65753,
        "longitude": 25.39333
      },
      "lks94": {
        "easting": 589901.876,
        "northing": 6058786.35
      }
    },
    {
      "id": "judu:stop:16174",
      "stopId": "16174",
      "name": "Slėnis",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5224",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "58"
      ],
      "wgs84": {
        "latitude": 54.65714,
        "longitude": 25.39439
      },
      "lks94": {
        "easting": 589971.128,
        "northing": 6058744.307
      }
    },
    {
      "id": "judu:stop:16175",
      "stopId": "16175",
      "name": "Naujosios Vilnios sankryža",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5225",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "58"
      ],
      "wgs84": {
        "latitude": 54.65389,
        "longitude": 25.40869
      },
      "lks94": {
        "easting": 590901.01,
        "northing": 6058401.047
      }
    },
    {
      "id": "judu:stop:16176",
      "stopId": "16176",
      "name": "2-asis Didžiasalis",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5226",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14"
      ],
      "wgs84": {
        "latitude": 54.64802,
        "longitude": 25.40662
      },
      "lks94": {
        "easting": 590780.527,
        "northing": 6057745.135
      }
    },
    {
      "id": "judu:stop:16179",
      "stopId": "16179",
      "name": "Grigaičių žiedas",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5227",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14",
        "58"
      ],
      "wgs84": {
        "latitude": 54.66329,
        "longitude": 25.41498
      },
      "lks94": {
        "easting": 591285.791,
        "northing": 6059455.274
      }
    },
    {
      "id": "judu:stop:16180",
      "stopId": "16180",
      "name": "2-asis Didžiasalis",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5228",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14"
      ],
      "wgs84": {
        "latitude": 54.64777,
        "longitude": 25.40621
      },
      "lks94": {
        "easting": 590754.625,
        "northing": 6057716.784
      }
    },
    {
      "id": "judu:stop:16182",
      "stopId": "16182",
      "name": "Naujosios Vilnios sankryža",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5230",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14"
      ],
      "wgs84": {
        "latitude": 54.65256,
        "longitude": 25.40902
      },
      "lks94": {
        "easting": 590925.272,
        "northing": 6058253.467
      }
    },
    {
      "id": "judu:stop:16183",
      "stopId": "16183",
      "name": "1-asis Didžiasalis",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5231",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14"
      ],
      "wgs84": {
        "latitude": 54.63861,
        "longitude": 25.39994
      },
      "lks94": {
        "easting": 590370.313,
        "northing": 6056689.342
      }
    },
    {
      "id": "judu:stop:16184",
      "stopId": "16184",
      "name": "1-asis Didžiasalis",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5232",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "14"
      ],
      "wgs84": {
        "latitude": 54.64001,
        "longitude": 25.40136
      },
      "lks94": {
        "easting": 590458.864,
        "northing": 6056846.966
      }
    },
    {
      "id": "judu:stop:16230",
      "stopId": "16230",
      "name": "Šumsko kryptis",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1439",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "33",
        "58"
      ],
      "wgs84": {
        "latitude": 54.65934,
        "longitude": 25.36306
      },
      "lks94": {
        "easting": 587944.977,
        "northing": 6058949.448
      }
    },
    {
      "id": "judu:stop:16231",
      "stopId": "16231",
      "name": "Šumsko kryptis",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1440",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "58"
      ],
      "wgs84": {
        "latitude": 54.65884,
        "longitude": 25.36494
      },
      "lks94": {
        "easting": 588067.349,
        "northing": 6058896.161
      }
    },
    {
      "id": "judu:stop:16236",
      "stopId": "16236",
      "name": "Grigiškių poliklinika",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4123",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "28",
        "29",
        "59",
        "68",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.67278,
        "longitude": 25.09004
      },
      "lks94": {
        "easting": 570307.23,
        "northing": 6060137.523
      }
    },
    {
      "id": "judu:stop:16263",
      "stopId": "16263",
      "name": "Vokės sodai",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4124",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "28"
      ],
      "wgs84": {
        "latitude": 54.68346,
        "longitude": 25.07075
      },
      "lks94": {
        "easting": 569044.955,
        "northing": 6061306.945
      }
    },
    {
      "id": "judu:stop:16266",
      "stopId": "16266",
      "name": "Vokės sodai",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4126",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "28"
      ],
      "wgs84": {
        "latitude": 54.68403,
        "longitude": 25.07035
      },
      "lks94": {
        "easting": 569018.196,
        "northing": 6061369.987
      }
    },
    {
      "id": "judu:stop:16267",
      "stopId": "16267",
      "name": "Kauno Vokės st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4127",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "28"
      ],
      "wgs84": {
        "latitude": 54.68066,
        "longitude": 25.07473
      },
      "lks94": {
        "easting": 569306.356,
        "northing": 6060999.257
      }
    },
    {
      "id": "judu:stop:16268",
      "stopId": "16268",
      "name": "Kauno Vokės st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4128",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "28"
      ],
      "wgs84": {
        "latitude": 54.68059,
        "longitude": 25.07504
      },
      "lks94": {
        "easting": 569326.466,
        "northing": 6060991.773
      }
    },
    {
      "id": "judu:stop:16291",
      "stopId": "16291",
      "name": "Geležinio Vilko st.",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2145",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "87"
      ],
      "wgs84": {
        "latitude": 54.75762,
        "longitude": 25.27183
      },
      "lks94": {
        "easting": 581860.929,
        "northing": 6069776.295
      }
    },
    {
      "id": "judu:stop:16295",
      "stopId": "16295",
      "name": "Geležinio Vilko st.",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2146",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "26",
        "87"
      ],
      "wgs84": {
        "latitude": 54.75848,
        "longitude": 25.27229
      },
      "lks94": {
        "easting": 581888.799,
        "northing": 6069872.54
      }
    },
    {
      "id": "judu:stop:16305",
      "stopId": "16305",
      "name": "Kairėnai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1015",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18"
      ],
      "wgs84": {
        "latitude": 54.73646,
        "longitude": 25.40379
      },
      "lks94": {
        "easting": 590401.075,
        "northing": 6067583.484
      }
    },
    {
      "id": "judu:stop:16306",
      "stopId": "16306",
      "name": "Kairėnai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3526",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "18",
        "38",
        "114"
      ],
      "wgs84": {
        "latitude": 54.73664,
        "longitude": 25.4021
      },
      "lks94": {
        "easting": 590291.85,
        "northing": 6067601.339
      }
    },
    {
      "id": "judu:stop:16307",
      "stopId": "16307",
      "name": "Kairėnai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1029",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "38",
        "114"
      ],
      "wgs84": {
        "latitude": 54.73719,
        "longitude": 25.40245
      },
      "lks94": {
        "easting": 590313.164,
        "northing": 6067662.996
      }
    },
    {
      "id": "judu:stop:16323",
      "stopId": "16323",
      "name": "Mykolo Lietuvio st.",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3837",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "40"
      ],
      "wgs84": {
        "latitude": 54.74254,
        "longitude": 25.22692
      },
      "lks94": {
        "easting": 578999.814,
        "northing": 6068046.585
      }
    },
    {
      "id": "judu:stop:16386",
      "stopId": "16386",
      "name": "Viršilų st.",
      "description": "link troleibusų parko",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1841",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "7",
        "9",
        "16",
        "18",
        "19",
        "21",
        "22",
        "30",
        "32",
        "52",
        "54",
        "59",
        "68",
        "73",
        "75",
        "N2",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.7033,
        "longitude": 25.21824
      },
      "lks94": {
        "easting": 578516.76,
        "northing": 6063669.913
      }
    },
    {
      "id": "judu:stop:16422",
      "stopId": "16422",
      "name": "Vismaliukai",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3572",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "38"
      ],
      "wgs84": {
        "latitude": 54.75228,
        "longitude": 25.41632
      },
      "lks94": {
        "easting": 591172.381,
        "northing": 6069360.232
      }
    },
    {
      "id": "judu:stop:16424",
      "stopId": "16424",
      "name": "Miškadvaris",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3574",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "38"
      ],
      "wgs84": {
        "latitude": 54.7538,
        "longitude": 25.41403
      },
      "lks94": {
        "easting": 591021.568,
        "northing": 6069526.412
      }
    },
    {
      "id": "judu:stop:16425",
      "stopId": "16425",
      "name": "Inovacijų pramonės parkas",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3575",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "38"
      ],
      "wgs84": {
        "latitude": 54.75313,
        "longitude": 25.4154
      },
      "lks94": {
        "easting": 591111.254,
        "northing": 6069453.63
      }
    },
    {
      "id": "judu:stop:16453",
      "stopId": "16453",
      "name": "Meškonių st.",
      "description": "į miestą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2426",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "115",
        "122"
      ],
      "wgs84": {
        "latitude": 54.67992,
        "longitude": 25.42
      },
      "lks94": {
        "easting": 591572.201,
        "northing": 6061312.462
      }
    },
    {
      "id": "judu:stop:16454",
      "stopId": "16454",
      "name": "Meškonių st.",
      "description": "išlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2427",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "115",
        "122"
      ],
      "wgs84": {
        "latitude": 54.68002,
        "longitude": 25.42011
      },
      "lks94": {
        "easting": 591579.069,
        "northing": 6061323.734
      }
    },
    {
      "id": "judu:stop:16553",
      "stopId": "16553",
      "name": "Nepriklausomybės aikštė",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0238",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "25",
        "56"
      ],
      "wgs84": {
        "latitude": 54.69099,
        "longitude": 25.25993
      },
      "lks94": {
        "easting": 581228.169,
        "northing": 6062347.404
      }
    },
    {
      "id": "judu:stop:16581",
      "stopId": "16581",
      "name": "Stotis",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0547",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "3",
        "4",
        "41",
        "42",
        "54",
        "78"
      ],
      "wgs84": {
        "latitude": 54.67191,
        "longitude": 25.28338
      },
      "lks94": {
        "easting": 582778.73,
        "northing": 6060251.449
      }
    },
    {
      "id": "judu:stop:16622",
      "stopId": "16622",
      "name": "Lazdynėliai",
      "description": "įlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1652",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "21",
        "69"
      ],
      "wgs84": {
        "latitude": 54.66261,
        "longitude": 25.19196
      },
      "lks94": {
        "easting": 576899.949,
        "northing": 6059112.548
      }
    },
    {
      "id": "judu:stop:16627",
      "stopId": "16627",
      "name": "Petro Baublio st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2127",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "35",
        "36",
        "65",
        "66",
        "76",
        "120",
        "121"
      ],
      "wgs84": {
        "latitude": 54.75086,
        "longitude": 25.28497
      },
      "lks94": {
        "easting": 582720.415,
        "northing": 6069039.406
      }
    },
    {
      "id": "judu:stop:16628",
      "stopId": "16628",
      "name": "Petro Baublio st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2125b",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "35",
        "36",
        "65",
        "66",
        "76",
        "120",
        "121"
      ],
      "wgs84": {
        "latitude": 54.75052,
        "longitude": 25.28355
      },
      "lks94": {
        "easting": 582629.7,
        "northing": 6068999.895
      }
    },
    {
      "id": "judu:stop:16649",
      "stopId": "16649",
      "name": "Santariškių žiedas",
      "description": "išlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2136a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1G",
        "55",
        "N3"
      ],
      "wgs84": {
        "latitude": 54.76262,
        "longitude": 25.2822
      },
      "lks94": {
        "easting": 582518.182,
        "northing": 6070344.884
      }
    },
    {
      "id": "judu:stop:16654",
      "stopId": "16654",
      "name": "Degučių st.",
      "description": "link Pagirių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3116",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.59214,
        "longitude": 25.15946
      },
      "lks94": {
        "easting": 574932.713,
        "northing": 6051235.059
      }
    },
    {
      "id": "judu:stop:16655",
      "stopId": "16655",
      "name": "Degučių st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3117",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.5925,
        "longitude": 25.15804
      },
      "lks94": {
        "easting": 574840.287,
        "northing": 6051273.609
      }
    },
    {
      "id": "judu:stop:16658",
      "stopId": "16658",
      "name": "Daniliškės",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3120",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.60088,
        "longitude": 25.13766
      },
      "lks94": {
        "easting": 573508.157,
        "northing": 6052184.683
      }
    },
    {
      "id": "judu:stop:16691",
      "stopId": "16691",
      "name": "Ąžuolyno st.",
      "description": "link Viršuliškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1842",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "7"
      ],
      "wgs84": {
        "latitude": 54.70695,
        "longitude": 25.23769
      },
      "lks94": {
        "easting": 579763.104,
        "northing": 6064098.041
      }
    },
    {
      "id": "judu:stop:16692",
      "stopId": "16692",
      "name": "Ąžuolyno st.",
      "description": "link Akropolio",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1843",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "7"
      ],
      "wgs84": {
        "latitude": 54.70755,
        "longitude": 25.23795
      },
      "lks94": {
        "easting": 579778.681,
        "northing": 6064165.109
      }
    },
    {
      "id": "judu:stop:16703",
      "stopId": "16703",
      "name": "Paukščių takas",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1667",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "7",
        "21",
        "22",
        "55",
        "68"
      ],
      "wgs84": {
        "latitude": 54.67972,
        "longitude": 25.20699
      },
      "lks94": {
        "easting": 577836.84,
        "northing": 6061033.23
      }
    },
    {
      "id": "judu:stop:16713",
      "stopId": "16713",
      "name": "Airių st.",
      "description": "link Gurių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4019",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "33",
        "122"
      ],
      "wgs84": {
        "latitude": 54.65149,
        "longitude": 25.34953
      },
      "lks94": {
        "easting": 587088.859,
        "northing": 6058059.004
      }
    },
    {
      "id": "judu:stop:16715",
      "stopId": "16715",
      "name": "Airių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4024",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "33",
        "122"
      ],
      "wgs84": {
        "latitude": 54.65204,
        "longitude": 25.3498
      },
      "lks94": {
        "easting": 587105.105,
        "northing": 6058120.545
      }
    },
    {
      "id": "judu:stop:16724",
      "stopId": "16724",
      "name": "Savičiūnų st.",
      "description": "link Gurių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4025",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "33",
        "122"
      ],
      "wgs84": {
        "latitude": 54.65472,
        "longitude": 25.35366
      },
      "lks94": {
        "easting": 587348.434,
        "northing": 6058423.582
      }
    },
    {
      "id": "judu:stop:16725",
      "stopId": "16725",
      "name": "Savičiūnų st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4026",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "33",
        "122"
      ],
      "wgs84": {
        "latitude": 54.6545,
        "longitude": 25.3533
      },
      "lks94": {
        "easting": 587325.678,
        "northing": 6058398.652
      }
    },
    {
      "id": "judu:stop:16749",
      "stopId": "16749",
      "name": "Vytauto Andriaus Graičiūno st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2828",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "25"
      ],
      "wgs84": {
        "latitude": 54.60815,
        "longitude": 25.15942
      },
      "lks94": {
        "easting": 574900.736,
        "northing": 6053016.712
      }
    },
    {
      "id": "judu:stop:16751",
      "stopId": "16751",
      "name": "Medkirčių st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3121",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.59454,
        "longitude": 25.15251
      },
      "lks94": {
        "easting": 574479.194,
        "northing": 6051494.759
      }
    },
    {
      "id": "judu:stop:16752",
      "stopId": "16752",
      "name": "Medkirčių st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3122",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.59427,
        "longitude": 25.1529
      },
      "lks94": {
        "easting": 574504.889,
        "northing": 6051465.125
      }
    },
    {
      "id": "judu:stop:16770",
      "stopId": "16770",
      "name": "Vinco Pietario st.",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0615",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "29",
        "56",
        "N9"
      ],
      "wgs84": {
        "latitude": 54.67638,
        "longitude": 25.25014
      },
      "lks94": {
        "easting": 580625.989,
        "northing": 6060710.223
      }
    },
    {
      "id": "judu:stop:16772",
      "stopId": "16772",
      "name": "Verslo trikampis",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0253",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "56",
        "123"
      ],
      "wgs84": {
        "latitude": 54.68703,
        "longitude": 25.25946
      },
      "lks94": {
        "easting": 581205.776,
        "northing": 6061906.165
      }
    },
    {
      "id": "judu:stop:16773",
      "stopId": "16773",
      "name": "Verslo trikampis",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0254",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "25",
        "56",
        "123"
      ],
      "wgs84": {
        "latitude": 54.68664,
        "longitude": 25.25903
      },
      "lks94": {
        "easting": 581178.831,
        "northing": 6061862.266
      }
    },
    {
      "id": "judu:stop:16788",
      "stopId": "16788",
      "name": "Titnago st.",
      "description": "link žiedo",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2428",
      "modes": [
        "trolleybus"
      ],
      "routeShortNames": [
        "4",
        "15",
        "18"
      ],
      "wgs84": {
        "latitude": 54.6503,
        "longitude": 25.18546
      },
      "lks94": {
        "easting": 576503.742,
        "northing": 6057735.506
      }
    },
    {
      "id": "judu:stop:16832",
      "stopId": "16832",
      "name": "Žynių st.",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2270",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "65",
        "76",
        "120"
      ],
      "wgs84": {
        "latitude": 54.78168,
        "longitude": 25.35503
      },
      "lks94": {
        "easting": 587164.013,
        "northing": 6072554.123
      }
    },
    {
      "id": "judu:stop:16861",
      "stopId": "16861",
      "name": "Lentvario kryžkelė",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/6005",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.61951,
        "longitude": 25.06831
      },
      "lks94": {
        "easting": 568995.87,
        "northing": 6054187.652
      }
    },
    {
      "id": "judu:stop:16863",
      "stopId": "16863",
      "name": "Dobūklė",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/6007",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.61973,
        "longitude": 25.09049
      },
      "lks94": {
        "easting": 570427.91,
        "northing": 6054234.14
      }
    },
    {
      "id": "judu:stop:16864",
      "stopId": "16864",
      "name": "Dobūklė",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/6008",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.6198,
        "longitude": 25.08953
      },
      "lks94": {
        "easting": 570365.791,
        "northing": 6054240.968
      }
    },
    {
      "id": "judu:stop:16870",
      "stopId": "16870",
      "name": "Žynių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2271",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "65",
        "76"
      ],
      "wgs84": {
        "latitude": 54.78308,
        "longitude": 25.35433
      },
      "lks94": {
        "easting": 587115.978,
        "northing": 6072709.055
      }
    },
    {
      "id": "judu:stop:16879",
      "stopId": "16879",
      "name": "Mačiuliškių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3921",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "68"
      ],
      "wgs84": {
        "latitude": 54.64386,
        "longitude": 25.07848
      },
      "lks94": {
        "easting": 569611.066,
        "northing": 6056907.548
      }
    },
    {
      "id": "judu:stop:16880",
      "stopId": "16880",
      "name": "Mačiuliškių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3922",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "68"
      ],
      "wgs84": {
        "latitude": 54.64365,
        "longitude": 25.08055
      },
      "lks94": {
        "easting": 569745.03,
        "northing": 6056886.23
      }
    },
    {
      "id": "judu:stop:16896",
      "stopId": "16896",
      "name": "Garbės st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4416",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32",
        "118"
      ],
      "wgs84": {
        "latitude": 54.73051,
        "longitude": 25.18419
      },
      "lks94": {
        "easting": 576271.212,
        "northing": 6066660.508
      }
    },
    {
      "id": "judu:stop:16898",
      "stopId": "16898",
      "name": "Garbės st.",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4419",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32",
        "118"
      ],
      "wgs84": {
        "latitude": 54.72982,
        "longitude": 25.18311
      },
      "lks94": {
        "easting": 576202.95,
        "northing": 6066582.546
      }
    },
    {
      "id": "judu:stop:16903",
      "stopId": "16903",
      "name": "Lentvaris",
      "description": "link Grigiškių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3006",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "68"
      ],
      "wgs84": {
        "latitude": 54.64554,
        "longitude": 25.04896
      },
      "lks94": {
        "easting": 567702.961,
        "northing": 6057065.66
      }
    },
    {
      "id": "judu:stop:16920",
      "stopId": "16920",
      "name": "Tautų st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4022",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "58",
        "122"
      ],
      "wgs84": {
        "latitude": 54.65056,
        "longitude": 25.32347
      },
      "lks94": {
        "easting": 585409.186,
        "northing": 6057923.508
      }
    },
    {
      "id": "judu:stop:16971",
      "stopId": "16971",
      "name": "Vytauto Pociūno st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3406",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32"
      ],
      "wgs84": {
        "latitude": 54.70395,
        "longitude": 25.20551
      },
      "lks94": {
        "easting": 577695.097,
        "northing": 6063728.085
      }
    },
    {
      "id": "judu:stop:16973",
      "stopId": "16973",
      "name": "Vytauto Pociūno st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3407",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32"
      ],
      "wgs84": {
        "latitude": 54.70496,
        "longitude": 25.20548
      },
      "lks94": {
        "easting": 577691.233,
        "northing": 6063840.452
      }
    },
    {
      "id": "judu:stop:16977",
      "stopId": "16977",
      "name": "Žirnių st.",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4001",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12",
        "14",
        "16",
        "58",
        "61",
        "122"
      ],
      "wgs84": {
        "latitude": 54.65394,
        "longitude": 25.30397
      },
      "lks94": {
        "easting": 584143.856,
        "northing": 6058276.116
      }
    },
    {
      "id": "judu:stop:16978",
      "stopId": "16978",
      "name": "Žirnių st.",
      "description": "link oro uosto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1513",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2",
        "14",
        "88",
        "119",
        "122"
      ],
      "wgs84": {
        "latitude": 54.6547,
        "longitude": 25.30181
      },
      "lks94": {
        "easting": 584002.913,
        "northing": 6058358.107
      }
    },
    {
      "id": "judu:stop:17003",
      "stopId": "17003",
      "name": "Liepynės kapinės",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2654",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "2",
        "122"
      ],
      "wgs84": {
        "latitude": 54.65412,
        "longitude": 25.29115
      },
      "lks94": {
        "easting": 583316.272,
        "northing": 6058280.864
      }
    },
    {
      "id": "judu:stop:17007",
      "stopId": "17007",
      "name": "Gerviškių st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2429",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "115",
        "122"
      ],
      "wgs84": {
        "latitude": 54.68233,
        "longitude": 25.42799
      },
      "lks94": {
        "easting": 592081.966,
        "northing": 6061591.107
      }
    },
    {
      "id": "judu:stop:17009",
      "stopId": "17009",
      "name": "Gerviškių st.",
      "description": "į miestą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2431",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "115",
        "122"
      ],
      "wgs84": {
        "latitude": 54.68233,
        "longitude": 25.42822
      },
      "lks94": {
        "easting": 592096.796,
        "northing": 6061591.408
      }
    },
    {
      "id": "judu:stop:17033",
      "stopId": "17033",
      "name": "Gulbinėlių st.",
      "description": "į miestą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2272",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "121"
      ],
      "wgs84": {
        "latitude": 54.77035,
        "longitude": 25.30112
      },
      "lks94": {
        "easting": 583719.782,
        "northing": 6071227.558
      }
    },
    {
      "id": "judu:stop:17034",
      "stopId": "17034",
      "name": "Gulbinėlių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2273",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "121"
      ],
      "wgs84": {
        "latitude": 54.77138,
        "longitude": 25.30117
      },
      "lks94": {
        "easting": 583720.872,
        "northing": 6071342.244
      }
    },
    {
      "id": "judu:stop:17036",
      "stopId": "17036",
      "name": "Raudonės st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2275",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "121"
      ],
      "wgs84": {
        "latitude": 54.77427,
        "longitude": 25.30032
      },
      "lks94": {
        "easting": 583660.221,
        "northing": 6071662.851
      }
    },
    {
      "id": "judu:stop:17037",
      "stopId": "17037",
      "name": "Raudonės st.",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2276",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "121"
      ],
      "wgs84": {
        "latitude": 54.7738,
        "longitude": 25.30039
      },
      "lks94": {
        "easting": 583665.694,
        "northing": 6071610.629
      }
    },
    {
      "id": "judu:stop:17038",
      "stopId": "17038",
      "name": "Mažieji Gulbinai",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2277",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "121"
      ],
      "wgs84": {
        "latitude": 54.78649,
        "longitude": 25.29783
      },
      "lks94": {
        "easting": 583474.858,
        "northing": 6073019.819
      }
    },
    {
      "id": "judu:stop:17039",
      "stopId": "17039",
      "name": "Mažieji Gulbinai",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2278",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "121"
      ],
      "wgs84": {
        "latitude": 54.7862,
        "longitude": 25.2977
      },
      "lks94": {
        "easting": 583467.094,
        "northing": 6072987.39
      }
    },
    {
      "id": "judu:stop:17040",
      "stopId": "17040",
      "name": "Pijų st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2279",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "121"
      ],
      "wgs84": {
        "latitude": 54.7949,
        "longitude": 25.29333
      },
      "lks94": {
        "easting": 583168.175,
        "northing": 6073950.402
      }
    },
    {
      "id": "judu:stop:17041",
      "stopId": "17041",
      "name": "Pijų st.",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2280",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "121"
      ],
      "wgs84": {
        "latitude": 54.7948,
        "longitude": 25.293
      },
      "lks94": {
        "easting": 583147.161,
        "northing": 6073938.882
      }
    },
    {
      "id": "judu:stop:17118",
      "stopId": "17118",
      "name": "Imanuelio Kanto st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3636",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "117"
      ],
      "wgs84": {
        "latitude": 54.70404,
        "longitude": 25.18815
      },
      "lks94": {
        "easting": 576576.129,
        "northing": 6063719.024
      }
    },
    {
      "id": "judu:stop:17120",
      "stopId": "17120",
      "name": "Imanuelio Kanto st.",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3637",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "117"
      ],
      "wgs84": {
        "latitude": 54.70491,
        "longitude": 25.18879
      },
      "lks94": {
        "easting": 576615.735,
        "northing": 6063816.542
      }
    },
    {
      "id": "judu:stop:17121",
      "stopId": "17121",
      "name": "Paplūdimio st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3638",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "117"
      ],
      "wgs84": {
        "latitude": 54.69888,
        "longitude": 25.1769
      },
      "lks94": {
        "easting": 575860.73,
        "northing": 6063132.563
      }
    },
    {
      "id": "judu:stop:17123",
      "stopId": "17123",
      "name": "Paplūdimio st.",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3639",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "117"
      ],
      "wgs84": {
        "latitude": 54.69899,
        "longitude": 25.17747
      },
      "lks94": {
        "easting": 575897.264,
        "northing": 6063145.421
      }
    },
    {
      "id": "judu:stop:17124",
      "stopId": "17124",
      "name": "Pakrantės st.",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3640",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "117"
      ],
      "wgs84": {
        "latitude": 54.6984,
        "longitude": 25.17182
      },
      "lks94": {
        "easting": 575534.19,
        "northing": 6063073.667
      }
    },
    {
      "id": "judu:stop:17129",
      "stopId": "17129",
      "name": "Žvorūnos st.",
      "description": "į miestą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2164",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "120"
      ],
      "wgs84": {
        "latitude": 54.78773,
        "longitude": 25.35966
      },
      "lks94": {
        "easting": 587448.769,
        "northing": 6073233.173
      }
    },
    {
      "id": "judu:stop:17130",
      "stopId": "17130",
      "name": "Užpalių st.",
      "description": "į miestą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2165",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "120"
      ],
      "wgs84": {
        "latitude": 54.78858,
        "longitude": 25.36426
      },
      "lks94": {
        "easting": 587742.766,
        "northing": 6073333.514
      }
    },
    {
      "id": "judu:stop:17131",
      "stopId": "17131",
      "name": "Bubilo st.",
      "description": "į miestą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2166",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "120"
      ],
      "wgs84": {
        "latitude": 54.78356,
        "longitude": 25.36891
      },
      "lks94": {
        "easting": 588052.72,
        "northing": 6072780.683
      }
    },
    {
      "id": "judu:stop:17133",
      "stopId": "17133",
      "name": "Kryžiokų sodų st.",
      "description": "į miestą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2168",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "120"
      ],
      "wgs84": {
        "latitude": 54.77993,
        "longitude": 25.36615
      },
      "lks94": {
        "easting": 587883.07,
        "northing": 6072373.25
      }
    },
    {
      "id": "judu:stop:17150",
      "stopId": "17150",
      "name": "Padvarės st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2282",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "121"
      ],
      "wgs84": {
        "latitude": 54.79746,
        "longitude": 25.29563
      },
      "lks94": {
        "easting": 583310.804,
        "northing": 6074238.03
      }
    },
    {
      "id": "judu:stop:17152",
      "stopId": "17152",
      "name": "Padvarės st.",
      "description": "į miestą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2284",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "121"
      ],
      "wgs84": {
        "latitude": 54.79725,
        "longitude": 25.29527
      },
      "lks94": {
        "easting": 583288.089,
        "northing": 6074214.232
      }
    },
    {
      "id": "judu:stop:17153",
      "stopId": "17153",
      "name": "Didieji Gulbinai",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2285",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "121"
      ],
      "wgs84": {
        "latitude": 54.80316,
        "longitude": 25.29658
      },
      "lks94": {
        "easting": 583360.155,
        "northing": 6074873.501
      }
    },
    {
      "id": "judu:stop:17179",
      "stopId": "17179",
      "name": "Taurupės st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3641",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "117"
      ],
      "wgs84": {
        "latitude": 54.70126,
        "longitude": 25.18265
      },
      "lks94": {
        "easting": 576226.884,
        "northing": 6063403.657
      }
    },
    {
      "id": "judu:stop:17181",
      "stopId": "17181",
      "name": "Taurupės st.",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3643",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "117"
      ],
      "wgs84": {
        "latitude": 54.70119,
        "longitude": 25.18285
      },
      "lks94": {
        "easting": 576239.906,
        "northing": 6063396.084
      }
    },
    {
      "id": "judu:stop:17186",
      "stopId": "17186",
      "name": "Pakrantės st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3644",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "117"
      ],
      "wgs84": {
        "latitude": 54.69844,
        "longitude": 25.17185
      },
      "lks94": {
        "easting": 575536.049,
        "northing": 6063078.15
      }
    },
    {
      "id": "judu:stop:17190",
      "stopId": "17190",
      "name": "Trakėnų st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3646",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "117"
      ],
      "wgs84": {
        "latitude": 54.69881,
        "longitude": 25.16742
      },
      "lks94": {
        "easting": 575249.825,
        "northing": 6063114.569
      }
    },
    {
      "id": "judu:stop:17191",
      "stopId": "17191",
      "name": "Trakėnų st.",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3647",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "117"
      ],
      "wgs84": {
        "latitude": 54.69893,
        "longitude": 25.16645
      },
      "lks94": {
        "easting": 575187.082,
        "northing": 6063126.884
      }
    },
    {
      "id": "judu:stop:17194",
      "stopId": "17194",
      "name": "Gelūžės st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3648",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "117"
      ],
      "wgs84": {
        "latitude": 54.70048,
        "longitude": 25.16032
      },
      "lks94": {
        "easting": 574789.12,
        "northing": 6063292.833
      }
    },
    {
      "id": "judu:stop:17196",
      "stopId": "17196",
      "name": "Gelūžės st.",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3650",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "117"
      ],
      "wgs84": {
        "latitude": 54.69994,
        "longitude": 25.1615
      },
      "lks94": {
        "easting": 574866.169,
        "northing": 6063233.995
      }
    },
    {
      "id": "judu:stop:17203",
      "stopId": "17203",
      "name": "Obeliškių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3652",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "117"
      ],
      "wgs84": {
        "latitude": 54.70299,
        "longitude": 25.14734
      },
      "lks94": {
        "easting": 573947.958,
        "northing": 6063558.415
      }
    },
    {
      "id": "judu:stop:17205",
      "stopId": "17205",
      "name": "Obeliškių st.",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3653",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "117"
      ],
      "wgs84": {
        "latitude": 54.70284,
        "longitude": 25.14757
      },
      "lks94": {
        "easting": 573963.054,
        "northing": 6063541.964
      }
    },
    {
      "id": "judu:stop:17208",
      "stopId": "17208",
      "name": "Vienkiemių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3654",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "117"
      ],
      "wgs84": {
        "latitude": 54.70294,
        "longitude": 25.14099
      },
      "lks94": {
        "easting": 573538.799,
        "northing": 6063546.179
      }
    },
    {
      "id": "judu:stop:17221",
      "stopId": "17221",
      "name": "Vėluvos st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3658",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "118"
      ],
      "wgs84": {
        "latitude": 54.71251,
        "longitude": 25.1606
      },
      "lks94": {
        "easting": 574785.029,
        "northing": 6064631.929
      }
    },
    {
      "id": "judu:stop:17222",
      "stopId": "17222",
      "name": "Katiliškės",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4014",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12"
      ],
      "wgs84": {
        "latitude": 54.60587,
        "longitude": 25.31291
      },
      "lks94": {
        "easting": 584820.685,
        "northing": 6052937.402
      }
    },
    {
      "id": "judu:stop:17223",
      "stopId": "17223",
      "name": "Vėluvos st.",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3659",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "118"
      ],
      "wgs84": {
        "latitude": 54.71283,
        "longitude": 25.16034
      },
      "lks94": {
        "easting": 574767.688,
        "northing": 6064667.264
      }
    },
    {
      "id": "judu:stop:17225",
      "stopId": "17225",
      "name": "Varnės st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3660",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "118"
      ],
      "wgs84": {
        "latitude": 54.71623,
        "longitude": 25.17064
      },
      "lks94": {
        "easting": 575425.037,
        "northing": 6065056.665
      }
    },
    {
      "id": "judu:stop:17228",
      "stopId": "17228",
      "name": "Varnės st.",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3662",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "118"
      ],
      "wgs84": {
        "latitude": 54.71584,
        "longitude": 25.16911
      },
      "lks94": {
        "easting": 575327.186,
        "northing": 6065011.62
      }
    },
    {
      "id": "judu:stop:17230",
      "stopId": "17230",
      "name": "Pergalės st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3663",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "118"
      ],
      "wgs84": {
        "latitude": 54.72432,
        "longitude": 25.17904
      },
      "lks94": {
        "easting": 575951.102,
        "northing": 6065966.047
      }
    },
    {
      "id": "judu:stop:17232",
      "stopId": "17232",
      "name": "Pergalės st.",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3664",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "118"
      ],
      "wgs84": {
        "latitude": 54.72417,
        "longitude": 25.1786
      },
      "lks94": {
        "easting": 575923.04,
        "northing": 6065948.878
      }
    },
    {
      "id": "judu:stop:17239",
      "stopId": "17239",
      "name": "Šilo tiltas",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1139",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "119"
      ],
      "wgs84": {
        "latitude": 54.70488,
        "longitude": 25.31085
      },
      "lks94": {
        "easting": 584481.948,
        "northing": 6063953.274
      }
    },
    {
      "id": "judu:stop:17241",
      "stopId": "17241",
      "name": "Vinco Grybo st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1140",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "119"
      ],
      "wgs84": {
        "latitude": 54.70387,
        "longitude": 25.3172
      },
      "lks94": {
        "easting": 584893.279,
        "northing": 6063848.537
      }
    },
    {
      "id": "judu:stop:17242",
      "stopId": "17242",
      "name": "Vinco Grybo st.",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1141",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "119"
      ],
      "wgs84": {
        "latitude": 54.70401,
        "longitude": 25.31701
      },
      "lks94": {
        "easting": 584880.742,
        "northing": 6063863.887
      }
    },
    {
      "id": "judu:stop:17246",
      "stopId": "17246",
      "name": "Saulės slėnis",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1143",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "119"
      ],
      "wgs84": {
        "latitude": 54.70241,
        "longitude": 25.32416
      },
      "lks94": {
        "easting": 585344.889,
        "northing": 6063694.499
      }
    },
    {
      "id": "judu:stop:17248",
      "stopId": "17248",
      "name": "Saulės slėnis",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1145",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "119"
      ],
      "wgs84": {
        "latitude": 54.70233,
        "longitude": 25.32467
      },
      "lks94": {
        "easting": 585377.926,
        "northing": 6063686.216
      }
    },
    {
      "id": "judu:stop:17252",
      "stopId": "17252",
      "name": "Mažieji Pupojai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1050",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "119"
      ],
      "wgs84": {
        "latitude": 54.7077,
        "longitude": 25.40045
      },
      "lks94": {
        "easting": 590249.877,
        "northing": 6064378.626
      }
    },
    {
      "id": "judu:stop:17253",
      "stopId": "17253",
      "name": "Mažieji Pupojai",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1051",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "119"
      ],
      "wgs84": {
        "latitude": 54.70762,
        "longitude": 25.40079
      },
      "lks94": {
        "easting": 590271.964,
        "northing": 6064370.161
      }
    },
    {
      "id": "judu:stop:17256",
      "stopId": "17256",
      "name": "Šiaurės Sodai",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1054",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "119"
      ],
      "wgs84": {
        "latitude": 54.70877,
        "longitude": 25.40521
      },
      "lks94": {
        "easting": 590554.223,
        "northing": 6064503.832
      }
    },
    {
      "id": "judu:stop:17258",
      "stopId": "17258",
      "name": "Šiaurės Sodai",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1056",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "119"
      ],
      "wgs84": {
        "latitude": 54.70883,
        "longitude": 25.40502
      },
      "lks94": {
        "easting": 590541.847,
        "northing": 6064510.264
      }
    },
    {
      "id": "judu:stop:17263",
      "stopId": "17263",
      "name": "Centrinė st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1058",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "119"
      ],
      "wgs84": {
        "latitude": 54.71276,
        "longitude": 25.41542
      },
      "lks94": {
        "easting": 591203.174,
        "northing": 6064961.078
      }
    },
    {
      "id": "judu:stop:17265",
      "stopId": "17265",
      "name": "Centrinė st.",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1060",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "119"
      ],
      "wgs84": {
        "latitude": 54.71277,
        "longitude": 25.41509
      },
      "lks94": {
        "easting": 591181.89,
        "northing": 6064961.762
      }
    },
    {
      "id": "judu:stop:17268",
      "stopId": "17268",
      "name": "Šv.Jono Bosko gimnazija",
      "description": "galinė st.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1062",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "119"
      ],
      "wgs84": {
        "latitude": 54.71652,
        "longitude": 25.42595
      },
      "lks94": {
        "easting": 591873.131,
        "northing": 6065393.243
      }
    },
    {
      "id": "judu:stop:17270",
      "stopId": "17270",
      "name": "Egliškės",
      "description": "į miestą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1063",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "119"
      ],
      "wgs84": {
        "latitude": 54.71739,
        "longitude": 25.42249
      },
      "lks94": {
        "easting": 591648.257,
        "northing": 6065485.537
      }
    },
    {
      "id": "judu:stop:17272",
      "stopId": "17272",
      "name": "Egliškės",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1065",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "119"
      ],
      "wgs84": {
        "latitude": 54.71771,
        "longitude": 25.42313
      },
      "lks94": {
        "easting": 591688.766,
        "northing": 6065521.984
      }
    },
    {
      "id": "judu:stop:17313",
      "stopId": "17313",
      "name": "Kernavės st.",
      "description": "liš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0712",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "69",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.70204,
        "longitude": 25.27568
      },
      "lks94": {
        "easting": 582221.174,
        "northing": 6063595.457
      }
    },
    {
      "id": "judu:stop:17315",
      "stopId": "17315",
      "name": "Kernavės st.",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0713",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "69"
      ],
      "wgs84": {
        "latitude": 54.70129,
        "longitude": 25.27491
      },
      "lks94": {
        "easting": 582173.064,
        "northing": 6063511.091
      }
    },
    {
      "id": "judu:stop:17317",
      "stopId": "17317",
      "name": "Krokuvos st.",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0715",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "69",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.69884,
        "longitude": 25.27446
      },
      "lks94": {
        "easting": 582149.012,
        "northing": 6063237.912
      }
    },
    {
      "id": "judu:stop:17318",
      "stopId": "17318",
      "name": "Oršos st.",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0716",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5",
        "49",
        "69"
      ],
      "wgs84": {
        "latitude": 54.70417,
        "longitude": 25.27691
      },
      "lks94": {
        "easting": 582296.134,
        "northing": 6063833.939
      }
    },
    {
      "id": "judu:stop:17320",
      "stopId": "17320",
      "name": "Lentvaris",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3007",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "68"
      ],
      "wgs84": {
        "latitude": 54.64513,
        "longitude": 25.0536
      },
      "lks94": {
        "easting": 568003.114,
        "northing": 6057024.514
      }
    },
    {
      "id": "judu:stop:17323",
      "stopId": "17323",
      "name": "Krokuvos st.",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0717",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "69"
      ],
      "wgs84": {
        "latitude": 54.69846,
        "longitude": 25.27328
      },
      "lks94": {
        "easting": 582073.723,
        "northing": 6063194.243
      }
    },
    {
      "id": "judu:stop:17333",
      "stopId": "17333",
      "name": "Gileikių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3338",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32",
        "118"
      ],
      "wgs84": {
        "latitude": 54.73576,
        "longitude": 25.21127
      },
      "lks94": {
        "easting": 578005.207,
        "northing": 6067274.542
      }
    },
    {
      "id": "judu:stop:17352",
      "stopId": "17352",
      "name": "Rotušė",
      "description": "į stotį",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0449a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "89"
      ],
      "wgs84": {
        "latitude": 54.67772,
        "longitude": 25.28639
      },
      "lks94": {
        "easting": 582961.02,
        "northing": 6060901.574
      }
    },
    {
      "id": "judu:stop:17495",
      "stopId": "17495",
      "name": "Šnipiškės",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0718",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "69"
      ],
      "wgs84": {
        "latitude": 54.69947,
        "longitude": 25.26883
      },
      "lks94": {
        "easting": 581784.866,
        "northing": 6063301.449
      }
    },
    {
      "id": "judu:stop:17504",
      "stopId": "17504",
      "name": "Skapiškio st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2434",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "123"
      ],
      "wgs84": {
        "latitude": 54.64083,
        "longitude": 25.20573
      },
      "lks94": {
        "easting": 577829.895,
        "northing": 6056703.888
      }
    },
    {
      "id": "judu:stop:17505",
      "stopId": "17505",
      "name": "Panerių kalvyno st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2435",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "123"
      ],
      "wgs84": {
        "latitude": 54.6388,
        "longitude": 25.20398
      },
      "lks94": {
        "easting": 577720.81,
        "northing": 6056476.039
      }
    },
    {
      "id": "judu:stop:17506",
      "stopId": "17506",
      "name": "Panerių kalvyno st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2436",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "123"
      ],
      "wgs84": {
        "latitude": 54.63899,
        "longitude": 25.20459
      },
      "lks94": {
        "easting": 577759.823,
        "northing": 6056497.859
      }
    },
    {
      "id": "judu:stop:17507",
      "stopId": "17507",
      "name": "Skapiškio st.",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2437",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "123"
      ],
      "wgs84": {
        "latitude": 54.64137,
        "longitude": 25.2059
      },
      "lks94": {
        "easting": 577839.836,
        "northing": 6056764.171
      }
    },
    {
      "id": "judu:stop:17589",
      "stopId": "17589",
      "name": "Rudamina",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4328",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12",
        "14",
        "16"
      ],
      "wgs84": {
        "latitude": 54.5921,
        "longitude": 25.34908
      },
      "lks94": {
        "easting": 587186.728,
        "northing": 6051449.281
      }
    },
    {
      "id": "judu:stop:17594",
      "stopId": "17594",
      "name": "Rudamina",
      "description": "į miestą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4334",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "12"
      ],
      "wgs84": {
        "latitude": 54.59165,
        "longitude": 25.34692
      },
      "lks94": {
        "easting": 587048.102,
        "northing": 6051396.527
      }
    },
    {
      "id": "judu:stop:17638",
      "stopId": "17638",
      "name": "Europos aikštė",
      "description": "link Žirmūnų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0103",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "3G",
        "3G-A",
        "4G",
        "9",
        "19",
        "30",
        "43",
        "56",
        "63",
        "88",
        "89",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.69528,
        "longitude": 25.27759
      },
      "lks94": {
        "easting": 582357.965,
        "northing": 6062845.399
      }
    },
    {
      "id": "judu:stop:17769",
      "stopId": "17769",
      "name": "Smalinės st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3665",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "4G",
        "75"
      ],
      "wgs84": {
        "latitude": 54.70995,
        "longitude": 25.18933
      },
      "lks94": {
        "easting": 576641.031,
        "northing": 6064378.023
      }
    },
    {
      "id": "judu:stop:17792",
      "stopId": "17792",
      "name": "Aitvarų st.",
      "description": "į miestą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2169",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "120"
      ],
      "wgs84": {
        "latitude": 54.78674,
        "longitude": 25.36723
      },
      "lks94": {
        "easting": 587937.763,
        "northing": 6073132.467
      }
    },
    {
      "id": "judu:stop:17854",
      "stopId": "17854",
      "name": "Smėlio st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4354",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "61"
      ],
      "wgs84": {
        "latitude": 54.6344,
        "longitude": 25.35045
      },
      "lks94": {
        "easting": 587184.791,
        "northing": 6056158.293
      }
    },
    {
      "id": "judu:stop:17862",
      "stopId": "17862",
      "name": "Prano Vaičaičio st.",
      "description": "link Ateities g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2020",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "125"
      ],
      "wgs84": {
        "latitude": 54.74077,
        "longitude": 25.25086
      },
      "lks94": {
        "easting": 580544.711,
        "northing": 6067876.825
      }
    },
    {
      "id": "judu:stop:17863",
      "stopId": "17863",
      "name": "Prano Vaičaičio st.",
      "description": "link Bajorų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2021",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "125"
      ],
      "wgs84": {
        "latitude": 54.74074,
        "longitude": 25.25118
      },
      "lks94": {
        "easting": 580565.375,
        "northing": 6067873.854
      }
    },
    {
      "id": "judu:stop:17865",
      "stopId": "17865",
      "name": "Visorių sodai",
      "description": "link Ateities g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2023",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "125"
      ],
      "wgs84": {
        "latitude": 54.74565,
        "longitude": 25.25082
      },
      "lks94": {
        "easting": 580532.453,
        "northing": 6068419.863
      }
    },
    {
      "id": "judu:stop:17866",
      "stopId": "17866",
      "name": "Visorių sodai",
      "description": "link Bajorų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2024",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "125"
      ],
      "wgs84": {
        "latitude": 54.74482,
        "longitude": 25.25071
      },
      "lks94": {
        "easting": 580527.018,
        "northing": 6068327.368
      }
    },
    {
      "id": "judu:stop:17867",
      "stopId": "17867",
      "name": "Mamerto Indriliūno st.",
      "description": "link Ateities g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2025",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "125"
      ],
      "wgs84": {
        "latitude": 54.74709,
        "longitude": 25.24589
      },
      "lks94": {
        "easting": 580212.211,
        "northing": 6068574.47
      }
    },
    {
      "id": "judu:stop:17869",
      "stopId": "17869",
      "name": "Mamerto Indriliūno st.",
      "description": "link Bajorų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2026",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "125"
      ],
      "wgs84": {
        "latitude": 54.74768,
        "longitude": 25.24472
      },
      "lks94": {
        "easting": 580135.724,
        "northing": 6068638.793
      }
    },
    {
      "id": "judu:stop:17871",
      "stopId": "17871",
      "name": "Mykolo Sleževičiaus st.",
      "description": "link Ateities g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2027",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "75",
        "125"
      ],
      "wgs84": {
        "latitude": 54.73889,
        "longitude": 25.25557
      },
      "lks94": {
        "easting": 580851.723,
        "northing": 6067673.022
      }
    },
    {
      "id": "judu:stop:17872",
      "stopId": "17872",
      "name": "Mykolo Sleževičiaus st.",
      "description": "link Bajorų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2028",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "75",
        "125"
      ],
      "wgs84": {
        "latitude": 54.73863,
        "longitude": 25.25718
      },
      "lks94": {
        "easting": 580955.911,
        "northing": 6067645.944
      }
    },
    {
      "id": "judu:stop:17889",
      "stopId": "17889",
      "name": "Šilo st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1127",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "37",
        "119"
      ],
      "wgs84": {
        "latitude": 54.70037,
        "longitude": 25.3496
      },
      "lks94": {
        "easting": 586988.816,
        "northing": 6063498.705
      }
    },
    {
      "id": "judu:stop:17944",
      "stopId": "17944",
      "name": "Pripetės st.",
      "description": "link Rudaminos",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2655",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "12",
        "19",
        "42",
        "82"
      ],
      "wgs84": {
        "latitude": 54.62936,
        "longitude": 25.30463
      },
      "lks94": {
        "easting": 584237.248,
        "northing": 6055541.518
      }
    },
    {
      "id": "judu:stop:17945",
      "stopId": "17945",
      "name": "Pripetės st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2656",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "9",
        "12",
        "14",
        "19",
        "82"
      ],
      "wgs84": {
        "latitude": 54.62968,
        "longitude": 25.30473
      },
      "lks94": {
        "easting": 584243.043,
        "northing": 6055577.249
      }
    },
    {
      "id": "judu:stop:17952",
      "stopId": "17952",
      "name": "Tujų st.",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3576",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "38"
      ],
      "wgs84": {
        "latitude": 54.75517,
        "longitude": 25.41665
      },
      "lks94": {
        "easting": 591187.127,
        "northing": 6069682.276
      }
    },
    {
      "id": "judu:stop:18018",
      "stopId": "18018",
      "name": "Chemijos institutas",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2139",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "57",
        "125"
      ],
      "wgs84": {
        "latitude": 54.75392,
        "longitude": 25.26381
      },
      "lks94": {
        "easting": 581352.171,
        "northing": 6069355.201
      }
    },
    {
      "id": "judu:stop:18073",
      "stopId": "18073",
      "name": "Plungės st.",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2929",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "20"
      ],
      "wgs84": {
        "latitude": 54.66163,
        "longitude": 25.14856
      },
      "lks94": {
        "easting": 574101.884,
        "northing": 6058956.829
      }
    },
    {
      "id": "judu:stop:18370",
      "stopId": "18370",
      "name": "Balsiai",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2221",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "36",
        "66"
      ],
      "wgs84": {
        "latitude": 54.78544,
        "longitude": 25.34673
      },
      "lks94": {
        "easting": 586622.101,
        "northing": 6072962.277
      }
    },
    {
      "id": "judu:stop:18375",
      "stopId": "18375",
      "name": "Oro uostas",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/6015",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1",
        "2",
        "3G",
        "88",
        "N8"
      ],
      "wgs84": {
        "latitude": 54.64396,
        "longitude": 25.27959
      },
      "lks94": {
        "easting": 582590.96,
        "northing": 6057136.55
      }
    },
    {
      "id": "judu:stop:18426",
      "stopId": "18426",
      "name": "Naujaneriai",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2241",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "36",
        "65",
        "76",
        "120"
      ],
      "wgs84": {
        "latitude": 54.80143,
        "longitude": 25.34802
      },
      "lks94": {
        "easting": 586670.854,
        "northing": 6074743.353
      }
    },
    {
      "id": "judu:stop:18427",
      "stopId": "18427",
      "name": "Naujaneriai",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2242",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "66"
      ],
      "wgs84": {
        "latitude": 54.80145,
        "longitude": 25.34816
      },
      "lks94": {
        "easting": 586679.812,
        "northing": 6074745.752
      }
    },
    {
      "id": "judu:stop:18480",
      "stopId": "18480",
      "name": "Žvėryno žiedas",
      "description": "išlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5151a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32",
        "59",
        "63"
      ],
      "wgs84": {
        "latitude": 54.69833,
        "longitude": 25.24528
      },
      "lks94": {
        "easting": 580269.237,
        "northing": 6063147.398
      }
    },
    {
      "id": "judu:stop:18481",
      "stopId": "18481",
      "name": "Žvėryno žiedas",
      "description": "išlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5151b",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "11",
        "116"
      ],
      "wgs84": {
        "latitude": 54.69866,
        "longitude": 25.24504
      },
      "lks94": {
        "easting": 580253.116,
        "northing": 6063183.849
      }
    },
    {
      "id": "judu:stop:18504",
      "stopId": "18504",
      "name": "Antavilių sodai",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3555",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "121"
      ],
      "wgs84": {
        "latitude": 54.80162,
        "longitude": 25.40469
      },
      "lks94": {
        "easting": 590313.785,
        "northing": 6074836.029
      }
    },
    {
      "id": "judu:stop:18526",
      "stopId": "18526",
      "name": "Fabriko st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/6016",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.62572,
        "longitude": 25.06645
      },
      "lks94": {
        "easting": 568865.259,
        "northing": 6054876.926
      }
    },
    {
      "id": "judu:stop:18532",
      "stopId": "18532",
      "name": "Jono Galvydžio st.",
      "description": "link Žirmūnų",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0930",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "30",
        "33",
        "69"
      ],
      "wgs84": {
        "latitude": 54.71199,
        "longitude": 25.29395
      },
      "lks94": {
        "easting": 583378.247,
        "northing": 6064724.311
      }
    },
    {
      "id": "judu:stop:18564",
      "stopId": "18564",
      "name": "Antavilių sodai",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3556",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "121"
      ],
      "wgs84": {
        "latitude": 54.80183,
        "longitude": 25.40439
      },
      "lks94": {
        "easting": 590294.03,
        "northing": 6074859.013
      }
    },
    {
      "id": "judu:stop:18565",
      "stopId": "18565",
      "name": "Spalio st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1061",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "119"
      ],
      "wgs84": {
        "latitude": 54.71449,
        "longitude": 25.4184
      },
      "lks94": {
        "easting": 591391.288,
        "northing": 6065157.477
      }
    },
    {
      "id": "judu:stop:18566",
      "stopId": "18566",
      "name": "Spalio st.",
      "description": "iš miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1059",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "119"
      ],
      "wgs84": {
        "latitude": 54.71472,
        "longitude": 25.4189
      },
      "lks94": {
        "easting": 591422.984,
        "northing": 6065183.724
      }
    },
    {
      "id": "judu:stop:18674",
      "stopId": "18674",
      "name": "Vėtrungių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3339",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "N4"
      ],
      "wgs84": {
        "latitude": 54.73745,
        "longitude": 25.23185
      },
      "lks94": {
        "easting": 579327.18,
        "northing": 6067485.692
      }
    },
    {
      "id": "judu:stop:18690",
      "stopId": "18690",
      "name": "Islandijos st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0208b",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "N4",
        "N6"
      ],
      "wgs84": {
        "latitude": 54.68486,
        "longitude": 25.27776
      },
      "lks94": {
        "easting": 582390.03,
        "northing": 6061685.995
      }
    },
    {
      "id": "judu:stop:18721",
      "stopId": "18721",
      "name": "Bukiškių st.",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0515a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "87"
      ],
      "wgs84": {
        "latitude": 54.75906,
        "longitude": 25.20435
      },
      "lks94": {
        "easting": 577515.068,
        "northing": 6069859.891
      }
    },
    {
      "id": "judu:stop:18733",
      "stopId": "18733",
      "name": "Žaliasis tiltas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0102b",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "N4"
      ],
      "wgs84": {
        "latitude": 54.69298,
        "longitude": 25.28064
      },
      "lks94": {
        "easting": 582559.237,
        "northing": 6062593.023
      }
    },
    {
      "id": "judu:stop:18768",
      "stopId": "18768",
      "name": "2-asis paplūdimys",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3577",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "15"
      ],
      "wgs84": {
        "latitude": 54.74214,
        "longitude": 25.29471
      },
      "lks94": {
        "easting": 583365.306,
        "northing": 6068080.511
      }
    },
    {
      "id": "judu:stop:18780",
      "stopId": "18780",
      "name": "Žygio st.",
      "description": "link Gurių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0933",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "33"
      ],
      "wgs84": {
        "latitude": 54.70312,
        "longitude": 25.28761
      },
      "lks94": {
        "easting": 582987.849,
        "northing": 6063729.686
      }
    },
    {
      "id": "judu:stop:18787",
      "stopId": "18787",
      "name": "Grūdų st.",
      "description": "link N.Vilnios",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1408a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.66767,
        "longitude": 25.35943
      },
      "lks94": {
        "easting": 587692.838,
        "northing": 6059871.91
      }
    },
    {
      "id": "judu:stop:18824",
      "stopId": "18824",
      "name": "Edinburgo st.",
      "description": "į centrą",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5008",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "52",
        "87"
      ],
      "wgs84": {
        "latitude": 54.75057,
        "longitude": 25.21315
      },
      "lks94": {
        "easting": 578097.771,
        "northing": 6068924.812
      }
    },
    {
      "id": "judu:stop:18831",
      "stopId": "18831",
      "name": "Mykolo Lietuvio st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3850",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "40"
      ],
      "wgs84": {
        "latitude": 54.74337,
        "longitude": 25.2262
      },
      "lks94": {
        "easting": 578951.842,
        "northing": 6068138.144
      }
    },
    {
      "id": "judu:stop:18847",
      "stopId": "18847",
      "name": "Žygio st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0900",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "5",
        "26",
        "34",
        "65",
        "69"
      ],
      "wgs84": {
        "latitude": 54.70373,
        "longitude": 25.28748
      },
      "lks94": {
        "easting": 582978.225,
        "northing": 6063797.417
      }
    },
    {
      "id": "judu:stop:18852",
      "stopId": "18852",
      "name": "Liubarto tiltas",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0301a",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "7",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.68889,
        "longitude": 25.25543
      },
      "lks94": {
        "easting": 580942.247,
        "northing": 6062108.505
      }
    },
    {
      "id": "judu:stop:18878",
      "stopId": "18878",
      "name": "Girinaičių st.",
      "description": "link Antavilių",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3563",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "121"
      ],
      "wgs84": {
        "latitude": 54.77663,
        "longitude": 25.38429
      },
      "lks94": {
        "easting": 589057.173,
        "northing": 6072028.89
      }
    },
    {
      "id": "judu:stop:18879",
      "stopId": "18879",
      "name": "Pečiukai",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3557",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "121"
      ],
      "wgs84": {
        "latitude": 54.78228,
        "longitude": 25.38398
      },
      "lks94": {
        "easting": 589024.82,
        "northing": 6072657.264
      }
    },
    {
      "id": "judu:stop:18884",
      "stopId": "18884",
      "name": "Kazio Bizausko st.",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1400",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.67364,
        "longitude": 25.3985
      },
      "lks94": {
        "easting": 590199.733,
        "northing": 6060585.768
      }
    },
    {
      "id": "judu:stop:18889",
      "stopId": "18889",
      "name": "Pečiukai",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3573",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "121"
      ],
      "wgs84": {
        "latitude": 54.7809,
        "longitude": 25.38362
      },
      "lks94": {
        "easting": 589004.695,
        "northing": 6072503.232
      }
    },
    {
      "id": "judu:stop:18891",
      "stopId": "18891",
      "name": "Kazio Bizausko st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1399",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.67322,
        "longitude": 25.39773
      },
      "lks94": {
        "easting": 590151.004,
        "northing": 6060538.04
      }
    },
    {
      "id": "judu:stop:18892",
      "stopId": "18892",
      "name": "Girinaičių st.",
      "description": "link centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3579",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "17",
        "39",
        "121"
      ],
      "wgs84": {
        "latitude": 54.77554,
        "longitude": 25.38386
      },
      "lks94": {
        "easting": 589031.904,
        "northing": 6071907.042
      }
    },
    {
      "id": "judu:stop:18903",
      "stopId": "18903",
      "name": "Strielčiukai",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1416b",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.67722,
        "longitude": 25.39801
      },
      "lks94": {
        "easting": 590160.199,
        "northing": 6060983.536
      }
    },
    {
      "id": "judu:stop:18904",
      "stopId": "18904",
      "name": "Edinburgo st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5021",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "52"
      ],
      "wgs84": {
        "latitude": 54.75002,
        "longitude": 25.21217
      },
      "lks94": {
        "easting": 578035.744,
        "northing": 6068862.513
      }
    },
    {
      "id": "judu:stop:18905",
      "stopId": "18905",
      "name": "Pikutiškių st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5022",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "52"
      ],
      "wgs84": {
        "latitude": 54.74728,
        "longitude": 25.19603
      },
      "lks94": {
        "easting": 577001.95,
        "northing": 6068539.748
      }
    },
    {
      "id": "judu:stop:18926",
      "stopId": "18926",
      "name": "Zujūnai",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4410a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32",
        "118"
      ],
      "wgs84": {
        "latitude": 54.72569,
        "longitude": 25.18634
      },
      "lks94": {
        "easting": 576418.752,
        "northing": 6066126.438
      }
    },
    {
      "id": "judu:stop:18927",
      "stopId": "18927",
      "name": "Zujūnai",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4406a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32",
        "118"
      ],
      "wgs84": {
        "latitude": 54.72779,
        "longitude": 25.18304
      },
      "lks94": {
        "easting": 576202.25,
        "northing": 6066356.554
      }
    },
    {
      "id": "judu:stop:18928",
      "stopId": "18928",
      "name": "Garbės st.",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4416a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32",
        "118"
      ],
      "wgs84": {
        "latitude": 54.72905,
        "longitude": 25.18331
      },
      "lks94": {
        "easting": 576217.276,
        "northing": 6066497.071
      }
    },
    {
      "id": "judu:stop:18938",
      "stopId": "18938",
      "name": "Bagušių st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1442",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.66876,
        "longitude": 25.38099
      },
      "lks94": {
        "easting": 589081.136,
        "northing": 6060020.347
      }
    },
    {
      "id": "judu:stop:18939",
      "stopId": "18939",
      "name": "Bukiškių",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5005b",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "87"
      ],
      "wgs84": {
        "latitude": 54.75856,
        "longitude": 25.20438
      },
      "lks94": {
        "easting": 577517.954,
        "northing": 6069804.279
      }
    },
    {
      "id": "judu:stop:18975",
      "stopId": "18975",
      "name": "Justiniškių žiedas",
      "description": "išlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3215",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "73"
      ],
      "wgs84": {
        "latitude": 54.70925,
        "longitude": 25.21259
      },
      "lks94": {
        "easting": 578141.19,
        "northing": 6064325.769
      }
    },
    {
      "id": "judu:stop:18983",
      "stopId": "18983",
      "name": "Įtraukties centras",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1411a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "122"
      ],
      "wgs84": {
        "latitude": 54.67521,
        "longitude": 25.3742
      },
      "lks94": {
        "easting": 588629.125,
        "northing": 6060729.541
      }
    },
    {
      "id": "judu:stop:18996",
      "stopId": "18996",
      "name": "Zigmantiškių st.",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/6017",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "51"
      ],
      "wgs84": {
        "latitude": 54.6319,
        "longitude": 25.06148
      },
      "lks94": {
        "easting": 568533.946,
        "northing": 6055559.826
      }
    },
    {
      "id": "judu:stop:19051",
      "stopId": "19051",
      "name": "Kriaučiūnai",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/3615a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "63"
      ],
      "wgs84": {
        "latitude": 54.71213,
        "longitude": 25.15035
      },
      "lks94": {
        "easting": 574125.278,
        "northing": 6064578.766
      }
    },
    {
      "id": "judu:stop:19064",
      "stopId": "19064",
      "name": "Ąžuolų st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4415a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32"
      ],
      "wgs84": {
        "latitude": 54.72071,
        "longitude": 25.19467
      },
      "lks94": {
        "easting": 576964.743,
        "northing": 6065581.326
      }
    },
    {
      "id": "judu:stop:19076",
      "stopId": "19076",
      "name": "Strielčiukai",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1415a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.67715,
        "longitude": 25.39782
      },
      "lks94": {
        "easting": 590148.101,
        "northing": 6060975.502
      }
    },
    {
      "id": "judu:stop:19086",
      "stopId": "19086",
      "name": "Pramogų arena",
      "description": "iš stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0802a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "1G",
        "10",
        "26",
        "34",
        "35",
        "36",
        "49",
        "50",
        "55",
        "65",
        "66"
      ],
      "wgs84": {
        "latitude": 54.71757,
        "longitude": 25.28688
      },
      "lks94": {
        "easting": 582911.316,
        "northing": 6065336.915
      }
    },
    {
      "id": "judu:stop:19105",
      "stopId": "19105",
      "name": "Grūšiakalnio st.",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2167",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "120"
      ],
      "wgs84": {
        "latitude": 54.78055,
        "longitude": 25.37009
      },
      "lks94": {
        "easting": 588135.162,
        "northing": 6072447.193
      }
    },
    {
      "id": "judu:stop:19106",
      "stopId": "19106",
      "name": "Sodų st.",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/4405a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "32"
      ],
      "wgs84": {
        "latitude": 54.72378,
        "longitude": 25.1884
      },
      "lks94": {
        "easting": 576555.041,
        "northing": 6065916.122
      }
    },
    {
      "id": "judu:stop:19134",
      "stopId": "19134",
      "name": "Tomo Žebrausko st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5023",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "52"
      ],
      "wgs84": {
        "latitude": 54.74835,
        "longitude": 25.20083
      },
      "lks94": {
        "easting": 577308.927,
        "northing": 6068664.106
      }
    },
    {
      "id": "judu:stop:19135",
      "stopId": "19135",
      "name": "Alėja",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1413a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.67308,
        "longitude": 25.39092
      },
      "lks94": {
        "easting": 589712.108,
        "northing": 6060513.738
      }
    },
    {
      "id": "judu:stop:19136",
      "stopId": "19136",
      "name": "Pikutiškių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5025",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "52"
      ],
      "wgs84": {
        "latitude": 54.74716,
        "longitude": 25.19503
      },
      "lks94": {
        "easting": 576937.799,
        "northing": 6068525.296
      }
    },
    {
      "id": "judu:stop:19137",
      "stopId": "19137",
      "name": "Laidagalių st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/5026",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "52"
      ],
      "wgs84": {
        "latitude": 54.74679,
        "longitude": 25.18844
      },
      "lks94": {
        "easting": 576514.243,
        "northing": 6068476.912
      }
    },
    {
      "id": "judu:stop:19157",
      "stopId": "19157",
      "name": "Siesikų st.",
      "description": "link Buivydiškių g.",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1906a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "7"
      ],
      "wgs84": {
        "latitude": 54.70922,
        "longitude": 25.24139
      },
      "lks94": {
        "easting": 579997.071,
        "northing": 6064354.874
      }
    },
    {
      "id": "judu:stop:19193",
      "stopId": "19193",
      "name": "J. Jasinskio st.",
      "description": "iš centro",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/0217a",
      "modes": [
        "bus",
        "trolleybus"
      ],
      "routeShortNames": [
        "1",
        "3",
        "7",
        "11",
        "116",
        "123",
        "N7"
      ],
      "wgs84": {
        "latitude": 54.68814,
        "longitude": 25.26451
      },
      "lks94": {
        "easting": 581529.14,
        "northing": 6062035.546
      }
    },
    {
      "id": "judu:stop:19200",
      "stopId": "19200",
      "name": "Alėja",
      "description": "link N.Vilnios",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1414a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.67299,
        "longitude": 25.39042
      },
      "lks94": {
        "easting": 589680.06,
        "northing": 6060503.083
      }
    },
    {
      "id": "judu:stop:19201",
      "stopId": "19201",
      "name": "Versmių st.",
      "description": "link N.Vilnios",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1410a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.66793,
        "longitude": 25.37329
      },
      "lks94": {
        "easting": 588586.283,
        "northing": 6059918.24
      }
    },
    {
      "id": "judu:stop:19202",
      "stopId": "19202",
      "name": "Versmių st.",
      "description": "link stoties",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1409a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.66813,
        "longitude": 25.3719
      },
      "lks94": {
        "easting": 588496.19,
        "northing": 6059938.744
      }
    },
    {
      "id": "judu:stop:19203",
      "stopId": "19203",
      "name": "Versmių st.",
      "description": "visos kryptys",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1456",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "122"
      ],
      "wgs84": {
        "latitude": 54.66828,
        "longitude": 25.37257
      },
      "lks94": {
        "easting": 588539.08,
        "northing": 6059956.282
      }
    },
    {
      "id": "judu:stop:19204",
      "stopId": "19204",
      "name": "Įtraukties centras",
      "description": "link N.Vilnios",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1412a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "122"
      ],
      "wgs84": {
        "latitude": 54.67541,
        "longitude": 25.37428
      },
      "lks94": {
        "easting": 588633.848,
        "northing": 6060751.899
      }
    },
    {
      "id": "judu:stop:19206",
      "stopId": "19206",
      "name": "Bagušių st.",
      "description": "link N.Vilnios",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1441",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "31",
        "122",
        "N5"
      ],
      "wgs84": {
        "latitude": 54.66912,
        "longitude": 25.38151
      },
      "lks94": {
        "easting": 589113.888,
        "northing": 6060061.069
      }
    },
    {
      "id": "judu:stop:19208",
      "stopId": "19208",
      "name": "Taugotiškių st.",
      "description": "link N.Vilnios",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1445",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "122"
      ],
      "wgs84": {
        "latitude": 54.67272,
        "longitude": 25.37348
      },
      "lks94": {
        "easting": 588588.112,
        "northing": 6060451.533
      }
    },
    {
      "id": "judu:stop:19209",
      "stopId": "19209",
      "name": "Taugotiškių st.",
      "description": "link miesto",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1454",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "122"
      ],
      "wgs84": {
        "latitude": 54.6723,
        "longitude": 25.37329
      },
      "lks94": {
        "easting": 588576.772,
        "northing": 6060404.554
      }
    },
    {
      "id": "judu:stop:19220",
      "stopId": "19220",
      "name": "Pasakų parkas",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1717a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "116"
      ],
      "wgs84": {
        "latitude": 54.68562,
        "longitude": 25.20518
      },
      "lks94": {
        "easting": 577708.851,
        "northing": 6061687.82
      }
    },
    {
      "id": "judu:stop:19221",
      "stopId": "19221",
      "name": "Pasakų parkas",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1716a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "116"
      ],
      "wgs84": {
        "latitude": 54.68552,
        "longitude": 25.2051
      },
      "lks94": {
        "easting": 577703.884,
        "northing": 6061676.603
      }
    },
    {
      "id": "judu:stop:19222",
      "stopId": "19222",
      "name": "Loretos Asanavičiūtės st.",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1661a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "116"
      ],
      "wgs84": {
        "latitude": 54.68335,
        "longitude": 25.19618
      },
      "lks94": {
        "easting": 577132.872,
        "northing": 6061425.273
      }
    },
    {
      "id": "judu:stop:19223",
      "stopId": "19223",
      "name": "Loretos Asanavičiūtės st.",
      "description": "",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/1662a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "116"
      ],
      "wgs84": {
        "latitude": 54.68354,
        "longitude": 25.19613
      },
      "lks94": {
        "easting": 577129.288,
        "northing": 6061446.363
      }
    },
    {
      "id": "judu:stop:19255",
      "stopId": "19255",
      "name": "Vilkpėdės žiedas",
      "description": "išlaipinimas",
      "stopUrl": "https://www.stops.lt/vilnius/index.html#stop/2425a",
      "modes": [
        "bus"
      ],
      "routeShortNames": [
        "13",
        "29",
        "56",
        "73"
      ],
      "wgs84": {
        "latitude": 54.66588,
        "longitude": 25.24627
      },
      "lks94": {
        "easting": 580397.151,
        "northing": 6059537.278
      }
    }
  ]
}
